/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(161);
	module.exports = __webpack_require__(88);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(162);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(100)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetID = resetID;
	exports.default = idgen;
	var id = 0;
	
	function resetID() {
	  id = 0;
	}
	
	function idgen() {
	  var oldId = id;
	  id += 1;
	  return oldId;
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(34);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = {
	  STYLES: ['large', 'small', 'floating', 'flat'],
	  WAVES: ['light', 'red', 'yellow', 'orange', 'purple', 'green', 'teal'],
	  SIZES: ['s', 'm', 'l', 'xl'],
	  PLACEMENTS: ['left', 'center', 'right'],
	  SCALES: ['big', 'small'],
	  ICON_SIZES: ['tiny', 'small', 'medium', 'large']
	};
	exports.default = _default;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Icon = function Icon(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["className", "children"]);
	
	  var classes = {
	    'material-icons': true
	  };
	  var rest = Object.assign(props, {});
	
	  _constants.default.PLACEMENTS.forEach(function (p) {
	    classes[p] = props[p];
	    delete rest[p];
	  });
	
	  _constants.default.ICON_SIZES.forEach(function (s) {
	    classes[s] = props[s];
	    delete rest[s];
	  });
	
	  return /*#__PURE__*/_react.default.createElement("i", _extends({
	    className: (0, _classnames.default)(classes, className)
	  }, rest), children);
	};
	
	Icon.propTypes = {
	  /**
	   * Classname passed to i tag
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Icon type: <a href='https://material.io/icons/'>https://material.io/icons/</a>
	   */
	  children: _propTypes.default.string.isRequired,
	
	  /**
	   * Placement for icon if used beside a text ↓
	   */
	  left: _propTypes.default.bool,
	  center: _propTypes.default.bool,
	  right: _propTypes.default.bool,
	
	  /**
	   * Sizes for icons ↓
	   */
	  tiny: _propTypes.default.bool,
	  small: _propTypes.default.bool,
	  medium: _propTypes.default.bool,
	  large: _propTypes.default.bool
	};
	var _default = Icon;
	exports.default = _default;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(145));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(46));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(9);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(146));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(152);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(153);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(49);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _batch = __webpack_require__(50);
	
	var _reactBatchedUpdates = __webpack_require__(155);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(51));
	
	exports.shallowEqual = _shallowEqual["default"];
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCategoryBills = exports.updateBill = exports.getBill = exports.addBill = exports.deleteBill = exports.getBills = undefined;
	
	var _types = __webpack_require__(78);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBills = exports.getBills = function getBills() {
	    return function (dispatch) {
	
	        _axios2.default.get("https://my-json-server.typicode.com/Deepak2607/Deepak2607.github.io/bills").then(function (res) {
	            console.log(res);
	            dispatch({
	                type: _types.GET_BILLS,
	                payload: res.data
	            });
	        });
	    };
	};
	
	var deleteBill = exports.deleteBill = function deleteBill(id) {
	    return function (dispatch) {
	
	        dispatch({
	            type: _types.DELETE_BILL,
	            payload: id
	        });
	        _axios2.default.delete("https://my-json-server.typicode.com/Deepak2607/Deepak2607.github.io/bills/" + id).then(function (res) {
	            dispatch({
	                type: _types.DELETE_BILL,
	                payload: id
	            });
	        });
	    };
	};
	
	var addBill = exports.addBill = function addBill(bill) {
	    return function (dispatch) {
	
	        _axios2.default.post("https://my-json-server.typicode.com/Deepak2607/Deepak2607.github.io/bills", bill).then(function (res) {
	            console.log(res);
	            dispatch({
	                type: _types.ADD_BILL,
	                payload: res.data
	            });
	        });
	    };
	};
	
	var getBill = exports.getBill = function getBill(id) {
	    return function (dispatch) {
	        _axios2.default.get("https://my-json-server.typicode.com/Deepak2607/Deepak2607.github.io/bills/" + id).then(function (res) {
	            dispatch({
	                type: _types.GET_BILL,
	                payload: res.data
	            });
	        });
	    };
	};
	
	var updateBill = exports.updateBill = function updateBill(bill) {
	    return function (dispatch) {
	        _axios2.default.put("https://my-json-server.typicode.com/Deepak2607/Deepak2607.github.io/bills/" + bill.id, bill).then(function (res) {
	            dispatch({
	                type: _types.UPDATE_BILL,
	                payload: res.data
	            });
	        });
	    };
	};
	
	var getCategoryBills = exports.getCategoryBills = function getCategoryBills(category) {
	    return function (dispatch) {
	
	        _axios2.default.get("https://my-json-server.typicode.com/Deepak2607/Deepak2607.github.io/bills/?category=" + category).then(function (res) {
	            console.log(res);
	            dispatch({
	                type: _types.GET_CAT_BILLS,
	                payload: res.data
	            });
	        });
	    };
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Autocomplete", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "Breadcrumb", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumb.default;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "Caption", {
	  enumerable: true,
	  get: function get() {
	    return _Caption.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardPanel", {
	  enumerable: true,
	  get: function get() {
	    return _CardPanel.default;
	  }
	});
	Object.defineProperty(exports, "CardTitle", {
	  enumerable: true,
	  get: function get() {
	    return _CardTitle.default;
	  }
	});
	Object.defineProperty(exports, "Carousel", {
	  enumerable: true,
	  get: function get() {
	    return _Carousel.default;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _Col.default;
	  }
	});
	Object.defineProperty(exports, "Collapsible", {
	  enumerable: true,
	  get: function get() {
	    return _Collapsible.default;
	  }
	});
	Object.defineProperty(exports, "CollapsibleItem", {
	  enumerable: true,
	  get: function get() {
	    return _CollapsibleItem.default;
	  }
	});
	Object.defineProperty(exports, "Collection", {
	  enumerable: true,
	  get: function get() {
	    return _Collection.default;
	  }
	});
	Object.defineProperty(exports, "CollectionItem", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionItem.default;
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	Object.defineProperty(exports, "DatePicker", {
	  enumerable: true,
	  get: function get() {
	    return _DatePicker.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Dropdown", {
	  enumerable: true,
	  get: function get() {
	    return _Dropdown.default;
	  }
	});
	Object.defineProperty(exports, "Footer", {
	  enumerable: true,
	  get: function get() {
	    return _Footer.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "MediaBox", {
	  enumerable: true,
	  get: function get() {
	    return _MediaBox.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "NavItem", {
	  enumerable: true,
	  get: function get() {
	    return _NavItem.default;
	  }
	});
	Object.defineProperty(exports, "Navbar", {
	  enumerable: true,
	  get: function get() {
	    return _Navbar.default;
	  }
	});
	Object.defineProperty(exports, "Pagination", {
	  enumerable: true,
	  get: function get() {
	    return _Pagination.default;
	  }
	});
	Object.defineProperty(exports, "PaginationButton", {
	  enumerable: true,
	  get: function get() {
	    return _PaginationButton.default;
	  }
	});
	Object.defineProperty(exports, "Parallax", {
	  enumerable: true,
	  get: function get() {
	    return _Parallax.default;
	  }
	});
	Object.defineProperty(exports, "Preloader", {
	  enumerable: true,
	  get: function get() {
	    return _Preloader.default;
	  }
	});
	Object.defineProperty(exports, "ProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _ProgressBar.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "Range", {
	  enumerable: true,
	  get: function get() {
	    return _Range.default;
	  }
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _Row.default;
	  }
	});
	Object.defineProperty(exports, "SearchForm", {
	  enumerable: true,
	  get: function get() {
	    return _SearchForm.default;
	  }
	});
	Object.defineProperty(exports, "Section", {
	  enumerable: true,
	  get: function get() {
	    return _Section.default;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "SideNav", {
	  enumerable: true,
	  get: function get() {
	    return _SideNav.default;
	  }
	});
	Object.defineProperty(exports, "SideNavItem", {
	  enumerable: true,
	  get: function get() {
	    return _SideNavItem.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	Object.defineProperty(exports, "Spinner", {
	  enumerable: true,
	  get: function get() {
	    return _Spinner.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "TextInput", {
	  enumerable: true,
	  get: function get() {
	    return _TextInput.default;
	  }
	});
	Object.defineProperty(exports, "Textarea", {
	  enumerable: true,
	  get: function get() {
	    return _Textarea.default;
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _TimePicker.default;
	  }
	});
	Object.defineProperty(exports, "Toast", {
	  enumerable: true,
	  get: function get() {
	    return _Toast.default;
	  }
	});
	Object.defineProperty(exports, "resetID", {
	  enumerable: true,
	  get: function get() {
	    return _idgen.resetID;
	  }
	});
	
	var _Autocomplete = _interopRequireDefault(__webpack_require__(40));
	
	var _Badge = _interopRequireDefault(__webpack_require__(104));
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(105));
	
	var _Button = _interopRequireDefault(__webpack_require__(21));
	
	var _Caption = _interopRequireDefault(__webpack_require__(106));
	
	var _Card = _interopRequireDefault(__webpack_require__(107));
	
	var _CardPanel = _interopRequireDefault(__webpack_require__(108));
	
	var _CardTitle = _interopRequireDefault(__webpack_require__(109));
	
	var _Carousel = _interopRequireDefault(__webpack_require__(110));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(111));
	
	var _Chip = _interopRequireDefault(__webpack_require__(112));
	
	var _Col = _interopRequireDefault(__webpack_require__(13));
	
	var _Collapsible = _interopRequireDefault(__webpack_require__(113));
	
	var _CollapsibleItem = _interopRequireDefault(__webpack_require__(114));
	
	var _Collection = _interopRequireDefault(__webpack_require__(115));
	
	var _CollectionItem = _interopRequireDefault(__webpack_require__(116));
	
	var _Container = _interopRequireDefault(__webpack_require__(117));
	
	var _DatePicker = _interopRequireDefault(__webpack_require__(118));
	
	var _Divider = _interopRequireDefault(__webpack_require__(119));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(41));
	
	var _Footer = _interopRequireDefault(__webpack_require__(120));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	var _MediaBox = _interopRequireDefault(__webpack_require__(121));
	
	var _Modal = _interopRequireDefault(__webpack_require__(122));
	
	var _NavItem = _interopRequireDefault(__webpack_require__(123));
	
	var _Navbar = _interopRequireDefault(__webpack_require__(124));
	
	var _Pagination = _interopRequireDefault(__webpack_require__(125));
	
	var _PaginationButton = _interopRequireDefault(__webpack_require__(42));
	
	var _Parallax = _interopRequireDefault(__webpack_require__(126));
	
	var _Preloader = _interopRequireDefault(__webpack_require__(127));
	
	var _ProgressBar = _interopRequireDefault(__webpack_require__(128));
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(129));
	
	var _Range = _interopRequireDefault(__webpack_require__(130));
	
	var _Row = _interopRequireDefault(__webpack_require__(22));
	
	var _SearchForm = _interopRequireDefault(__webpack_require__(43));
	
	var _Section = _interopRequireDefault(__webpack_require__(131));
	
	var _Select = _interopRequireDefault(__webpack_require__(132));
	
	var _SideNav = _interopRequireDefault(__webpack_require__(133));
	
	var _SideNavItem = _interopRequireDefault(__webpack_require__(134));
	
	var _Slide = _interopRequireDefault(__webpack_require__(135));
	
	var _Slider = _interopRequireDefault(__webpack_require__(136));
	
	var _Spinner = _interopRequireDefault(__webpack_require__(44));
	
	var _Switch = _interopRequireDefault(__webpack_require__(137));
	
	var _Tab = _interopRequireDefault(__webpack_require__(45));
	
	var _Table = _interopRequireDefault(__webpack_require__(138));
	
	var _Tabs = _interopRequireDefault(__webpack_require__(139));
	
	var _TextInput = _interopRequireDefault(__webpack_require__(14));
	
	var _Textarea = _interopRequireDefault(__webpack_require__(140));
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(141));
	
	var _Toast = _interopRequireDefault(__webpack_require__(142));
	
	var _idgen = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Col = function Col(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      _ref$node = _ref.node,
	      C = _ref$node === void 0 ? 'div' : _ref$node,
	      s = _ref.s,
	      m = _ref.m,
	      l = _ref.l,
	      xl = _ref.xl,
	      offset = _ref.offset,
	      push = _ref.push,
	      pull = _ref.pull,
	      other = _objectWithoutProperties(_ref, ["children", "className", "node", "s", "m", "l", "xl", "offset", "push", "pull"]);
	
	  var sizes = {
	    s: s,
	    m: m,
	    l: l,
	    xl: xl
	  };
	  var classes = {
	    col: true
	  };
	
	  _constants.default.SIZES.forEach(function (size) {
	    return classes[size + sizes[size]] = sizes[size];
	  });
	
	  if (offset) {
	    offset.split(' ').forEach(function (offset) {
	      return classes['offset-' + offset] = true;
	    });
	  }
	
	  if (push) {
	    push.split(' ').forEach(function (push) {
	      return classes['push-' + push] = true;
	    });
	  }
	
	  if (pull) {
	    pull.split(' ').forEach(function (pull) {
	      return classes['pull-' + pull] = true;
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement(C, _extends({}, other, {
	    className: (0, _classnames.default)(classes, className)
	  }), children);
	};
	
	Col.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	
	  /**
	   * Columns for extra large size screens (Large Desktop Devices > 1200px)
	   */
	  xl: _propTypes.default.number,
	
	  /**
	   * Columns for large size screens (Desktop Devices > 992px)
	   */
	  l: _propTypes.default.number,
	
	  /**
	   * Columns for middle size screens (Tablet Devices > 600px)
	   */
	  m: _propTypes.default.number,
	
	  /**
	   * Columns for small size screens (Mobile Devices <= 600px)
	   */
	  s: _propTypes.default.number,
	
	  /**
	   * The node to be used for the column
	   * @default div
	   */
	  node: _propTypes.default.node,
	
	  /**
	   * To offset/push/pull, simply add s2 to the class where s signifies the screen
	   * class-prefix (s = mobile devices, m = tablet devices, l = desktop devices, xl= large desktop devices) and the number after
	   * is the number of columns you want to offset/push/pull by.
	   */
	  offset: _propTypes.default.string,
	  push: _propTypes.default.string,
	  pull: _propTypes.default.string
	};
	var _default = Col;
	exports.default = _default;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var TextInput = _react.default.forwardRef(function (props, ref) {
	  // eslint-disable-next-line react/prop-types
	  var dataLength = props['data-length'];
	  var inputRef = ref || (0, _react.createRef)(null);
	  (0, _react.useEffect)(function () {
	    if (inputRef && dataLength) {
	      M.CharacterCounter.init(inputRef.current);
	    }
	  }, [dataLength, inputRef]);
	  (0, _react.useEffect)(function () {
	    M.updateTextFields();
	  }, [props.children]);
	
	  var children = props.children,
	      s = props.s,
	      m = props.m,
	      l = props.l,
	      xl = props.xl,
	      disabled = props.disabled,
	      noLayout = props.noLayout,
	      placeholder = props.placeholder,
	      icon = props.icon,
	      label = props.label,
	      inputClassName = props.inputClassName,
	      success = props.success,
	      error = props.error,
	      password = props.password,
	      email = props.email,
	      validate = props.validate,
	      defaultValue = props.defaultValue,
	      value = props.value,
	      type = props.type,
	      other = _objectWithoutProperties(props, ["children", "s", "m", "l", "xl", "disabled", "noLayout", "placeholder", "icon", "label", "inputClassName", "success", "error", "password", "email", "validate", "defaultValue", "value", "type"]);
	
	  var sizes = {
	    s: s,
	    m: m,
	    l: l,
	    xl: xl
	  };
	  var responsiveClasses;
	
	  if (!noLayout) {
	    responsiveClasses = {
	      col: true
	    };
	
	    _constants.default.SIZES.forEach(function (size) {
	      responsiveClasses[size + sizes[size]] = sizes[size];
	    });
	  }
	
	  var wrapperClasses = (0, _classnames.default)('input-field', responsiveClasses);
	  var computedType;
	
	  if (type) {
	    computedType = type;
	  } else if (password) {
	    computedType = 'password';
	  } else if (email) {
	    computedType = 'email';
	  } else {
	    computedType = 'text';
	  }
	
	  var inputProps = _objectSpread({
	    placeholder: placeholder,
	    type: computedType,
	    value: value,
	    defaultValue: defaultValue,
	    disabled: disabled
	  }, other);
	
	  var renderLabel = function renderLabel() {
	    return label && /*#__PURE__*/_react.default.createElement("label", {
	      className: (0, _classnames.default)({
	        active: value || placeholder,
	        'label-icon': typeof label !== 'string'
	      }),
	      "data-success": success,
	      "data-error": error,
	      htmlFor: inputProps.id
	    }, label);
	  };
	
	  var renderHelper = function renderHelper() {
	    return (error || success) && /*#__PURE__*/_react.default.createElement("span", {
	      className: "helper-text",
	      "data-error": error,
	      "data-success": success
	    });
	  };
	
	  var renderIcon = function renderIcon() {
	    if (!icon) return;
	
	    if (typeof icon === 'string') {
	      return /*#__PURE__*/_react.default.createElement("i", {
	        className: "material-icons prefix"
	      }, icon);
	    }
	
	    return _react.default.cloneElement(icon, {
	      className: 'prefix'
	    });
	  };
	
	  if (type === 'file') {
	    return /*#__PURE__*/_react.default.createElement("div", {
	      className: "".concat(wrapperClasses, " file-field")
	    }, /*#__PURE__*/_react.default.createElement("div", {
	      className: "btn"
	    }, /*#__PURE__*/_react.default.createElement("span", null, label), /*#__PURE__*/_react.default.createElement("input", _extends({
	      type: "file",
	      className: (0, _classnames.default)({
	        validate: validate
	      }, inputClassName)
	    }, inputProps))), /*#__PURE__*/_react.default.createElement("div", {
	      className: "file-path-wrapper"
	    }, /*#__PURE__*/_react.default.createElement("input", {
	      className: "file-path validate",
	      type: "text"
	    })), renderHelper(), children);
	  }
	
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: wrapperClasses
	  }, renderIcon(), /*#__PURE__*/_react.default.createElement("input", _extends({
	    ref: inputRef,
	    className: (0, _classnames.default)({
	      validate: validate
	    }, inputClassName)
	  }, inputProps)), renderLabel(), renderHelper(), children);
	});
	
	TextInput.displayName = 'TextInput';
	TextInput.propTypes = {
	  /**
	   * Strip away all layout classes such as col and sX
	   */
	  noLayout: _propTypes.default.bool,
	
	  /**
	   * Responsive size for Mobile Devices
	   */
	  s: _propTypes.default.number,
	
	  /**
	   * Responsive size for Tablet Devices
	   */
	  m: _propTypes.default.number,
	
	  /**
	   *  Responsive size for Desktop Devices
	   */
	  l: _propTypes.default.number,
	
	  /**
	   *  Responsive size for Large Desktop Devices
	   */
	  xl: _propTypes.default.number,
	
	  /**
	   * disabled input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Placeholder string
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * override id
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * prefix icon, name of the icon or a node
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * label text
	   */
	  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
	
	  /**
	   * Input initial value
	   */
	  defaultValue: _propTypes.default.string,
	
	  /**
	   * Input value
	   */
	  value: _propTypes.default.string,
	
	  /**
	   * Add validate class to input
	   */
	  validate: _propTypes.default.bool,
	
	  /**
	   * Custom success message
	   */
	  success: _propTypes.default.string,
	
	  /**
	   * Custom error message
	   */
	  error: _propTypes.default.string,
	
	  /**
	   * Additional classes for input
	   */
	  inputClassName: _propTypes.default.string,
	
	  /**
	   * override type="text"
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * onChange callback
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * password type
	   */
	  password: _propTypes.default.bool,
	
	  /**
	   * email type
	   */
	  email: _propTypes.default.bool,
	
	  /**
	   * children
	   */
	  children: _propTypes.default.node
	};
	TextInput.defaultProps = {
	  id: "TextInput-".concat((0, _idgen.default)())
	};
	var _default = TextInput;
	exports.default = _default;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 16 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 17 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 18 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(102);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(103);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Button = function Button(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      node = _ref.node,
	      fab = _ref.fab,
	      modal = _ref.modal,
	      flat = _ref.flat,
	      floating = _ref.floating,
	      large = _ref.large,
	      small = _ref.small,
	      disabled = _ref.disabled,
	      waves = _ref.waves,
	      tooltip = _ref.tooltip,
	      _ref$tooltipOptions = _ref.tooltipOptions,
	      tooltipOptions = _ref$tooltipOptions === void 0 ? {} : _ref$tooltipOptions,
	      icon = _ref.icon,
	      props = _objectWithoutProperties(_ref, ["children", "className", "node", "fab", "modal", "flat", "floating", "large", "small", "disabled", "waves", "tooltip", "tooltipOptions", "icon"]);
	
	  var _btn = (0, _react.useRef)(null);
	
	  var _fab = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    if (tooltip) {
	      var instance = M.Tooltip.init(_btn.current, tooltipOptions);
	      return function () {
	        instance && instance.destroy();
	      };
	    }
	  }, [tooltip, tooltipOptions, children]);
	  (0, _react.useEffect)(function () {
	    if (fab) {
	      var instance = M.FloatingActionButton.init(_fab.current, fab);
	      return function () {
	        instance && instance.destroy();
	      };
	    }
	  }, [fab]);
	
	  var renderFab = function renderFab(classes) {
	    return /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
	      ref: _fab.current,
	      className: (0, _classnames.default)('fixed-action-btn', {
	        toolbar: fab.toolbarEnabled
	      })
	    }), /*#__PURE__*/_react.default.createElement("a", {
	      className: classes
	    }, icon || /*#__PURE__*/_react.default.createElement(_Icon.default, null, "edit")), /*#__PURE__*/_react.default.createElement("ul", null, _react.Children.map(children, function (child) {
	      return /*#__PURE__*/_react.default.createElement("li", {
	        key: (0, _idgen.default)()
	      }, child);
	    })));
	  };
	
	  var C = node;
	  var classes = {
	    btn: true,
	    disabled: disabled,
	    'waves-effect': waves
	  };
	
	  if (_constants.default.WAVES.indexOf(waves) > -1) {
	    classes['waves-' + waves] = true;
	  }
	
	  var styles = {
	    flat: flat,
	    floating: floating,
	    large: large,
	    small: small
	  };
	
	  _constants.default.STYLES.forEach(function (style) {
	    if (styles[style]) {
	      classes.btn = false;
	      classes['btn-' + style] = true;
	    }
	  });
	
	  if (modal) {
	    classes['modal-' + modal] = true;
	  }
	
	  if (fab) {
	    return renderFab((0, _classnames.default)(classes, className));
	  } else {
	    return /*#__PURE__*/_react.default.createElement(C, _extends({}, props, {
	      disabled: disabled,
	      className: (0, _classnames.default)(classes, className),
	      ref: _btn,
	      "data-tooltip": tooltip
	    }), icon, children);
	  }
	};
	
	Button.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Enable other styles
	   */
	  flat: _propTypes.default.bool,
	  large: _propTypes.default.bool,
	  small: _propTypes.default.bool,
	  floating: _propTypes.default.bool,
	
	  /**
	   * Fixed action button
	   * If enabled, any children button will be rendered as actions, remember to provide an icon.
	   *  FAB Options are here: https://materializecss.com/floating-action-button.html#options
	   * @default false
	   * @default options {
	   *  direction: 'top',
	   *  hoverEnabled: true,
	   *  toolbarEnabled: false,
	   * }
	   */
	  fab: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    direction: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
	    hoverEnabled: _propTypes.default.bool,
	    toolbarEnabled: _propTypes.default.bool
	  })]),
	
	  /**
	   * The icon to display, if specified it will create a button with the material icon.
	   */
	  icon: _propTypes.default.node,
	  modal: _propTypes.default.oneOf(['close', 'confirm']),
	  node: _propTypes.default.node,
	
	  /**
	   * Will be disabled when fab is set.
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Tooltip to show when mouse hovered
	   */
	  tooltip: _propTypes.default.string,
	
	  /**
	   * Tooltips options as here
	   * https://materializecss.com/tooltips.html#options
	   */
	  tooltipOptions: _propTypes.default.shape({
	    exitDelay: _propTypes.default.number,
	    enterDelay: _propTypes.default.number,
	    html: _propTypes.default.string,
	    margin: _propTypes.default.number,
	    inDuration: _propTypes.default.number,
	    outDuration: _propTypes.default.number,
	    transitionMovement: _propTypes.default.number,
	    delay: _propTypes.default.number,
	    position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
	  }),
	  waves: _propTypes.default.oneOf(['light', 'red', 'yellow', 'orange', 'purple', 'green', 'teal'])
	};
	Button.defaultProps = {
	  node: 'button'
	};
	var _default = Button;
	exports.default = _default;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Row = function Row(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      _ref$node = _ref.node,
	      Node = _ref$node === void 0 ? 'div' : _ref$node,
	      props = _objectWithoutProperties(_ref, ["children", "className", "node"]);
	
	  return /*#__PURE__*/_react.default.createElement(Node, _extends({
	    className: (0, _classnames.default)('row', className)
	  }, props), children);
	};
	
	Row.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  node: _propTypes.default.node
	};
	var _default = Row;
	exports.default = _default;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _batch = __webpack_require__(50);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var Subscription = /*#__PURE__*/function () {
	  function Subscription(store, parentSub) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.handleChangeWrapper = function handleChangeWrapper() {
	    if (this.onStateChange) {
	      this.onStateChange();
	    }
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports["default"] = Subscription;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(156);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(168));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
	  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
	  }
	
	  if (enumerableOnly) keys = keys.filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	  });
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread2({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(57)["default"];
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var settle = __webpack_require__(67);
	var cookies = __webpack_require__(70);
	var buildURL = __webpack_require__(35);
	var buildFullPath = __webpack_require__(64);
	var parseHeaders = __webpack_require__(75);
	var isURLSameOrigin = __webpack_require__(73);
	var createError = __webpack_require__(31);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(66);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(5);
	var normalizeHeaderName = __webpack_require__(74);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(28);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(28);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(95);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(20);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(58);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.autocompleteOptions = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Autocomplete = function Autocomplete(_ref) {
	  var className = _ref.className,
	      title = _ref.title,
	      icon = _ref.icon,
	      s = _ref.s,
	      m = _ref.m,
	      l = _ref.l,
	      xl = _ref.xl,
	      id = _ref.id,
	      options = _ref.options,
	      rest = _objectWithoutProperties(_ref, ["className", "title", "icon", "s", "m", "l", "xl", "id", "options"]);
	
	  var autocompleteRef = (0, _react.useRef)(null);
	  var sizes = {
	    s: s,
	    m: m,
	    l: l,
	    xl: xl
	  };
	  var classes = {
	    col: true
	  };
	
	  _constants.default.SIZES.forEach(function (size) {
	    classes[size + sizes[size]] = sizes[size];
	  });
	
	  (0, _react.useEffect)(function () {
	    M.updateTextFields();
	    var instance = M.Autocomplete.init(autocompleteRef.current, options);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [options]);
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)('input-field', className, classes)
	  }, icon && (0, _react.cloneElement)(icon, {
	    className: 'prefix'
	  }), /*#__PURE__*/_react.default.createElement("input", _extends({
	    className: "autocomplete",
	    type: "text",
	    ref: autocompleteRef,
	    id: id
	  }, rest)), /*#__PURE__*/_react.default.createElement("label", {
	    htmlFor: id
	  }, title));
	};
	
	var autocompleteOptions = _propTypes.default.shape({
	  /**
	   * Data object defining autocomplete options with optional icon strings.
	   */
	  data: _propTypes.default.objectOf(_propTypes.default.string),
	
	  /**
	   * Limit of results the autocomplete shows.
	   */
	  limit: _propTypes.default.number,
	
	  /**
	   * Callback for when autocompleted.
	   */
	  onAutocomplete: _propTypes.default.func,
	
	  /**
	   * 	Minimum number of characters before autocomplete starts.
	   */
	  minLength: _propTypes.default.number,
	
	  /**
	   * Sort function that defines the order of the list of autocomplete options.
	   */
	  sortFunction: _propTypes.default.func
	});
	
	exports.autocompleteOptions = autocompleteOptions;
	Autocomplete.propTypes = {
	  /**
	   * Uniquely identifies <input> generated by this component
	   * Used by corresponding <label> for attribute
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	  className: _propTypes.default.string,
	
	  /**
	   * The title of the autocomplete component.
	   */
	  title: _propTypes.default.string,
	
	  /**
	   * Optional materialize icon to add to the autocomplete bar
	   */
	  icon: _propTypes.default.node,
	  s: _propTypes.default.number,
	  m: _propTypes.default.number,
	  l: _propTypes.default.number,
	  xl: _propTypes.default.number,
	
	  /**
	   * Placeholder for input element
	   * */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Called when the value of the input gets changed - by user typing or clicking on an auto-complete item.
	   * Function signature: (event, value) => ()
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the input
	   */
	  value: _propTypes.default.string,
	
	  /**
	   * Options for the autocomplete
	   * <a target="_blank" rel="external" href="https://materializecss.com/autocomplete.html#options</a>
	   */
	  options: autocompleteOptions
	};
	Autocomplete.defaultProps = {
	  id: "Autocomplete-".concat((0, _idgen.default)()),
	  options: {
	    data: {},
	    limit: Infinity,
	    onAutocomplete: null,
	    minLength: 1,
	    sortFunction: null
	  }
	};
	var _default = Autocomplete;
	exports.default = _default;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.dropdownOptions = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Dropdown = function Dropdown(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      trigger = _ref.trigger,
	      options = _ref.options,
	      props = _objectWithoutProperties(_ref, ["children", "className", "trigger", "options"]);
	
	  var _dropdownContent = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var instance = M.Dropdown.init(document.querySelector("[data-target=\"".concat(props.id, "\"]")), options);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [options, props.id, children]);
	
	  var renderTrigger = function renderTrigger() {
	    return (0, _react.cloneElement)(trigger, {
	      'data-target': props.id,
	      className: (0, _classnames.default)(trigger.props.className, 'dropdown-trigger')
	    });
	  };
	
	  var renderItems = function renderItems(c) {
	    return _react.Children.map(c, function (element) {
	      if (!element || element.type === 'li') {
	        // Skip null, undefined, or li children
	        return element;
	      } else if (element.type === _react.Fragment) {
	        // Recurse here for Fragments
	        return renderItems(element.props.children);
	      } else if (element.type.name === 'Divider' || element.type.displayName === 'Divider') {
	        // Replace <Divider/> component with proper semantics
	        return /*#__PURE__*/_react.default.createElement("li", {
	          key: (0, _idgen.default)(),
	          className: "divider",
	          tabIndex: "-1"
	        });
	      } else {
	        // Wrap child element in <li/>
	        return /*#__PURE__*/_react.default.createElement("li", {
	          key: (0, _idgen.default)()
	        }, element);
	      }
	    });
	  };
	
	  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, renderTrigger(), /*#__PURE__*/_react.default.createElement("ul", _extends({}, props, {
	    className: (0, _classnames.default)('dropdown-content', className),
	    ref: _dropdownContent
	  }), renderItems(children)));
	};
	
	var dropdownOptions = _propTypes.default.shape({
	  alignment: _propTypes.default.oneOf(['left', 'right']),
	  autoTrigger: _propTypes.default.bool,
	  constrainWidth: _propTypes.default.bool,
	  container: _propTypes.default.node,
	  coverTrigger: _propTypes.default.bool,
	  closeOnClick: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  inDuration: _propTypes.default.number,
	  outDuration: _propTypes.default.number,
	  onOpenStart: _propTypes.default.func,
	  onOpenEnd: _propTypes.default.func,
	  onCloseStart: _propTypes.default.func,
	  onCloseEnd: _propTypes.default.func
	});
	
	exports.dropdownOptions = dropdownOptions;
	Dropdown.propTypes = {
	  id: _propTypes.default.string,
	
	  /**
	   * The node to trigger the dropdown
	   */
	  trigger: _propTypes.default.node.isRequired,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	
	  /**
	   * Options hash for the dropdown
	   * <a target="_blank" href="http://materializecss.com/dropdown.html#options">http://materializecss.com/dropdown.html</a>
	   */
	  options: dropdownOptions
	};
	Dropdown.defaultProps = {
	  id: "Dropdown_".concat((0, _idgen.default)()),
	  options: {
	    alignment: 'left',
	    autoTrigger: true,
	    constrainWidth: true,
	    container: null,
	    coverTrigger: true,
	    closeOnClick: true,
	    hover: false,
	    inDuration: 150,
	    outDuration: 250,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null
	  }
	};
	var _default = Dropdown;
	exports.default = _default;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaginationButton = function PaginationButton(_ref) {
	  var _ref$active = _ref.active,
	      active = _ref$active === void 0 ? false : _ref$active,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
	      href = _ref.href,
	      onSelect = _ref.onSelect;
	  var classes = {
	    'waves-effect': !disabled,
	    disabled: disabled,
	    active: active
	  };
	  var linkProps = href ? {
	    href: href
	  } : null;
	  return /*#__PURE__*/_react.default.createElement("li", {
	    className: (0, _classnames.default)(classes, className),
	    onClick: onSelect
	  }, /*#__PURE__*/_react.default.createElement("a", linkProps, children));
	};
	
	PaginationButton.propTypes = {
	  active: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	  href: _propTypes.default.string,
	  onSelect: _propTypes.default.func
	};
	var _default = PaginationButton;
	exports.default = _default;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	var _TextInput = _interopRequireDefault(__webpack_require__(14));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchForm = function SearchForm(_ref) {
	  var searchIcon = _ref.searchIcon,
	      closeIcon = _ref.closeIcon;
	  return /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
	    label: searchIcon,
	    type: "search"
	  }, closeIcon));
	};
	
	SearchForm.propTypes = {
	  searchIcon: _propTypes.default.node.isRequired,
	  closeIcon: _propTypes.default.node.isRequired
	};
	SearchForm.defaultProps = {
	  searchIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "search"),
	  closeIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "close")
	};
	var _default = SearchForm;
	exports.default = _default;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Spinner = function Spinner(_ref) {
	  var _cx;
	
	  var color = _ref.color,
	      only = _ref.only,
	      className = _ref.className;
	  var spinnerClasses = (0, _classnames.default)('spinner-layer', (_cx = {}, _defineProperty(_cx, "spinner-".concat(color, "-only"), only), _defineProperty(_cx, "spinner-".concat(color), !only), _cx));
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)(spinnerClasses, className)
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: "circle-clipper left"
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: "circle"
	  })), /*#__PURE__*/_react.default.createElement("div", {
	    className: "gap-patch"
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: "circle"
	  })), /*#__PURE__*/_react.default.createElement("div", {
	    className: "circle-clipper right"
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: "circle"
	  })));
	};
	
	Spinner.defaultProps = {
	  only: true
	};
	Spinner.propTypes = {
	  className: _propTypes.default.string,
	  color: _propTypes.default.string,
	  only: _propTypes.default.bool
	};
	var _default = Spinner;
	exports.default = _default;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Col = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is just a holder for the props and children for tab, thus
	// there is no logic here.
	var Tab = function Tab(_ref) {
	  var children = _ref.children,
	      idx = _ref.idx,
	      className = _ref.className;
	  return /*#__PURE__*/_react.default.createElement(_Col.default, {
	    id: "tab_".concat(idx),
	    s: 12,
	    className: className
	  }, children);
	};
	
	Tab.propTypes = {
	  title: _propTypes.default.string.isRequired,
	  idx: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  tabWidth: _propTypes.default.number
	};
	var _default = Tab;
	exports.default = _default;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(20);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(23));
	
	var _useIsomorphicLayoutEffect = __webpack_require__(52);
	
	var _Context = __webpack_require__(9);
	
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["reactReduxForwardedRef"]);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var subscription = new _Subscription["default"](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(53));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(9);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(9);
	
	var _useReduxContext2 = __webpack_require__(48);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBatch = exports.setBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(154));
	
	var _warning = _interopRequireDefault(__webpack_require__(54));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(56);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 56 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 57 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 58 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(60);

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var bind = __webpack_require__(34);
	var Axios = __webpack_require__(62);
	var mergeConfig = __webpack_require__(32);
	var defaults = __webpack_require__(33);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(29);
	axios.CancelToken = __webpack_require__(61);
	axios.isCancel = __webpack_require__(30);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(76);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(72);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(29);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var buildURL = __webpack_require__(35);
	var InterceptorManager = __webpack_require__(63);
	var dispatchRequest = __webpack_require__(65);
	var mergeConfig = __webpack_require__(32);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(71);
	var combineURLs = __webpack_require__(69);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var transformData = __webpack_require__(68);
	var isCancel = __webpack_require__(30);
	var defaults = __webpack_require__(33);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(31);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(24);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Bills = __webpack_require__(81);
	
	var _Bills2 = _interopRequireDefault(_Bills);
	
	var _AddBill = __webpack_require__(79);
	
	var _AddBill2 = _interopRequireDefault(_AddBill);
	
	var _EditBill = __webpack_require__(82);
	
	var _EditBill2 = _interopRequireDefault(_EditBill);
	
	var _Navbar = __webpack_require__(87);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Chart = __webpack_require__(83);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _store = __webpack_require__(91);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(
	          _reactRouterDom.BrowserRouter,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "text-font" },
	            _react2.default.createElement(_Navbar2.default, null),
	            _react2.default.createElement(
	              _reactRouterDom.Switch,
	              null,
	              _react2.default.createElement(_reactRouterDom.Route, { path: "/", exact: true, component: _Bills2.default }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: "/chart", exact: true, component: _Chart2.default }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: "/add", exact: true, component: _AddBill2.default }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: "/bill/edit/:id", exact: true, component: _EditBill2.default })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_BILLS = exports.GET_BILLS = "GET_BILLS";
	
	var GET_BILL = exports.GET_BILL = "GET_BILL";
	
	var ADD_BILL = exports.ADD_BILL = "ADD_BILL";
	
	var UPDATE_BILL = exports.UPDATE_BILL = "UPDATE_BILL";
	
	var DELETE_BILL = exports.DELETE_BILL = "DELETE_BILL";
	
	var GET_CAT_BILLS = exports.GET_CAT_BILLS = "GET_CAT_BILLS";

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactMaterialize = __webpack_require__(12);
	
	var _billActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddBill = function (_Component) {
	  _inherits(AddBill, _Component);
	
	  function AddBill() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddBill);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddBill.__proto__ || Object.getPrototypeOf(AddBill)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      amount: "",
	      category: "",
	      description: "",
	      date: ""
	    }, _this.handleAmount = function (event) {
	      _this.setState({ amount: event.target.value });
	    }, _this.handleCategory = function (event) {
	      _this.setState({ category: event.target.value });
	    }, _this.handleDescription = function (event) {
	      _this.setState({ description: event.target.value });
	    }, _this.handleDate = function (event) {
	      _this.setState({ date: event.target.value });
	    }, _this.onSubmit = function (event) {
	
	      event.preventDefault();
	      var _this$state = _this.state,
	          amount = _this$state.amount,
	          category = _this$state.category,
	          date = _this$state.date,
	          description = _this$state.description;
	
	
	      var newBill = {
	        id: _this.props.bills.length + 1,
	        description: description,
	        category: category,
	        amount: amount,
	        date: date
	      };
	
	      _this.props.addBill(newBill);
	
	      _this.setState({
	        amount: "",
	        category: "",
	        date: "",
	        description: ""
	      });
	
	      _this.props.history.push("/");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddBill, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      //fetching all bills data
	      this.props.getBills();
	    }
	
	    //functions to handle input changes in form
	
	
	    //adding newBill to the list of bills
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          amount = _state.amount,
	          category = _state.category,
	          date = _state.date,
	          description = _state.description;
	
	
	      return _react2.default.createElement(
	        _reactMaterialize.Row,
	        null,
	        _react2.default.createElement(_reactMaterialize.Col, { m: 3 }),
	        _react2.default.createElement(
	          _reactMaterialize.Col,
	          { m: 6, l: 4, s: 12 },
	          _react2.default.createElement(
	            _reactMaterialize.Card,
	            { className: "margin-top" },
	            _react2.default.createElement(
	              "h5",
	              { className: "heading" },
	              "Add a Bill"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: amount, type: "number", placeholder: "Enter Amount",
	                onChange: this.handleAmount, label: "amount" })
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: category, type: "text", placeholder: "Enter Category",
	                onChange: this.handleCategory, label: "category" })
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: description, type: "text", placeholder: "Enter Description",
	                onChange: this.handleDescription, label: "description" })
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: date, type: "date", placeholder: "Enter Date",
	                onChange: this.handleDate, label: "date" })
	            ),
	            _react2.default.createElement(
	              _reactMaterialize.Button,
	              { waves: "light", onClick: this.onSubmit },
	              "Add"
	            )
	          )
	        ),
	        _react2.default.createElement(_reactMaterialize.Col, { m: 3 })
	      );
	    }
	  }]);
	
	  return AddBill;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bills: state.bill.bills
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { addBill: _billActions.addBill, getBills: _billActions.getBills })(AddBill);

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(24);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactMaterialize = __webpack_require__(12);
	
	var _billActions = __webpack_require__(11);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bill = function (_Component) {
	  _inherits(Bill, _Component);
	
	  function Bill() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bill);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bill.__proto__ || Object.getPrototypeOf(Bill)).call.apply(_ref, [this].concat(args))), _this), _this.onDeleteClick = function (id) {
	      _this.props.deleteBill(id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //function to delete a bill
	
	
	  _createClass(Bill, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props$bill = this.props.bill,
	          id = _props$bill.id,
	          amount = _props$bill.amount,
	          category = _props$bill.category,
	          description = _props$bill.description,
	          date = _props$bill.date,
	          should_be_paid = _props$bill.should_be_paid;
	
	      var title = id + ". " + description + " Bill";
	
	      return (
	        //rendering a bill
	        _react2.default.createElement(
	          _reactMaterialize.Card,
	          { title: title,
	            actions: [_react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                _reactMaterialize.Button,
	                { onClick: function onClick() {
	                    return _this2.onDeleteClick(id);
	                  }, waves: "light" },
	                "Delete Bill"
	              ),
	              "\u2002",
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "bill/edit/" + id },
	                _react2.default.createElement(
	                  _reactMaterialize.Button,
	                  null,
	                  "Edit Bill"
	                )
	              ),
	              should_be_paid === true ? _react2.default.createElement(
	                _reactMaterialize.Chip,
	                { className: "chip" },
	                "Should be Paid"
	              ) : null
	            )]
	          },
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "font-size" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Total: ",
	              _react2.default.createElement(
	                "span",
	                { className: "float-right" },
	                "Rs. ",
	                amount
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Category: ",
	              _react2.default.createElement(
	                "span",
	                { className: "float-right" },
	                category
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Date: ",
	              _react2.default.createElement(
	                "span",
	                { className: "float-right" },
	                date
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Bill;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { deleteBill: _billActions.deleteBill })(Bill);

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactMaterialize = __webpack_require__(12);
	
	var _billActions = __webpack_require__(11);
	
	var _Dropdown = __webpack_require__(86);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Bill = __webpack_require__(80);
	
	var _Bill2 = _interopRequireDefault(_Bill);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bills = function (_Component) {
	  _inherits(Bills, _Component);
	
	  function Bills() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bills);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bills.__proto__ || Object.getPrototypeOf(Bills)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      render: false,
	      category: "All Categories"
	    }, _this.onSelect = function (event) {
	
	      _this.props.getCategoryBills(event.target.value);
	
	      _this.setState({
	        category: event.target.value,
	        render: false
	      });
	      setTimeout(function () {
	        _this.setState({ render: true });
	      }, 1000);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Bills, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      //fetching all bills data
	      this.props.getBills();
	
	      setTimeout(function () {
	        _this2.setState({ render: true });
	      }, 500);
	    }
	
	    //function to fetch all bills of selected category
	
	  }, {
	    key: "render",
	    value: function render() {
	
	      //the amount of budget for month is taken as 40000
	      var budget = 40000;
	      var _props = this.props,
	          bills = _props.bills,
	          category_bills = _props.category_bills;
	
	      //sorting 'all bills' data in descending order of amount
	
	      bills.sort(function (a, b) {
	        return parseInt(b.amount) - parseInt(a.amount);
	      });
	
	      //updating each bill with a 'should be paid' property (finding minimum number of bills that should be paid)
	      var updated_bills = bills.map(function (bill) {
	        if (bill.amount <= budget) {
	          budget -= bill.amount;
	          return Object.assign({}, bill, { should_be_paid: true });
	        } else {
	          return Object.assign({}, bill, { should_be_paid: false });
	        }
	      });
	
	      //sorting 'all bills' data in ascending order of id's
	      updated_bills.sort(function (a, b) {
	        return parseInt(a.id) - parseInt(b.id);
	      });
	
	      //deciding which bills will be rendered, based on category
	      var bills_to_render = this.state.category == "All Categories" ? updated_bills : category_bills;
	
	      //preloader will be rendered until 'this.state.render' is false
	      if (this.state.render == false) {
	        return _react2.default.createElement(
	          "div",
	          { className: "preloader" },
	          _react2.default.createElement(
	            _reactMaterialize.Row,
	            null,
	            _react2.default.createElement(_reactMaterialize.Col, { s: 5 }),
	            _react2.default.createElement(
	              _reactMaterialize.Col,
	              { s: 2 },
	              _react2.default.createElement(_reactMaterialize.Preloader, { active: true, color: "blue", flashing: true })
	            ),
	            _react2.default.createElement(_reactMaterialize.Col, { s: 5 })
	          )
	        );
	      }
	
	      return (
	
	        //rendering bills
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(_Dropdown2.default, { onSelect: this.onSelect, bills: bills, category: this.state.category }),
	          _react2.default.createElement(
	            _reactMaterialize.Row,
	            null,
	            bills_to_render && bills_to_render.map(function (bill) {
	              return _react2.default.createElement(
	                _reactMaterialize.Col,
	                { className: "col-sm-12 col-md-12 col-lg-6" },
	                _react2.default.createElement(_Bill2.default, { key: bill.id, bill: bill })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Bills;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bills: state.bill.bills,
	    category_bills: state.bill.category_bills
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getBills: _billActions.getBills, getCategoryBills: _billActions.getCategoryBills })(Bills);

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactMaterialize = __webpack_require__(12);
	
	var _billActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditBill = function (_Component) {
	  _inherits(EditBill, _Component);
	
	  function EditBill() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditBill);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditBill.__proto__ || Object.getPrototypeOf(EditBill)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      amount: "",
	      category: "",
	      description: "",
	      date: ""
	    }, _this.handleAmount = function (event) {
	      _this.setState({ amount: event.target.value });
	    }, _this.handleCategory = function (event) {
	      _this.setState({ category: event.target.value });
	    }, _this.handleDescription = function (event) {
	      _this.setState({ description: event.target.value });
	    }, _this.handleDate = function (event) {
	      _this.setState({ date: event.target.value });
	    }, _this.onSubmit = function (event) {
	
	      event.preventDefault();
	      var _this$state = _this.state,
	          amount = _this$state.amount,
	          category = _this$state.category,
	          date = _this$state.date,
	          description = _this$state.description;
	
	
	      var updatedBill = {
	        id: _this.props.match.params.id,
	        description: description,
	        category: category,
	        amount: amount,
	        date: date
	      };
	
	      _this.props.updateBill(updatedBill);
	
	      _this.setState({
	        amount: "",
	        category: "",
	        date: "",
	        description: ""
	      });
	
	      _this.props.history.push("/");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditBill, [{
	    key: "componentDidMount",
	
	
	    //fetching bill data with id given
	    value: function componentDidMount() {
	      var id = this.props.match.params.id;
	
	      this.props.getBill(id);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      //updating state with fetched bill data, so that old values can be shown in input fields of the form
	      var _nextProps$bill = nextProps.bill,
	          amount = _nextProps$bill.amount,
	          category = _nextProps$bill.category,
	          description = _nextProps$bill.description,
	          date = _nextProps$bill.date;
	
	      this.setState({ amount: amount, category: category, description: description, date: date });
	    }
	
	    //functions to handle input changes in form
	
	
	    //updating bill data with given id, in the list of bills
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          amount = _state.amount,
	          category = _state.category,
	          date = _state.date,
	          description = _state.description;
	
	
	      return _react2.default.createElement(
	        _reactMaterialize.Row,
	        null,
	        _react2.default.createElement(_reactMaterialize.Col, { m: 4 }),
	        _react2.default.createElement(
	          _reactMaterialize.Col,
	          { m: 6, l: 4, s: 12 },
	          _react2.default.createElement(
	            _reactMaterialize.Card,
	            { className: "margin-top" },
	            _react2.default.createElement(
	              "h5",
	              { className: "heading" },
	              "Update Bill"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: amount, type: "number", placeholder: "Enter Amount",
	                onChange: this.handleAmount, label: "amount" })
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: category, type: "text", placeholder: "Enter Category",
	                onChange: this.handleCategory, label: "category" })
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: description, type: "text", placeholder: "Enter Description",
	                onChange: this.handleDescription, label: "description" })
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_reactMaterialize.TextInput, { value: date, type: "date", placeholder: "Enter Date",
	                onChange: this.handleDate, label: "date" })
	            ),
	            _react2.default.createElement(
	              _reactMaterialize.Button,
	              { waves: "light", onClick: this.onSubmit },
	              "Update"
	            )
	          )
	        ),
	        _react2.default.createElement(_reactMaterialize.Col, { m: 4 })
	      );
	    }
	  }]);
	
	  return EditBill;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bill: state.bill.bill
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getBill: _billActions.getBill, updateBill: _billActions.updateBill })(EditBill);

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canvasjs = __webpack_require__(85);
	
	var _canvasjs2 = _interopRequireDefault(_canvasjs);
	
	var _reactRedux = __webpack_require__(10);
	
	var _billActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CanvasJS = _canvasjs2.default.CanvasJS;
	var CanvasJSChart = _canvasjs2.default.CanvasJSChart;
	
	var Chart = function (_Component) {
	    _inherits(Chart, _Component);
	
	    function Chart() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Chart);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chart.__proto__ || Object.getPrototypeOf(Chart)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	            _this.props.getBills();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Chart, [{
	        key: "render",
	        value: function render() {
	            var bills = this.props.bills;
	
	            //building data for chart
	
	            var data = bills.map(function (bill) {
	                var s = bill.date;
	                var p = parseInt(s[3]);
	                var q = parseInt(s[4]);
	                var r = p * 10 + q;
	                return { x: r, y: parseInt(bill.amount) };
	            });
	
	            var options = {
	                animationEnabled: true,
	                exportEnabled: true,
	                theme: "light2",
	                title: {
	                    text: "Time-series chart of the monthly billing cycle",
	                    fontSize: 20
	                },
	                axisY: {
	                    title: "Amount Spent",
	                    fontSize: 10,
	                    suffix: " Rs"
	                },
	                axisX: {
	                    title: "Day",
	                    fontSize: 10,
	                    suffix: " Jan",
	                    interval: 2
	                },
	                data: [{
	                    type: "line",
	                    toolTipContent: "{x} Jan: {y} Rs",
	                    dataPoints: data
	                }]
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { style: { marginTop: "25px" }, className: "container" },
	                _react2.default.createElement(CanvasJSChart, { options: options })
	            );
	        }
	    }]);
	
	    return Chart;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        bills: state.bill.bills
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getBills: _billActions.getBills })(Chart);

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 CanvasJS HTML5 & JavaScript Charts - v2.3.2 GA - https://canvasjs.com/ 
	 Copyright 2018 fenopix
	
	  --------------------- License Information --------------------
	 CanvasJS is a commercial product which requires purchase of license. Without a commercial license you can use it for evaluation purposes for upto 30 days. Please refer to the following link for further details.
	     https://canvasjs.com/license/
	
	*/
	/*eslint-disable*/
	/*jshint ignore:start*/
	(function () {
	  function qa(h, p) {
	    h.prototype = eb(p.prototype);h.prototype.constructor = h;h.base = p.prototype;
	  }function eb(h) {
	    function p() {}p.prototype = h;return new p();
	  }function Ya(h, p, D) {
	    "millisecond" === D ? h.setMilliseconds(h.getMilliseconds() + 1 * p) : "second" === D ? h.setSeconds(h.getSeconds() + 1 * p) : "minute" === D ? h.setMinutes(h.getMinutes() + 1 * p) : "hour" === D ? h.setHours(h.getHours() + 1 * p) : "day" === D ? h.setDate(h.getDate() + 1 * p) : "week" === D ? h.setDate(h.getDate() + 7 * p) : "month" === D ? h.setMonth(h.getMonth() + 1 * p) : "year" === D && h.setFullYear(h.getFullYear() + 1 * p);return h;
	  }function $(h, p) {
	    var D = !1;0 > h && (D = !0, h *= -1);h = "" + h;for (p = p ? p : 1; h.length < p;) {
	      h = "0" + h;
	    }return D ? "-" + h : h;
	  }function Ia(h) {
	    if (!h) return h;h = h.replace(/^\s\s*/, "");for (var p = /\s/, D = h.length; p.test(h.charAt(--D));) {}return h.slice(0, D + 1);
	  }function Ea(h) {
	    h.roundRect = function (h, D, r, u, H, F, z, v) {
	      z && (this.fillStyle = z);v && (this.strokeStyle = v);"undefined" === typeof H && (H = 5);this.lineWidth = F;this.beginPath();this.moveTo(h + H, D);this.lineTo(h + r - H, D);this.quadraticCurveTo(h + r, D, h + r, D + H);this.lineTo(h + r, D + u - H);
	      this.quadraticCurveTo(h + r, D + u, h + r - H, D + u);this.lineTo(h + H, D + u);this.quadraticCurveTo(h, D + u, h, D + u - H);this.lineTo(h, D + H);this.quadraticCurveTo(h, D, h + H, D);this.closePath();z && this.fill();v && 0 < F && this.stroke();
	    };
	  }function Sa(h, p) {
	    return h - p;
	  }function Ta(h, p, D) {
	    if (h && p && D) {
	      D = D + "." + p;var r = "image/" + p;h = h.toDataURL(r);var u = !1,
	          H = document.createElement("a");H.download = D;H.href = h;if ("undefined" !== typeof Blob && new Blob()) {
	        for (var F = h.replace(/^data:[a-z\/]*;base64,/, ""), F = atob(F), z = new ArrayBuffer(F.length), z = new Uint8Array(z), v = 0; v < F.length; v++) {
	          z[v] = F.charCodeAt(v);
	        }p = new Blob([z.buffer], { type: "image/" + p });try {
	          window.navigator.msSaveBlob(p, D), u = !0;
	        } catch (L) {
	          H.dataset.downloadurl = [r, H.download, H.href].join(":"), H.href = window.URL.createObjectURL(p);
	        }
	      }if (!u) try {
	        event = document.createEvent("MouseEvents"), event.initMouseEvent("click", !0, !1, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), H.dispatchEvent ? H.dispatchEvent(event) : H.fireEvent && H.fireEvent("onclick");
	      } catch (E) {
	        p = window.open(), p.document.write("<img src='" + h + "'></img><div>Please right click on the image and save it to your device</div>"), p.document.close();
	      }
	    }
	  }function N(h) {
	    var p = ((h & 16711680) >> 16).toString(16),
	        D = ((h & 65280) >> 8).toString(16);h = ((h & 255) >> 0).toString(16);p = 2 > p.length ? "0" + p : p;D = 2 > D.length ? "0" + D : D;h = 2 > h.length ? "0" + h : h;return "#" + p + D + h;
	  }function fb(h, p) {
	    var D = this.length >>> 0,
	        r = Number(p) || 0,
	        r = 0 > r ? Math.ceil(r) : Math.floor(r);for (0 > r && (r += D); r < D; r++) {
	      if (r in this && this[r] === h) return r;
	    }return -1;
	  }function u(h) {
	    return null === h || "undefined" === typeof h;
	  }function Fa(h) {
	    h.indexOf || (h.indexOf = fb);return h;
	  }function gb(h) {
	    if (U.fSDec) h[ja("`eeDwdouMhrudods")](ja("e`u`@ohl`uhnoHuds`uhnoDoe"), function () {
	      U._fTWm && U._fTWm(h);
	    });
	  }function Za(h, p, D) {
	    D = D || "normal";var r = h + "_" + p + "_" + D,
	        u = $a[r];if (isNaN(u)) {
	      try {
	        h = "position:absolute; left:0px; top:-20000px; padding:0px;margin:0px;border:none;white-space:pre;line-height:normal;font-family:" + h + "; font-size:" + p + "px; font-weight:" + D + ";";if (!xa) {
	          var H = document.body;xa = document.createElement("span");xa.innerHTML = "";var F = document.createTextNode("Mpgyi");xa.appendChild(F);H.appendChild(xa);
	        }xa.style.display = "";xa.setAttribute("style", h);u = Math.round(xa.offsetHeight);
	        xa.style.display = "none";
	      } catch (z) {
	        u = Math.ceil(1.1 * p);
	      }u = Math.max(u, p);$a[r] = u;
	    }return u;
	  }function R(h, p) {
	    var D = [];if (D = { solid: [], shortDash: [3, 1], shortDot: [1, 1], shortDashDot: [3, 1, 1, 1], shortDashDotDot: [3, 1, 1, 1, 1, 1], dot: [1, 2], dash: [4, 2], dashDot: [4, 2, 1, 2], longDash: [8, 2], longDashDot: [8, 2, 1, 2], longDashDotDot: [8, 2, 1, 2, 1, 2] }[h || "solid"]) for (var r = 0; r < D.length; r++) {
	      D[r] *= p;
	    } else D = [];return D;
	  }function O(h, p, D, r, u) {
	    r = r || [];u = u || !1;r.push([h, p, D, u]);return h.addEventListener ? (h.addEventListener(p, D, u), D) : h.attachEvent ? (r = function r(p) {
	      p = p || window.event;p.preventDefault = p.preventDefault || function () {
	        p.returnValue = !1;
	      };p.stopPropagation = p.stopPropagation || function () {
	        p.cancelBubble = !0;
	      };D.call(h, p);
	    }, h.attachEvent("on" + p, r), r) : !1;
	  }function ab(h, p, D) {
	    h *= W;p *= W;h = D.getImageData(h, p, 2, 2).data;p = !0;for (D = 0; 4 > D; D++) {
	      if (h[D] !== h[D + 4] | h[D] !== h[D + 8] | h[D] !== h[D + 12]) {
	        p = !1;break;
	      }
	    }return p ? h[0] << 16 | h[1] << 8 | h[2] : 0;
	  }function na(h, p, D) {
	    return h in p ? p[h] : D[h];
	  }function Oa(h, p, D) {
	    if (r && bb) {
	      var u = h.getContext("2d");Pa = u.webkitBackingStorePixelRatio || u.mozBackingStorePixelRatio || u.msBackingStorePixelRatio || u.oBackingStorePixelRatio || u.backingStorePixelRatio || 1;W = Ua / Pa;h.width = p * W;h.height = D * W;Ua !== Pa && (h.style.width = p + "px", h.style.height = D + "px", u.scale(W, W));
	    } else h.width = p, h.height = D;
	  }function hb(h) {
	    if (!ib) {
	      var p = !1,
	          D = !1;"undefined" === typeof ra.Chart.creditHref ? (h.creditHref = ja("iuuqr;..b`ow`rkr/bnl."), h.creditText = ja("B`ow`rKR/bnl")) : (p = h.updateOption("creditText"), D = h.updateOption("creditHref"));if (h.creditHref && h.creditText) {
	        h._creditLink || (h._creditLink = document.createElement("a"), h._creditLink.setAttribute("class", "canvasjs-chart-credit"), h._creditLink.setAttribute("title", "JavaScript Charts"), h._creditLink.setAttribute("style", "outline:none;margin:0px;position:absolute;right:2px;top:" + (h.height - 14) + "px;color:dimgrey;text-decoration:none;font-size:11px;font-family: Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif"), h._creditLink.setAttribute("tabIndex", -1), h._creditLink.setAttribute("target", "_blank"));if (0 === h.renderCount || p || D) h._creditLink.setAttribute("href", h.creditHref), h._creditLink.innerHTML = h.creditText;h._creditLink && h.creditHref && h.creditText ? (h._creditLink.parentElement || h._canvasJSContainer.appendChild(h._creditLink), h._creditLink.style.top = h.height - 14 + "px") : h._creditLink.parentElement && h._canvasJSContainer.removeChild(h._creditLink);
	      }
	    }
	  }function ta(h, p) {
	    Ja && (this.canvasCount |= 0, window.console.log(++this.canvasCount));var D = document.createElement("canvas");D.setAttribute("class", "canvasjs-chart-canvas");Oa(D, h, p);r || "undefined" === typeof G_vmlCanvasManager || G_vmlCanvasManager.initElement(D);return D;
	  }function sa(h, p, D) {
	    for (var r in D) {
	      p.style[r] = D[r];
	    }
	  }function ua(h, p, D) {
	    p.getAttribute("state") || (p.style.backgroundColor = h.toolbar.backgroundColor, p.style.color = h.toolbar.fontColor, p.style.border = "none", sa(h, p, { WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none", userSelect: "none" }));p.getAttribute("state") !== D && (p.setAttribute("state", D), p.setAttribute("type", "button"), sa(h, p, { padding: "5px 12px",
	      cursor: "pointer", "float": "left", width: "40px", height: "25px", outline: "0px", verticalAlign: "baseline", lineHeight: "0" }), p.setAttribute("title", h._cultureInfo[D + "Text"]), p.innerHTML = "<img style='height:95%; pointer-events: none;' src='" + jb[D].image + "' alt='" + h._cultureInfo[D + "Text"] + "' />");
	  }function Qa() {
	    for (var h = null, p = 0; p < arguments.length; p++) {
	      h = arguments[p], h.style && (h.style.display = "inline");
	    }
	  }function va() {
	    for (var h = null, p = 0; p < arguments.length; p++) {
	      (h = arguments[p]) && h.style && (h.style.display = "none");
	    }
	  }
	  function V(h, p, D, r, v) {
	    this._defaultsKey = h;this._themeOptionsKey = p;this._index = r;this.parent = v;this._eventListeners = [];h = {};this.theme && u(p) && u(r) ? h = u(ya[this.theme]) ? ya.light1 : ya[this.theme] : this.parent && this.parent.themeOptions && this.parent.themeOptions[p] && (null === r ? h = this.parent.themeOptions[p] : 0 < this.parent.themeOptions[p].length && (r = Math.min(this.parent.themeOptions[p].length - 1, r), h = this.parent.themeOptions[p][r]));this.themeOptions = h;this.options = D ? D : { _isPlaceholder: !0 };this.setOptions(this.options, h);
	  }function Ga(h, p, r, u, v) {
	    "undefined" === typeof v && (v = 0);this._padding = v;this._x1 = h;this._y1 = p;this._x2 = r;this._y2 = u;this._rightOccupied = this._leftOccupied = this._bottomOccupied = this._topOccupied = this._padding;
	  }function ka(h, p) {
	    ka.base.constructor.call(this, "TextBlock", null, p, null, null);this.ctx = h;this._isDirty = !0;this._wrappedText = null;this._initialize();
	  }function Va(h, p) {
	    Va.base.constructor.call(this, "Toolbar", "toolbar", p, null, h);this.chart = h;this.canvas = h.canvas;this.ctx = this.chart.ctx;this.optionsName = "toolbar";
	  }function Aa(h, p) {
	    Aa.base.constructor.call(this, "Title", "title", p, null, h);this.chart = h;this.canvas = h.canvas;this.ctx = this.chart.ctx;this.optionsName = "title";if (u(this.options.margin) && h.options.subtitles) for (var r = h.options.subtitles, za = 0; za < r.length; za++) {
	      if ((u(r[za].horizontalAlign) && "center" === this.horizontalAlign || r[za].horizontalAlign === this.horizontalAlign) && (u(r[za].verticalAlign) && "top" === this.verticalAlign || r[za].verticalAlign === this.verticalAlign) && !r[za].dockInsidePlotArea === !this.dockInsidePlotArea) {
	        this.margin = 0;break;
	      }
	    }"undefined" === typeof this.options.fontSize && (this.fontSize = this.chart.getAutoFontSize(this.fontSize));this.height = this.width = null;this.bounds = { x1: null, y1: null, x2: null, y2: null };
	  }function Ka(h, p, r) {
	    Ka.base.constructor.call(this, "Subtitle", "subtitles", p, r, h);this.chart = h;this.canvas = h.canvas;this.ctx = this.chart.ctx;this.optionsName = "subtitles";this.isOptionsInArray = !0;"undefined" === typeof this.options.fontSize && (this.fontSize = this.chart.getAutoFontSize(this.fontSize));this.height = this.width = null;
	    this.bounds = { x1: null, y1: null, x2: null, y2: null };
	  }function Wa() {
	    this.pool = [];
	  }function La(h) {
	    var p;h && Ma[h] && (p = Ma[h]);La.base.constructor.call(this, "CultureInfo", null, p, null, null);
	  }var Ja = !1,
	      U = {},
	      r = !!document.createElement("canvas").getContext,
	      ra = { Chart: { width: 500, height: 400, zoomEnabled: !1, zoomType: "x", backgroundColor: "white", theme: "light1", animationEnabled: !1, animationDuration: 1200, dataPointWidth: null, dataPointMinWidth: null, dataPointMaxWidth: null, colorSet: "colorSet1", culture: "en", creditHref: "", creditText: "CanvasJS",
	      interactivityEnabled: !0, exportEnabled: !1, exportFileName: "Chart", rangeChanging: null, rangeChanged: null, publicProperties: { title: "readWrite", subtitles: "readWrite", toolbar: "readWrite", toolTip: "readWrite", legend: "readWrite", axisX: "readWrite", axisY: "readWrite", axisX2: "readWrite", axisY2: "readWrite", data: "readWrite", options: "readWrite", bounds: "readOnly", container: "readOnly" } }, Title: { padding: 0, text: null, verticalAlign: "top", horizontalAlign: "center", fontSize: 20, fontFamily: "Calibri", fontWeight: "normal", fontColor: "black",
	      fontStyle: "normal", borderThickness: 0, borderColor: "black", cornerRadius: 0, backgroundColor: r ? "transparent" : null, margin: 5, wrap: !0, maxWidth: null, dockInsidePlotArea: !1, publicProperties: { options: "readWrite", bounds: "readOnly", chart: "readOnly" } }, Subtitle: { padding: 0, text: null, verticalAlign: "top", horizontalAlign: "center", fontSize: 14, fontFamily: "Calibri", fontWeight: "normal", fontColor: "black", fontStyle: "normal", borderThickness: 0, borderColor: "black", cornerRadius: 0, backgroundColor: null, margin: 2, wrap: !0, maxWidth: null,
	      dockInsidePlotArea: !1, publicProperties: { options: "readWrite", bounds: "readOnly", chart: "readOnly" } }, Toolbar: { backgroundColor: "white", backgroundColorOnHover: "#2196f3", borderColor: "#2196f3", borderThickness: 1, fontColor: "black", fontColorOnHover: "white", publicProperties: { options: "readWrite", chart: "readOnly" } }, Legend: { name: null, verticalAlign: "center", horizontalAlign: "right", fontSize: 14, fontFamily: "calibri", fontWeight: "normal", fontColor: "black", fontStyle: "normal", cursor: null, itemmouseover: null, itemmouseout: null,
	      itemmousemove: null, itemclick: null, dockInsidePlotArea: !1, reversed: !1, backgroundColor: r ? "transparent" : null, borderColor: r ? "transparent" : null, borderThickness: 0, cornerRadius: 0, maxWidth: null, maxHeight: null, markerMargin: null, itemMaxWidth: null, itemWidth: null, itemWrap: !0, itemTextFormatter: null, publicProperties: { options: "readWrite", bounds: "readOnly", chart: "readOnly" } }, ToolTip: { enabled: !0, shared: !1, animationEnabled: !0, content: null, contentFormatter: null, reversed: !1, backgroundColor: r ? "rgba(255,255,255,.9)" : "rgb(255,255,255)",
	      borderColor: null, borderThickness: 2, cornerRadius: 5, fontSize: 14, fontColor: "black", fontFamily: "Calibri, Arial, Georgia, serif;", fontWeight: "normal", fontStyle: "italic", publicProperties: { options: "readWrite", chart: "readOnly" } }, Axis: { minimum: null, maximum: null, viewportMinimum: null, viewportMaximum: null, interval: null, intervalType: null, reversed: !1, logarithmic: !1, logarithmBase: 10, title: null, titleFontColor: "black", titleFontSize: 20, titleFontFamily: "arial", titleFontWeight: "normal", titleFontStyle: "normal", titleWrap: !0,
	      titleMaxWidth: null, titleBackgroundColor: r ? "transparent" : null, titleBorderColor: r ? "transparent" : null, titleBorderThickness: 0, titleCornerRadius: 0, labelAngle: 0, labelFontFamily: "arial", labelFontColor: "black", labelFontSize: 12, labelFontWeight: "normal", labelFontStyle: "normal", labelAutoFit: !0, labelWrap: !0, labelMaxWidth: null, labelFormatter: null, labelBackgroundColor: r ? "transparent" : null, labelBorderColor: r ? "transparent" : null, labelBorderThickness: 0, labelCornerRadius: 0, labelPlacement: "outside", prefix: "", suffix: "",
	      includeZero: !0, tickLength: 5, tickColor: "black", tickThickness: 1, lineColor: "black", lineThickness: 1, lineDashType: "solid", gridColor: "A0A0A0", gridThickness: 0, gridDashType: "solid", interlacedColor: r ? "transparent" : null, valueFormatString: null, margin: 2, publicProperties: { options: "readWrite", stripLines: "readWrite", scaleBreaks: "readWrite", crosshair: "readWrite", bounds: "readOnly", chart: "readOnly" } }, StripLine: { value: null, startValue: null, endValue: null, color: "orange", opacity: null, thickness: 2, lineDashType: "solid", label: "",
	      labelPlacement: "inside", labelAlign: "far", labelWrap: !0, labelMaxWidth: null, labelBackgroundColor: null, labelBorderColor: r ? "transparent" : null, labelBorderThickness: 0, labelCornerRadius: 0, labelFontFamily: "arial", labelFontColor: "orange", labelFontSize: 12, labelFontWeight: "normal", labelFontStyle: "normal", labelFormatter: null, showOnTop: !1, publicProperties: { options: "readWrite", axis: "readOnly", bounds: "readOnly", chart: "readOnly" } }, ScaleBreaks: { autoCalculate: !1, collapsibleThreshold: "25%", maxNumberOfAutoBreaks: 2, spacing: 8,
	      type: "straight", color: "#FFFFFF", fillOpacity: 0.9, lineThickness: 2, lineColor: "#E16E6E", lineDashType: "solid", publicProperties: { options: "readWrite", customBreaks: "readWrite", axis: "readOnly", autoBreaks: "readOnly", bounds: "readOnly", chart: "readOnly" } }, Break: { startValue: null, endValue: null, spacing: 8, type: "straight", color: "#FFFFFF", fillOpacity: 0.9, lineThickness: 2, lineColor: "#E16E6E", lineDashType: "solid", publicProperties: { options: "readWrite", scaleBreaks: "readOnly", bounds: "readOnly", chart: "readOnly" } }, Crosshair: { enabled: !1,
	      snapToDataPoint: !1, color: "grey", opacity: null, thickness: 2, lineDashType: "solid", label: "", labelWrap: !0, labelMaxWidth: null, labelBackgroundColor: r ? "grey" : null, labelBorderColor: r ? "grey" : null, labelBorderThickness: 0, labelCornerRadius: 0, labelFontFamily: r ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri", labelFontSize: 12, labelFontColor: "#fff", labelFontWeight: "normal", labelFontStyle: "normal", labelFormatter: null, valueFormatString: null, publicProperties: { options: "readWrite", axis: "readOnly", bounds: "readOnly",
	        chart: "readOnly" } }, DataSeries: { name: null, dataPoints: null, label: "", bevelEnabled: !1, highlightEnabled: !0, cursor: "default", indexLabel: "", indexLabelPlacement: "auto", indexLabelOrientation: "horizontal", indexLabelFontColor: "black", indexLabelFontSize: 12, indexLabelFontStyle: "normal", indexLabelFontFamily: "Arial", indexLabelFontWeight: "normal", indexLabelBackgroundColor: null, indexLabelLineColor: "gray", indexLabelLineThickness: 1, indexLabelLineDashType: "solid", indexLabelMaxWidth: null, indexLabelWrap: !0, indexLabelFormatter: null,
	      lineThickness: 2, lineDashType: "solid", connectNullData: !1, nullDataLineDashType: "dash", color: null, lineColor: null, risingColor: "white", fallingColor: "red", fillOpacity: null, startAngle: 0, radius: null, innerRadius: null, neckHeight: null, neckWidth: null, reversed: !1, valueRepresents: null, linkedDataSeriesIndex: null, whiskerThickness: 2, whiskerDashType: "solid", whiskerColor: null, whiskerLength: null, stemThickness: 2, stemColor: null, stemDashType: "solid", upperBoxColor: "white", lowerBoxColor: "white", type: "column", xValueType: "number",
	      axisXType: "primary", axisYType: "primary", axisXIndex: 0, axisYIndex: 0, xValueFormatString: null, yValueFormatString: null, zValueFormatString: null, percentFormatString: null, showInLegend: null, legendMarkerType: null, legendMarkerColor: null, legendText: null, legendMarkerBorderColor: r ? "transparent" : null, legendMarkerBorderThickness: 0, markerType: "circle", markerColor: null, markerSize: null, markerBorderColor: r ? "transparent" : null, markerBorderThickness: 0, mouseover: null, mouseout: null, mousemove: null, click: null, toolTipContent: null,
	      visible: !0, publicProperties: { options: "readWrite", axisX: "readWrite", axisY: "readWrite", chart: "readOnly" } }, TextBlock: { x: 0, y: 0, width: null, height: null, maxWidth: null, maxHeight: null, padding: 0, angle: 0, text: "", horizontalAlign: "center", fontSize: 12, fontFamily: "calibri", fontWeight: "normal", fontColor: "black", fontStyle: "normal", borderThickness: 0, borderColor: "black", cornerRadius: 0, backgroundColor: null, textBaseline: "top" }, CultureInfo: { decimalSeparator: ".", digitGroupSeparator: ",", zoomText: "Zoom", panText: "Pan", resetText: "Reset",
	      menuText: "More Options", saveJPGText: "Save as JPEG", savePNGText: "Save as PNG", printText: "Print", days: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), shortDays: "Sun Mon Tue Wed Thu Fri Sat".split(" "), months: "January February March April May June July August September October November December".split(" "), shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ") } },
	      Ma = { en: {} },
	      v = r ? "Trebuchet MS, Helvetica, sans-serif" : "Arial",
	      Ha = r ? "Impact, Charcoal, sans-serif" : "Arial",
	      Ba = { colorSet1: "#4F81BC #C0504E #9BBB58 #23BFAA #8064A1 #4AACC5 #F79647 #7F6084 #77A033 #33558B #E59566".split(" "), colorSet2: "#6D78AD #51CDA0 #DF7970 #4C9CA0 #AE7D99 #C9D45C #5592AD #DF874D #52BCA8 #8E7AA3 #E3CB64 #C77B85 #C39762 #8DD17E #B57952 #FCC26C".split(" "), colorSet3: "#8CA1BC #36845C #017E82 #8CB9D0 #708C98 #94838D #F08891 #0366A7 #008276 #EE7757 #E5BA3A #F2990B #03557B #782970".split(" ") },
	      I,
	      fa,
	      Q,
	      ha,
	      ga;fa = "#333333";Q = "#000000";I = "#666666";ga = ha = "#000000";var X = 20,
	      E = 14,
	      Xa = { colorSet: "colorSet1",
	    backgroundColor: "#FFFFFF", title: { fontFamily: Ha, fontSize: 32, fontColor: fa, fontWeight: "normal", verticalAlign: "top", margin: 5 }, subtitles: [{ fontFamily: Ha, fontSize: E, fontColor: fa, fontWeight: "normal", verticalAlign: "top", margin: 5 }], data: [{ indexLabelFontFamily: v, indexLabelFontSize: E, indexLabelFontColor: fa, indexLabelFontWeight: "normal", indexLabelLineThickness: 1 }], axisX: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: fa, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal",
	      lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 0, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], axisX2: [{ titleFontFamily: v,
	      titleFontSize: X, titleFontColor: fa, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 0, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1,
	        lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], axisY: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: fa, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 1, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300",
	        thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], axisY2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: fa, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 1,
	      gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], legend: { fontFamily: v, fontSize: 14, fontColor: fa, fontWeight: "bold", verticalAlign: "bottom",
	      horizontalAlign: "center" }, toolTip: { fontFamily: v, fontSize: 14, fontStyle: "normal", cornerRadius: 0, borderThickness: 1 } };Q = fa = "#F5F5F5";I = "#FFFFFF";ha = "#40BAF1";ga = "#F5F5F5";var X = 20,
	      E = 14,
	      cb = { colorSet: "colorSet2", title: { fontFamily: v, fontSize: 33, fontColor: "#3A3A3A", fontWeight: "bold", verticalAlign: "top", margin: 5 }, subtitles: [{ fontFamily: v, fontSize: E, fontColor: "#3A3A3A", fontWeight: "normal", verticalAlign: "top", margin: 5 }], data: [{ indexLabelFontFamily: v, indexLabelFontSize: E, indexLabelFontColor: "#666666", indexLabelFontWeight: "normal",
	      indexLabelLineThickness: 1 }], axisX: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: "#666666", titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: "#666666", labelFontWeight: "normal", lineThickness: 1, lineColor: "#BBBBBB", tickThickness: 1, tickColor: "#BBBBBB", gridThickness: 1, gridColor: "#BBBBBB", stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FFA500", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FFA500", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E,
	        labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: "black", color: "black", thickness: 1, lineDashType: "dot" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], axisX2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: "#666666", titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: "#666666", labelFontWeight: "normal", lineThickness: 1, lineColor: "#BBBBBB", tickColor: "#BBBBBB", tickThickness: 1, gridThickness: 1, gridColor: "#BBBBBB",
	      stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FFA500", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FFA500", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: "black", color: "black", thickness: 1, lineDashType: "dot" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], axisY: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: "#666666", titleFontWeight: "normal",
	      labelFontFamily: v, labelFontSize: E, labelFontColor: "#666666", labelFontWeight: "normal", lineThickness: 0, lineColor: "#BBBBBB", tickColor: "#BBBBBB", tickThickness: 1, gridThickness: 1, gridColor: "#BBBBBB", stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FFA500", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FFA500", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: "black", color: "black", thickness: 1, lineDashType: "dot" },
	      scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], axisY2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: "#666666", titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: "#666666", labelFontWeight: "normal", lineThickness: 0, lineColor: "#BBBBBB", tickColor: "#BBBBBB", tickThickness: 1, gridThickness: 1, gridColor: "#BBBBBB", stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FFA500", labelFontWeight: "normal", labelBackgroundColor: null,
	        color: "#FFA500", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#EEEEEE", labelFontWeight: "normal", labelBackgroundColor: "black", color: "black", thickness: 1, lineDashType: "dot" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#BBBBBB", lineThickness: 1, lineDashType: "solid" } }], legend: { fontFamily: v, fontSize: 14, fontColor: "#3A3A3A", fontWeight: "bold", verticalAlign: "bottom", horizontalAlign: "center" }, toolTip: { fontFamily: v, fontSize: 14, fontStyle: "normal", cornerRadius: 0, borderThickness: 1 } };
	  Q = fa = "#F5F5F5";I = "#FFFFFF";ha = "#40BAF1";ga = "#F5F5F5";X = 20;E = 14;Ha = { colorSet: "colorSet12", backgroundColor: "#2A2A2A", title: { fontFamily: Ha, fontSize: 32, fontColor: fa, fontWeight: "normal", verticalAlign: "top", margin: 5 }, subtitles: [{ fontFamily: Ha, fontSize: E, fontColor: fa, fontWeight: "normal", verticalAlign: "top", margin: 5 }], toolbar: { backgroundColor: "#666666", backgroundColorOnHover: "#FF7372", borderColor: "#FF7372", borderThickness: 1, fontColor: "#F5F5F5", fontColorOnHover: "#F5F5F5" }, data: [{ indexLabelFontFamily: v, indexLabelFontSize: E,
	      indexLabelFontColor: Q, indexLabelFontWeight: "normal", indexLabelLineThickness: 1 }], axisX: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 0, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v,
	        labelFontSize: E, labelFontColor: "#000000", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777", lineThickness: 1, lineDashType: "solid", color: "#111111" } }], axisX2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 0, gridColor: I, stripLines: [{ labelFontFamily: v,
	        labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#000000", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777", lineThickness: 1, lineDashType: "solid", color: "#111111" } }], axisY: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v,
	      labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 1, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#000000", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777",
	        lineThickness: 1, lineDashType: "solid", color: "#111111" } }], axisY2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 1, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#000000",
	        labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777", lineThickness: 1, lineDashType: "solid", color: "#111111" } }], legend: { fontFamily: v, fontSize: 14, fontColor: fa, fontWeight: "bold", verticalAlign: "bottom", horizontalAlign: "center" }, toolTip: { fontFamily: v, fontSize: 14, fontStyle: "normal", cornerRadius: 0, borderThickness: 1, fontColor: Q, backgroundColor: "rgba(0, 0, 0, .7)" } };I = "#FFFFFF";Q = fa = "#FAFAFA";ha = "#40BAF1";ga = "#F5F5F5";
	  var X = 20,
	      E = 14,
	      ya = { light1: Xa, light2: cb, dark1: Ha, dark2: { colorSet: "colorSet2", backgroundColor: "#32373A", title: { fontFamily: v, fontSize: 32, fontColor: fa, fontWeight: "normal", verticalAlign: "top", margin: 5 }, subtitles: [{ fontFamily: v, fontSize: E, fontColor: fa, fontWeight: "normal", verticalAlign: "top", margin: 5 }], toolbar: { backgroundColor: "#666666", backgroundColorOnHover: "#FF7372", borderColor: "#FF7372", borderThickness: 1, fontColor: "#F5F5F5", fontColorOnHover: "#F5F5F5" }, data: [{ indexLabelFontFamily: v, indexLabelFontSize: E,
	        indexLabelFontColor: Q, indexLabelFontWeight: "normal", indexLabelLineThickness: 1 }], axisX: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 0, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v,
	          labelFontSize: E, labelFontColor: "#000000", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777", lineThickness: 1, lineDashType: "solid", color: "#111111" } }], axisX2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 1, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 0, gridColor: I, stripLines: [{ labelFontFamily: v,
	          labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#000000", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777", lineThickness: 1, lineDashType: "solid", color: "#111111" } }], axisY: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v,
	        labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 0, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 1, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#000000", labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777",
	          lineThickness: 1, lineDashType: "solid", color: "#111111" } }], axisY2: [{ titleFontFamily: v, titleFontSize: X, titleFontColor: Q, titleFontWeight: "normal", labelFontFamily: v, labelFontSize: E, labelFontColor: Q, labelFontWeight: "normal", lineThickness: 0, lineColor: I, tickThickness: 1, tickColor: I, gridThickness: 1, gridColor: I, stripLines: [{ labelFontFamily: v, labelFontSize: E, labelFontColor: "#FF7300", labelFontWeight: "normal", labelBackgroundColor: null, color: "#FF7300", thickness: 1 }], crosshair: { labelFontFamily: v, labelFontSize: E, labelFontColor: "#000000",
	          labelFontWeight: "normal", labelBackgroundColor: ga, color: ha, thickness: 1, lineDashType: "dash" }, scaleBreaks: { type: "zigzag", spacing: "2%", lineColor: "#777777", lineThickness: 1, lineDashType: "solid", color: "#111111" } }], legend: { fontFamily: v, fontSize: 14, fontColor: fa, fontWeight: "bold", verticalAlign: "bottom", horizontalAlign: "center" }, toolTip: { fontFamily: v, fontSize: 14, fontStyle: "normal", cornerRadius: 0, borderThickness: 1, fontColor: Q, backgroundColor: "rgba(0, 0, 0, .7)" } }, theme1: Xa, theme2: cb, theme3: Xa },
	      S = { numberDuration: 1,
	    yearDuration: 314496E5, monthDuration: 2592E6, weekDuration: 6048E5, dayDuration: 864E5, hourDuration: 36E5, minuteDuration: 6E4, secondDuration: 1E3, millisecondDuration: 1, dayOfWeekFromInt: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" ") };(function () {
	    U.fSDec = function (h) {
	      for (var p = "", r = 0; r < h.length; r++) {
	        p += String.fromCharCode(Math.ceil(h.length / 57 / 5) ^ h.charCodeAt(r));
	      }return p;
	    };U.obj = { trVs: "Ush`m!Wdsrhno", fntStr: "qy!B`mhcsh-!Mtbhe`!Fs`oed-!Mtbhe`!R`or!Tohbned-!@sh`m-!r`or,rdshg", txtBl: "udyuC`rdmhod",
	      fnt: "gnou", fSy: "ghmmRuxmd", fTx: "ghmmUdyu", grClr: "fsdx", cntx: "buy", tp: "unq" };delete ra[U.fSDec("Bi`su")][U.fSDec("bsdehuIsdg")];U.pro = { sCH: ra[U.fSDec("Bi`su")][U.fSDec("bsdehuIsdg")] };U._fTWm = function (h) {
	      if ("undefined" === typeof U.pro.sCH && !db) try {
	        var p = h[U.fSDec(U.obj.cntx)];p[U.fSDec(U.obj.txtBl)] = U.fSDec(U.obj.tp);p[U.fSDec(U.obj.fnt)] = 11 + U.fSDec(U.obj.fntStr);p[U.fSDec(U.obj.fSy)] = U.fSDec(U.obj.grClr);p[U.fSDec(U.obj.fTx)](U.fSDec(U.obj.trVs), 2, h.height - 11 - 2);
	      } catch (r) {}
	    };
	  })();var $a = {},
	      xa = null,
	      kb = function kb() {
	    this.ctx.clearRect(0, 0, this.width, this.height);this.backgroundColor && (this.ctx.fillStyle = this.backgroundColor, this.ctx.fillRect(0, 0, this.width, this.height));
	  },
	      lb = function lb(h, p, r) {
	    p = Math.min(this.width, this.height);return Math.max("theme4" === this.theme ? 0 : 300 <= p ? 12 : 10, Math.round(p * (h / 400)));
	  },
	      Ca = function () {
	    var h = /D{1,4}|M{1,4}|Y{1,4}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|f{1,3}|t{1,2}|T{1,2}|K|z{1,3}|"[^"]*"|'[^']*'/g,
	        p = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
	        r = "Sun Mon Tue Wed Thu Fri Sat".split(" "),
	        u = "January February March April May June July August September October November December".split(" "),
	        v = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
	        H = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
	        F = /[^-+\dA-Z]/g;return function (z, E, L) {
	      var R = L ? L.days : p,
	          I = L ? L.months : u,
	          N = L ? L.shortDays : r,
	          O = L ? L.shortMonths : v;L = "";var S = !1;z = z && z.getTime ? z : z ? new Date(z) : new Date();if (isNaN(z)) throw SyntaxError("invalid date");
	      "UTC:" === E.slice(0, 4) && (E = E.slice(4), S = !0);L = S ? "getUTC" : "get";var U = z[L + "Date"](),
	          V = z[L + "Day"](),
	          M = z[L + "Month"](),
	          Q = z[L + "FullYear"](),
	          a = z[L + "Hours"](),
	          d = z[L + "Minutes"](),
	          b = z[L + "Seconds"](),
	          c = z[L + "Milliseconds"](),
	          e = S ? 0 : z.getTimezoneOffset();return L = E.replace(h, function (g) {
	        switch (g) {case "D":
	            return U;case "DD":
	            return $(U, 2);case "DDD":
	            return N[V];case "DDDD":
	            return R[V];case "M":
	            return M + 1;case "MM":
	            return $(M + 1, 2);case "MMM":
	            return O[M];case "MMMM":
	            return I[M];case "Y":
	            return parseInt(String(Q).slice(-2));
	          case "YY":
	            return $(String(Q).slice(-2), 2);case "YYY":
	            return $(String(Q).slice(-3), 3);case "YYYY":
	            return $(Q, 4);case "h":
	            return a % 12 || 12;case "hh":
	            return $(a % 12 || 12, 2);case "H":
	            return a;case "HH":
	            return $(a, 2);case "m":
	            return d;case "mm":
	            return $(d, 2);case "s":
	            return b;case "ss":
	            return $(b, 2);case "f":
	            return String(c).slice(0, 1);case "ff":
	            return $(String(c).slice(0, 2), 2);case "fff":
	            return $(String(c).slice(0, 3), 3);case "t":
	            return 12 > a ? "a" : "p";case "tt":
	            return 12 > a ? "am" : "pm";case "T":
	            return 12 > a ? "A" : "P";case "TT":
	            return 12 > a ? "AM" : "PM";case "K":
	            return S ? "UTC" : (String(z).match(H) || [""]).pop().replace(F, "");case "z":
	            return (0 < e ? "-" : "+") + Math.floor(Math.abs(e) / 60);case "zz":
	            return (0 < e ? "-" : "+") + $(Math.floor(Math.abs(e) / 60), 2);case "zzz":
	            return (0 < e ? "-" : "+") + $(Math.floor(Math.abs(e) / 60), 2) + $(Math.abs(e) % 60, 2);default:
	            return g.slice(1, g.length - 1);}
	      });
	    };
	  }(),
	      ba = function ba(h, p, r) {
	    if (null === h) return "";if (!isFinite(h)) return h;h = Number(h);var u = 0 > h ? !0 : !1;u && (h *= -1);var v = r ? r.decimalSeparator : ".",
	        H = r ? r.digitGroupSeparator : ",",
	        F = "";p = String(p);var F = 1,
	        z = r = "",
	        E = -1,
	        L = [],
	        R = [],
	        I = 0,
	        N = 0,
	        S = 0,
	        O = !1,
	        U = 0,
	        z = p.match(/"[^"]*"|'[^']*'|[eE][+-]*[0]+|[,]+[.]|\u2030|./g);p = null;for (var Q = 0; z && Q < z.length; Q++) {
	      if (p = z[Q], "." === p && 0 > E) E = Q;else {
	        if ("%" === p) F *= 100;else if ("\u2030" === p) {
	          F *= 1E3;continue;
	        } else if ("," === p[0] && "." === p[p.length - 1]) {
	          F /= Math.pow(1E3, p.length - 1);E = Q + p.length - 1;continue;
	        } else "E" !== p[0] && "e" !== p[0] || "0" !== p[p.length - 1] || (O = !0);0 > E ? (L.push(p), "#" === p || "0" === p ? I++ : "," === p && S++) : (R.push(p), "#" !== p && "0" !== p || N++);
	      }
	    }O && (p = Math.floor(h), z = -Math.floor(Math.log(h) / Math.LN10 + 1), U = 0 === h ? 0 : 0 === p ? -(I + z) : String(p).length - I, F /= Math.pow(10, U));0 > E && (E = Q);F = (h * F).toFixed(N);p = F.split(".");F = (p[0] + "").split("");h = (p[1] + "").split("");F && "0" === F[0] && F.shift();for (O = z = Q = N = E = 0; 0 < L.length;) {
	      if (p = L.pop(), "#" === p || "0" === p) {
	        if (E++, E === I) {
	          var M = F,
	              F = [];if ("0" === p) for (p = I - N - (M ? M.length : 0); 0 < p;) {
	            M.unshift("0"), p--;
	          }for (; 0 < M.length;) {
	            r = M.pop() + r, O++, 0 === O % z && Q === S && 0 < M.length && (r = H + r);
	          }
	        } else 0 < F.length ? (r = F.pop() + r, N++, O++) : "0" === p && (r = "0" + r, N++, O++), 0 === O % z && Q === S && 0 < F.length && (r = H + r);
	      } else "E" !== p[0] && "e" !== p[0] || "0" !== p[p.length - 1] || !/[eE][+-]*[0]+/.test(p) ? "," === p ? (Q++, z = O, O = 0, 0 < F.length && (r = H + r)) : r = 1 < p.length && ('"' === p[0] && '"' === p[p.length - 1] || "'" === p[0] && "'" === p[p.length - 1]) ? p.slice(1, p.length - 1) + r : p + r : (p = 0 > U ? p.replace("+", "").replace("-", "") : p.replace("-", ""), r += p.replace(/[0]+/, function (h) {
	        return $(U, h.length);
	      }));
	    }H = "";for (L = !1; 0 < R.length;) {
	      p = R.shift(), "#" === p || "0" === p ? 0 < h.length && 0 !== Number(h.join("")) ? (H += h.shift(), L = !0) : "0" === p && (H += "0", L = !0) : 1 < p.length && ('"' === p[0] && '"' === p[p.length - 1] || "'" === p[0] && "'" === p[p.length - 1]) ? H += p.slice(1, p.length - 1) : "E" !== p[0] && "e" !== p[0] || "0" !== p[p.length - 1] || !/[eE][+-]*[0]+/.test(p) ? H += p : (p = 0 > U ? p.replace("+", "").replace("-", "") : p.replace("-", ""), H += p.replace(/[0]+/, function (h) {
	        return $(U, h.length);
	      }));
	    }r += (L ? v : "") + H;return u ? "-" + r : r;
	  },
	      Ra = function Ra(h) {
	    var p = 0,
	        r = 0;h = h || window.event;h.offsetX || 0 === h.offsetX ? (p = h.offsetX, r = h.offsetY) : h.layerX || 0 == h.layerX ? (p = h.layerX, r = h.layerY) : (p = h.pageX - h.target.offsetLeft, r = h.pageY - h.target.offsetTop);return { x: p, y: r };
	  },
	      bb = !0,
	      Ua = window.devicePixelRatio || 1,
	      Pa = 1,
	      W = bb ? Ua / Pa : 1,
	      ea = function ea(h, p, r, u, v, H, F, z, E, L, R, N, O) {
	    "undefined" === typeof O && (O = 1);F = F || 0;z = z || "black";var I = 15 < u - p && 15 < v - r ? 8 : 0.35 * Math.min(u - p, v - r);h.beginPath();h.moveTo(p, r);h.save();h.fillStyle = H;h.globalAlpha = O;h.fillRect(p, r, u - p, v - r);h.globalAlpha = 1;0 < F && (O = 0 === F % 2 ? 0 : 0.5, h.beginPath(), h.lineWidth = F, h.strokeStyle = z, h.moveTo(p, r), h.rect(p - O, r - O, u - p + 2 * O, v - r + 2 * O), h.stroke());h.restore();!0 === E && (h.save(), h.beginPath(), h.moveTo(p, r), h.lineTo(p + I, r + I), h.lineTo(u - I, r + I), h.lineTo(u, r), h.closePath(), F = h.createLinearGradient((u + p) / 2, r + I, (u + p) / 2, r), F.addColorStop(0, H), F.addColorStop(1, "rgba(255, 255, 255, .4)"), h.fillStyle = F, h.fill(), h.restore());!0 === L && (h.save(), h.beginPath(), h.moveTo(p, v), h.lineTo(p + I, v - I), h.lineTo(u - I, v - I), h.lineTo(u, v), h.closePath(), F = h.createLinearGradient((u + p) / 2, v - I, (u + p) / 2, v), F.addColorStop(0, H), F.addColorStop(1, "rgba(255, 255, 255, .4)"), h.fillStyle = F, h.fill(), h.restore());!0 === R && (h.save(), h.beginPath(), h.moveTo(p, r), h.lineTo(p + I, r + I), h.lineTo(p + I, v - I), h.lineTo(p, v), h.closePath(), F = h.createLinearGradient(p + I, (v + r) / 2, p, (v + r) / 2), F.addColorStop(0, H), F.addColorStop(1, "rgba(255, 255, 255, 0.1)"), h.fillStyle = F, h.fill(), h.restore());!0 === N && (h.save(), h.beginPath(), h.moveTo(u, r), h.lineTo(u - I, r + I), h.lineTo(u - I, v - I), h.lineTo(u, v), F = h.createLinearGradient(u - I, (v + r) / 2, u, (v + r) / 2), F.addColorStop(0, H), F.addColorStop(1, "rgba(255, 255, 255, 0.1)"), h.fillStyle = F, F.addColorStop(0, H), F.addColorStop(1, "rgba(255, 255, 255, 0.1)"), h.fillStyle = F, h.fill(), h.closePath(), h.restore());
	  },
	      ja = function ja(h) {
	    for (var p = "", r = 0; r < h.length; r++) {
	      p += String.fromCharCode(Math.ceil(h.length / 57 / 5) ^ h.charCodeAt(r));
	    }return p;
	  },
	      db = window && window[ja("mnb`uhno")] && window[ja("mnb`uhno")].href && window[ja("mnb`uhno")].href.indexOf && (-1 !== window[ja("mnb`uhno")].href.indexOf(ja("b`ow`rkr/bnl")) || -1 !== window[ja("mnb`uhno")].href.indexOf(ja("gdonqhy/bnl")) || -1 !== window[ja("mnb`uhno")].href.indexOf(ja("gheemd"))),
	      ib = db && -1 === window[ja("mnb`uhno")].href.indexOf(ja("gheemd")),
	      jb = { reset: { image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPjSURBVFhHxVdJaFNRFP1J/jwkP5MxsbaC1WJEglSxOFAXIsFpVRE3ggi1K90obioRRBA33XXnQnciirhQcMCdorgQxBkXWlREkFKsWkv5npvckp/XnzRpKh64kLw733fffe9L/wrL0+mVUdO8uTSZ3MBL/we2qg4rkuSpodCELstXE46ziVkLQ6FQcGOmeSSq6wd4aV50d3drWjj8kQKZJTUc9kxFGenv79dZrDksTSTWWJp2QYtEPiErysyzdX0LsxsCQR8keX8gs6RHIk8ysdgKFg2G53mhuOPsshTlBjKaFo1g7SqLNoShKLdFXT8huQ/paLSbxatYnc2mHMM4hr18Vi8TIvCmXF3vYrW6cF23gGTOk0M1wA4RKvOmq6vLZRVJipvmSWT6tZ6CSEYkco5V50VPT4+D7RwOqi6RiSZm0fJ+vggSqkeoypdsNmuyelNwbXsbgvkWYMtzDWNvWaijoyOBqE+hVK8abcssUeXQ/YfKyi0gFYv1Ipgfoj34fYGTJLOYJA0ODirok32GLN8XhUWCwSes1hIwBg6LydJ/tEeRRapAdUp+wSAiZchtZZWWgAZ+JNpD8peYXQVK9UwUxNpzOK8pq97kURZhYTCKBwPD7h2zK+js7Myi7D8Fod+0TkMI8+EMAngLGc/WtBFWawkFHFnoj/t9KLgGmF0B3QfkxC+EarxkdhnFYlFLY06USqUwL7UMjICHfh/wOc2sCqhpxGbCkLvL7EUDbF73+6DkmVWB6zi7xUDQSLeYvWjAILvm9zEnkJhlbRcDQZcv6Kg2AipyT/Axw6wKlqVSqxDdjF8Izfod13qURdrG/nxehY+xGh+h0CSzKygGvSNQIcc097BI24jb9hax6kj2E7OrMFX1il+ICEf2NrPbhiXLl+fYl+U7zK4iYdsDcyLGf+ofFlkwcN+s10KhmpuYhhtm0hCLVIFL0MDsqNlDIqy9x2CLs1jL6OvrI7vPRbtohXG6eFmsFnHDGAp6n9AgyuVySRZrGvROxRgIfLXhzjrNYnNBUxNX/dMgRWT1mt4XLDovaApD53E9W3ilNX5M55LJHpRtIsgAvciR4WWcgK2Dvb1YqgXevmF8z2zEBTcKG39EfSKsT9EbhVUaI2FZO+oZIqImxol6j66/hcAu4sSN4vc1ZPoKeoE6RGhYL2YYA+ymOSSi0Z0wWntbtkGUWCvfSDXIxONraZ/FY90KUfNTpfC5spnNLgxoYNnR9RO4F8ofXEHOgogCQE99w+fF2Xw+b7O59rEOsyRqGEfpVoaDMQQ1CZrG46bcM6AZ0C/wPqNfHliqejyTySxh9TqQpL+xmbIlkB9SlAAAAABJRU5ErkJggg==" },
	    pan: { image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAICSURBVEhLxZbPahNRGMUn/5MpuAiBEAIufQGfzr5E40YptBXajYzudCEuGqS+gGlrFwquDGRTutBdYfydzJ3LzeQmJGZue+Dw/Z17Mnfmu5Pof9Hr9Z61Wq0bWZMKj263O6xWq99wU9lOpzPMKgEhEcRucNOcioOK+0RzBhNvt9tPV4nmVF19+OWhVqt9xXgFXZq+8lCv119UKpUJ7iX2FmvFTKz8RH34YdBsNk8wVtjE4fGYwm8wrrDi3WBG5oKXZGRSS9hGuNFojLTe2lFz5xThWZIktayyiE2FdT3rzXBXz7krKiL8c17wAKFDjCus2AvW+YGZ9y2JF0VFRuMPfI//rsCE/C+s26s4gQu9ul7r4NteKx7H8XOC724xNNGbaNu++IrBqbOV7Tj3FgMRvc/YKOr3+3sE47wgEt/Bl/gaK5cHbNU11vYSXylfpK7XOvjuumPp4Wcoipu30Qsez2uMXYz4lfI+mOmwothY+SLiXJy7mKVpWs3Si0CoOMfeI9Od43Wic+jO+ZVv+crsm9QSNhUW9LXSeoPBYLXopthGuFQgdIxxhY+UDwlt1x5CZ1hX+NTUdt/OIvjKaDSmuOJfaIVNPKX+W18j/PLA2/kR44p5Sd8HbHngT/yTfNRWUXX14ZcL3wmX0+TLf8YO7CGT8yFE5zB3/gney25/OETRP9CtPDFe5jShAAAAAElFTkSuQmCC" },
	    zoom: { image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALWSURBVEhLvZZLaBNRFIabyftBIgEfqCCBoCC6MYqiXYiIj4U76U4X7sUHbhQhUBfixhZEUBDB16YuFERaUaQLK7ooCOJj4UKtYEFU0EptShO/A9Ph3js3k8lo/eHnP7n3nP/M3LlzMz1hkUwmNziOcyKRSFyFt+LxeD/c2Wq1Ym7Kv0M2m11Os1OxWGycn1OwZXCGuXfwIhezkd9/jRgNT2L4ldhs1pbkX5OLJe4euVxuGQaPCa3mnUjtJx7BDuKusJTCV6jVVGHTMuYRjxma7yIOhTgFY6jNaAKew2xPKpVay9ganmkvj+M448/MfJdT5K5Gg4HJacRngPFgqVRaRNwW1B4i7yehWfsEDdz1K+A01AoxPIqGAiuwGfkOTY8+1A6u7AyiFTB2Hu0KPIrdiOnzHLWDybeImvy+Wq2mZa5bUHsD0Zpz+KxHdWQymV6kAb1ElqeORgJLvgnRdj1+R1AfzkIvSUjxVjQSarVakrueIPT8+H1F5jSUy+WXiJrUYBVWyVxU4PEU8TzhfaijUqnMIWrjaY492eWRwdKOIqrnIxnXwLLeRLwk2GQzrEMjg0avEbXxkIxr4OoOImpj2QwyFgms1koa/SZUG8s+0iGnEhNfCNXEhzIXBVz0McTzEvJ+70P9oNFtxEzei3aFYrFYxmuSUPWSv9Yi9IMm2xE1We56Mp1OV4nDwqFmBDV9gk9AEh4gZtFHNt8W4kAUCoXF5MorY9Z/kDni9nDv7hc0i2fhgLvTtX8a99PoMPPagTFPxofRzmDJ9yM+AyEmTfgGysYbQcfhDzPPJDmX0c7gDg4gs9BqFIWhm/Nct5H8gtBq1I7UfIbtvmIuoaGQcp+fdpbbSM43eEH5wrwLbXmhm/fU63VHXjcuok7hEByFY/AeHGC8L5/PL3HT5xGH1uYwfPOICGo+CBcU0vwO1BqzUqILDl/z/9VYIMfpddiAc47jDP8BsUpb13wOLRwAAAAASUVORK5CYII=" },
	    menu: { image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVFhH7dc9CsJAFATgRxIIBCwCqZKATX5sbawsY2MvWOtF9AB6AU8gguAJbD2AnZ2VXQT/Ko2TYGCL2OYtYQc+BuYA+1hCtnCVwMm27SGaXpDJIAiCvCkVR05hGOZNN3HkFMdx3nQRR06+76/R1IcFLJlNQEWlmWlBTwJtKLKHynehZqnjOGM0PYWRVXk61C37p7xlZ3Hk5HneCk1dmMH811xGoKLSzDiQwIBZB4ocoPJdqNkDt2yKlueWRVGUtzy3rPwo3sWRU3nLjuLI6OO67oZM00wMw3hrmpZx0XU9syxrR0T0BeMpb9dneSR2AAAAAElFTkSuQmCC" },
	    handle: { image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAAXNSR0IArs4c6QAAAAZiS0dEANAAzwDP4Z7KegAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAAd0SU1FB9sHGw0cMqdt1UwAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAaElEQVQoz+3SsRFAQBCF4Z9WJM8KCDVwownl6YXsTmCUsyKGkZzcl7zkz3YLkypgAnreFmDEpHkIwVOMfpdi9CEEN2nGpFdwD03yEqDtOgCaun7sqSTDH32I1pQA2Pb9sZecAxc5r3IAb21d6878xsAAAAAASUVORK5CYII=" } };V.prototype.setOptions = function (h, p) {
	    if (ra[this._defaultsKey]) {
	      var r = ra[this._defaultsKey],
	          u;for (u in r) {
	        "publicProperties" !== u && r.hasOwnProperty(u) && (this[u] = h && u in h ? h[u] : p && u in p ? p[u] : r[u]);
	      }
	    } else Ja && window.console && console.log("defaults not set");
	  };V.prototype.get = function (h) {
	    var p = ra[this._defaultsKey];if ("options" === h) return this.options && this.options._isPlaceholder ? null : this.options;if (p.hasOwnProperty(h) || p.publicProperties && p.publicProperties.hasOwnProperty(h)) return this[h];window.console && window.console.log('Property "' + h + "\" doesn't exist. Please check for typo.");
	  };V.prototype.set = function (h, p, r) {
	    r = "undefined" === typeof r ? !0 : r;var u = ra[this._defaultsKey];if ("options" === h) this.createUserOptions(p);else if (u.hasOwnProperty(h) || u.publicProperties && u.publicProperties.hasOwnProperty(h) && "readWrite" === u.publicProperties[h]) this.options._isPlaceholder && this.createUserOptions(), this.options[h] = p;else {
	      window.console && (u.publicProperties && u.publicProperties.hasOwnProperty(h) && "readOnly" === u.publicProperties[h] ? window.console.log('Property "' + h + '" is read-only.') : window.console.log('Property "' + h + "\" doesn't exist. Please check for typo."));
	      return;
	    }r && (this.stockChart || this.chart || this).render();
	  };V.prototype.addTo = function (h, p, r, u) {
	    u = "undefined" === typeof u ? !0 : u;var v = ra[this._defaultsKey];v.hasOwnProperty(h) || v.publicProperties && v.publicProperties.hasOwnProperty(h) && "readWrite" === v.publicProperties[h] ? (this.options._isPlaceholder && this.createUserOptions(), "undefined" === typeof this.options[h] && (this.options[h] = []), h = this.options[h], r = "undefined" === typeof r || null === r ? h.length : r, h.splice(r, 0, p), u && (this.chart || this).render()) : window.console && (v.publicProperties && v.publicProperties.hasOwnProperty(h) && "readOnly" === v.publicProperties[h] ? window.console.log('Property "' + h + '" is read-only.') : window.console.log('Property "' + h + "\" doesn't exist. Please check for typo."));
	  };V.prototype.createUserOptions = function (h) {
	    if ("undefined" !== typeof h || this.options._isPlaceholder) if (this.parent.options._isPlaceholder && this.parent.createUserOptions(), this.isOptionsInArray) {
	      this.parent.options[this.optionsName] || (this.parent.options[this.optionsName] = []);var p = this.parent.options[this.optionsName],
	          r = p.length;this.options._isPlaceholder || (Fa(p), r = p.indexOf(this.options));this.options = "undefined" === typeof h ? {} : h;p[r] = this.options;
	    } else this.options = "undefined" === typeof h ? {} : h, h = this.parent.options, this.optionsName ? p = this.optionsName : (p = this._defaultsKey) && 0 !== p.length ? (r = p.charAt(0).toLowerCase(), 1 < p.length && (r = r.concat(p.slice(1))), p = r) : p = void 0, h[p] = this.options;
	  };V.prototype.remove = function (h) {
	    h = "undefined" === typeof h ? !0 : h;if (this.isOptionsInArray) {
	      var p = this.parent.options[this.optionsName];Fa(p);var r = p.indexOf(this.options);0 <= r && p.splice(r, 1);
	    } else delete this.parent.options[this.optionsName];h && (this.chart || this).render();
	  };V.prototype.updateOption = function (h) {
	    !ra[this._defaultsKey] && Ja && window.console && console.log("defaults not set");var p = ra[this._defaultsKey],
	        r = {},
	        v = this[h],
	        E = this._themeOptionsKey,
	        H = this._index;this.theme && u(E) && u(H) ? r = u(ya[this.theme]) ? ya.light1 : ya[this.theme] : this.parent && this.parent.themeOptions && this.parent.themeOptions[E] && (null === H ? r = this.parent.themeOptions[E] : 0 < this.parent.themeOptions[E].length && (r = Math.min(this.parent.themeOptions[E].length - 1, H), r = this.parent.themeOptions[E][r]));this.themeOptions = r;h in p && (v = h in this.options ? this.options[h] : r && h in r ? r[h] : p[h]);if (v === this[h]) return !1;this[h] = v;return !0;
	  };V.prototype.trackChanges = function (h) {
	    if (!this.sessionVariables) throw "Session Variable Store not set";this.sessionVariables[h] = this.options[h];
	  };V.prototype.isBeingTracked = function (h) {
	    this.options._oldOptions || (this.options._oldOptions = {});return this.options._oldOptions[h] ? !0 : !1;
	  };V.prototype.hasOptionChanged = function (h) {
	    if (!this.sessionVariables) throw "Session Variable Store not set";return this.sessionVariables[h] !== this.options[h];
	  };V.prototype.addEventListener = function (h, p, r) {
	    h && p && (this._eventListeners[h] = this._eventListeners[h] || [], this._eventListeners[h].push({ context: r || this, eventHandler: p }));
	  };V.prototype.removeEventListener = function (h, p) {
	    if (h && p && this._eventListeners[h]) for (var r = this._eventListeners[h], u = 0; u < r.length; u++) {
	      if (r[u].eventHandler === p) {
	        r[u].splice(u, 1);break;
	      }
	    }
	  };V.prototype.removeAllEventListeners = function () {
	    this._eventListeners = [];
	  };V.prototype.dispatchEvent = function (h, p, r) {
	    if (h && this._eventListeners[h]) {
	      p = p || {};for (var u = this._eventListeners[h], v = 0; v < u.length; v++) {
	        u[v].eventHandler.call(u[v].context, p);
	      }
	    }"function" === typeof this[h] && this[h].call(r || this.chart, p);
	  };Ga.prototype.registerSpace = function (h, p) {
	    "top" === h ? this._topOccupied += p.height : "bottom" === h ? this._bottomOccupied += p.height : "left" === h ? this._leftOccupied += p.width : "right" === h && (this._rightOccupied += p.width);
	  };Ga.prototype.unRegisterSpace = function (h, p) {
	    "top" === h ? this._topOccupied -= p.height : "bottom" === h ? this._bottomOccupied -= p.height : "left" === h ? this._leftOccupied -= p.width : "right" === h && (this._rightOccupied -= p.width);
	  };Ga.prototype.getFreeSpace = function () {
	    return { x1: this._x1 + this._leftOccupied, y1: this._y1 + this._topOccupied, x2: this._x2 - this._rightOccupied, y2: this._y2 - this._bottomOccupied, width: this._x2 - this._x1 - this._rightOccupied - this._leftOccupied,
	      height: this._y2 - this._y1 - this._bottomOccupied - this._topOccupied };
	  };Ga.prototype.reset = function () {
	    this._rightOccupied = this._leftOccupied = this._bottomOccupied = this._topOccupied = this._padding;
	  };qa(ka, V);ka.prototype._initialize = function () {
	    u(this.padding) || "object" !== _typeof(this.padding) ? this.topPadding = this.rightPadding = this.bottomPadding = this.leftPadding = Number(this.padding) | 0 : (this.topPadding = u(this.padding.top) ? 0 : Number(this.padding.top) | 0, this.rightPadding = u(this.padding.right) ? 0 : Number(this.padding.right) | 0, this.bottomPadding = u(this.padding.bottom) ? 0 : Number(this.padding.bottom) | 0, this.leftPadding = u(this.padding.left) ? 0 : Number(this.padding.left) | 0);
	  };ka.prototype.render = function (h) {
	    if (0 !== this.fontSize) {
	      h && this.ctx.save();var p = this.ctx.font;this.ctx.textBaseline = this.textBaseline;var r = 0;this._isDirty && this.measureText(this.ctx);this.ctx.translate(this.x, this.y + r);"middle" === this.textBaseline && (r = -this._lineHeight / 2);this.ctx.font = this._getFontString();this.ctx.rotate(Math.PI / 180 * this.angle);var u = 0,
	          v = this.topPadding,
	          H = null;this.ctx.roundRect || Ea(this.ctx);(0 < this.borderThickness && this.borderColor || this.backgroundColor) && this.ctx.roundRect(0, r, this.width, this.height, this.cornerRadius, this.borderThickness, this.backgroundColor, this.borderColor);this.ctx.fillStyle = this.fontColor;for (r = 0; r < this._wrappedText.lines.length; r++) {
	        H = this._wrappedText.lines[r], "right" === this.horizontalAlign ? u = (this.width - (this.leftPadding + this.rightPadding)) / 2 - H.width / 2 + this.leftPadding : "left" === this.horizontalAlign ? u = this.leftPadding : "center" === this.horizontalAlign && (u = (this.width - (this.leftPadding + this.rightPadding)) / 2 - H.width / 2 + this.leftPadding), this.ctx.fillText(H.text, u, v), v += H.height;
	      }this.ctx.font = p;h && this.ctx.restore();
	    }
	  };ka.prototype.setText = function (h) {
	    this.text = h;this._isDirty = !0;this._wrappedText = null;
	  };ka.prototype.measureText = function () {
	    this._lineHeight = Za(this.fontFamily, this.fontSize, this.fontWeight);if (null === this.maxWidth) throw "Please set maxWidth and height for TextBlock";this._wrapText(this.ctx);
	    this._isDirty = !1;return { width: this.width, height: this.height };
	  };ka.prototype._getLineWithWidth = function (h, p, r) {
	    h = String(h);if (!h) return { text: "", width: 0 };var u = r = 0,
	        v = h.length - 1,
	        H = Infinity;for (this.ctx.font = this._getFontString(); u <= v;) {
	      var H = Math.floor((u + v) / 2),
	          F = h.substr(0, H + 1);r = this.ctx.measureText(F).width;if (r < p) u = H + 1;else if (r > p) v = H - 1;else break;
	    }r > p && 1 < F.length && (F = F.substr(0, F.length - 1), r = this.ctx.measureText(F).width);p = !0;if (F.length === h.length || " " === h[F.length]) p = !1;p && (h = F.split(" "), 1 < h.length && h.pop(), F = h.join(" "), r = this.ctx.measureText(F).width);return { text: F, width: r };
	  };ka.prototype._wrapText = function () {
	    var h = new String(Ia(String(this.text))),
	        p = [],
	        r = this.ctx.font,
	        u = 0,
	        v = 0;this.ctx.font = this._getFontString();if (0 === this.frontSize) v = u = 0;else for (; 0 < h.length;) {
	      var H = this.maxHeight - (this.topPadding + this.bottomPadding),
	          F = this._getLineWithWidth(h, this.maxWidth - (this.leftPadding + this.rightPadding), !1);F.height = this._lineHeight;p.push(F);var z = v,
	          v = Math.max(v, F.width),
	          u = u + F.height,
	          h = Ia(h.slice(F.text.length, h.length));H && u > H && (F = p.pop(), u -= F.height, v = z);
	    }this._wrappedText = { lines: p, width: v, height: u };this.width = v + (this.leftPadding + this.rightPadding);this.height = u + (this.topPadding + this.bottomPadding);this.ctx.font = r;
	  };ka.prototype._getFontString = function () {
	    var h;h = "" + (this.fontStyle ? this.fontStyle + " " : "");h += this.fontWeight ? this.fontWeight + " " : "";h += this.fontSize ? this.fontSize + "px " : "";var p = this.fontFamily ? this.fontFamily + "" : "";!r && p && (p = p.split(",")[0], "'" !== p[0] && '"' !== p[0] && (p = "'" + p + "'"));return h += p;
	  };
	  qa(Va, V);qa(Aa, V);Aa.prototype.setLayout = function () {
	    if (this.text) {
	      var h = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
	          p = h.layoutManager.getFreeSpace(),
	          r = p.x1,
	          v = p.y1,
	          E = 0,
	          H = 0,
	          F = this.chart._menuButton && this.chart.exportEnabled && "top" === this.verticalAlign ? 22 : 0,
	          z,
	          I;"top" === this.verticalAlign || "bottom" === this.verticalAlign ? (null === this.maxWidth && (this.maxWidth = p.width - 4 - F * ("center" === this.horizontalAlign ? 2 : 1)), H = 0.5 * p.height - this.margin - 2, E = 0) : "center" === this.verticalAlign && ("left" === this.horizontalAlign || "right" === this.horizontalAlign ? (null === this.maxWidth && (this.maxWidth = p.height - 4), H = 0.5 * p.width - this.margin - 2) : "center" === this.horizontalAlign && (null === this.maxWidth && (this.maxWidth = p.width - 4), H = 0.5 * p.height - 4));var L;u(this.padding) || "number" !== typeof this.padding ? u(this.padding) || "object" !== _typeof(this.padding) || (L = this.padding.top ? this.padding.top : this.padding.bottom ? this.padding.bottom : 0, L += this.padding.bottom ? this.padding.bottom : this.padding.top ? this.padding.top : 0, L *= 1.25) : L = 2.5 * this.padding;this.wrap || (H = Math.min(H, Math.max(1.5 * this.fontSize, this.fontSize + L)));H = new ka(this.ctx, { fontSize: this.fontSize, fontFamily: this.fontFamily, fontColor: this.fontColor, fontStyle: this.fontStyle, fontWeight: this.fontWeight, horizontalAlign: this.horizontalAlign, verticalAlign: this.verticalAlign, borderColor: this.borderColor, borderThickness: this.borderThickness, backgroundColor: this.backgroundColor, maxWidth: this.maxWidth, maxHeight: H, cornerRadius: this.cornerRadius, text: this.text, padding: this.padding, textBaseline: "top" });
	      L = H.measureText();"top" === this.verticalAlign || "bottom" === this.verticalAlign ? ("top" === this.verticalAlign ? (v = p.y1 + 2, I = "top") : "bottom" === this.verticalAlign && (v = p.y2 - 2 - L.height, I = "bottom"), "left" === this.horizontalAlign ? r = p.x1 + 2 : "center" === this.horizontalAlign ? r = p.x1 + p.width / 2 - L.width / 2 : "right" === this.horizontalAlign && (r = p.x2 - 2 - L.width - F), z = this.horizontalAlign, this.width = L.width, this.height = L.height) : "center" === this.verticalAlign && ("left" === this.horizontalAlign ? (r = p.x1 + 2, v = p.y2 - 2 - (this.maxWidth / 2 - L.width / 2), E = -90, I = "left", this.width = L.height, this.height = L.width) : "right" === this.horizontalAlign ? (r = p.x2 - 2, v = p.y1 + 2 + (this.maxWidth / 2 - L.width / 2), E = 90, I = "right", this.width = L.height, this.height = L.width) : "center" === this.horizontalAlign && (v = h.y1 + (h.height / 2 - L.height / 2), r = h.x1 + (h.width / 2 - L.width / 2), I = "center", this.width = L.width, this.height = L.height), z = "center");H.x = r;H.y = v;H.angle = E;H.horizontalAlign = z;this._textBlock = H;h.layoutManager.registerSpace(I, { width: this.width + ("left" === I || "right" === I ? this.margin + 2 : 0),
	        height: this.height + ("top" === I || "bottom" === I ? this.margin + 2 : 0) });this.bounds = { x1: r, y1: v, x2: r + this.width, y2: v + this.height };this.ctx.textBaseline = "top";
	    }
	  };Aa.prototype.render = function () {
	    this._textBlock && this._textBlock.render(!0);
	  };qa(Ka, V);Ka.prototype.setLayout = Aa.prototype.setLayout;Ka.prototype.render = Aa.prototype.render;Wa.prototype.get = function (h, p) {
	    var r = null;0 < this.pool.length ? (r = this.pool.pop(), Oa(r, h, p)) : r = ta(h, p);return r;
	  };Wa.prototype.release = function (h) {
	    this.pool.push(h);
	  };qa(La, V);var Na = { addTheme: function addTheme(h, p) {
	      ya[h] = p;
	    }, addColorSet: function addColorSet(h, p) {
	      Ba[h] = p;
	    }, addCultureInfo: function addCultureInfo(h, p) {
	      Ma[h] = p;
	    }, formatNumber: function formatNumber(h, p, r) {
	      r = r || "en";if (Ma[r]) return ba(h, p || "#,##0.##", new La(r));throw "Unknown Culture Name";
	    }, formatDate: function formatDate(h, p, r) {
	      r = r || "en";if (Ma[r]) return Ca(h, p || "DD MMM YYYY", new La(r));throw "Unknown Culture Name";
	    } };"undefined" !== typeof module && "undefined" !== typeof module.exports ? module.exports = Na :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return Na;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : window.CanvasJS = Na;Na.Chart = function () {
	    function h(a, d) {
	      return a.x - d.x;
	    }function p(a, d) {
	      d = d || {};this.theme = u(d.theme) || u(ya[d.theme]) ? "light1" : d.theme;p.base.constructor.call(this, "Chart", null, d, null, null);var b = this;this._containerId = a;this._objectsInitialized = !1;this.overlaidCanvasCtx = this.ctx = null;this._indexLabels = [];this._panTimerId = 0;this._lastTouchEventType = "";this._lastTouchData = null;this.isAnimating = !1;this.renderCount = 0;this.disableToolTip = this.animatedRender = !1;this.canvasPool = new Wa();this.allDOMEventHandlers = [];this.panEnabled = !1;this._defaultCursor = "default";this.plotArea = { canvas: null, ctx: null, x1: 0, y1: 0, x2: 0, y2: 0, width: 0, height: 0 };this._dataInRenderedOrder = [];if (this.container = "string" === typeof this._containerId ? document.getElementById(this._containerId) : this._containerId) {
	        this.container.innerHTML = "";var c = 0,
	            e = 0,
	            c = this.options.width ? this.width : 0 < this.container.clientWidth ? this.container.clientWidth : this.width,
	            e = this.options.height ? this.height : 0 < this.container.clientHeight ? this.container.clientHeight : this.height;this.width = c;this.height = e;this.x1 = this.y1 = 0;this.x2 = this.width;this.y2 = this.height;this._selectedColorSet = "undefined" !== typeof Ba[this.colorSet] ? Ba[this.colorSet] : Ba.colorSet1;this._canvasJSContainer = document.createElement("div");this._canvasJSContainer.setAttribute("class", "canvasjs-chart-container");this._canvasJSContainer.style.position = "relative";this._canvasJSContainer.style.textAlign = "left";this._canvasJSContainer.style.cursor = "auto";r || (this._canvasJSContainer.style.height = "0px");this.container.appendChild(this._canvasJSContainer);
	        this.canvas = ta(c, e);this._preRenderCanvas = ta(c, e);this.canvas.style.position = "absolute";this.canvas.style.WebkitUserSelect = "none";this.canvas.style.MozUserSelect = "none";this.canvas.style.msUserSelect = "none";this.canvas.style.userSelect = "none";this.canvas.getContext && (this._canvasJSContainer.appendChild(this.canvas), this.ctx = this.canvas.getContext("2d"), this.ctx.textBaseline = "top", Ea(this.ctx), this._preRenderCtx = this._preRenderCanvas.getContext("2d"), this._preRenderCtx.textBaseline = "top", Ea(this._preRenderCtx), r ? this.plotArea.ctx = this.ctx : (this.plotArea.canvas = ta(c, e), this.plotArea.canvas.style.position = "absolute", this.plotArea.canvas.setAttribute("class", "plotAreaCanvas"), this._canvasJSContainer.appendChild(this.plotArea.canvas), this.plotArea.ctx = this.plotArea.canvas.getContext("2d")), this.overlaidCanvas = ta(c, e), this.overlaidCanvas.style.position = "absolute", this.overlaidCanvas.style.webkitTapHighlightColor = "transparent", this.overlaidCanvas.style.WebkitUserSelect = "none", this.overlaidCanvas.style.MozUserSelect = "none", this.overlaidCanvas.style.msUserSelect = "none", this.overlaidCanvas.style.userSelect = "none", this.overlaidCanvas.getContext && (this._canvasJSContainer.appendChild(this.overlaidCanvas), this.overlaidCanvasCtx = this.overlaidCanvas.getContext("2d"), this.overlaidCanvasCtx.textBaseline = "top", Ea(this.overlaidCanvasCtx)), this._eventManager = new ha(this), this.windowResizeHandler = O(window, "resize", function () {
	          b._updateSize() && b.render();
	        }, this.allDOMEventHandlers), this._toolBar = document.createElement("div"), this._toolBar.setAttribute("class", "canvasjs-chart-toolbar"), this._toolBar.style.cssText = "position: absolute; right: 1px; top: 1px;", this._canvasJSContainer.appendChild(this._toolBar), this.bounds = { x1: 0, y1: 0, x2: this.width, y2: this.height }, O(this.overlaidCanvas, "click", function (a) {
	          b._mouseEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, "mousemove", function (a) {
	          b._mouseEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, "mouseup", function (a) {
	          b._mouseEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, "mousedown", function (a) {
	          b._mouseEventHandler(a);va(b._dropdownMenu);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, "mouseout", function (a) {
	          b._mouseEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart", function (a) {
	          b._touchEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove", function (a) {
	          b._touchEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend", function (a) {
	          b._touchEventHandler(a);
	        }, this.allDOMEventHandlers), O(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerCancel" : "touchcancel", function (a) {
	          b._touchEventHandler(a);
	        }, this.allDOMEventHandlers), this.toolTip = new $(this, this.options.toolTip), this.data = null, this.axisX = [], this.axisX2 = [], this.axisY = [], this.axisY2 = [], this.sessionVariables = { axisX: [], axisX2: [], axisY: [], axisY2: [] });
	      } else window.console && window.console.log('CanvasJS Error: Chart Container with id "' + this._containerId + '" was not found');
	    }function v(a, d) {
	      for (var b = [], c, e = 0; e < a.length; e++) {
	        if (0 == e) b.push(a[0]);else {
	          var g, k, l;l = e - 1;g = 0 === l ? 0 : l - 1;k = l === a.length - 1 ? l : l + 1;c = Math.abs((a[k].x - a[g].x) / (0 === a[k].x - a[l].x ? 0.01 : a[k].x - a[l].x)) * (d - 1) / 2 + 1;var w = (a[k].x - a[g].x) / c;c = (a[k].y - a[g].y) / c;b[b.length] = a[l].x > a[g].x && 0 < w || a[l].x < a[g].x && 0 > w ? { x: a[l].x + w / 3, y: a[l].y + c / 3 } : { x: a[l].x, y: a[l].y + c / 9 };l = e;g = 0 === l ? 0 : l - 1;k = l === a.length - 1 ? l : l + 1;c = Math.abs((a[k].x - a[g].x) / (0 === a[l].x - a[g].x ? 0.01 : a[l].x - a[g].x)) * (d - 1) / 2 + 1;w = (a[k].x - a[g].x) / c;c = (a[k].y - a[g].y) / c;b[b.length] = a[l].x > a[g].x && 0 < w || a[l].x < a[g].x && 0 > w ? { x: a[l].x - w / 3, y: a[l].y - c / 3 } : { x: a[l].x, y: a[l].y - c / 9 };b[b.length] = a[e];
	        }
	      }return b;
	    }function E(a, d, b, c, e, g, k, l, w, m) {
	      var s = 0;m ? (k.color = g, l.color = g) : m = 1;s = w ? Math.abs(e - b) : Math.abs(c - d);s = 0 < k.trimLength ? Math.abs(s * k.trimLength / 100) : Math.abs(s - k.length);w ? (b += s / 2, e -= s / 2) : (d += s / 2, c -= s / 2);var s = 1 === Math.round(k.thickness) % 2 ? 0.5 : 0,
	          q = 1 === Math.round(l.thickness) % 2 ? 0.5 : 0;a.save();a.globalAlpha = m;a.strokeStyle = l.color || g;a.lineWidth = l.thickness || 2;a.setLineDash && a.setLineDash(R(l.dashType, l.thickness));a.beginPath();w && 0 < l.thickness ? (a.moveTo(c - k.thickness / 2, Math.round((b + e) / 2) - q), a.lineTo(d + k.thickness / 2, Math.round((b + e) / 2) - q)) : 0 < l.thickness && (a.moveTo(Math.round((d + c) / 2) - q, b + k.thickness / 2), a.lineTo(Math.round((d + c) / 2) - q, e - k.thickness / 2));a.stroke();a.strokeStyle = k.color || g;a.lineWidth = k.thickness || 2;a.setLineDash && a.setLineDash(R(k.dashType, k.thickness));a.beginPath();w && 0 < k.thickness ? (a.moveTo(c - s, b), a.lineTo(c - s, e), a.moveTo(d + s, b), a.lineTo(d + s, e)) : 0 < k.thickness && (a.moveTo(d, b + s), a.lineTo(c, b + s), a.moveTo(d, e - s), a.lineTo(c, e - s));a.stroke();a.restore();
	    }function I(a, d, b, c, e) {
	      if (null === a || "undefined" === typeof a) return "undefined" === typeof b ? d : b;a = parseFloat(a.toString()) * (0 <= a.toString().indexOf("%") ? d / 100 : 1);"undefined" !== typeof c && (a = Math.min(c, a), "undefined" !== typeof e && (a = Math.max(e, a)));return !isNaN(a) && a <= d && 0 <= a ? a : "undefined" === typeof b ? d : b;
	    }function H(a, d) {
	      H.base.constructor.call(this, "Legend", "legend", d, null, a);this.chart = a;this.canvas = a.canvas;this.ctx = this.chart.ctx;this.ghostCtx = this.chart._eventManager.ghostCtx;this.items = [];this.optionsName = "legend";this.height = this.width = 0;this.orientation = null;this.dataSeries = [];this.bounds = { x1: null, y1: null, x2: null, y2: null };"undefined" === typeof this.options.fontSize && (this.fontSize = this.chart.getAutoFontSize(this.fontSize));this.lineHeight = Za(this.fontFamily, this.fontSize, this.fontWeight);this.horizontalSpacing = this.fontSize;
	    }function F(a, d, b, c) {
	      F.base.constructor.call(this, "DataSeries", "data", d, b, a);this.chart = a;this.canvas = a.canvas;this._ctx = a.canvas.ctx;this.index = b;this.noDataPointsInPlotArea = 0;this.id = c;this.chart._eventManager.objectMap[c] = { id: c, objectType: "dataSeries", dataSeriesIndex: b };a = d.dataPoints ? d.dataPoints.length : 0;this.dataPointEOs = [];for (d = 0; d < a; d++) {
	        this.dataPointEOs[d] = {};
	      }this.dataPointIds = [];this.plotUnit = [];this.axisY = this.axisX = null;this.optionsName = "data";this.isOptionsInArray = !0;null === this.fillOpacity && (this.type.match(/area/i) ? this.fillOpacity = 0.7 : this.fillOpacity = 1);this.axisPlacement = this.getDefaultAxisPlacement();"undefined" === typeof this.options.indexLabelFontSize && (this.indexLabelFontSize = this.chart.getAutoFontSize(this.indexLabelFontSize));
	    }function z(a, d, b, c, e, g) {
	      z.base.constructor.call(this, "Axis", d, b, c, a);this.chart = a;this.canvas = a.canvas;this.ctx = a.ctx;this.intervalStartPosition = this.maxHeight = this.maxWidth = 0;this.labels = [];this.dataSeries = [];this._stripLineLabels = this._ticks = this._labels = null;this.dataInfo = { min: Infinity, max: -Infinity,
	        viewPortMin: Infinity, viewPortMax: -Infinity, minDiff: Infinity };this.isOptionsInArray = !0;"axisX" === e ? ("left" === g || "bottom" === g ? (this.optionsName = "axisX", u(this.chart.sessionVariables.axisX[c]) && (this.chart.sessionVariables.axisX[c] = {}), this.sessionVariables = this.chart.sessionVariables.axisX[c]) : (this.optionsName = "axisX2", u(this.chart.sessionVariables.axisX2[c]) && (this.chart.sessionVariables.axisX2[c] = {}), this.sessionVariables = this.chart.sessionVariables.axisX2[c]), this.options.interval || (this.intervalType = null)) : "left" === g || "bottom" === g ? (this.optionsName = "axisY", u(this.chart.sessionVariables.axisY[c]) && (this.chart.sessionVariables.axisY[c] = {}), this.sessionVariables = this.chart.sessionVariables.axisY[c]) : (this.optionsName = "axisY2", u(this.chart.sessionVariables.axisY2[c]) && (this.chart.sessionVariables.axisY2[c] = {}), this.sessionVariables = this.chart.sessionVariables.axisY2[c]);"undefined" === typeof this.options.titleFontSize && (this.titleFontSize = this.chart.getAutoFontSize(this.titleFontSize));"undefined" === typeof this.options.labelFontSize && (this.labelFontSize = this.chart.getAutoFontSize(this.labelFontSize));this.type = e;"axisX" !== e || b && "undefined" !== typeof b.gridThickness || (this.gridThickness = 0);this._position = g;this.lineCoordinates = { x1: null, y1: null, x2: null, y2: null, width: null };this.labelAngle = (this.labelAngle % 360 + 360) % 360;90 < this.labelAngle && 270 > this.labelAngle ? this.labelAngle -= 180 : 270 <= this.labelAngle && 360 >= this.labelAngle && (this.labelAngle -= 360);this.options.scaleBreaks && (this.scaleBreaks = new Q(this.chart, this.options.scaleBreaks, ++this.chart._eventManager.lastObjectId, this));this.stripLines = [];if (this.options.stripLines && 0 < this.options.stripLines.length) for (a = 0; a < this.options.stripLines.length; a++) {
	        this.stripLines.push(new X(this.chart, this.options.stripLines[a], a, ++this.chart._eventManager.lastObjectId, this));
	      }this.options.crosshair && (this.crosshair = new fa(this.chart, this.options.crosshair, this));this._titleTextBlock = null;this.hasOptionChanged("viewportMinimum") && null === this.viewportMinimum && (this.options.viewportMinimum = void 0, this.sessionVariables.viewportMinimum = null);this.hasOptionChanged("viewportMinimum") || isNaN(this.sessionVariables.newViewportMinimum) || null === this.sessionVariables.newViewportMinimum ? this.sessionVariables.newViewportMinimum = null : this.viewportMinimum = this.sessionVariables.newViewportMinimum;this.hasOptionChanged("viewportMaximum") && null === this.viewportMaximum && (this.options.viewportMaximum = void 0, this.sessionVariables.viewportMaximum = null);this.hasOptionChanged("viewportMaximum") || isNaN(this.sessionVariables.newViewportMaximum) || null === this.sessionVariables.newViewportMaximum ? this.sessionVariables.newViewportMaximum = null : this.viewportMaximum = this.sessionVariables.newViewportMaximum;null !== this.minimum && null !== this.viewportMinimum && (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));null !== this.maximum && null !== this.viewportMaximum && (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));this.trackChanges("viewportMinimum");this.trackChanges("viewportMaximum");
	    }function Q(a, d, b, c) {
	      Q.base.constructor.call(this, "ScaleBreaks", "scaleBreaks", d, null, c);this.id = b;this.chart = a;this.ctx = this.chart.ctx;this.axis = c;this.optionsName = "scaleBreaks";this.isOptionsInArray = !1;this._appliedBreaks = [];this.customBreaks = [];this.autoBreaks = [];"string" === typeof this.spacing ? (this.spacing = parseFloat(this.spacing), this.spacing = isNaN(this.spacing) ? 8 : (10 < this.spacing ? 10 : this.spacing) + "%") : "number" !== typeof this.spacing && (this.spacing = 8);this.autoCalculate && (this.maxNumberOfAutoBreaks = Math.min(this.maxNumberOfAutoBreaks, 5));if (this.options.customBreaks && 0 < this.options.customBreaks.length) {
	        for (a = 0; a < this.options.customBreaks.length; a++) {
	          this.customBreaks.push(new L(this.chart, "customBreaks", this.options.customBreaks[a], a, ++this.chart._eventManager.lastObjectId, this)), "number" === typeof this.customBreaks[a].startValue && "number" === typeof this.customBreaks[a].endValue && this.customBreaks[a].endValue !== this.customBreaks[a].startValue && this._appliedBreaks.push(this.customBreaks[a]);
	        }this._appliedBreaks.sort(function (a, c) {
	          return a.startValue - c.startValue;
	        });
	        for (a = 0; a < this._appliedBreaks.length - 1; a++) {
	          this._appliedBreaks[a].endValue >= this._appliedBreaks[a + 1].startValue && (this._appliedBreaks[a].endValue = Math.max(this._appliedBreaks[a].endValue, this._appliedBreaks[a + 1].endValue), window.console && window.console.log("CanvasJS Error: Breaks " + a + " and " + (a + 1) + " are overlapping."), this._appliedBreaks.splice(a, 2), a--);
	        }
	      }
	    }function L(a, d, b, c, e, g) {
	      L.base.constructor.call(this, "Break", d, b, c, g);this.id = e;this.chart = a;this.ctx = this.chart.ctx;this.scaleBreaks = g;this.optionsName = d;this.isOptionsInArray = !0;this.type = b.type ? this.type : g.type;this.fillOpacity = u(b.fillOpacity) ? g.fillOpacity : this.fillOpacity;this.lineThickness = u(b.lineThickness) ? g.lineThickness : this.lineThickness;this.color = b.color ? this.color : g.color;this.lineColor = b.lineColor ? this.lineColor : g.lineColor;this.lineDashType = b.lineDashType ? this.lineDashType : g.lineDashType;!u(this.startValue) && this.startValue.getTime && (this.startValue = this.startValue.getTime());!u(this.endValue) && this.endValue.getTime && (this.endValue = this.endValue.getTime());"number" === typeof this.startValue && "number" === typeof this.endValue && this.endValue < this.startValue && (a = this.startValue, this.startValue = this.endValue, this.endValue = a);this.spacing = "undefined" === typeof b.spacing ? g.spacing : b.spacing;"string" === typeof this.options.spacing ? (this.spacing = parseFloat(this.spacing), this.spacing = isNaN(this.spacing) ? 0 : (10 < this.spacing ? 10 : this.spacing) + "%") : "number" !== typeof this.options.spacing && (this.spacing = g.spacing);this.size = g.parent.logarithmic ? 1 : 0;
	    }function X(a, d, b, c, e) {
	      X.base.constructor.call(this, "StripLine", "stripLines", d, b, e);this.id = c;this.chart = a;this.ctx = this.chart.ctx;this.label = this.label;this.axis = e;this.optionsName = "stripLines";this.isOptionsInArray = !0;this._thicknessType = "pixel";null !== this.startValue && null !== this.endValue && (this.value = e.logarithmic ? Math.sqrt((this.startValue.getTime ? this.startValue.getTime() : this.startValue) * (this.endValue.getTime ? this.endValue.getTime() : this.endValue)) : ((this.startValue.getTime ? this.startValue.getTime() : this.startValue) + (this.endValue.getTime ? this.endValue.getTime() : this.endValue)) / 2, this._thicknessType = null);
	    }function fa(a, d, b) {
	      fa.base.constructor.call(this, "Crosshair", "crosshair", d, null, b);this.chart = a;this.ctx = this.chart.ctx;this.axis = b;this.optionsName = "crosshair";this._thicknessType = "pixel";
	    }function $(a, d) {
	      $.base.constructor.call(this, "ToolTip", "toolTip", d, null, a);this.chart = a;this.canvas = a.canvas;this.ctx = this.chart.ctx;this.currentDataPointIndex = this.currentSeriesIndex = -1;this._prevY = this._prevX = NaN;this.containerTransitionDuration = 0.1;this.mozContainerTransition = this.getContainerTransition(this.containerTransitionDuration);this.optionsName = "toolTip";this._initialize();
	    }function ha(a) {
	      this.chart = a;this.lastObjectId = 0;this.objectMap = [];this.rectangularRegionEventSubscriptions = [];this.previousDataPointEventObject = null;this.ghostCanvas = ta(this.chart.width, this.chart.height);this.ghostCtx = this.ghostCanvas.getContext("2d");this.mouseoveredObjectMaps = [];
	    }function ga(a) {
	      this.chart = a;this.ctx = this.chart.plotArea.ctx;
	      this.animations = [];this.animationRequestId = null;
	    }qa(p, V);p.prototype.destroy = function () {
	      var a = this.allDOMEventHandlers;this._animator && this._animator.cancelAllAnimations();this._panTimerId && clearTimeout(this._panTimerId);for (var d = 0; d < a.length; d++) {
	        var b = a[d][0],
	            c = a[d][1],
	            e = a[d][2],
	            g = a[d][3],
	            g = g || !1;b.removeEventListener ? b.removeEventListener(c, e, g) : b.detachEvent && b.detachEvent("on" + c, e);
	      }this.allDOMEventHandlers = [];for (this.removeAllEventListeners(); this._canvasJSContainer && this._canvasJSContainer.hasChildNodes();) {
	        this._canvasJSContainer.removeChild(this._canvasJSContainer.lastChild);
	      }for (; this.container && this.container.hasChildNodes();) {
	        this.container.removeChild(this.container.lastChild);
	      }for (; this._dropdownMenu && this._dropdownMenu.hasChildNodes();) {
	        this._dropdownMenu.removeChild(this._dropdownMenu.lastChild);
	      }this.overlaidCanvas = this.canvas = this.container = this._canvasJSContainer = null;this._toolBar = this._dropdownMenu = this._menuButton = this._resetButton = this._zoomButton = this._breaksCanvas = this._preRenderCanvas = this.toolTip.container = null;
	    };p.prototype._updateOptions = function () {
	      var a = this;this.updateOption("width");this.updateOption("height");this.updateOption("dataPointWidth");this.updateOption("dataPointMinWidth");this.updateOption("dataPointMaxWidth");this.updateOption("interactivityEnabled");this.updateOption("theme");this.updateOption("colorSet") && (this._selectedColorSet = "undefined" !== typeof Ba[this.colorSet] ? Ba[this.colorSet] : Ba.colorSet1);this.updateOption("backgroundColor");this.backgroundColor || (this.backgroundColor = "rgba(0,0,0,0)");this.updateOption("culture");this._cultureInfo = new La(this.options.culture);this.updateOption("animationEnabled");this.animationEnabled = this.animationEnabled && r;this.updateOption("animationDuration");this.updateOption("rangeChanging");this.updateOption("rangeChanged");this.updateOption("exportEnabled");this.updateOption("exportFileName");this.updateOption("zoomType");if (this.options.zoomEnabled) {
	        if (!this._zoomButton) {
	          var d = !1;va(this._zoomButton = document.createElement("button"));ua(this, this._zoomButton, "pan");this._toolBar.appendChild(this._zoomButton);
	          this._zoomButton.style.borderRight = this.toolbar.borderThickness + "px solid " + this.toolbar.borderColor;O(this._zoomButton, "touchstart", function (a) {
	            d = !0;
	          }, this.allDOMEventHandlers);O(this._zoomButton, "click", function () {
	            a.zoomEnabled ? (a.zoomEnabled = !1, a.panEnabled = !0, ua(a, a._zoomButton, "zoom")) : (a.zoomEnabled = !0, a.panEnabled = !1, ua(a, a._zoomButton, "pan"));a.render();
	          }, this.allDOMEventHandlers);O(this._zoomButton, "mouseover", function () {
	            d ? d = !1 : (sa(a, a._zoomButton, { backgroundColor: a.toolbar.backgroundColorOnHover,
	              color: a.toolbar.fontColorOnHover, transition: "0.4s", WebkitTransition: "0.4s" }), 0 >= navigator.userAgent.search("MSIE") && sa(a, a._zoomButton.childNodes[0], { WebkitFilter: "invert(100%)", filter: "invert(100%)" }));
	          }, this.allDOMEventHandlers);O(this._zoomButton, "mouseout", function () {
	            d || (sa(a, a._zoomButton, { backgroundColor: a.toolbar.backgroundColor, color: a.toolbar.fontColor, transition: "0.4s", WebkitTransition: "0.4s" }), 0 >= navigator.userAgent.search("MSIE") && sa(a, a._zoomButton.childNodes[0], { WebkitFilter: "invert(0%)",
	              filter: "invert(0%)" }));
	          }, this.allDOMEventHandlers);
	        }this._resetButton || (d = !1, va(this._resetButton = document.createElement("button")), ua(this, this._resetButton, "reset"), this._resetButton.style.borderRight = (this.exportEnabled ? this.toolbar.borderThickness : 0) + "px solid " + this.toolbar.borderColor, this._toolBar.appendChild(this._resetButton), O(this._resetButton, "touchstart", function (a) {
	          d = !0;
	        }, this.allDOMEventHandlers), O(this._resetButton, "click", function () {
	          a.toolTip.hide();a.zoomEnabled || a.panEnabled ? (a.zoomEnabled = !0, a.panEnabled = !1, ua(a, a._zoomButton, "pan"), a._defaultCursor = "default", a.overlaidCanvas.style.cursor = a._defaultCursor) : (a.zoomEnabled = !1, a.panEnabled = !1);if (a.sessionVariables.axisX) for (var c = 0; c < a.sessionVariables.axisX.length; c++) {
	            a.sessionVariables.axisX[c].newViewportMinimum = null, a.sessionVariables.axisX[c].newViewportMaximum = null;
	          }if (a.sessionVariables.axisX2) for (c = 0; c < a.sessionVariables.axisX2.length; c++) {
	            a.sessionVariables.axisX2[c].newViewportMinimum = null, a.sessionVariables.axisX2[c].newViewportMaximum = null;
	          }if (a.sessionVariables.axisY) for (c = 0; c < a.sessionVariables.axisY.length; c++) {
	            a.sessionVariables.axisY[c].newViewportMinimum = null, a.sessionVariables.axisY[c].newViewportMaximum = null;
	          }if (a.sessionVariables.axisY2) for (c = 0; c < a.sessionVariables.axisY2.length; c++) {
	            a.sessionVariables.axisY2[c].newViewportMinimum = null, a.sessionVariables.axisY2[c].newViewportMaximum = null;
	          }a.resetOverlayedCanvas();va(a._zoomButton, a._resetButton);a._dispatchRangeEvent("rangeChanging", "reset");a.render();a._dispatchRangeEvent("rangeChanged", "reset");a.syncCharts && a.syncCharts(null, null);
	        }, this.allDOMEventHandlers), O(this._resetButton, "mouseover", function () {
	          d || (sa(a, a._resetButton, { backgroundColor: a.toolbar.backgroundColorOnHover, color: a.toolbar.hoverFfontColorOnHoverontColor, transition: "0.4s", WebkitTransition: "0.4s" }), 0 >= navigator.userAgent.search("MSIE") && sa(a, a._resetButton.childNodes[0], { WebkitFilter: "invert(100%)", filter: "invert(100%)" }));
	        }, this.allDOMEventHandlers), O(this._resetButton, "mouseout", function () {
	          d || (sa(a, a._resetButton, { backgroundColor: a.toolbar.backgroundColor, color: a.toolbar.fontColor, transition: "0.4s", WebkitTransition: "0.4s" }), 0 >= navigator.userAgent.search("MSIE") && sa(a, a._resetButton.childNodes[0], { WebkitFilter: "invert(0%)", filter: "invert(0%)" }));
	        }, this.allDOMEventHandlers), this.overlaidCanvas.style.cursor = a._defaultCursor);this.zoomEnabled || this.panEnabled || (this._zoomButton ? (a._zoomButton.getAttribute("state") === a._cultureInfo.zoomText ? (this.panEnabled = !0, this.zoomEnabled = !1) : (this.zoomEnabled = !0, this.panEnabled = !1), Qa(a._zoomButton, a._resetButton)) : (this.zoomEnabled = !0, this.panEnabled = !1));
	      } else this.panEnabled = this.zoomEnabled = !1;this._menuButton ? this.exportEnabled ? Qa(this._menuButton) : va(this._menuButton) : this.exportEnabled && r && (d = !1, this._menuButton = document.createElement("button"), ua(this, this._menuButton, "menu"), this._toolBar.appendChild(this._menuButton), O(this._menuButton, "touchstart", function (a) {
	        d = !0;
	      }, this.allDOMEventHandlers), O(this._menuButton, "click", function () {
	        "none" !== a._dropdownMenu.style.display || a._dropDownCloseTime && 500 >= new Date().getTime() - a._dropDownCloseTime.getTime() || (a._dropdownMenu.style.display = "block", a._menuButton.blur(), a._dropdownMenu.focus());
	      }, this.allDOMEventHandlers, !0), O(this._menuButton, "mouseover", function () {
	        d || (sa(a, a._menuButton, { backgroundColor: a.toolbar.backgroundColorOnHover, color: a.toolbar.fontColorOnHover }), 0 >= navigator.userAgent.search("MSIE") && sa(a, a._menuButton.childNodes[0], { WebkitFilter: "invert(100%)", filter: "invert(100%)" }));
	      }, this.allDOMEventHandlers, !0), O(this._menuButton, "mouseout", function () {
	        d || (sa(a, a._menuButton, { backgroundColor: a.toolbar.backgroundColor, color: a.toolbar.fontColor }), 0 >= navigator.userAgent.search("MSIE") && sa(a, a._menuButton.childNodes[0], { WebkitFilter: "invert(0%)", filter: "invert(0%)" }));
	      }, this.allDOMEventHandlers, !0));if (!this._dropdownMenu && this.exportEnabled && r) {
	        d = !1;this._dropdownMenu = document.createElement("div");this._dropdownMenu.setAttribute("tabindex", -1);var b = -1 !== this.theme.indexOf("dark") ? "black" : "#888888";this._dropdownMenu.style.cssText = "position: absolute; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; cursor: pointer;right: 0px;top: 25px;min-width: 120px;outline: 0;font-size: 14px; font-family: Arial, Helvetica, sans-serif;padding: 5px 0px 5px 0px;text-align: left;line-height: 10px;background-color:" + this.toolbar.backgroundColor + ";box-shadow: 2px 2px 10px " + b;a._dropdownMenu.style.display = "none";this._toolBar.appendChild(this._dropdownMenu);O(this._dropdownMenu, "blur", function () {
	          va(a._dropdownMenu);
	          a._dropDownCloseTime = new Date();
	        }, this.allDOMEventHandlers, !0);b = document.createElement("div");b.style.cssText = "padding: 12px 8px 12px 8px";b.innerHTML = this._cultureInfo.printText;b.style.backgroundColor = this.toolbar.backgroundColor;b.style.color = this.toolbar.fontColor;this._dropdownMenu.appendChild(b);O(b, "touchstart", function (a) {
	          d = !0;
	        }, this.allDOMEventHandlers);O(b, "mouseover", function () {
	          d || (this.style.backgroundColor = a.toolbar.backgroundColorOnHover, this.style.color = a.toolbar.fontColorOnHover);
	        }, this.allDOMEventHandlers, !0);O(b, "mouseout", function () {
	          d || (this.style.backgroundColor = a.toolbar.backgroundColor, this.style.color = a.toolbar.fontColor);
	        }, this.allDOMEventHandlers, !0);O(b, "click", function () {
	          a.print();va(a._dropdownMenu);
	        }, this.allDOMEventHandlers, !0);b = document.createElement("div");b.style.cssText = "padding: 12px 8px 12px 8px";b.innerHTML = this._cultureInfo.saveJPGText;b.style.backgroundColor = this.toolbar.backgroundColor;b.style.color = this.toolbar.fontColor;this._dropdownMenu.appendChild(b);O(b, "touchstart", function (a) {
	          d = !0;
	        }, this.allDOMEventHandlers);O(b, "mouseover", function () {
	          d || (this.style.backgroundColor = a.toolbar.backgroundColorOnHover, this.style.color = a.toolbar.fontColorOnHover);
	        }, this.allDOMEventHandlers, !0);O(b, "mouseout", function () {
	          d || (this.style.backgroundColor = a.toolbar.backgroundColor, this.style.color = a.toolbar.fontColor);
	        }, this.allDOMEventHandlers, !0);O(b, "click", function () {
	          Ta(a.canvas, "jpeg", a.exportFileName);va(a._dropdownMenu);
	        }, this.allDOMEventHandlers, !0);b = document.createElement("div");b.style.cssText = "padding: 12px 8px 12px 8px";b.innerHTML = this._cultureInfo.savePNGText;b.style.backgroundColor = this.toolbar.backgroundColor;b.style.color = this.toolbar.fontColor;this._dropdownMenu.appendChild(b);O(b, "touchstart", function (a) {
	          d = !0;
	        }, this.allDOMEventHandlers);O(b, "mouseover", function () {
	          d || (this.style.backgroundColor = a.toolbar.backgroundColorOnHover, this.style.color = a.toolbar.fontColorOnHover);
	        }, this.allDOMEventHandlers, !0);O(b, "mouseout", function () {
	          d || (this.style.backgroundColor = a.toolbar.backgroundColor, this.style.color = a.toolbar.fontColor);
	        }, this.allDOMEventHandlers, !0);O(b, "click", function () {
	          Ta(a.canvas, "png", a.exportFileName);va(a._dropdownMenu);
	        }, this.allDOMEventHandlers, !0);
	      }"none" !== this._toolBar.style.display && this._zoomButton && (this.panEnabled ? ua(a, a._zoomButton, "zoom") : ua(a, a._zoomButton, "pan"), a._resetButton.getAttribute("state") !== a._cultureInfo.resetText && ua(a, a._resetButton, "reset"));this.options.toolTip && this.toolTip.options !== this.options.toolTip && (this.toolTip.options = this.options.toolTip);
	      for (var c in this.toolTip.options) {
	        this.toolTip.options.hasOwnProperty(c) && this.toolTip.updateOption(c);
	      }
	    };p.prototype._updateSize = function () {
	      var a;a = [this.canvas, this.overlaidCanvas, this._eventManager.ghostCanvas];var d = 0,
	          b = 0;this.options.width ? d = this.width : this.width = d = 0 < this.container.clientWidth ? this.container.clientWidth : this.width;this.options.height ? b = this.height : this.height = b = 0 < this.container.clientHeight ? this.container.clientHeight : this.height;if (this.canvas.width !== d * W || this.canvas.height !== b * W) {
	        for (var c = 0; c < a.length; c++) {
	          Oa(a[c], d, b);
	        }a = !0;
	      } else a = !1;return a;
	    };p.prototype._initialize = function () {
	      this.isNavigator = u(this.parent) || u(this.parent._defaultsKey) || "Navigator" !== this.parent._defaultsKey ? !1 : !0;this.toolbar = new Va(this, this.options.toolbar);this._animator ? this._animator.cancelAllAnimations() : this._animator = new ga(this);this.removeAllEventListeners();this.disableToolTip = !1;this._axes = [];this.funnelPyramidClickHandler = this.pieDoughnutClickHandler = null;this._updateOptions();this.animatedRender = r && this.animationEnabled && 0 === this.renderCount;this._updateSize();this.clearCanvas();this.ctx.beginPath();this.axisX = [];this.axisX2 = [];this.axisY = [];this.axisY2 = [];this._indexLabels = [];this._dataInRenderedOrder = [];this._events = [];this._eventManager && this._eventManager.reset();this.plotInfo = { axisPlacement: null, plotTypes: [] };this.layoutManager = new Ga(0, 0, this.width, this.height, this.isNavigator ? 0 : 2);this.plotArea.layoutManager && this.plotArea.layoutManager.reset();this.data = [];var a = 0,
	          d = null;if (this.options.data) {
	        for (var b = 0; b < this.options.data.length; b++) {
	          if (a++, !this.options.data[b].type || 0 <= p._supportedChartTypes.indexOf(this.options.data[b].type)) {
	            var c = new F(this, this.options.data[b], a - 1, ++this._eventManager.lastObjectId);"error" === c.type && (c.linkedDataSeriesIndex = u(this.options.data[b].linkedDataSeriesIndex) ? b - 1 : this.options.data[b].linkedDataSeriesIndex, 0 > c.linkedDataSeriesIndex || c.linkedDataSeriesIndex >= this.options.data.length || "number" !== typeof c.linkedDataSeriesIndex || "error" === this.options.data[c.linkedDataSeriesIndex].type) && (c.linkedDataSeriesIndex = null);null === c.name && (c.name = "DataSeries " + a);null === c.color ? 1 < this.options.data.length ? (c._colorSet = [this._selectedColorSet[c.index % this._selectedColorSet.length]], c.color = this._selectedColorSet[c.index % this._selectedColorSet.length]) : c._colorSet = "line" === c.type || "stepLine" === c.type || "spline" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "stackedArea" === c.type || "stackedArea100" === c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type || "candlestick" === c.type || "ohlc" === c.type || "waterfall" === c.type || "boxAndWhisker" === c.type ? [this._selectedColorSet[0]] : this._selectedColorSet : c._colorSet = [c.color];null === c.markerSize && (("line" === c.type || "stepLine" === c.type || "spline" === c.type || 0 <= c.type.toLowerCase().indexOf("area")) && c.dataPoints && c.dataPoints.length < this.width / 16 || "scatter" === c.type) && (c.markerSize = 8);"bubble" !== c.type && "scatter" !== c.type || !c.dataPoints || (c.dataPoints.some ? c.dataPoints.some(function (a) {
	              return a.x;
	            }) && c.dataPoints.sort(h) : c.dataPoints.sort(h));
	            this.data.push(c);var e = c.axisPlacement,
	                d = d || e,
	                g;"normal" === e ? "xySwapped" === this.plotInfo.axisPlacement ? g = 'You cannot combine "' + c.type + '" with bar chart' : "none" === this.plotInfo.axisPlacement ? g = 'You cannot combine "' + c.type + '" with pie chart' : null === this.plotInfo.axisPlacement && (this.plotInfo.axisPlacement = "normal") : "xySwapped" === e ? "normal" === this.plotInfo.axisPlacement ? g = 'You cannot combine "' + c.type + '" with line, area, column or pie chart' : "none" === this.plotInfo.axisPlacement ? g = 'You cannot combine "' + c.type + '" with pie chart' : null === this.plotInfo.axisPlacement && (this.plotInfo.axisPlacement = "xySwapped") : "none" === e ? "normal" === this.plotInfo.axisPlacement ? g = 'You cannot combine "' + c.type + '" with line, area, column or bar chart' : "xySwapped" === this.plotInfo.axisPlacement ? g = 'You cannot combine "' + c.type + '" with bar chart' : null === this.plotInfo.axisPlacement && (this.plotInfo.axisPlacement = "none") : null === e && "none" === this.plotInfo.axisPlacement && (g = 'You cannot combine "' + c.type + '" with pie chart');if (g && window.console) {
	              window.console.log(g);
	              return;
	            }
	          }
	        }for (b = 0; b < this.data.length; b++) {
	          if ("none" == d && "error" === this.data[b].type && window.console) {
	            window.console.log('You cannot combine "' + c.type + '" with error chart');return;
	          }"error" === this.data[b].type && (this.data[b].axisPlacement = this.plotInfo.axisPlacement = d || "normal", this.data[b]._linkedSeries = null === this.data[b].linkedDataSeriesIndex ? null : this.data[this.data[b].linkedDataSeriesIndex]);
	        }
	      }this._objectsInitialized = !0;this._plotAreaElements = [];
	    };p._supportedChartTypes = Fa("line stepLine spline column area stepArea splineArea bar bubble scatter stackedColumn stackedColumn100 stackedBar stackedBar100 stackedArea stackedArea100 candlestick ohlc boxAndWhisker rangeColumn error rangeBar rangeArea rangeSplineArea pie doughnut funnel pyramid waterfall".split(" "));
	    p.prototype.setLayout = function () {
	      for (var a = this._plotAreaElements, d = 0; d < this.data.length; d++) {
	        if ("normal" === this.plotInfo.axisPlacement || "xySwapped" === this.plotInfo.axisPlacement) {
	          if (!this.data[d].axisYType || "primary" === this.data[d].axisYType) if (this.options.axisY && 0 < this.options.axisY.length) {
	            if (!this.axisY.length) for (var b = 0; b < this.options.axisY.length; b++) {
	              "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY[b] = new z(this, "axisY", this.options.axisY[b], b, "axisY", "left")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY[b] = new z(this, "axisY", this.options.axisY[b], b, "axisY", "bottom"));
	            }this.data[d].axisY = this.axisY[0 <= this.data[d].axisYIndex && this.data[d].axisYIndex < this.axisY.length ? this.data[d].axisYIndex : 0];this.axisY[0 <= this.data[d].axisYIndex && this.data[d].axisYIndex < this.axisY.length ? this.data[d].axisYIndex : 0].dataSeries.push(this.data[d]);
	          } else this.axisY.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY[0] = new z(this, "axisY", this.options.axisY, 0, "axisY", "left")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY[0] = new z(this, "axisY", this.options.axisY, 0, "axisY", "bottom"))), this.data[d].axisY = this.axisY[0], this.axisY[0].dataSeries.push(this.data[d]);if ("secondary" === this.data[d].axisYType) if (this.options.axisY2 && 0 < this.options.axisY2.length) {
	            if (!this.axisY2.length) for (b = 0; b < this.options.axisY2.length; b++) {
	              "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY2[b] = new z(this, "axisY2", this.options.axisY2[b], b, "axisY", "right")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY2[b] = new z(this, "axisY2", this.options.axisY2[b], b, "axisY", "top"));
	            }this.data[d].axisY = this.axisY2[0 <= this.data[d].axisYIndex && this.data[d].axisYIndex < this.axisY2.length ? this.data[d].axisYIndex : 0];this.axisY2[0 <= this.data[d].axisYIndex && this.data[d].axisYIndex < this.axisY2.length ? this.data[d].axisYIndex : 0].dataSeries.push(this.data[d]);
	          } else this.axisY2.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY2[0] = new z(this, "axisY2", this.options.axisY2, 0, "axisY", "right")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY2[0] = new z(this, "axisY2", this.options.axisY2, 0, "axisY", "top"))), this.data[d].axisY = this.axisY2[0], this.axisY2[0].dataSeries.push(this.data[d]);if (!this.data[d].axisXType || "primary" === this.data[d].axisXType) if (this.options.axisX && 0 < this.options.axisX.length) {
	            if (!this.axisX.length) for (b = 0; b < this.options.axisX.length; b++) {
	              "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX[b] = new z(this, "axisX", this.options.axisX[b], b, "axisX", "bottom")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX[b] = new z(this, "axisX", this.options.axisX[b], b, "axisX", "left"));
	            }this.data[d].axisX = this.axisX[0 <= this.data[d].axisXIndex && this.data[d].axisXIndex < this.axisX.length ? this.data[d].axisXIndex : 0];this.axisX[0 <= this.data[d].axisXIndex && this.data[d].axisXIndex < this.axisX.length ? this.data[d].axisXIndex : 0].dataSeries.push(this.data[d]);
	          } else this.axisX.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX[0] = new z(this, "axisX", this.options.axisX, 0, "axisX", "bottom")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX[0] = new z(this, "axisX", this.options.axisX, 0, "axisX", "left"))), this.data[d].axisX = this.axisX[0], this.axisX[0].dataSeries.push(this.data[d]);if ("secondary" === this.data[d].axisXType) if (this.options.axisX2 && 0 < this.options.axisX2.length) {
	            if (!this.axisX2.length) for (b = 0; b < this.options.axisX2.length; b++) {
	              "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX2[b] = new z(this, "axisX2", this.options.axisX2[b], b, "axisX", "top")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX2[b] = new z(this, "axisX2", this.options.axisX2[b], b, "axisX", "right"));
	            }this.data[d].axisX = this.axisX2[0 <= this.data[d].axisXIndex && this.data[d].axisXIndex < this.axisX2.length ? this.data[d].axisXIndex : 0];this.axisX2[0 <= this.data[d].axisXIndex && this.data[d].axisXIndex < this.axisX2.length ? this.data[d].axisXIndex : 0].dataSeries.push(this.data[d]);
	          } else this.axisX2.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX2[0] = new z(this, "axisX2", this.options.axisX2, 0, "axisX", "top")) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX2[0] = new z(this, "axisX2", this.options.axisX2, 0, "axisX", "right"))), this.data[d].axisX = this.axisX2[0], this.axisX2[0].dataSeries.push(this.data[d]);
	        }
	      }if (this.axisY) {
	        for (b = 1; b < this.axisY.length; b++) {
	          "undefined" === typeof this.axisY[b].options.gridThickness && (this.axisY[b].gridThickness = 0);
	        }for (b = 0; b < this.axisY.length - 1; b++) {
	          "undefined" === typeof this.axisY[b].options.margin && (this.axisY[b].margin = 10);
	        }
	      }if (this.axisY2) {
	        for (b = 1; b < this.axisY2.length; b++) {
	          "undefined" === typeof this.axisY2[b].options.gridThickness && (this.axisY2[b].gridThickness = 0);
	        }for (b = 0; b < this.axisY2.length - 1; b++) {
	          "undefined" === typeof this.axisY2[b].options.margin && (this.axisY2[b].margin = 10);
	        }
	      }this.axisY && 0 < this.axisY.length && this.axisY2 && 0 < this.axisY2.length && (0 < this.axisY[0].gridThickness && "undefined" === typeof this.axisY2[0].options.gridThickness ? this.axisY2[0].gridThickness = 0 : 0 < this.axisY2[0].gridThickness && "undefined" === typeof this.axisY[0].options.gridThickness && (this.axisY[0].gridThickness = 0));if (this.axisX) for (b = 0; b < this.axisX.length; b++) {
	        "undefined" === typeof this.axisX[b].options.gridThickness && (this.axisX[b].gridThickness = 0);
	      }if (this.axisX2) for (b = 0; b < this.axisX2.length; b++) {
	        "undefined" === typeof this.axisX2[b].options.gridThickness && (this.axisX2[b].gridThickness = 0);
	      }this.axisX && 0 < this.axisX.length && this.axisX2 && 0 < this.axisX2.length && (0 < this.axisX[0].gridThickness && "undefined" === typeof this.axisX2[0].options.gridThickness ? this.axisX2[0].gridThickness = 0 : 0 < this.axisX2[0].gridThickness && "undefined" === typeof this.axisX[0].options.gridThickness && (this.axisX[0].gridThickness = 0));b = !1;if (0 < this._axes.length && (this.zoomEnabled || this.panEnabled)) for (d = 0; d < this._axes.length; d++) {
	        if (null !== this._axes[d].viewportMinimum || null !== this._axes[d].viewportMaximum) {
	          b = !0;break;
	        }
	      }b ? (Qa(this._zoomButton, this._resetButton), this._toolBar.style.border = this.toolbar.borderThickness + "px solid " + this.toolbar.borderColor, this._zoomButton.style.borderRight = this.toolbar.borderThickness + "px solid " + this.toolbar.borderColor, this._resetButton.style.borderRight = (this.exportEnabled ? this.toolbar.borderThickness : 0) + "px solid " + this.toolbar.borderColor) : (va(this._zoomButton, this._resetButton), this._toolBar.style.border = this.toolbar.borderThickness + "px solid transparent", this.options.zoomEnabled && (this.zoomEnabled = !0, this.panEnabled = !1));gb(this);this._processData();this.options.title && (this.title = new Aa(this, this.options.title), this.title.dockInsidePlotArea ? a.push(this.title) : this.title.setLayout());this.subtitles = [];if (this.options.subtitles) for (d = 0; d < this.options.subtitles.length; d++) {
	        b = new Ka(this, this.options.subtitles[d], d), this.subtitles.push(b), b.dockInsidePlotArea ? a.push(b) : b.setLayout();
	      }this.legend = new H(this, this.options.legend);for (d = 0; d < this.data.length; d++) {
	        (this.data[d].showInLegend || "pie" === this.data[d].type || "doughnut" === this.data[d].type || "funnel" === this.data[d].type || "pyramid" === this.data[d].type) && this.legend.dataSeries.push(this.data[d]);
	      }this.legend.dockInsidePlotArea ? a.push(this.legend) : this.legend.setLayout();for (d = 0; d < this._axes.length; d++) {
	        if (this._axes[d].scaleBreaks && this._axes[d].scaleBreaks._appliedBreaks.length) {
	          r ? (this._breaksCanvas = ta(this.width, this.height, !0), this._breaksCanvasCtx = this._breaksCanvas.getContext("2d")) : (this._breaksCanvas = this.canvas, this._breaksCanvasCtx = this.ctx);break;
	        }
	      }this._preRenderCanvas = ta(this.width, this.height);this._preRenderCtx = this._preRenderCanvas.getContext("2d");
	      "normal" !== this.plotInfo.axisPlacement && "xySwapped" !== this.plotInfo.axisPlacement || z.setLayout(this.axisX, this.axisX2, this.axisY, this.axisY2, this.plotInfo.axisPlacement, this.layoutManager.getFreeSpace());
	    };p.prototype.renderElements = function () {
	      var a = this._plotAreaElements;this.title && !this.title.dockInsidePlotArea && this.title.render();for (var d = 0; d < this.subtitles.length; d++) {
	        this.subtitles[d].dockInsidePlotArea || this.subtitles[d].render();
	      }this.legend.dockInsidePlotArea || this.legend.render();if ("normal" === this.plotInfo.axisPlacement || "xySwapped" === this.plotInfo.axisPlacement) z.render(this.axisX, this.axisX2, this.axisY, this.axisY2, this.plotInfo.axisPlacement);else if ("none" === this.plotInfo.axisPlacement) this.preparePlotArea();else return;for (d = 0; d < a.length; d++) {
	        a[d].setLayout(), a[d].render();
	      }var b = [];if (this.animatedRender) {
	        var c = ta(this.width, this.height);c.getContext("2d").drawImage(this.canvas, 0, 0, this.width, this.height);
	      }hb(this);var a = this.ctx.miterLimit,
	          e;this.ctx.miterLimit = 3;r && this._breaksCanvas && (this._preRenderCtx.drawImage(this.canvas, 0, 0, this.width, this.height), this._preRenderCtx.drawImage(this._breaksCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx.globalCompositeOperation = "source-atop", this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), this._preRenderCtx.clearRect(0, 0, this.width, this.height));for (d = 0; d < this.plotInfo.plotTypes.length; d++) {
	        for (var g = this.plotInfo.plotTypes[d], k = 0; k < g.plotUnits.length; k++) {
	          var l = g.plotUnits[k],
	              w = null;l.targetCanvas = null;this.animatedRender && (l.targetCanvas = ta(this.width, this.height), l.targetCanvasCtx = l.targetCanvas.getContext("2d"), e = l.targetCanvasCtx.miterLimit, l.targetCanvasCtx.miterLimit = 3);"line" === l.type ? w = this.renderLine(l) : "stepLine" === l.type ? w = this.renderStepLine(l) : "spline" === l.type ? w = this.renderSpline(l) : "column" === l.type ? w = this.renderColumn(l) : "bar" === l.type ? w = this.renderBar(l) : "area" === l.type ? w = this.renderArea(l) : "stepArea" === l.type ? w = this.renderStepArea(l) : "splineArea" === l.type ? w = this.renderSplineArea(l) : "stackedColumn" === l.type ? w = this.renderStackedColumn(l) : "stackedColumn100" === l.type ? w = this.renderStackedColumn100(l) : "stackedBar" === l.type ? w = this.renderStackedBar(l) : "stackedBar100" === l.type ? w = this.renderStackedBar100(l) : "stackedArea" === l.type ? w = this.renderStackedArea(l) : "stackedArea100" === l.type ? w = this.renderStackedArea100(l) : "bubble" === l.type ? w = w = this.renderBubble(l) : "scatter" === l.type ? w = this.renderScatter(l) : "pie" === l.type ? this.renderPie(l) : "doughnut" === l.type ? this.renderPie(l) : "funnel" === l.type ? w = this.renderFunnel(l) : "pyramid" === l.type ? w = this.renderFunnel(l) : "candlestick" === l.type ? w = this.renderCandlestick(l) : "ohlc" === l.type ? w = this.renderCandlestick(l) : "rangeColumn" === l.type ? w = this.renderRangeColumn(l) : "error" === l.type ? w = this.renderError(l) : "rangeBar" === l.type ? w = this.renderRangeBar(l) : "rangeArea" === l.type ? w = this.renderRangeArea(l) : "rangeSplineArea" === l.type ? w = this.renderRangeSplineArea(l) : "waterfall" === l.type ? w = this.renderWaterfall(l) : "boxAndWhisker" === l.type && (w = this.renderBoxAndWhisker(l));
	          for (var m = 0; m < l.dataSeriesIndexes.length; m++) {
	            this._dataInRenderedOrder.push(this.data[l.dataSeriesIndexes[m]]);
	          }this.animatedRender && (l.targetCanvasCtx.miterLimit = e, w && b.push(w));
	        }
	      }this.ctx.miterLimit = a;this.animatedRender && this._breaksCanvasCtx && b.push({ source: this._breaksCanvasCtx, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0, startTimePercent: 0.7 });this.animatedRender && 0 < this._indexLabels.length && (e = ta(this.width, this.height).getContext("2d"), b.push(this.renderIndexLabels(e)));var s = this;if (0 < b.length) s.disableToolTip = !0, s._animator.animate(200, s.animationDuration, function (a) {
	        s.ctx.clearRect(0, 0, s.width, s.height);s.ctx.drawImage(c, 0, 0, Math.floor(s.width * W), Math.floor(s.height * W), 0, 0, s.width, s.height);for (var e = 0; e < b.length; e++) {
	          w = b[e], 1 > a && "undefined" !== typeof w.startTimePercent ? a >= w.startTimePercent && w.animationCallback(w.easingFunction(a - w.startTimePercent, 0, 1, 1 - w.startTimePercent), w) : w.animationCallback(w.easingFunction(a, 0, 1, 1), w);
	        }s.dispatchEvent("dataAnimationIterationEnd", { chart: s });
	      }, function () {
	        b = [];for (var a = 0; a < s.plotInfo.plotTypes.length; a++) {
	          for (var e = s.plotInfo.plotTypes[a], d = 0; d < e.plotUnits.length; d++) {
	            e.plotUnits[d].targetCanvas = null;
	          }
	        }c = null;s.disableToolTip = !1;
	      });else {
	        if (s._breaksCanvas) if (r) s.plotArea.ctx.drawImage(s._breaksCanvas, 0, 0, this.width, this.height);else for (m = 0; m < s._axes.length; m++) {
	          s._axes[m].createMask();
	        }0 < s._indexLabels.length && s.renderIndexLabels();s.dispatchEvent("dataAnimationIterationEnd", { chart: s });
	      }this.attachPlotAreaEventHandlers();
	      this.zoomEnabled || this.panEnabled || !this._zoomButton || "none" === this._zoomButton.style.display || va(this._zoomButton, this._resetButton);this.toolTip._updateToolTip();this.renderCount++;Ja && (s = this, setTimeout(function () {
	        var a = document.getElementById("ghostCanvasCopy");a && (Oa(a, s.width, s.height), a.getContext("2d").drawImage(s._eventManager.ghostCanvas, 0, 0));
	      }, 2E3));this._breaksCanvas && (delete this._breaksCanvas, delete this._breaksCanvasCtx);for (m = 0; m < this._axes.length; m++) {
	        this._axes[m].maskCanvas && (delete this._axes[m].maskCanvas, delete this._axes[m].maskCtx);
	      }
	    };p.prototype.render = function (a) {
	      a && (this.options = a);this._initialize();this.setLayout();this.renderElements();this._preRenderCanvas = null;
	    };p.prototype.attachPlotAreaEventHandlers = function () {
	      this.attachEvent({ context: this, chart: this, mousedown: this._plotAreaMouseDown, mouseup: this._plotAreaMouseUp, mousemove: this._plotAreaMouseMove, cursor: this.panEnabled ? "move" : "default", capture: !0, bounds: this.plotArea });
	    };p.prototype.categoriseDataSeries = function () {
	      for (var a = "", d = 0; d < this.data.length; d++) {
	        if (a = this.data[d], a.dataPoints && 0 !== a.dataPoints.length && a.visible && 0 <= p._supportedChartTypes.indexOf(a.type)) {
	          for (var b = null, c = !1, e = null, g = !1, k = 0; k < this.plotInfo.plotTypes.length; k++) {
	            if (this.plotInfo.plotTypes[k].type === a.type) {
	              c = !0;b = this.plotInfo.plotTypes[k];break;
	            }
	          }c || (b = { type: a.type, totalDataSeries: 0, plotUnits: [] }, this.plotInfo.plotTypes.push(b));for (k = 0; k < b.plotUnits.length; k++) {
	            if (b.plotUnits[k].axisYType === a.axisYType && b.plotUnits[k].axisXType === a.axisXType && b.plotUnits[k].axisYIndex === a.axisYIndex && b.plotUnits[k].axisXIndex === a.axisXIndex) {
	              g = !0;e = b.plotUnits[k];break;
	            }
	          }g || (e = { type: a.type, previousDataSeriesCount: 0, index: b.plotUnits.length, plotType: b, axisXType: a.axisXType, axisYType: a.axisYType, axisYIndex: a.axisYIndex, axisXIndex: a.axisXIndex, axisY: "primary" === a.axisYType ? this.axisY[0 <= a.axisYIndex && a.axisYIndex < this.axisY.length ? a.axisYIndex : 0] : this.axisY2[0 <= a.axisYIndex && a.axisYIndex < this.axisY2.length ? a.axisYIndex : 0], axisX: "primary" === a.axisXType ? this.axisX[0 <= a.axisXIndex && a.axisXIndex < this.axisX.length ? a.axisXIndex : 0] : this.axisX2[0 <= a.axisXIndex && a.axisXIndex < this.axisX2.length ? a.axisXIndex : 0], dataSeriesIndexes: [], yTotals: [] }, b.plotUnits.push(e));b.totalDataSeries++;e.dataSeriesIndexes.push(d);a.plotUnit = e;
	        }
	      }for (d = 0; d < this.plotInfo.plotTypes.length; d++) {
	        for (b = this.plotInfo.plotTypes[d], k = a = 0; k < b.plotUnits.length; k++) {
	          b.plotUnits[k].previousDataSeriesCount = a, a += b.plotUnits[k].dataSeriesIndexes.length;
	        }
	      }
	    };p.prototype.assignIdToDataPoints = function () {
	      for (var a = 0; a < this.data.length; a++) {
	        var d = this.data[a];
	        if (d.dataPoints) for (var b = d.dataPoints.length, c = 0; c < b; c++) {
	          d.dataPointIds[c] = ++this._eventManager.lastObjectId;
	        }
	      }
	    };p.prototype._processData = function () {
	      this.assignIdToDataPoints();this.categoriseDataSeries();for (var a = 0; a < this.plotInfo.plotTypes.length; a++) {
	        for (var d = this.plotInfo.plotTypes[a], b = 0; b < d.plotUnits.length; b++) {
	          var c = d.plotUnits[b];"line" === c.type || "stepLine" === c.type || "spline" === c.type || "column" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "bar" === c.type || "bubble" === c.type || "scatter" === c.type ? this._processMultiseriesPlotUnit(c) : "stackedColumn" === c.type || "stackedBar" === c.type || "stackedArea" === c.type ? this._processStackedPlotUnit(c) : "stackedColumn100" === c.type || "stackedBar100" === c.type || "stackedArea100" === c.type ? this._processStacked100PlotUnit(c) : "candlestick" === c.type || "ohlc" === c.type || "rangeColumn" === c.type || "rangeBar" === c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type || "error" === c.type || "boxAndWhisker" === c.type ? this._processMultiYPlotUnit(c) : "waterfall" === c.type && this._processSpecificPlotUnit(c);
	        }
	      }this.calculateAutoBreaks();
	    };p.prototype._processMultiseriesPlotUnit = function (a) {
	      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g = !1, k = 0; k < a.dataSeriesIndexes.length; k++) {
	        var l = this.data[a.dataSeriesIndexes[k]],
	            w = 0,
	            m = !1,
	            s = !1,
	            q;if ("normal" === l.axisPlacement || "xySwapped" === l.axisPlacement) var n = a.axisX.sessionVariables.newViewportMinimum ? a.axisX.sessionVariables.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : a.axisX.logarithmic ? 0 : -Infinity,
	            f = a.axisX.sessionVariables.newViewportMaximum ? a.axisX.sessionVariables.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;if (l.dataPoints[w].x && l.dataPoints[w].x.getTime || "dateTime" === l.xValueType) g = !0;for (w = 0; w < l.dataPoints.length; w++) {
	          "undefined" === typeof l.dataPoints[w].x && (l.dataPoints[w].x = w + (a.axisX.logarithmic ? 1 : 0));l.dataPoints[w].x.getTime ? (g = !0, c = l.dataPoints[w].x.getTime()) : c = l.dataPoints[w].x;e = l.dataPoints[w].y;c < b.min && (b.min = c);c > b.max && (b.max = c);e < d.min && "number" === typeof e && (d.min = e);e > d.max && "number" === typeof e && (d.max = e);if (0 < w) {
	            if (a.axisX.logarithmic) {
	              var B = c / l.dataPoints[w - 1].x;1 > B && (B = 1 / B);b.minDiff > B && 1 !== B && (b.minDiff = B);
	            } else B = c - l.dataPoints[w - 1].x, 0 > B && (B *= -1), b.minDiff > B && 0 !== B && (b.minDiff = B);null !== e && null !== l.dataPoints[w - 1].y && (a.axisY.logarithmic ? (B = e / l.dataPoints[w - 1].y, 1 > B && (B = 1 / B), d.minDiff > B && 1 !== B && (d.minDiff = B)) : (B = e - l.dataPoints[w - 1].y, 0 > B && (B *= -1), d.minDiff > B && 0 !== B && (d.minDiff = B)));
	          }if (c < n && !m) null !== e && (q = c);else {
	            if (!m && (m = !0, 0 < w)) {
	              w -= 2;continue;
	            }if (c > f && !s) s = !0;else if (c > f && s) continue;l.dataPoints[w].label && (a.axisX.labels[c] = l.dataPoints[w].label);c < b.viewPortMin && (b.viewPortMin = c);c > b.viewPortMax && (b.viewPortMax = c);null === e ? b.viewPortMin === c && q < c && (b.viewPortMin = q) : (e < d.viewPortMin && "number" === typeof e && (d.viewPortMin = e), e > d.viewPortMax && "number" === typeof e && (d.viewPortMax = e));
	          }
	        }l.axisX.valueType = l.xValueType = g ? "dateTime" : "number";
	      }
	    };p.prototype._processStackedPlotUnit = function (a) {
	      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
	        for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g = !1, k = [], l = [], w = Infinity, m = -Infinity, s = 0; s < a.dataSeriesIndexes.length; s++) {
	          var q = this.data[a.dataSeriesIndexes[s]],
	              n = 0,
	              f = !1,
	              B = !1,
	              h;if ("normal" === q.axisPlacement || "xySwapped" === q.axisPlacement) var p = a.axisX.sessionVariables.newViewportMinimum ? a.axisX.sessionVariables.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : -Infinity,
	              t = a.axisX.sessionVariables.newViewportMaximum ? a.axisX.sessionVariables.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;if (q.dataPoints[n].x && q.dataPoints[n].x.getTime || "dateTime" === q.xValueType) g = !0;for (n = 0; n < q.dataPoints.length; n++) {
	            "undefined" === typeof q.dataPoints[n].x && (q.dataPoints[n].x = n + (a.axisX.logarithmic ? 1 : 0));q.dataPoints[n].x.getTime ? (g = !0, c = q.dataPoints[n].x.getTime()) : c = q.dataPoints[n].x;e = u(q.dataPoints[n].y) ? 0 : q.dataPoints[n].y;c < b.min && (b.min = c);c > b.max && (b.max = c);if (0 < n) {
	              if (a.axisX.logarithmic) {
	                var r = c / q.dataPoints[n - 1].x;1 > r && (r = 1 / r);b.minDiff > r && 1 !== r && (b.minDiff = r);
	              } else r = c - q.dataPoints[n - 1].x, 0 > r && (r *= -1), b.minDiff > r && 0 !== r && (b.minDiff = r);null !== e && null !== q.dataPoints[n - 1].y && (a.axisY.logarithmic ? 0 < e && (r = e / q.dataPoints[n - 1].y, 1 > r && (r = 1 / r), d.minDiff > r && 1 !== r && (d.minDiff = r)) : (r = e - q.dataPoints[n - 1].y, 0 > r && (r *= -1), d.minDiff > r && 0 !== r && (d.minDiff = r)));
	            }if (c < p && !f) null !== q.dataPoints[n].y && (h = c);else {
	              if (!f && (f = !0, 0 < n)) {
	                n -= 2;continue;
	              }if (c > t && !B) B = !0;else if (c > t && B) continue;q.dataPoints[n].label && (a.axisX.labels[c] = q.dataPoints[n].label);c < b.viewPortMin && (b.viewPortMin = c);c > b.viewPortMax && (b.viewPortMax = c);null === q.dataPoints[n].y ? b.viewPortMin === c && h < c && (b.viewPortMin = h) : (a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + e, 0 <= e ? k[c] ? k[c] += e : (k[c] = e, w = Math.min(e, w)) : l[c] ? l[c] += e : (l[c] = e, m = Math.max(e, m)));
	            }
	          }a.axisY.scaleBreaks && a.axisY.scaleBreaks.autoCalculate && 1 <= a.axisY.scaleBreaks.maxNumberOfAutoBreaks && (d.dataPointYPositiveSums ? (d.dataPointYPositiveSums.push.apply(d.dataPointYPositiveSums, k), d.dataPointYNegativeSums.push.apply(d.dataPointYPositiveSums, l)) : (d.dataPointYPositiveSums = k, d.dataPointYNegativeSums = l));q.axisX.valueType = q.xValueType = g ? "dateTime" : "number";
	        }for (n in k) {
	          k.hasOwnProperty(n) && !isNaN(n) && (a = k[n], a < d.min && (d.min = Math.min(a, w)), a > d.max && (d.max = a), n < b.viewPortMin || n > b.viewPortMax || (a < d.viewPortMin && (d.viewPortMin = Math.min(a, w)), a > d.viewPortMax && (d.viewPortMax = a)));
	        }for (n in l) {
	          l.hasOwnProperty(n) && !isNaN(n) && (a = l[n], a < d.min && (d.min = a), a > d.max && (d.max = Math.max(a, m)), n < b.viewPortMin || n > b.viewPortMax || (a < d.viewPortMin && (d.viewPortMin = a), a > d.viewPortMax && (d.viewPortMax = Math.max(a, m))));
	        }
	      }
	    };p.prototype._processStacked100PlotUnit = function (a) {
	      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
	        for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g = !1, k = !1, l = !1, w = [], m = 0; m < a.dataSeriesIndexes.length; m++) {
	          var s = this.data[a.dataSeriesIndexes[m]],
	              q = 0,
	              n = !1,
	              f = !1,
	              B;if ("normal" === s.axisPlacement || "xySwapped" === s.axisPlacement) var h = a.axisX.sessionVariables.newViewportMinimum ? a.axisX.sessionVariables.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : -Infinity,
	              r = a.axisX.sessionVariables.newViewportMaximum ? a.axisX.sessionVariables.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;if (s.dataPoints[q].x && s.dataPoints[q].x.getTime || "dateTime" === s.xValueType) g = !0;for (q = 0; q < s.dataPoints.length; q++) {
	            "undefined" === typeof s.dataPoints[q].x && (s.dataPoints[q].x = q + (a.axisX.logarithmic ? 1 : 0));s.dataPoints[q].x.getTime ? (g = !0, c = s.dataPoints[q].x.getTime()) : c = s.dataPoints[q].x;e = u(s.dataPoints[q].y) ? null : s.dataPoints[q].y;c < b.min && (b.min = c);c > b.max && (b.max = c);if (0 < q) {
	              if (a.axisX.logarithmic) {
	                var t = c / s.dataPoints[q - 1].x;1 > t && (t = 1 / t);b.minDiff > t && 1 !== t && (b.minDiff = t);
	              } else t = c - s.dataPoints[q - 1].x, 0 > t && (t *= -1), b.minDiff > t && 0 !== t && (b.minDiff = t);u(e) || null === s.dataPoints[q - 1].y || (a.axisY.logarithmic ? 0 < e && (t = e / s.dataPoints[q - 1].y, 1 > t && (t = 1 / t), d.minDiff > t && 1 !== t && (d.minDiff = t)) : (t = e - s.dataPoints[q - 1].y, 0 > t && (t *= -1), d.minDiff > t && 0 !== t && (d.minDiff = t)));
	            }if (c < h && !n) null !== e && (B = c);else {
	              if (!n && (n = !0, 0 < q)) {
	                q -= 2;continue;
	              }if (c > r && !f) f = !0;else if (c > r && f) continue;s.dataPoints[q].label && (a.axisX.labels[c] = s.dataPoints[q].label);c < b.viewPortMin && (b.viewPortMin = c);c > b.viewPortMax && (b.viewPortMax = c);null === e ? b.viewPortMin === c && B < c && (b.viewPortMin = B) : (a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + e, 0 <= e ? k = !0 : 0 > e && (l = !0), w[c] = w[c] ? w[c] + Math.abs(e) : Math.abs(e));
	            }
	          }s.axisX.valueType = s.xValueType = g ? "dateTime" : "number";
	        }a.axisY.logarithmic ? (d.max = u(d.viewPortMax) ? 99 * Math.pow(a.axisY.logarithmBase, -0.05) : Math.max(d.viewPortMax, 99 * Math.pow(a.axisY.logarithmBase, -0.05)), d.min = u(d.viewPortMin) ? 1 : Math.min(d.viewPortMin, 1)) : k && !l ? (d.max = u(d.viewPortMax) ? 99 : Math.max(d.viewPortMax, 99), d.min = u(d.viewPortMin) ? 1 : Math.min(d.viewPortMin, 1)) : k && l ? (d.max = u(d.viewPortMax) ? 99 : Math.max(d.viewPortMax, 99), d.min = u(d.viewPortMin) ? -99 : Math.min(d.viewPortMin, -99)) : !k && l && (d.max = u(d.viewPortMax) ? -1 : Math.max(d.viewPortMax, -1), d.min = u(d.viewPortMin) ? -99 : Math.min(d.viewPortMin, -99));d.viewPortMin = d.min;d.viewPortMax = d.max;a.dataPointYSums = w;
	      }
	    };p.prototype._processMultiYPlotUnit = function (a) {
	      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g, k, l = !1, w = 0; w < a.dataSeriesIndexes.length; w++) {
	        var m = this.data[a.dataSeriesIndexes[w]],
	            s = 0,
	            q = !1,
	            n = !1,
	            f,
	            B,
	            h;if ("normal" === m.axisPlacement || "xySwapped" === m.axisPlacement) var r = a.axisX.sessionVariables.newViewportMinimum ? a.axisX.sessionVariables.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : a.axisX.logarithmic ? 0 : -Infinity,
	            t = a.axisX.sessionVariables.newViewportMaximum ? a.axisX.sessionVariables.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;if (m.dataPoints[s].x && m.dataPoints[s].x.getTime || "dateTime" === m.xValueType) l = !0;for (s = 0; s < m.dataPoints.length; s++) {
	          "undefined" === typeof m.dataPoints[s].x && (m.dataPoints[s].x = s + (a.axisX.logarithmic ? 1 : 0));m.dataPoints[s].x.getTime ? (l = !0, c = m.dataPoints[s].x.getTime()) : c = m.dataPoints[s].x;if ((e = m.dataPoints[s].y) && e.length) {
	            g = Math.min.apply(null, e);k = Math.max.apply(null, e);B = !0;for (var p = 0; p < e.length; p++) {
	              null === e.k && (B = !1);
	            }B && (q || (h = f), f = c);
	          }c < b.min && (b.min = c);c > b.max && (b.max = c);g < d.min && (d.min = g);k > d.max && (d.max = k);0 < s && (a.axisX.logarithmic ? (B = c / m.dataPoints[s - 1].x, 1 > B && (B = 1 / B), b.minDiff > B && 1 !== B && (b.minDiff = B)) : (B = c - m.dataPoints[s - 1].x, 0 > B && (B *= -1), b.minDiff > B && 0 !== B && (b.minDiff = B)), e && null !== e[0] && m.dataPoints[s - 1].y && null !== m.dataPoints[s - 1].y[0] && (a.axisY.logarithmic ? (B = e[0] / m.dataPoints[s - 1].y[0], 1 > B && (B = 1 / B), d.minDiff > B && 1 !== B && (d.minDiff = B)) : (B = e[0] - m.dataPoints[s - 1].y[0], 0 > B && (B *= -1), d.minDiff > B && 0 !== B && (d.minDiff = B))));if (!(c < r) || q) {
	            if (!q && (q = !0, 0 < s)) {
	              s -= 2;f = h;continue;
	            }if (c > t && !n) n = !0;else if (c > t && n) continue;m.dataPoints[s].label && (a.axisX.labels[c] = m.dataPoints[s].label);c < b.viewPortMin && (b.viewPortMin = c);c > b.viewPortMax && (b.viewPortMax = c);if (b.viewPortMin === c && e) for (p = 0; p < e.length; p++) {
	              if (null === e[p] && f < c) {
	                b.viewPortMin = f;break;
	              }
	            }null === e ? b.viewPortMin === c && f < c && (b.viewPortMin = f) : (g < d.viewPortMin && (d.viewPortMin = g), k > d.viewPortMax && (d.viewPortMax = k));
	          }
	        }m.axisX.valueType = m.xValueType = l ? "dateTime" : "number";
	      }
	    };p.prototype._processSpecificPlotUnit = function (a) {
	      if ("waterfall" === a.type && a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g = !1, k = 0; k < a.dataSeriesIndexes.length; k++) {
	        var l = this.data[a.dataSeriesIndexes[k]],
	            w = 0,
	            m = !1,
	            s = !1,
	            q = c = 0;if ("normal" === l.axisPlacement || "xySwapped" === l.axisPlacement) var n = a.axisX.sessionVariables.newViewportMinimum ? a.axisX.sessionVariables.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : a.axisX.logarithmic ? 0 : -Infinity,
	            f = a.axisX.sessionVariables.newViewportMaximum ? a.axisX.sessionVariables.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;if (l.dataPoints[w].x && l.dataPoints[w].x.getTime || "dateTime" === l.xValueType) g = !0;for (w = 0; w < l.dataPoints.length; w++) {
	          "undefined" !== typeof l.dataPoints[w].isCumulativeSum && !0 === l.dataPoints[w].isCumulativeSum ? (l.dataPointEOs[w].cumulativeSumYStartValue = 0, l.dataPointEOs[w].cumulativeSum = 0 === w ? 0 : l.dataPointEOs[w - 1].cumulativeSum, l.dataPoints[w].y = 0 === w ? 0 : l.dataPointEOs[w - 1].cumulativeSum) : "undefined" !== typeof l.dataPoints[w].isIntermediateSum && !0 === l.dataPoints[w].isIntermediateSum ? (l.dataPointEOs[w].cumulativeSumYStartValue = q, l.dataPointEOs[w].cumulativeSum = 0 === w ? 0 : l.dataPointEOs[w - 1].cumulativeSum, l.dataPoints[w].y = 0 === w ? 0 : c, q = 0 === w ? 0 : l.dataPointEOs[w - 1].cumulativeSum, c = 0) : (e = "number" !== typeof l.dataPoints[w].y ? 0 : l.dataPoints[w].y, l.dataPointEOs[w].cumulativeSumYStartValue = 0 === w ? 0 : l.dataPointEOs[w - 1].cumulativeSum, l.dataPointEOs[w].cumulativeSum = 0 === w ? e : l.dataPointEOs[w - 1].cumulativeSum + e, c += e);
	        }for (w = 0; w < l.dataPoints.length; w++) {
	          if ("undefined" === typeof l.dataPoints[w].x && (l.dataPoints[w].x = w + (a.axisX.logarithmic ? 1 : 0)), l.dataPoints[w].x.getTime ? (g = !0, c = l.dataPoints[w].x.getTime()) : c = l.dataPoints[w].x, e = l.dataPoints[w].y, c < b.min && (b.min = c), c > b.max && (b.max = c), l.dataPointEOs[w].cumulativeSum < d.min && (d.min = l.dataPointEOs[w].cumulativeSum), l.dataPointEOs[w].cumulativeSum > d.max && (d.max = l.dataPointEOs[w].cumulativeSum), 0 < w && (a.axisX.logarithmic ? (q = c / l.dataPoints[w - 1].x, 1 > q && (q = 1 / q), b.minDiff > q && 1 !== q && (b.minDiff = q)) : (q = c - l.dataPoints[w - 1].x, 0 > q && (q *= -1), b.minDiff > q && 0 !== q && (b.minDiff = q)), null !== e && null !== l.dataPoints[w - 1].y && (a.axisY.logarithmic ? (e = l.dataPointEOs[w].cumulativeSum / l.dataPointEOs[w - 1].cumulativeSum, 1 > e && (e = 1 / e), d.minDiff > e && 1 !== e && (d.minDiff = e)) : (e = l.dataPointEOs[w].cumulativeSum - l.dataPointEOs[w - 1].cumulativeSum, 0 > e && (e *= -1), d.minDiff > e && 0 !== e && (d.minDiff = e)))), !(c < n) || m) {
	            if (!m && (m = !0, 0 < w)) {
	              w -= 2;continue;
	            }if (c > f && !s) s = !0;else if (c > f && s) continue;l.dataPoints[w].label && (a.axisX.labels[c] = l.dataPoints[w].label);c < b.viewPortMin && (b.viewPortMin = c);c > b.viewPortMax && (b.viewPortMax = c);0 < w && (l.dataPointEOs[w - 1].cumulativeSum < d.viewPortMin && (d.viewPortMin = l.dataPointEOs[w - 1].cumulativeSum), l.dataPointEOs[w - 1].cumulativeSum > d.viewPortMax && (d.viewPortMax = l.dataPointEOs[w - 1].cumulativeSum));l.dataPointEOs[w].cumulativeSum < d.viewPortMin && (d.viewPortMin = l.dataPointEOs[w].cumulativeSum);l.dataPointEOs[w].cumulativeSum > d.viewPortMax && (d.viewPortMax = l.dataPointEOs[w].cumulativeSum);
	          }
	        }l.axisX.valueType = l.xValueType = g ? "dateTime" : "number";
	      }
	    };p.prototype.calculateAutoBreaks = function () {
	      function a(a, c, b, e) {
	        if (e) return b = Math.pow(Math.min(b * a / c, c / a), 0.2), 1 >= b && (b = Math.pow(1 > a ? 1 / a : Math.min(c / a, a), 0.25)), { startValue: a * b, endValue: c / b };b = 0.2 * Math.min(b - c + a, c - a);0 >= b && (b = 0.25 * Math.min(c - a, Math.abs(a)));return { startValue: a + b, endValue: c - b };
	      }function d(a) {
	        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
	          var c = a.axisX.scaleBreaks && a.axisX.scaleBreaks.autoCalculate && 1 <= a.axisX.scaleBreaks.maxNumberOfAutoBreaks,
	              b = a.axisY.scaleBreaks && a.axisY.scaleBreaks.autoCalculate && 1 <= a.axisY.scaleBreaks.maxNumberOfAutoBreaks;if (c || b) for (var d = a.axisY.dataInfo, f = a.axisX.dataInfo, g, m = f.min, l = f.max, k = d.min, n = d.max, f = f._dataRanges, d = d._dataRanges, q, w = 0, s = 0; s < a.dataSeriesIndexes.length; s++) {
	            var h = e.data[a.dataSeriesIndexes[s]];if (!(4 > h.dataPoints.length)) for (w = 0; w < h.dataPoints.length; w++) {
	              if (c && (q = (l + 1 - m) * Math.max(parseFloat(a.axisX.scaleBreaks.collapsibleThreshold) || 10, 10) / 100, g = h.dataPoints[w].x.getTime ? h.dataPoints[w].x.getTime() : h.dataPoints[w].x, q = Math.floor((g - m) / q), g < f[q].min && (f[q].min = g), g > f[q].max && (f[q].max = g)), b) {
	                var r = (n + 1 - k) * Math.max(parseFloat(a.axisY.scaleBreaks.collapsibleThreshold) || 10, 10) / 100;if ((g = "waterfall" === a.type ? h.dataPointEOs[w].cumulativeSum : h.dataPoints[w].y) && g.length) for (var p = 0; p < g.length; p++) {
	                  q = Math.floor((g[p] - k) / r), g[p] < d[q].min && (d[q].min = g[p]), g[p] > d[q].max && (d[q].max = g[p]);
	                } else u(g) || (q = Math.floor((g - k) / r), g < d[q].min && (d[q].min = g), g > d[q].max && (d[q].max = g));
	              }
	            }
	          }
	        }
	      }function b(a) {
	        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length) && a.axisX.scaleBreaks && a.axisX.scaleBreaks.autoCalculate && 1 <= a.axisX.scaleBreaks.maxNumberOfAutoBreaks) for (var c = a.axisX.dataInfo, b = c.min, d = c.max, f = c._dataRanges, g, m = 0, l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var k = e.data[a.dataSeriesIndexes[l]];if (!(4 > k.dataPoints.length)) for (m = 0; m < k.dataPoints.length; m++) {
	            g = (d + 1 - b) * Math.max(parseFloat(a.axisX.scaleBreaks.collapsibleThreshold) || 10, 10) / 100, c = k.dataPoints[m].x.getTime ? k.dataPoints[m].x.getTime() : k.dataPoints[m].x, g = Math.floor((c - b) / g), c < f[g].min && (f[g].min = c), c > f[g].max && (f[g].max = c);
	          }
	        }
	      }for (var c, e = this, g = !1, k = 0; k < this._axes.length; k++) {
	        if (this._axes[k].scaleBreaks && this._axes[k].scaleBreaks.autoCalculate && 1 <= this._axes[k].scaleBreaks.maxNumberOfAutoBreaks) {
	          g = !0;this._axes[k].dataInfo._dataRanges = [];for (var l = 0; l < 100 / Math.max(parseFloat(this._axes[k].scaleBreaks.collapsibleThreshold) || 10, 10); l++) {
	            this._axes[k].dataInfo._dataRanges.push({ min: Infinity, max: -Infinity });
	          }
	        }
	      }if (g) {
	        for (k = 0; k < this.plotInfo.plotTypes.length; k++) {
	          for (g = this.plotInfo.plotTypes[k], l = 0; l < g.plotUnits.length; l++) {
	            c = g.plotUnits[l], "line" === c.type || "stepLine" === c.type || "spline" === c.type || "column" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "bar" === c.type || "bubble" === c.type || "scatter" === c.type || "candlestick" === c.type || "ohlc" === c.type || "rangeColumn" === c.type || "rangeBar" === c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type || "waterfall" === c.type || "error" === c.type || "boxAndWhisker" === c.type ? d(c) : 0 <= c.type.indexOf("stacked") && b(c);
	          }
	        }for (k = 0; k < this._axes.length; k++) {
	          if (this._axes[k].dataInfo._dataRanges) {
	            var w = this._axes[k].dataInfo.min;c = (this._axes[k].dataInfo.max + 1 - w) * Math.max(parseFloat(this._axes[k].scaleBreaks.collapsibleThreshold) || 10, 10) / 100;var m = this._axes[k].dataInfo._dataRanges,
	                s,
	                q,
	                g = [];if (this._axes[k].dataInfo.dataPointYPositiveSums) {
	              var n = this._axes[k].dataInfo.dataPointYPositiveSums;
	              s = m;for (l in n) {
	                if (n.hasOwnProperty(l) && !isNaN(l) && (q = n[l], !u(q))) {
	                  var f = Math.floor((q - w) / c);q < s[f].min && (s[f].min = q);q > s[f].max && (s[f].max = q);
	                }
	              }delete this._axes[k].dataInfo.dataPointYPositiveSums;
	            }if (this._axes[k].dataInfo.dataPointYNegativeSums) {
	              n = this._axes[k].dataInfo.dataPointYNegativeSums;s = m;for (l in n) {
	                n.hasOwnProperty(l) && !isNaN(l) && (q = -1 * n[l], u(q) || (f = Math.floor((q - w) / c), q < s[f].min && (s[f].min = q), q > s[f].max && (s[f].max = q)));
	              }delete this._axes[k].dataInfo.dataPointYNegativeSums;
	            }for (l = 0; l < m.length - 1; l++) {
	              if (s = m[l].max, isFinite(s)) for (; l < m.length - 1;) {
	                if (w = m[l + 1].min, isFinite(w)) {
	                  q = w - s;q > c && g.push({ diff: q, start: s, end: w });break;
	                } else l++;
	              }
	            }if (this._axes[k].scaleBreaks.customBreaks) for (l = 0; l < this._axes[k].scaleBreaks.customBreaks.length; l++) {
	              for (c = 0; c < g.length; c++) {
	                if (this._axes[k].scaleBreaks.customBreaks[l].startValue <= g[c].start && g[c].start <= this._axes[k].scaleBreaks.customBreaks[l].endValue || this._axes[k].scaleBreaks.customBreaks[l].startValue <= g[c].start && g[c].start <= this._axes[k].scaleBreaks.customBreaks[l].endValue || g[c].start <= this._axes[k].scaleBreaks.customBreaks[l].startValue && this._axes[k].scaleBreaks.customBreaks[l].startValue <= g[c].end || g[c].start <= this._axes[k].scaleBreaks.customBreaks[l].endValue && this._axes[k].scaleBreaks.customBreaks[l].endValue <= g[c].end) g.splice(c, 1), c--;
	              }
	            }g.sort(function (a, c) {
	              return c.diff - a.diff;
	            });for (l = 0; l < Math.min(g.length, this._axes[k].scaleBreaks.maxNumberOfAutoBreaks); l++) {
	              c = a(g[l].start, g[l].end, this._axes[k].logarithmic ? this._axes[k].dataInfo.max / this._axes[k].dataInfo.min : this._axes[k].dataInfo.max - this._axes[k].dataInfo.min, this._axes[k].logarithmic), this._axes[k].scaleBreaks.autoBreaks.push(new L(this, "autoBreaks", c, l, ++this._eventManager.lastObjectId, this._axes[k].scaleBreaks)), this._axes[k].scaleBreaks._appliedBreaks.push(this._axes[k].scaleBreaks.autoBreaks[this._axes[k].scaleBreaks.autoBreaks.length - 1]);
	            }this._axes[k].scaleBreaks._appliedBreaks.sort(function (a, c) {
	              return a.startValue - c.startValue;
	            });
	          }
	        }
	      }
	    };p.prototype.getDataPointAtXY = function (a, d, b) {
	      b = b || !1;for (var c = [], e = this._dataInRenderedOrder.length - 1; 0 <= e; e--) {
	        var g = null;(g = this._dataInRenderedOrder[e].getDataPointAtXY(a, d, b)) && c.push(g);
	      }a = null;d = !1;for (b = 0; b < c.length; b++) {
	        if ("line" === c[b].dataSeries.type || "stepLine" === c[b].dataSeries.type || "area" === c[b].dataSeries.type || "stepArea" === c[b].dataSeries.type) if (e = na("markerSize", c[b].dataPoint, c[b].dataSeries) || 8, c[b].distance <= e / 2) {
	          d = !0;break;
	        }
	      }for (b = 0; b < c.length; b++) {
	        d && "line" !== c[b].dataSeries.type && "stepLine" !== c[b].dataSeries.type && "area" !== c[b].dataSeries.type && "stepArea" !== c[b].dataSeries.type || (a ? c[b].distance <= a.distance && (a = c[b]) : a = c[b]);
	      }return a;
	    };p.prototype.getObjectAtXY = function (a, d, b) {
	      var c = null;if (b = this.getDataPointAtXY(a, d, b || !1)) c = b.dataSeries.dataPointIds[b.dataPointIndex];else if (r) c = ab(a, d, this._eventManager.ghostCtx);else for (b = 0; b < this.legend.items.length; b++) {
	        var e = this.legend.items[b];a >= e.x1 && a <= e.x2 && d >= e.y1 && d <= e.y2 && (c = e.id);
	      }return c;
	    };p.prototype.getAutoFontSize = lb;p.prototype.resetOverlayedCanvas = function () {
	      this.overlaidCanvasCtx.clearRect(0, 0, this.width, this.height);
	    };p.prototype.clearCanvas = kb;p.prototype.attachEvent = function (a) {
	      this._events.push(a);
	    };p.prototype._touchEventHandler = function (a) {
	      if (a.changedTouches && this.interactivityEnabled) {
	        var d = [],
	            b = a.changedTouches,
	            c = b ? b[0] : a,
	            e = null;switch (a.type) {case "touchstart":case "MSPointerDown":
	            d = ["mousemove", "mousedown"];this._lastTouchData = Ra(c);this._lastTouchData.time = new Date();break;case "touchmove":case "MSPointerMove":
	            d = ["mousemove"];break;case "touchend":case "MSPointerUp":
	            var g = this._lastTouchData && this._lastTouchData.time ? new Date() - this._lastTouchData.time : 0,
	                d = "touchstart" === this._lastTouchEventType || "MSPointerDown" === this._lastTouchEventType || 300 > g ? ["mouseup", "click"] : ["mouseup"];break;default:
	            return;}if (!(b && 1 < b.length)) {
	          e = Ra(c);e.time = new Date();try {
	            var k = e.y - this._lastTouchData.y,
	                g = e.time - this._lastTouchData.time;if (1 < Math.abs(k) && this._lastTouchData.scroll || 5 < Math.abs(k) && 250 > g) this._lastTouchData.scroll = !0;
	          } catch (l) {}this._lastTouchEventType = a.type;if (this._lastTouchData.scroll && this.zoomEnabled) this.isDrag && this.resetOverlayedCanvas(), this.isDrag = !1;else for (b = 0; b < d.length; b++) {
	            if (e = d[b], k = document.createEvent("MouseEvent"), k.initMouseEvent(e, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), c.target.dispatchEvent(k), !u(this._lastTouchData.scroll) && !this._lastTouchData.scroll || !this._lastTouchData.scroll && 250 < g || "click" === e) a.preventManipulation && a.preventManipulation(), a.preventDefault && a.preventDefault();
	          }
	        }
	      }
	    };p.prototype._dispatchRangeEvent = function (a, d) {
	      var b = { chart: this };b.type = a;b.trigger = d;var c = [];this.axisX && 0 < this.axisX.length && c.push("axisX");this.axisX2 && 0 < this.axisX2.length && c.push("axisX2");this.axisY && 0 < this.axisY.length && c.push("axisY");this.axisY2 && 0 < this.axisY2.length && c.push("axisY2");for (var e = 0; e < c.length; e++) {
	        if (u(b[c[e]]) && (b[c[e]] = []), "axisY" === c[e]) for (var g = 0; g < this.axisY.length; g++) {
	          b[c[e]].push({ viewportMinimum: this[c[e]][g].sessionVariables.newViewportMinimum, viewportMaximum: this[c[e]][g].sessionVariables.newViewportMaximum });
	        } else if ("axisY2" === c[e]) for (g = 0; g < this.axisY2.length; g++) {
	          b[c[e]].push({ viewportMinimum: this[c[e]][g].sessionVariables.newViewportMinimum, viewportMaximum: this[c[e]][g].sessionVariables.newViewportMaximum });
	        } else if ("axisX" === c[e]) for (g = 0; g < this.axisX.length; g++) {
	          b[c[e]].push({ viewportMinimum: this[c[e]][g].sessionVariables.newViewportMinimum, viewportMaximum: this[c[e]][g].sessionVariables.newViewportMaximum });
	        } else if ("axisX2" === c[e]) for (g = 0; g < this.axisX2.length; g++) {
	          b[c[e]].push({ viewportMinimum: this[c[e]][g].sessionVariables.newViewportMinimum,
	            viewportMaximum: this[c[e]][g].sessionVariables.newViewportMaximum });
	        }
	      }this.dispatchEvent(a, b, this);
	    };p.prototype._mouseEventHandler = function (a) {
	      "undefined" === typeof a.target && a.srcElement && (a.target = a.srcElement);var d = Ra(a),
	          b = a.type,
	          c,
	          e;a.which ? e = 3 == a.which : a.button && (e = 2 == a.button);p.capturedEventParam && (c = p.capturedEventParam, "mouseup" === b && (p.capturedEventParam = null, c.chart.overlaidCanvas.releaseCapture ? c.chart.overlaidCanvas.releaseCapture() : document.documentElement.removeEventListener("mouseup", c.chart._mouseEventHandler, !1)), c.hasOwnProperty(b) && ("mouseup" !== b || c.chart.overlaidCanvas.releaseCapture ? a.target !== c.chart.overlaidCanvas && r || c[b].call(c.context, d.x, d.y) : a.target !== c.chart.overlaidCanvas && (c.chart.isDrag = !1)));if (this.interactivityEnabled) if (this._ignoreNextEvent) this._ignoreNextEvent = !1;else if (a.preventManipulation && a.preventManipulation(), a.preventDefault && a.preventDefault(), Ja && window.console && (window.console.log(b + " --\x3e x: " + d.x + "; y:" + d.y), e && window.console.log(a.which), "mouseup" === b && window.console.log("mouseup")), !e) {
	        if (!p.capturedEventParam && this._events) {
	          for (var g = 0; g < this._events.length; g++) {
	            if (this._events[g].hasOwnProperty(b)) if (c = this._events[g], e = c.bounds, d.x >= e.x1 && d.x <= e.x2 && d.y >= e.y1 && d.y <= e.y2) {
	              c[b].call(c.context, d.x, d.y);"mousedown" === b && !0 === c.capture ? (p.capturedEventParam = c, this.overlaidCanvas.setCapture ? this.overlaidCanvas.setCapture() : document.documentElement.addEventListener("mouseup", this._mouseEventHandler, !1)) : "mouseup" === b && (c.chart.overlaidCanvas.releaseCapture ? c.chart.overlaidCanvas.releaseCapture() : document.documentElement.removeEventListener("mouseup", this._mouseEventHandler, !1));break;
	            } else c = null;
	          }a.target.style.cursor = c && c.cursor ? c.cursor : this._defaultCursor;
	        }b = this.plotArea;if (d.x < b.x1 || d.x > b.x2 || d.y < b.y1 || d.y > b.y2) this.toolTip && this.toolTip.enabled ? this.toolTip.hide() : this.resetOverlayedCanvas();this.isDrag && this.zoomEnabled || !this._eventManager || this._eventManager.mouseEventHandler(a);
	      }
	    };p.prototype._plotAreaMouseDown = function (a, d) {
	      this.isDrag = !0;this.dragStartPoint = { x: a, y: d };
	    };p.prototype._plotAreaMouseUp = function (a, d) {
	      if (("normal" === this.plotInfo.axisPlacement || "xySwapped" === this.plotInfo.axisPlacement) && this.isDrag) {
	        var b = d - this.dragStartPoint.y,
	            c = a - this.dragStartPoint.x,
	            e = 0 <= this.zoomType.indexOf("x"),
	            g = 0 <= this.zoomType.indexOf("y"),
	            k = !1;this.resetOverlayedCanvas();if ("xySwapped" === this.plotInfo.axisPlacement) var l = g,
	            g = e,
	            e = l;if (this.panEnabled || this.zoomEnabled) {
	          if (this.panEnabled) for (e = g = 0; e < this._axes.length; e++) {
	            b = this._axes[e], b.logarithmic ? b.viewportMinimum < b.minimum ? (g = b.minimum / b.viewportMinimum, b.sessionVariables.newViewportMinimum = b.viewportMinimum * g, b.sessionVariables.newViewportMaximum = b.viewportMaximum * g, k = !0) : b.viewportMaximum > b.maximum && (g = b.viewportMaximum / b.maximum, b.sessionVariables.newViewportMinimum = b.viewportMinimum / g, b.sessionVariables.newViewportMaximum = b.viewportMaximum / g, k = !0) : b.viewportMinimum < b.minimum ? (g = b.minimum - b.viewportMinimum, b.sessionVariables.newViewportMinimum = b.viewportMinimum + g, b.sessionVariables.newViewportMaximum = b.viewportMaximum + g, k = !0) : b.viewportMaximum > b.maximum && (g = b.viewportMaximum - b.maximum, b.sessionVariables.newViewportMinimum = b.viewportMinimum - g, b.sessionVariables.newViewportMaximum = b.viewportMaximum - g, k = !0);
	          } else if ((!e || 2 < Math.abs(c)) && (!g || 2 < Math.abs(b)) && this.zoomEnabled) {
	            if (!this.dragStartPoint) return;b = e ? this.dragStartPoint.x : this.plotArea.x1;c = g ? this.dragStartPoint.y : this.plotArea.y1;e = e ? a : this.plotArea.x2;g = g ? d : this.plotArea.y2;2 < Math.abs(b - e) && 2 < Math.abs(c - g) && this._zoomPanToSelectedRegion(b, c, e, g) && (k = !0);
	          }k && (this._ignoreNextEvent = !0, this._dispatchRangeEvent("rangeChanging", "zoom"), this.render(), this._dispatchRangeEvent("rangeChanged", "zoom"), k && this.zoomEnabled && "none" === this._zoomButton.style.display && (Qa(this._zoomButton, this._resetButton), ua(this, this._zoomButton, "pan"), ua(this, this._resetButton, "reset")));
	        }
	      }this.isDrag = !1;if ("none" !== this.plotInfo.axisPlacement) {
	        this.resetOverlayedCanvas();if (this.axisX && 0 < this.axisX.length) for (k = 0; k < this.axisX.length; k++) {
	          this.axisX[k].crosshair && this.axisX[k].crosshair.enabled && this.axisX[k].renderCrosshair(a, d);
	        }if (this.axisX2 && 0 < this.axisX2.length) for (k = 0; k < this.axisX2.length; k++) {
	          this.axisX2[k].crosshair && this.axisX2[k].crosshair.enabled && this.axisX2[k].renderCrosshair(a, d);
	        }if (this.axisY && 0 < this.axisY.length) for (k = 0; k < this.axisY.length; k++) {
	          this.axisY[k].crosshair && this.axisY[k].crosshair.enabled && this.axisY[k].renderCrosshair(a, d);
	        }if (this.axisY2 && 0 < this.axisY2.length) for (k = 0; k < this.axisY2.length; k++) {
	          this.axisY2[k].crosshair && this.axisY2[k].crosshair.enabled && this.axisY2[k].renderCrosshair(a, d);
	        }
	      }
	    };p.prototype._plotAreaMouseMove = function (a, d) {
	      if (this.isDrag && "none" !== this.plotInfo.axisPlacement) {
	        var b = 0,
	            c = 0,
	            e = b = null,
	            e = 0 <= this.zoomType.indexOf("x"),
	            g = 0 <= this.zoomType.indexOf("y"),
	            k = this;"xySwapped" === this.plotInfo.axisPlacement && (b = g, g = e, e = b);b = this.dragStartPoint.x - a;c = this.dragStartPoint.y - d;2 < Math.abs(b) && 8 > Math.abs(b) && (this.panEnabled || this.zoomEnabled) ? this.toolTip.hide() : this.panEnabled || this.zoomEnabled || this.toolTip.mouseMoveHandler(a, d);if ((!e || 2 < Math.abs(b) || !g || 2 < Math.abs(c)) && (this.panEnabled || this.zoomEnabled)) if (this.panEnabled) e = { x1: e ? this.plotArea.x1 + b : this.plotArea.x1, y1: g ? this.plotArea.y1 + c : this.plotArea.y1, x2: e ? this.plotArea.x2 + b : this.plotArea.x2, y2: g ? this.plotArea.y2 + c : this.plotArea.y2 }, clearTimeout(k._panTimerId), k._panTimerId = setTimeout(function (c, b, e, f) {
	          return function () {
	            k._zoomPanToSelectedRegion(c, b, e, f, !0) && (k._dispatchRangeEvent("rangeChanging", "pan"), k.render(), k._dispatchRangeEvent("rangeChanged", "pan"), k.dragStartPoint.x = a, k.dragStartPoint.y = d);
	          };
	        }(e.x1, e.y1, e.x2, e.y2), 0);else if (this.zoomEnabled) {
	          this.resetOverlayedCanvas();b = this.overlaidCanvasCtx.globalAlpha;this.overlaidCanvasCtx.fillStyle = "#A89896";var c = e ? this.dragStartPoint.x : this.plotArea.x1,
	              l = g ? this.dragStartPoint.y : this.plotArea.y1,
	              w = e ? a - this.dragStartPoint.x : this.plotArea.x2 - this.plotArea.x1,
	              m = g ? d - this.dragStartPoint.y : this.plotArea.y2 - this.plotArea.y1;this.validateRegion(c, l, e ? a : this.plotArea.x2 - this.plotArea.x1, g ? d : this.plotArea.y2 - this.plotArea.y1, "xy" !== this.zoomType).isValid && (this.resetOverlayedCanvas(), this.overlaidCanvasCtx.fillStyle = "#99B2B5");this.overlaidCanvasCtx.globalAlpha = 0.7;this.overlaidCanvasCtx.fillRect(c, l, w, m);this.overlaidCanvasCtx.globalAlpha = b;
	        }
	      } else if (this.toolTip.mouseMoveHandler(a, d), "none" !== this.plotInfo.axisPlacement) {
	        if (this.axisX && 0 < this.axisX.length) for (e = 0; e < this.axisX.length; e++) {
	          this.axisX[e].crosshair && this.axisX[e].crosshair.enabled && this.axisX[e].renderCrosshair(a, d);
	        }if (this.axisX2 && 0 < this.axisX2.length) for (e = 0; e < this.axisX2.length; e++) {
	          this.axisX2[e].crosshair && this.axisX2[e].crosshair.enabled && this.axisX2[e].renderCrosshair(a, d);
	        }if (this.axisY && 0 < this.axisY.length) for (e = 0; e < this.axisY.length; e++) {
	          this.axisY[e].crosshair && this.axisY[e].crosshair.enabled && this.axisY[e].renderCrosshair(a, d);
	        }if (this.axisY2 && 0 < this.axisY2.length) for (e = 0; e < this.axisY2.length; e++) {
	          this.axisY2[e].crosshair && this.axisY2[e].crosshair.enabled && this.axisY2[e].renderCrosshair(a, d);
	        }
	      }
	    };p.prototype._zoomPanToSelectedRegion = function (a, d, b, c, e) {
	      a = this.validateRegion(a, d, b, c, e);d = a.axesWithValidRange;b = a.axesRanges;if (a.isValid) for (c = 0; c < d.length; c++) {
	        e = b[c], d[c].setViewPortRange(e.val1, e.val2), this.syncCharts && this.syncCharts(e.val1, e.val2);
	      }return a.isValid;
	    };p.prototype.validateRegion = function (a, d, b, c, e) {
	      e = e || !1;for (var g = 0 <= this.zoomType.indexOf("x"), k = 0 <= this.zoomType.indexOf("y"), l = !1, w = [], m = [], s = [], q = 0; q < this._axes.length; q++) {
	        ("axisX" === this._axes[q].type && g || "axisY" === this._axes[q].type && k) && m.push(this._axes[q]);
	      }for (k = 0; k < m.length; k++) {
	        var q = m[k],
	            g = !1,
	            n = q.convertPixelToValue({ x: a, y: d }),
	            f = q.convertPixelToValue({ x: b, y: c });
	        if (n > f) var B = f,
	            f = n,
	            n = B;if (q.scaleBreaks) for (B = 0; !g && B < q.scaleBreaks._appliedBreaks.length; B++) {
	          g = q.scaleBreaks._appliedBreaks[B].startValue <= n && q.scaleBreaks._appliedBreaks[B].endValue >= f;
	        }if (isFinite(q.dataInfo.minDiff)) if (B = q.getApparentDifference(n, f, null, !0), !(g || !(this.panEnabled && q.scaleBreaks && q.scaleBreaks._appliedBreaks.length) && (q.logarithmic && B < Math.pow(q.dataInfo.minDiff, 3) || !q.logarithmic && B < 3 * Math.abs(q.dataInfo.minDiff)) || n < q.minimum || f > q.maximum)) w.push(q), s.push({ val1: n, val2: f }), l = !0;else if (!e) {
	          l = !1;break;
	        }
	      }return { isValid: l, axesWithValidRange: w, axesRanges: s };
	    };p.prototype.preparePlotArea = function () {
	      var a = this.plotArea;!r && (0 < a.x1 || 0 < a.y1) && a.ctx.translate(a.x1, a.y1);if ((this.axisX[0] || this.axisX2[0]) && (this.axisY[0] || this.axisY2[0])) {
	        var d = this.axisX[0] ? this.axisX[0].lineCoordinates : this.axisX2[0].lineCoordinates;if (this.axisY && 0 < this.axisY.length && this.axisY[0]) {
	          var b = this.axisY[0];a.x1 = d.x1 < d.x2 ? d.x1 : b.lineCoordinates.x1;a.y1 = d.y1 < b.lineCoordinates.y1 ? d.y1 : b.lineCoordinates.y1;
	          a.x2 = d.x2 > b.lineCoordinates.x2 ? d.x2 : b.lineCoordinates.x2;a.y2 = d.y2 > d.y1 ? d.y2 : b.lineCoordinates.y2;a.width = a.x2 - a.x1;a.height = a.y2 - a.y1;
	        }this.axisY2 && 0 < this.axisY2.length && this.axisY2[0] && (b = this.axisY2[0], a.x1 = d.x1 < d.x2 ? d.x1 : b.lineCoordinates.x1, a.y1 = d.y1 < b.lineCoordinates.y1 ? d.y1 : b.lineCoordinates.y1, a.x2 = d.x2 > b.lineCoordinates.x2 ? d.x2 : b.lineCoordinates.x2, a.y2 = d.y2 > d.y1 ? d.y2 : b.lineCoordinates.y2, a.width = a.x2 - a.x1, a.height = a.y2 - a.y1);
	      } else d = this.layoutManager.getFreeSpace(), a.x1 = d.x1, a.x2 = d.x2, a.y1 = d.y1, a.y2 = d.y2, a.width = d.width, a.height = d.height;r || (a.canvas.width = a.width, a.canvas.height = a.height, a.canvas.style.left = a.x1 + "px", a.canvas.style.top = a.y1 + "px", (0 < a.x1 || 0 < a.y1) && a.ctx.translate(-a.x1, -a.y1));a.layoutManager = new Ga(a.x1, a.y1, a.x2, a.y2, 2);
	    };p.prototype.renderIndexLabels = function (a) {
	      var d = a || this.plotArea.ctx,
	          b = this.plotArea,
	          c = 0,
	          e = 0,
	          g = 0,
	          k = 0,
	          l = c = k = e = g = 0,
	          w = 0;for (a = 0; a < this._indexLabels.length; a++) {
	        var m = this._indexLabels[a],
	            s = m.chartType.toLowerCase(),
	            q,
	            n,
	            l = na("indexLabelFontColor", m.dataPoint, m.dataSeries),
	            w = na("indexLabelFontSize", m.dataPoint, m.dataSeries);q = na("indexLabelFontFamily", m.dataPoint, m.dataSeries);n = na("indexLabelFontStyle", m.dataPoint, m.dataSeries);var k = na("indexLabelFontWeight", m.dataPoint, m.dataSeries),
	            f = na("indexLabelBackgroundColor", m.dataPoint, m.dataSeries),
	            e = na("indexLabelMaxWidth", m.dataPoint, m.dataSeries),
	            g = na("indexLabelWrap", m.dataPoint, m.dataSeries),
	            B = na("indexLabelLineDashType", m.dataPoint, m.dataSeries),
	            h = na("indexLabelLineColor", m.dataPoint, m.dataSeries),
	            p = u(m.dataPoint.indexLabelLineThickness) ? u(m.dataSeries.options.indexLabelLineThickness) ? 0 : m.dataSeries.options.indexLabelLineThickness : m.dataPoint.indexLabelLineThickness,
	            c = 0 < p ? Math.min(10, ("normal" === this.plotInfo.axisPlacement ? this.plotArea.height : this.plotArea.width) << 0) : 0,
	            t = { percent: null, total: null },
	            C = null;if (0 <= m.dataSeries.type.indexOf("stacked") || "pie" === m.dataSeries.type || "doughnut" === m.dataSeries.type) t = this.getPercentAndTotal(m.dataSeries, m.dataPoint);if (m.dataSeries.indexLabelFormatter || m.dataPoint.indexLabelFormatter) C = { chart: this, dataSeries: m.dataSeries, dataPoint: m.dataPoint, index: m.indexKeyword, total: t.total, percent: t.percent };var x = m.dataPoint.indexLabelFormatter ? m.dataPoint.indexLabelFormatter(C) : m.dataPoint.indexLabel ? this.replaceKeywordsWithValue(m.dataPoint.indexLabel, m.dataPoint, m.dataSeries, null, m.indexKeyword) : m.dataSeries.indexLabelFormatter ? m.dataSeries.indexLabelFormatter(C) : m.dataSeries.indexLabel ? this.replaceKeywordsWithValue(m.dataSeries.indexLabel, m.dataPoint, m.dataSeries, null, m.indexKeyword) : null;if (null !== x && "" !== x) {
	          var t = na("indexLabelPlacement", m.dataPoint, m.dataSeries),
	              C = na("indexLabelOrientation", m.dataPoint, m.dataSeries),
	              ma = m.direction,
	              y = m.dataSeries.axisX,
	              A = m.dataSeries.axisY,
	              v = !1,
	              f = new ka(d, { x: 0, y: 0, maxWidth: e ? e : 0.5 * this.width, maxHeight: g ? 5 * w : 1.5 * w, angle: "horizontal" === C ? 0 : -90, text: x, padding: 0, backgroundColor: f, horizontalAlign: "left", fontSize: w, fontFamily: q, fontWeight: k, fontColor: l, fontStyle: n, textBaseline: "top" });f.measureText();m.dataSeries.indexLabelMaxWidth = f.maxWidth;if ("stackedarea100" === s) {
	            if (m.point.x < b.x1 || m.point.x > b.x2 || m.point.y < b.y1 - 1 || m.point.y > b.y2 + 1) continue;
	          } else if ("rangearea" === s || "rangesplinearea" === s) {
	            if (m.dataPoint.x < y.viewportMinimum || m.dataPoint.x > y.viewportMaximum || Math.max.apply(null, m.dataPoint.y) < A.viewportMinimum || Math.min.apply(null, m.dataPoint.y) > A.viewportMaximum) continue;
	          } else if (0 <= s.indexOf("line") || 0 <= s.indexOf("area") || 0 <= s.indexOf("bubble") || 0 <= s.indexOf("scatter")) {
	            if (m.dataPoint.x < y.viewportMinimum || m.dataPoint.x > y.viewportMaximum || m.dataPoint.y < A.viewportMinimum || m.dataPoint.y > A.viewportMaximum) continue;
	          } else if (0 <= s.indexOf("column") || "waterfall" === s || "error" === s && !m.axisSwapped) {
	            if (m.dataPoint.x < y.viewportMinimum || m.dataPoint.x > y.viewportMaximum || m.bounds.y1 > b.y2 || m.bounds.y2 < b.y1) continue;
	          } else if (0 <= s.indexOf("bar") || "error" === s) {
	            if (m.dataPoint.x < y.viewportMinimum || m.dataPoint.x > y.viewportMaximum || m.bounds.x1 > b.x2 || m.bounds.x2 < b.x1) continue;
	          } else if ("candlestick" === s || "ohlc" === s) {
	            if (m.dataPoint.x < y.viewportMinimum || m.dataPoint.x > y.viewportMaximum || Math.max.apply(null, m.dataPoint.y) < A.viewportMinimum || Math.min.apply(null, m.dataPoint.y) > A.viewportMaximum) continue;
	          } else if (m.dataPoint.x < y.viewportMinimum || m.dataPoint.x > y.viewportMaximum) continue;e = k = 2;"horizontal" === C ? (l = f.width, w = f.height) : (w = f.width, l = f.height);if ("normal" === this.plotInfo.axisPlacement) {
	            if (0 <= s.indexOf("line") || 0 <= s.indexOf("area")) t = "auto", k = 4;else if (0 <= s.indexOf("stacked")) "auto" === t && (t = "inside");else if ("bubble" === s || "scatter" === s) t = "inside";q = m.point.x - l / 2;"inside" !== t ? (e = b.y1, g = b.y2, 0 < ma ? (n = m.point.y - w - k - c, n < e && (n = "auto" === t ? Math.max(m.point.y, e) + k + c : e + k + c, v = n + w > m.point.y)) : (n = m.point.y + k + c, n > g - w - k - c && (n = "auto" === t ? Math.min(m.point.y, g) - w - k - c : g - w - k - c, v = n < m.point.y))) : (e = Math.max(m.bounds.y1, b.y1), g = Math.min(m.bounds.y2, b.y2), c = 0 <= s.indexOf("range") || "error" === s ? 0 < ma ? Math.max(m.bounds.y1, b.y1) + w / 2 + k : Math.min(m.bounds.y2, b.y2) - w / 2 - k : (Math.max(m.bounds.y1, b.y1) + Math.min(m.bounds.y2, b.y2)) / 2, 0 < ma ? (n = Math.max(m.point.y, c) - w / 2, n < e && ("bubble" === s || "scatter" === s) && (n = Math.max(m.point.y - w - k, b.y1 + k))) : (n = Math.min(m.point.y, c) - w / 2, n > g - w - k && ("bubble" === s || "scatter" === s) && (n = Math.min(m.point.y + k, b.y2 - w - k))), n = Math.min(n, g - w));
	          } else 0 <= s.indexOf("line") || 0 <= s.indexOf("area") || 0 <= s.indexOf("scatter") ? (t = "auto", e = 4) : 0 <= s.indexOf("stacked") ? "auto" === t && (t = "inside") : "bubble" === s && (t = "inside"), n = m.point.y - w / 2, "inside" !== t ? (k = b.x1, g = b.x2, 0 > ma ? (q = m.point.x - l - e - c, q < k && (q = "auto" === t ? Math.max(m.point.x, k) + e + c : k + e + c, v = q + l > m.point.x)) : (q = m.point.x + e + c, q > g - l - e - c && (q = "auto" === t ? Math.min(m.point.x, g) - l - e - c : g - l - e - c, v = q < m.point.x))) : (k = Math.max(m.bounds.x1, b.x1), Math.min(m.bounds.x2, b.x2), c = 0 <= s.indexOf("range") || "error" === s ? 0 > ma ? Math.max(m.bounds.x1, b.x1) + l / 2 + e : Math.min(m.bounds.x2, b.x2) - l / 2 - e : (Math.max(m.bounds.x1, b.x1) + Math.min(m.bounds.x2, b.x2)) / 2, q = 0 > ma ? Math.max(m.point.x, c) - l / 2 : Math.min(m.point.x, c) - l / 2, q = Math.max(q, k));"vertical" === C && (n += w);f.x = q;f.y = n;f.render(!0);p && "inside" !== t && (0 > s.indexOf("bar") && ("error" !== s || !m.axisSwapped) && m.point.x > b.x1 && m.point.x < b.x2 || !v) && (0 > s.indexOf("column") && ("error" !== s || m.axisSwapped) && m.point.y > b.y1 && m.point.y < b.y2 || !v) && (d.lineWidth = p, d.strokeStyle = h ? h : "gray", d.setLineDash && d.setLineDash(R(B, p)), d.beginPath(), d.moveTo(m.point.x, m.point.y), 0 <= s.indexOf("bar") || "error" === s && m.axisSwapped ? d.lineTo(q + (0 < m.direction ? 0 : l), n + ("horizontal" === C ? w : -w) / 2) : 0 <= s.indexOf("column") || "error" === s && !m.axisSwapped ? d.lineTo(q + l / 2, n + ((0 < m.direction ? w : -w) + ("horizontal" === C ? w : -w)) / 2) : d.lineTo(q + l / 2, n + ((n < m.point.y ? w : -w) + ("horizontal" === C ? w : -w)) / 2), d.stroke());
	        }
	      }d = { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0, startTimePercent: 0.7 };for (a = 0; a < this._indexLabels.length; a++) {
	        m = this._indexLabels[a], f = na("indexLabelBackgroundColor", m.dataPoint, m.dataSeries), m.dataSeries.indexLabelBackgroundColor = u(f) ? r ? "transparent" : null : f;
	      }return d;
	    };p.prototype.renderLine = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = this._eventManager.ghostCtx;b.save();var e = this.plotArea;b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();for (var g = [], k, l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var w = a.dataSeriesIndexes[l],
	              m = this.data[w];b.lineWidth = m.lineThickness;var s = m.dataPoints,
	              q = "solid";if (b.setLineDash) {
	            var n = R(m.nullDataLineDashType, m.lineThickness),
	                q = m.lineDashType,
	                f = R(q, m.lineThickness);b.setLineDash(f);
	          }var B = m.id;this._eventManager.objectMap[B] = { objectType: "dataSeries", dataSeriesIndex: w };B = N(B);c.strokeStyle = B;
	          c.lineWidth = 0 < m.lineThickness ? Math.max(m.lineThickness, 4) : 0;var B = m._colorSet,
	              h = B = m.lineColor = m.options.lineColor ? m.options.lineColor : B[0];b.strokeStyle = B;var p = !0,
	              t = 0,
	              C,
	              x;b.beginPath();if (0 < s.length) {
	            for (var u = !1, t = 0; t < s.length; t++) {
	              if (C = s[t].x.getTime ? s[t].x.getTime() : s[t].x, !(C < a.axisX.dataInfo.viewPortMin || C > a.axisX.dataInfo.viewPortMax && (!m.connectNullData || !u))) if ("number" !== typeof s[t].y) 0 < t && !(m.connectNullData || u || p) && (b.stroke(), r && c.stroke()), u = !0;else {
	                C = a.axisX.convertValueToPixel(C);x = a.axisY.convertValueToPixel(s[t].y);var y = m.dataPointIds[t];this._eventManager.objectMap[y] = { id: y, objectType: "dataPoint", dataSeriesIndex: w, dataPointIndex: t, x1: C, y1: x };p || u ? (!p && m.connectNullData ? (b.setLineDash && (m.options.nullDataLineDashType || q === m.lineDashType && m.lineDashType !== m.nullDataLineDashType) && (b.stroke(), b.beginPath(), b.moveTo(k.x, k.y), q = m.nullDataLineDashType, b.setLineDash(n)), b.lineTo(C, x), r && c.lineTo(C, x)) : (b.beginPath(), b.moveTo(C, x), r && (c.beginPath(), c.moveTo(C, x))), u = p = !1) : (b.lineTo(C, x), r && c.lineTo(C, x), 0 == t % 500 && (b.stroke(), b.beginPath(), b.moveTo(C, x), r && (c.stroke(), c.beginPath(), c.moveTo(C, x))));k = { x: C, y: x };t < s.length - 1 && (h !== (s[t].lineColor || B) || q !== (s[t].lineDashType || m.lineDashType)) && (b.stroke(), b.beginPath(), b.moveTo(C, x), h = s[t].lineColor || B, b.strokeStyle = h, b.setLineDash && (s[t].lineDashType ? (q = s[t].lineDashType, b.setLineDash(R(q, m.lineThickness))) : (q = m.lineDashType, b.setLineDash(f))));if (0 < s[t].markerSize || 0 < m.markerSize) {
	                  var A = m.getMarkerProperties(t, C, x, b);g.push(A);
	                  y = N(y);r && g.push({ x: C, y: x, ctx: c, type: A.type, size: A.size, color: y, borderColor: y, borderThickness: A.borderThickness });
	                }(s[t].indexLabel || m.indexLabel || s[t].indexLabelFormatter || m.indexLabelFormatter) && this._indexLabels.push({ chartType: "line", dataPoint: s[t], dataSeries: m, point: { x: C, y: x }, direction: 0 > s[t].y === a.axisY.reversed ? 1 : -1, color: B });
	              }
	            }b.stroke();r && c.stroke();
	          }
	        }ia.drawMarkers(g);r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), c.beginPath());b.restore();b.beginPath();return { source: d, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderStepLine = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = this._eventManager.ghostCtx;b.save();var e = this.plotArea;b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();for (var g = [], k, l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var w = a.dataSeriesIndexes[l],
	              m = this.data[w];b.lineWidth = m.lineThickness;var s = m.dataPoints,
	              q = "solid";if (b.setLineDash) {
	            var n = R(m.nullDataLineDashType, m.lineThickness),
	                q = m.lineDashType,
	                f = R(q, m.lineThickness);b.setLineDash(f);
	          }var B = m.id;this._eventManager.objectMap[B] = { objectType: "dataSeries", dataSeriesIndex: w };B = N(B);c.strokeStyle = B;c.lineWidth = 0 < m.lineThickness ? Math.max(m.lineThickness, 4) : 0;var B = m._colorSet,
	              h = B = m.lineColor = m.options.lineColor ? m.options.lineColor : B[0];b.strokeStyle = B;var p = !0,
	              t = 0,
	              C,
	              x;b.beginPath();if (0 < s.length) {
	            for (var u = !1, t = 0; t < s.length; t++) {
	              if (C = s[t].getTime ? s[t].x.getTime() : s[t].x, !(C < a.axisX.dataInfo.viewPortMin || C > a.axisX.dataInfo.viewPortMax && (!m.connectNullData || !u))) if ("number" !== typeof s[t].y) 0 < t && !(m.connectNullData || u || p) && (b.stroke(), r && c.stroke()), u = !0;else {
	                var y = x;C = a.axisX.convertValueToPixel(C);x = a.axisY.convertValueToPixel(s[t].y);var A = m.dataPointIds[t];this._eventManager.objectMap[A] = { id: A, objectType: "dataPoint", dataSeriesIndex: w, dataPointIndex: t, x1: C, y1: x };p || u ? (!p && m.connectNullData ? (b.setLineDash && (m.options.nullDataLineDashType || q === m.lineDashType && m.lineDashType !== m.nullDataLineDashType) && (b.stroke(), b.beginPath(), b.moveTo(k.x, k.y), q = m.nullDataLineDashType, b.setLineDash(n)), b.lineTo(C, y), b.lineTo(C, x), r && (c.lineTo(C, y), c.lineTo(C, x))) : (b.beginPath(), b.moveTo(C, x), r && (c.beginPath(), c.moveTo(C, x))), u = p = !1) : (b.lineTo(C, y), r && c.lineTo(C, y), b.lineTo(C, x), r && c.lineTo(C, x), 0 == t % 500 && (b.stroke(), b.beginPath(), b.moveTo(C, x), r && (c.stroke(), c.beginPath(), c.moveTo(C, x))));k = { x: C, y: x };t < s.length - 1 && (h !== (s[t].lineColor || B) || q !== (s[t].lineDashType || m.lineDashType)) && (b.stroke(), b.beginPath(), b.moveTo(C, x), h = s[t].lineColor || B, b.strokeStyle = h, b.setLineDash && (s[t].lineDashType ? (q = s[t].lineDashType, b.setLineDash(R(q, m.lineThickness))) : (q = m.lineDashType, b.setLineDash(f))));if (0 < s[t].markerSize || 0 < m.markerSize) y = m.getMarkerProperties(t, C, x, b), g.push(y), A = N(A), r && g.push({ x: C, y: x, ctx: c, type: y.type, size: y.size, color: A, borderColor: A, borderThickness: y.borderThickness });(s[t].indexLabel || m.indexLabel || s[t].indexLabelFormatter || m.indexLabelFormatter) && this._indexLabels.push({ chartType: "stepLine", dataPoint: s[t], dataSeries: m, point: { x: C, y: x }, direction: 0 > s[t].y === a.axisY.reversed ? 1 : -1, color: B });
	              }
	            }b.stroke();r && c.stroke();
	          }
	        }ia.drawMarkers(g);r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), c.beginPath());b.restore();b.beginPath();return { source: d, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation,
	          easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderSpline = function (a) {
	      function d(a) {
	        a = v(a, 2);if (0 < a.length) {
	          c.beginPath();r && e.beginPath();c.moveTo(a[0].x, a[0].y);a[0].newStrokeStyle && (c.strokeStyle = a[0].newStrokeStyle);a[0].newLineDashArray && c.setLineDash(a[0].newLineDashArray);r && e.moveTo(a[0].x, a[0].y);for (var b = 0; b < a.length - 3; b += 3) {
	            if (c.bezierCurveTo(a[b + 1].x, a[b + 1].y, a[b + 2].x, a[b + 2].y, a[b + 3].x, a[b + 3].y), r && e.bezierCurveTo(a[b + 1].x, a[b + 1].y, a[b + 2].x, a[b + 2].y, a[b + 3].x, a[b + 3].y), 0 < b && 0 === b % 3E3 || a[b + 3].newStrokeStyle || a[b + 3].newLineDashArray) c.stroke(), c.beginPath(), c.moveTo(a[b + 3].x, a[b + 3].y), a[b + 3].newStrokeStyle && (c.strokeStyle = a[b + 3].newStrokeStyle), a[b + 3].newLineDashArray && c.setLineDash(a[b + 3].newLineDashArray), r && (e.stroke(), e.beginPath(), e.moveTo(a[b + 3].x, a[b + 3].y));
	          }c.stroke();r && e.stroke();
	        }
	      }var b = a.targetCanvasCtx || this.plotArea.ctx,
	          c = r ? this._preRenderCtx : b;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = this._eventManager.ghostCtx;c.save();var g = this.plotArea;c.beginPath();
	        c.rect(g.x1, g.y1, g.width, g.height);c.clip();for (var k = [], l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var w = a.dataSeriesIndexes[l],
	              m = this.data[w];c.lineWidth = m.lineThickness;var s = m.dataPoints,
	              q = "solid";if (c.setLineDash) {
	            var n = R(m.nullDataLineDashType, m.lineThickness),
	                q = m.lineDashType,
	                f = R(q, m.lineThickness);c.setLineDash(f);
	          }var B = m.id;this._eventManager.objectMap[B] = { objectType: "dataSeries", dataSeriesIndex: w };B = N(B);e.strokeStyle = B;e.lineWidth = 0 < m.lineThickness ? Math.max(m.lineThickness, 4) : 0;var B = m._colorSet,
	              h = B = m.lineColor = m.options.lineColor ? m.options.lineColor : B[0];c.strokeStyle = B;var p = 0,
	              t,
	              u,
	              x = [];c.beginPath();if (0 < s.length) for (u = !1, p = 0; p < s.length; p++) {
	            if (t = s[p].getTime ? s[p].x.getTime() : s[p].x, !(t < a.axisX.dataInfo.viewPortMin || t > a.axisX.dataInfo.viewPortMax && (!m.connectNullData || !u))) if ("number" !== typeof s[p].y) 0 < p && !u && (m.connectNullData ? c.setLineDash && 0 < x.length && (m.options.nullDataLineDashType || !s[p - 1].lineDashType) && (x[x.length - 1].newLineDashArray = n, q = m.nullDataLineDashType) : (d(x), x = [])), u = !0;else {
	              t = a.axisX.convertValueToPixel(t);u = a.axisY.convertValueToPixel(s[p].y);var ma = m.dataPointIds[p];this._eventManager.objectMap[ma] = { id: ma, objectType: "dataPoint", dataSeriesIndex: w, dataPointIndex: p, x1: t, y1: u };x[x.length] = { x: t, y: u };p < s.length - 1 && (h !== (s[p].lineColor || B) || q !== (s[p].lineDashType || m.lineDashType)) && (h = s[p].lineColor || B, x[x.length - 1].newStrokeStyle = h, c.setLineDash && (s[p].lineDashType ? (q = s[p].lineDashType, x[x.length - 1].newLineDashArray = R(q, m.lineThickness)) : (q = m.lineDashType, x[x.length - 1].newLineDashArray = f)));if (0 < s[p].markerSize || 0 < m.markerSize) {
	                var y = m.getMarkerProperties(p, t, u, c);k.push(y);ma = N(ma);r && k.push({ x: t, y: u, ctx: e, type: y.type, size: y.size, color: ma, borderColor: ma, borderThickness: y.borderThickness });
	              }(s[p].indexLabel || m.indexLabel || s[p].indexLabelFormatter || m.indexLabelFormatter) && this._indexLabels.push({ chartType: "spline", dataPoint: s[p], dataSeries: m, point: { x: t, y: u }, direction: 0 > s[p].y === a.axisY.reversed ? 1 : -1, color: B });u = !1;
	            }
	          }d(x);
	        }ia.drawMarkers(k);r && (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.clearRect(g.x1, g.y1, g.width, g.height), e.beginPath());c.restore();c.beginPath();return { source: b, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear,
	          animationBase: 0 };
	      }
	    };p.prototype.renderColumn = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = 0,
	            k,
	            l,
	            w,
	            m = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            g = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1,
	            s = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : Math.min(0.15 * this.width, 0.9 * (this.plotArea.width / a.plotType.totalDataSeries)) << 0,
	            q = a.axisX.dataInfo.minDiff;isFinite(q) || (q = 0.3 * Math.abs(a.axisX.range));q = this.dataPointWidth = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.width * (a.axisX.logarithmic ? Math.log(q) / Math.log(a.axisX.range) : Math.abs(q) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;this.dataPointMaxWidth && g > s && (g = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, s));!this.dataPointMaxWidth && this.dataPointMinWidth && s < g && (s = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, g));q < g && (q = g);q > s && (q = s);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (s = 0; s < a.dataSeriesIndexes.length; s++) {
	          var n = a.dataSeriesIndexes[s],
	              f = this.data[n],
	              B = f.dataPoints;if (0 < B.length) for (var p = 5 < q && f.bevelEnabled ? !0 : !1, g = 0; g < B.length; g++) {
	            if (B[g].getTime ? w = B[g].x.getTime() : w = B[g].x, !(w < a.axisX.dataInfo.viewPortMin || w > a.axisX.dataInfo.viewPortMax) && "number" === typeof B[g].y) {
	              k = a.axisX.convertValueToPixel(w);l = a.axisY.convertValueToPixel(B[g].y);k = a.axisX.reversed ? k + a.plotType.totalDataSeries * q / 2 - (a.previousDataSeriesCount + s) * q << 0 : k - a.plotType.totalDataSeries * q / 2 + (a.previousDataSeriesCount + s) * q << 0;var h = a.axisX.reversed ? k - q << 0 : k + q << 0,
	                  t;0 <= B[g].y ? t = m : (t = l, l = m);l > t && (c = l, l = t, t = c);c = B[g].color ? B[g].color : f._colorSet[g % f._colorSet.length];ea(b, k, l, h, t, c, 0, null, p && 0 <= B[g].y, 0 > B[g].y && p, !1, !1, f.fillOpacity);c = f.dataPointIds[g];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: n, dataPointIndex: g, x1: k, y1: l, x2: h, y2: t };c = N(c);r && ea(this._eventManager.ghostCtx, k, l, h, t, c, 0, null, !1, !1, !1, !1);(B[g].indexLabel || f.indexLabel || B[g].indexLabelFormatter || f.indexLabelFormatter) && this._indexLabels.push({ chartType: "column", dataPoint: B[g], dataSeries: f, point: { x: k + (h - k) / 2, y: 0 > B[g].y === a.axisY.reversed ? l : t }, direction: 0 > B[g].y === a.axisY.reversed ? 1 : -1, bounds: { x1: k,
	                  y1: Math.min(l, t), x2: h, y2: Math.max(l, t) }, color: c });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();
	        return { source: d, dest: this.plotArea.ctx, animationCallback: M.yScaleAnimation, easingFunction: M.easing.easeOutQuart, animationBase: m < a.axisY.bounds.y1 ? a.axisY.bounds.y1 : m > a.axisY.bounds.y2 ? a.axisY.bounds.y2 : m };
	      }
	    };p.prototype.renderStackedColumn = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = [],
	            k = [],
	            l = [],
	            w = [],
	            m = 0,
	            s,
	            q,
	            n = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            m = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;s = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.15 * this.width << 0;var f = a.axisX.dataInfo.minDiff;isFinite(f) || (f = 0.3 * Math.abs(a.axisX.range));f = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.width * (a.axisX.logarithmic ? Math.log(f) / Math.log(a.axisX.range) : Math.abs(f) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;this.dataPointMaxWidth && m > s && (m = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, s));!this.dataPointMaxWidth && this.dataPointMinWidth && s < m && (s = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, m));f < m && (f = m);f > s && (f = s);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (var B = 0; B < a.dataSeriesIndexes.length; B++) {
	          var h = a.dataSeriesIndexes[B],
	              p = this.data[h],
	              t = p.dataPoints;if (0 < t.length) {
	            var u = 5 < f && p.bevelEnabled ? !0 : !1;b.strokeStyle = "#4572A7 ";for (m = 0; m < t.length; m++) {
	              if (c = t[m].x.getTime ? t[m].x.getTime() : t[m].x, !(c < a.axisX.dataInfo.viewPortMin || c > a.axisX.dataInfo.viewPortMax) && "number" === typeof t[m].y) {
	                s = a.axisX.convertValueToPixel(c);var x = s - a.plotType.plotUnits.length * f / 2 + a.index * f << 0,
	                    v = x + f << 0,
	                    y;if (a.axisY.logarithmic || a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 < t[m].y) l[c] = t[m].y + (l[c] ? l[c] : 0), 0 < l[c] && (q = a.axisY.convertValueToPixel(l[c]), y = "undefined" !== typeof g[c] ? g[c] : n, g[c] = q);else if (a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 >= t[m].y) w[c] = t[m].y + (w[c] ? w[c] : 0), y = a.axisY.convertValueToPixel(w[c]), q = "undefined" !== typeof k[c] ? k[c] : n, k[c] = y;else if (q = a.axisY.convertValueToPixel(t[m].y), 0 <= t[m].y) {
	                  var A = "undefined" !== typeof g[c] ? g[c] : 0;q -= A;y = n - A;g[c] = A + (y - q);
	                } else A = k[c] ? k[c] : 0, y = q + A, q = n + A, k[c] = A + (y - q);c = t[m].color ? t[m].color : p._colorSet[m % p._colorSet.length];ea(b, x, q, v, y, c, 0, null, u && 0 <= t[m].y, 0 > t[m].y && u, !1, !1, p.fillOpacity);c = p.dataPointIds[m];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: h, dataPointIndex: m, x1: x, y1: q, x2: v, y2: y };c = N(c);r && ea(this._eventManager.ghostCtx, x, q, v, y, c, 0, null, !1, !1, !1, !1);(t[m].indexLabel || p.indexLabel || t[m].indexLabelFormatter || p.indexLabelFormatter) && this._indexLabels.push({ chartType: "stackedColumn", dataPoint: t[m], dataSeries: p, point: { x: s, y: 0 <= t[m].y ? q : y }, direction: 0 > t[m].y === a.axisY.reversed ? 1 : -1, bounds: { x1: x, y1: Math.min(q, y), x2: v, y2: Math.max(q, y) }, color: c });
	              }
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx,
	          animationCallback: M.yScaleAnimation, easingFunction: M.easing.easeOutQuart, animationBase: n < a.axisY.bounds.y1 ? a.axisY.bounds.y1 : n > a.axisY.bounds.y2 ? a.axisY.bounds.y2 : n };
	      }
	    };p.prototype.renderStackedColumn100 = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = [],
	            k = [],
	            l = [],
	            w = [],
	            m = 0,
	            s,
	            q,
	            n = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            m = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;s = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.15 * this.width << 0;var f = a.axisX.dataInfo.minDiff;isFinite(f) || (f = 0.3 * Math.abs(a.axisX.range));f = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.width * (a.axisX.logarithmic ? Math.log(f) / Math.log(a.axisX.range) : Math.abs(f) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;this.dataPointMaxWidth && m > s && (m = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, s));!this.dataPointMaxWidth && this.dataPointMinWidth && s < m && (s = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, m));f < m && (f = m);f > s && (f = s);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (var B = 0; B < a.dataSeriesIndexes.length; B++) {
	          var p = a.dataSeriesIndexes[B],
	              h = this.data[p],
	              t = h.dataPoints;if (0 < t.length) for (var u = 5 < f && h.bevelEnabled ? !0 : !1, m = 0; m < t.length; m++) {
	            if (c = t[m].x.getTime ? t[m].x.getTime() : t[m].x, !(c < a.axisX.dataInfo.viewPortMin || c > a.axisX.dataInfo.viewPortMax) && "number" === typeof t[m].y) {
	              s = a.axisX.convertValueToPixel(c);q = 0 !== a.dataPointYSums[c] ? 100 * (t[m].y / a.dataPointYSums[c]) : 0;var x = s - a.plotType.plotUnits.length * f / 2 + a.index * f << 0,
	                  v = x + f << 0,
	                  y;if (a.axisY.logarithmic || a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 < t[m].y) {
	                l[c] = q + ("undefined" !== typeof l[c] ? l[c] : 0);if (0 >= l[c]) continue;q = a.axisY.convertValueToPixel(l[c]);y = g[c] ? g[c] : n;g[c] = q;
	              } else if (a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 >= t[m].y) w[c] = q + ("undefined" !== typeof w[c] ? w[c] : 0), y = a.axisY.convertValueToPixel(w[c]), q = k[c] ? k[c] : n, k[c] = y;else if (q = a.axisY.convertValueToPixel(q), 0 <= t[m].y) {
	                var A = "undefined" !== typeof g[c] ? g[c] : 0;q -= A;y = n - A;a.dataSeriesIndexes.length - 1 === B && 1 >= Math.abs(e.y1 - q) && (q = e.y1);g[c] = A + (y - q);
	              } else A = "undefined" !== typeof k[c] ? k[c] : 0, y = q + A, q = n + A, a.dataSeriesIndexes.length - 1 === B && 1 >= Math.abs(e.y2 - y) && (y = e.y2), k[c] = A + (y - q);c = t[m].color ? t[m].color : h._colorSet[m % h._colorSet.length];ea(b, x, q, v, y, c, 0, null, u && 0 <= t[m].y, 0 > t[m].y && u, !1, !1, h.fillOpacity);c = h.dataPointIds[m];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: p, dataPointIndex: m, x1: x, y1: q, x2: v, y2: y };c = N(c);r && ea(this._eventManager.ghostCtx, x, q, v, y, c, 0, null, !1, !1, !1, !1);(t[m].indexLabel || h.indexLabel || t[m].indexLabelFormatter || h.indexLabelFormatter) && this._indexLabels.push({ chartType: "stackedColumn100", dataPoint: t[m], dataSeries: h, point: { x: s, y: 0 <= t[m].y ? q : y }, direction: 0 > t[m].y === a.axisY.reversed ? 1 : -1, bounds: { x1: x, y1: Math.min(q, y), x2: v, y2: Math.max(q, y) }, color: c });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.yScaleAnimation, easingFunction: M.easing.easeOutQuart, animationBase: n < a.axisY.bounds.y1 ? a.axisY.bounds.y1 : n > a.axisY.bounds.y2 ? a.axisY.bounds.y2 : n };
	      }
	    };p.prototype.renderBar = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = 0,
	            k,
	            l,
	            w,
	            m = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            g = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1,
	            s = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : Math.min(0.15 * this.height, 0.9 * (this.plotArea.height / a.plotType.totalDataSeries)) << 0,
	            q = a.axisX.dataInfo.minDiff;isFinite(q) || (q = 0.3 * Math.abs(a.axisX.range));q = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.height * (a.axisX.logarithmic ? Math.log(q) / Math.log(a.axisX.range) : Math.abs(q) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;this.dataPointMaxWidth && g > s && (g = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, s));!this.dataPointMaxWidth && this.dataPointMinWidth && s < g && (s = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, g));q < g && (q = g);q > s && (q = s);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);
	        b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (s = 0; s < a.dataSeriesIndexes.length; s++) {
	          var n = a.dataSeriesIndexes[s],
	              f = this.data[n],
	              B = f.dataPoints;if (0 < B.length) {
	            var h = 5 < q && f.bevelEnabled ? !0 : !1;b.strokeStyle = "#4572A7 ";for (g = 0; g < B.length; g++) {
	              if (B[g].getTime ? w = B[g].x.getTime() : w = B[g].x, !(w < a.axisX.dataInfo.viewPortMin || w > a.axisX.dataInfo.viewPortMax) && "number" === typeof B[g].y) {
	                l = a.axisX.convertValueToPixel(w);
	                k = a.axisY.convertValueToPixel(B[g].y);l = a.axisX.reversed ? l + a.plotType.totalDataSeries * q / 2 - (a.previousDataSeriesCount + s) * q << 0 : l - a.plotType.totalDataSeries * q / 2 + (a.previousDataSeriesCount + s) * q << 0;var p = a.axisX.reversed ? l - q << 0 : l + q << 0,
	                    t;0 <= B[g].y ? t = m : (t = k, k = m);c = B[g].color ? B[g].color : f._colorSet[g % f._colorSet.length];ea(b, t, l, k, p, c, 0, null, h, !1, !1, !1, f.fillOpacity);c = f.dataPointIds[g];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: n, dataPointIndex: g, x1: t, y1: l, x2: k, y2: p };c = N(c);r && ea(this._eventManager.ghostCtx, t, l, k, p, c, 0, null, !1, !1, !1, !1);(B[g].indexLabel || f.indexLabel || B[g].indexLabelFormatter || f.indexLabelFormatter) && this._indexLabels.push({ chartType: "bar", dataPoint: B[g], dataSeries: f, point: { x: 0 <= B[g].y ? k : t, y: l + (p - l) / 2 }, direction: 0 > B[g].y === a.axisY.reversed ? 1 : -1, bounds: { x1: Math.min(t, k), y1: l, x2: Math.max(t, k), y2: p }, color: c });
	              }
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.xScaleAnimation, easingFunction: M.easing.easeOutQuart, animationBase: m < a.axisY.bounds.x1 ? a.axisY.bounds.x1 : m > a.axisY.bounds.x2 ? a.axisY.bounds.x2 : m };
	      }
	    };p.prototype.renderStackedBar = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = [],
	            k = [],
	            l = [],
	            w = [],
	            m = 0,
	            s,
	            q,
	            n = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            m = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;q = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.15 * this.height << 0;var f = a.axisX.dataInfo.minDiff;isFinite(f) || (f = 0.3 * Math.abs(a.axisX.range));f = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.height * (a.axisX.logarithmic ? Math.log(f) / Math.log(a.axisX.range) : Math.abs(f) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;this.dataPointMaxWidth && m > q && (m = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, q));!this.dataPointMaxWidth && this.dataPointMinWidth && q < m && (q = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, m));f < m && (f = m);f > q && (f = q);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (var B = 0; B < a.dataSeriesIndexes.length; B++) {
	          var p = a.dataSeriesIndexes[B],
	              h = this.data[p],
	              t = h.dataPoints;if (0 < t.length) {
	            var u = 5 < f && h.bevelEnabled ? !0 : !1;b.strokeStyle = "#4572A7 ";for (m = 0; m < t.length; m++) {
	              if (c = t[m].x.getTime ? t[m].x.getTime() : t[m].x, !(c < a.axisX.dataInfo.viewPortMin || c > a.axisX.dataInfo.viewPortMax) && "number" === typeof t[m].y) {
	                q = a.axisX.convertValueToPixel(c);var x = q - a.plotType.plotUnits.length * f / 2 + a.index * f << 0,
	                    v = x + f << 0,
	                    y;if (a.axisY.logarithmic || a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 < t[m].y) l[c] = t[m].y + (l[c] ? l[c] : 0), 0 < l[c] && (y = g[c] ? g[c] : n, g[c] = s = a.axisY.convertValueToPixel(l[c]));else if (a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 >= t[m].y) w[c] = t[m].y + (w[c] ? w[c] : 0), s = k[c] ? k[c] : n, k[c] = y = a.axisY.convertValueToPixel(w[c]);else if (s = a.axisY.convertValueToPixel(t[m].y), 0 <= t[m].y) {
	                  var A = g[c] ? g[c] : 0;y = n + A;s += A;g[c] = A + (s - y);
	                } else A = k[c] ? k[c] : 0, y = s - A, s = n - A, k[c] = A + (s - y);c = t[m].color ? t[m].color : h._colorSet[m % h._colorSet.length];ea(b, y, x, s, v, c, 0, null, u, !1, !1, !1, h.fillOpacity);c = h.dataPointIds[m];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: p, dataPointIndex: m, x1: y, y1: x, x2: s, y2: v };c = N(c);r && ea(this._eventManager.ghostCtx, y, x, s, v, c, 0, null, !1, !1, !1, !1);(t[m].indexLabel || h.indexLabel || t[m].indexLabelFormatter || h.indexLabelFormatter) && this._indexLabels.push({ chartType: "stackedBar", dataPoint: t[m], dataSeries: h, point: { x: 0 <= t[m].y ? s : y, y: q }, direction: 0 > t[m].y === a.axisY.reversed ? 1 : -1, bounds: { x1: Math.min(y, s), y1: x, x2: Math.max(y, s), y2: v }, color: c });
	              }
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.xScaleAnimation, easingFunction: M.easing.easeOutQuart, animationBase: n < a.axisY.bounds.x1 ? a.axisY.bounds.x1 : n > a.axisY.bounds.x2 ? a.axisY.bounds.x2 : n };
	      }
	    };p.prototype.renderStackedBar100 = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = [],
	            k = [],
	            l = [],
	            w = [],
	            m = 0,
	            s,
	            q,
	            n = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            m = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;q = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.15 * this.height << 0;var f = a.axisX.dataInfo.minDiff;isFinite(f) || (f = 0.3 * Math.abs(a.axisX.range));f = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.height * (a.axisX.logarithmic ? Math.log(f) / Math.log(a.axisX.range) : Math.abs(f) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;this.dataPointMaxWidth && m > q && (m = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, q));!this.dataPointMaxWidth && this.dataPointMinWidth && q < m && (q = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, m));f < m && (f = m);f > q && (f = q);b.save();r && this._eventManager.ghostCtx.save();
	        b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (var B = 0; B < a.dataSeriesIndexes.length; B++) {
	          var h = a.dataSeriesIndexes[B],
	              p = this.data[h],
	              t = p.dataPoints;if (0 < t.length) {
	            var u = 5 < f && p.bevelEnabled ? !0 : !1;b.strokeStyle = "#4572A7 ";for (m = 0; m < t.length; m++) {
	              if (c = t[m].x.getTime ? t[m].x.getTime() : t[m].x, !(c < a.axisX.dataInfo.viewPortMin || c > a.axisX.dataInfo.viewPortMax) && "number" === typeof t[m].y) {
	                q = a.axisX.convertValueToPixel(c);var x;x = 0 !== a.dataPointYSums[c] ? 100 * (t[m].y / a.dataPointYSums[c]) : 0;var v = q - a.plotType.plotUnits.length * f / 2 + a.index * f << 0,
	                    y = v + f << 0;if (a.axisY.logarithmic || a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 < t[m].y) {
	                  l[c] = x + (l[c] ? l[c] : 0);if (0 >= l[c]) continue;x = g[c] ? g[c] : n;g[c] = s = a.axisY.convertValueToPixel(l[c]);
	                } else if (a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length && 0 >= t[m].y) w[c] = x + (w[c] ? w[c] : 0), s = k[c] ? k[c] : n, k[c] = x = a.axisY.convertValueToPixel(w[c]);else if (s = a.axisY.convertValueToPixel(x), 0 <= t[m].y) {
	                  var A = g[c] ? g[c] : 0;x = n + A;s += A;a.dataSeriesIndexes.length - 1 === B && 1 >= Math.abs(e.x2 - s) && (s = e.x2);g[c] = A + (s - x);
	                } else A = k[c] ? k[c] : 0, x = s - A, s = n - A, a.dataSeriesIndexes.length - 1 === B && 1 >= Math.abs(e.x1 - x) && (x = e.x1), k[c] = A + (s - x);c = t[m].color ? t[m].color : p._colorSet[m % p._colorSet.length];ea(b, x, v, s, y, c, 0, null, u, !1, !1, !1, p.fillOpacity);c = p.dataPointIds[m];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: h,
	                  dataPointIndex: m, x1: x, y1: v, x2: s, y2: y };c = N(c);r && ea(this._eventManager.ghostCtx, x, v, s, y, c, 0, null, !1, !1, !1, !1);(t[m].indexLabel || p.indexLabel || t[m].indexLabelFormatter || p.indexLabelFormatter) && this._indexLabels.push({ chartType: "stackedBar100", dataPoint: t[m], dataSeries: p, point: { x: 0 <= t[m].y ? s : x, y: q }, direction: 0 > t[m].y === a.axisY.reversed ? 1 : -1, bounds: { x1: Math.min(x, s), y1: v, x2: Math.max(x, s), y2: y }, color: c });
	              }
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.xScaleAnimation, easingFunction: M.easing.easeOutQuart, animationBase: n < a.axisY.bounds.x1 ? a.axisY.bounds.x1 : n > a.axisY.bounds.x2 ? a.axisY.bounds.x2 : n };
	      }
	    };p.prototype.renderArea = function (a) {
	      var d, b;function c() {
	        A && (0 < B.lineThickness && g.stroke(), a.axisY.logarithmic || 0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum ? y = v : 0 > a.axisY.viewportMaximum ? y = w.y1 : 0 < a.axisY.viewportMinimum && (y = l.y2), g.lineTo(t, y), g.lineTo(A.x, y), g.closePath(), g.globalAlpha = B.fillOpacity, g.fill(), g.globalAlpha = 1, r && (k.lineTo(t, y), k.lineTo(A.x, y), k.closePath(), k.fill()), g.beginPath(), g.moveTo(t, u), k.beginPath(), k.moveTo(t, u), A = { x: t, y: u });
	      }
	      var e = a.targetCanvasCtx || this.plotArea.ctx,
	          g = r ? this._preRenderCtx : e;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var k = this._eventManager.ghostCtx,
	            l = a.axisX.lineCoordinates,
	            w = a.axisY.lineCoordinates,
	            m = [],
	            s = this.plotArea,
	            q;g.save();r && k.save();g.beginPath();g.rect(s.x1, s.y1, s.width, s.height);g.clip();r && (k.beginPath(), k.rect(s.x1, s.y1, s.width, s.height), k.clip());for (var n = 0; n < a.dataSeriesIndexes.length; n++) {
	          var f = a.dataSeriesIndexes[n],
	              B = this.data[f],
	              p = B.dataPoints,
	              m = B.id;this._eventManager.objectMap[m] = { objectType: "dataSeries",
	            dataSeriesIndex: f };m = N(m);k.fillStyle = m;m = [];d = !0;var h = 0,
	              t,
	              u,
	              x,
	              v = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	              y,
	              A = null;if (0 < p.length) {
	            var z = B._colorSet[h % B._colorSet.length],
	                aa = B.lineColor = B.options.lineColor || z,
	                T = aa;g.fillStyle = z;g.strokeStyle = aa;g.lineWidth = B.lineThickness;b = "solid";if (g.setLineDash) {
	              var Y = R(B.nullDataLineDashType, B.lineThickness);b = B.lineDashType;var ca = R(b, B.lineThickness);g.setLineDash(ca);
	            }for (var da = !0; h < p.length; h++) {
	              if (x = p[h].x.getTime ? p[h].x.getTime() : p[h].x, !(x < a.axisX.dataInfo.viewPortMin || x > a.axisX.dataInfo.viewPortMax && (!B.connectNullData || !da))) if ("number" !== typeof p[h].y) B.connectNullData || da || d || c(), da = !0;else {
	                t = a.axisX.convertValueToPixel(x);u = a.axisY.convertValueToPixel(p[h].y);d || da ? (!d && B.connectNullData ? (g.setLineDash && (B.options.nullDataLineDashType || b === B.lineDashType && B.lineDashType !== B.nullDataLineDashType) && (d = t, b = u, t = q.x, u = q.y, c(), g.moveTo(q.x, q.y), t = d, u = b, A = q, b = B.nullDataLineDashType, g.setLineDash(Y)), g.lineTo(t, u), r && k.lineTo(t, u)) : (g.beginPath(), g.moveTo(t, u), r && (k.beginPath(), k.moveTo(t, u)), A = { x: t, y: u }), da = d = !1) : (g.lineTo(t, u), r && k.lineTo(t, u), 0 == h % 250 && c());q = { x: t, y: u };h < p.length - 1 && (T !== (p[h].lineColor || aa) || b !== (p[h].lineDashType || B.lineDashType)) && (c(), T = p[h].lineColor || aa, g.strokeStyle = T, g.setLineDash && (p[h].lineDashType ? (b = p[h].lineDashType, g.setLineDash(R(b, B.lineThickness))) : (b = B.lineDashType, g.setLineDash(ca))));var Z = B.dataPointIds[h];this._eventManager.objectMap[Z] = { id: Z, objectType: "dataPoint", dataSeriesIndex: f,
	                  dataPointIndex: h, x1: t, y1: u };0 !== p[h].markerSize && (0 < p[h].markerSize || 0 < B.markerSize) && (x = B.getMarkerProperties(h, t, u, g), m.push(x), Z = N(Z), r && m.push({ x: t, y: u, ctx: k, type: x.type, size: x.size, color: Z, borderColor: Z, borderThickness: x.borderThickness }));(p[h].indexLabel || B.indexLabel || p[h].indexLabelFormatter || B.indexLabelFormatter) && this._indexLabels.push({ chartType: "area", dataPoint: p[h], dataSeries: B, point: { x: t, y: u }, direction: 0 > p[h].y === a.axisY.reversed ? 1 : -1, color: z });
	              }
	            }c();ia.drawMarkers(m);
	          }
	        }r && (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), g.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && g.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && g.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), g.clearRect(s.x1, s.y1, s.width, s.height), this._eventManager.ghostCtx.restore());g.restore();return { source: e, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear,
	          animationBase: 0 };
	      }
	    };p.prototype.renderSplineArea = function (a) {
	      function d() {
	        var b = v(x, 2);if (0 < b.length) {
	          if (0 < q.lineThickness) {
	            c.beginPath();c.moveTo(b[0].x, b[0].y);b[0].newStrokeStyle && (c.strokeStyle = b[0].newStrokeStyle);b[0].newLineDashArray && c.setLineDash(b[0].newLineDashArray);for (var d = 0; d < b.length - 3; d += 3) {
	              if (c.bezierCurveTo(b[d + 1].x, b[d + 1].y, b[d + 2].x, b[d + 2].y, b[d + 3].x, b[d + 3].y), r && e.bezierCurveTo(b[d + 1].x, b[d + 1].y, b[d + 2].x, b[d + 2].y, b[d + 3].x, b[d + 3].y), b[d + 3].newStrokeStyle || b[d + 3].newLineDashArray) c.stroke(), c.beginPath(), c.moveTo(b[d + 3].x, b[d + 3].y), b[d + 3].newStrokeStyle && (c.strokeStyle = b[d + 3].newStrokeStyle), b[d + 3].newLineDashArray && c.setLineDash(b[d + 3].newLineDashArray);
	            }c.stroke();
	          }c.beginPath();c.moveTo(b[0].x, b[0].y);r && (e.beginPath(), e.moveTo(b[0].x, b[0].y));for (d = 0; d < b.length - 3; d += 3) {
	            c.bezierCurveTo(b[d + 1].x, b[d + 1].y, b[d + 2].x, b[d + 2].y, b[d + 3].x, b[d + 3].y), r && e.bezierCurveTo(b[d + 1].x, b[d + 1].y, b[d + 2].x, b[d + 2].y, b[d + 3].x, b[d + 3].y);
	          }a.axisY.logarithmic || 0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum ? t = p : 0 > a.axisY.viewportMaximum ? t = k.y1 : 0 < a.axisY.viewportMinimum && (t = g.y2);u = { x: b[0].x, y: b[0].y };c.lineTo(b[b.length - 1].x, t);c.lineTo(u.x, t);c.closePath();c.globalAlpha = q.fillOpacity;c.fill();c.globalAlpha = 1;r && (e.lineTo(b[b.length - 1].x, t), e.lineTo(u.x, t), e.closePath(), e.fill());
	        }
	      }var b = a.targetCanvasCtx || this.plotArea.ctx,
	          c = r ? this._preRenderCtx : b;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = this._eventManager.ghostCtx,
	            g = a.axisX.lineCoordinates,
	            k = a.axisY.lineCoordinates,
	            l = [],
	            w = this.plotArea;c.save();r && e.save();c.beginPath();c.rect(w.x1, w.y1, w.width, w.height);c.clip();r && (e.beginPath(), e.rect(w.x1, w.y1, w.width, w.height), e.clip());for (var m = 0; m < a.dataSeriesIndexes.length; m++) {
	          var s = a.dataSeriesIndexes[m],
	              q = this.data[s],
	              n = q.dataPoints,
	              l = q.id;this._eventManager.objectMap[l] = { objectType: "dataSeries", dataSeriesIndex: s };l = N(l);e.fillStyle = l;var l = [],
	              f = 0,
	              B,
	              h,
	              p = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	              t,
	              u = null,
	              x = [];if (0 < n.length) {
	            var ma = q._colorSet[f % q._colorSet.length],
	                y = q.lineColor = q.options.lineColor || ma,
	                A = y;c.fillStyle = ma;c.strokeStyle = y;c.lineWidth = q.lineThickness;var z = "solid";if (c.setLineDash) {
	              var aa = R(q.nullDataLineDashType, q.lineThickness),
	                  z = q.lineDashType,
	                  T = R(z, q.lineThickness);c.setLineDash(T);
	            }for (h = !1; f < n.length; f++) {
	              if (B = n[f].x.getTime ? n[f].x.getTime() : n[f].x, !(B < a.axisX.dataInfo.viewPortMin || B > a.axisX.dataInfo.viewPortMax && (!q.connectNullData || !h))) if ("number" !== typeof n[f].y) 0 < f && !h && (q.connectNullData ? c.setLineDash && 0 < x.length && (q.options.nullDataLineDashType || !n[f - 1].lineDashType) && (x[x.length - 1].newLineDashArray = aa, z = q.nullDataLineDashType) : (d(), x = [])), h = !0;else {
	                B = a.axisX.convertValueToPixel(B);h = a.axisY.convertValueToPixel(n[f].y);var Y = q.dataPointIds[f];this._eventManager.objectMap[Y] = { id: Y, objectType: "dataPoint", dataSeriesIndex: s, dataPointIndex: f, x1: B, y1: h };x[x.length] = { x: B, y: h };f < n.length - 1 && (A !== (n[f].lineColor || y) || z !== (n[f].lineDashType || q.lineDashType)) && (A = n[f].lineColor || y, x[x.length - 1].newStrokeStyle = A, c.setLineDash && (n[f].lineDashType ? (z = n[f].lineDashType, x[x.length - 1].newLineDashArray = R(z, q.lineThickness)) : (z = q.lineDashType, x[x.length - 1].newLineDashArray = T)));if (0 !== n[f].markerSize && (0 < n[f].markerSize || 0 < q.markerSize)) {
	                  var ca = q.getMarkerProperties(f, B, h, c);l.push(ca);Y = N(Y);r && l.push({ x: B, y: h, ctx: e, type: ca.type, size: ca.size, color: Y, borderColor: Y, borderThickness: ca.borderThickness });
	                }(n[f].indexLabel || q.indexLabel || n[f].indexLabelFormatter || q.indexLabelFormatter) && this._indexLabels.push({ chartType: "splineArea", dataPoint: n[f], dataSeries: q,
	                  point: { x: B, y: h }, direction: 0 > n[f].y === a.axisY.reversed ? 1 : -1, color: ma });h = !1;
	              }
	            }d();ia.drawMarkers(l);
	          }
	        }r && (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.clearRect(w.x1, w.y1, w.width, w.height), this._eventManager.ghostCtx.restore());c.restore();return { source: b, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderStepArea = function (a) {
	      var d, b;function c() {
	        A && (0 < B.lineThickness && g.stroke(), a.axisY.logarithmic || 0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum ? y = v : 0 > a.axisY.viewportMaximum ? y = w.y1 : 0 < a.axisY.viewportMinimum && (y = l.y2), g.lineTo(t, y), g.lineTo(A.x, y), g.closePath(), g.globalAlpha = B.fillOpacity, g.fill(), g.globalAlpha = 1, r && (k.lineTo(t, y), k.lineTo(A.x, y), k.closePath(), k.fill()), g.beginPath(), g.moveTo(t, u), k.beginPath(), k.moveTo(t, u), A = { x: t, y: u });
	      }var e = a.targetCanvasCtx || this.plotArea.ctx,
	          g = r ? this._preRenderCtx : e;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var k = this._eventManager.ghostCtx,
	            l = a.axisX.lineCoordinates,
	            w = a.axisY.lineCoordinates,
	            m = [],
	            s = this.plotArea,
	            q;g.save();r && k.save();g.beginPath();g.rect(s.x1, s.y1, s.width, s.height);g.clip();r && (k.beginPath(), k.rect(s.x1, s.y1, s.width, s.height), k.clip());for (var n = 0; n < a.dataSeriesIndexes.length; n++) {
	          var f = a.dataSeriesIndexes[n],
	              B = this.data[f],
	              h = B.dataPoints,
	              m = B.id;this._eventManager.objectMap[m] = { objectType: "dataSeries", dataSeriesIndex: f };m = N(m);k.fillStyle = m;m = [];d = !0;var p = 0,
	              t,
	              u,
	              x,
	              v = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	              y,
	              A = null;b = !1;if (0 < h.length) {
	            var z = B._colorSet[p % B._colorSet.length],
	                aa = B.lineColor = B.options.lineColor || z,
	                T = aa;g.fillStyle = z;g.strokeStyle = aa;g.lineWidth = B.lineThickness;var Y = "solid";if (g.setLineDash) {
	              var ca = R(B.nullDataLineDashType, B.lineThickness),
	                  Y = B.lineDashType,
	                  da = R(Y, B.lineThickness);g.setLineDash(da);
	            }for (; p < h.length; p++) {
	              if (x = h[p].x.getTime ? h[p].x.getTime() : h[p].x, !(x < a.axisX.dataInfo.viewPortMin || x > a.axisX.dataInfo.viewPortMax && (!B.connectNullData || !b))) {
	                var Z = u;"number" !== typeof h[p].y ? (B.connectNullData || b || d || c(), b = !0) : (t = a.axisX.convertValueToPixel(x), u = a.axisY.convertValueToPixel(h[p].y), d || b ? (!d && B.connectNullData ? (g.setLineDash && (B.options.nullDataLineDashType || Y === B.lineDashType && B.lineDashType !== B.nullDataLineDashType) && (d = t, b = u, t = q.x, u = q.y, c(), g.moveTo(q.x, q.y), t = d, u = b, A = q, Y = B.nullDataLineDashType, g.setLineDash(ca)), g.lineTo(t, Z), g.lineTo(t, u), r && (k.lineTo(t, Z), k.lineTo(t, u))) : (g.beginPath(), g.moveTo(t, u), r && (k.beginPath(), k.moveTo(t, u)), A = { x: t, y: u }), b = d = !1) : (g.lineTo(t, Z), r && k.lineTo(t, Z), g.lineTo(t, u), r && k.lineTo(t, u), 0 == p % 250 && c()), q = { x: t, y: u }, p < h.length - 1 && (T !== (h[p].lineColor || aa) || Y !== (h[p].lineDashType || B.lineDashType)) && (c(), T = h[p].lineColor || aa, g.strokeStyle = T, g.setLineDash && (h[p].lineDashType ? (Y = h[p].lineDashType, g.setLineDash(R(Y, B.lineThickness))) : (Y = B.lineDashType, g.setLineDash(da)))), x = B.dataPointIds[p], this._eventManager.objectMap[x] = { id: x, objectType: "dataPoint", dataSeriesIndex: f, dataPointIndex: p, x1: t, y1: u }, 0 !== h[p].markerSize && (0 < h[p].markerSize || 0 < B.markerSize) && (Z = B.getMarkerProperties(p, t, u, g), m.push(Z), x = N(x), r && m.push({ x: t, y: u, ctx: k, type: Z.type, size: Z.size, color: x, borderColor: x, borderThickness: Z.borderThickness })), (h[p].indexLabel || B.indexLabel || h[p].indexLabelFormatter || B.indexLabelFormatter) && this._indexLabels.push({ chartType: "stepArea", dataPoint: h[p], dataSeries: B, point: { x: t, y: u }, direction: 0 > h[p].y === a.axisY.reversed ? 1 : -1, color: z }));
	              }
	            }c();ia.drawMarkers(m);
	          }
	        }r && (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), g.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && g.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && g.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), g.clearRect(s.x1, s.y1, s.width, s.height), this._eventManager.ghostCtx.restore());g.restore();return { source: e, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderStackedArea = function (a) {
	      function d() {
	        if (!(1 > m.length)) {
	          for (0 < A.lineThickness && c.stroke(); 0 < m.length;) {
	            var a = m.pop();c.lineTo(a.x, a.y);r && u.lineTo(a.x, a.y);
	          }c.closePath();c.globalAlpha = A.fillOpacity;c.fill();c.globalAlpha = 1;c.beginPath();r && (u.closePath(), u.fill(), u.beginPath());m = [];
	        }
	      }var b = a.targetCanvasCtx || this.plotArea.ctx,
	          c = r ? this._preRenderCtx : b;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = null,
	            g = null,
	            k = [],
	            l = this.plotArea,
	            w = [],
	            m = [],
	            s = [],
	            q = [],
	            n = 0,
	            f,
	            h,
	            p = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            u = this._eventManager.ghostCtx,
	            t,
	            C,
	            x;r && u.beginPath();c.save();r && u.save();c.beginPath();c.rect(l.x1, l.y1, l.width, l.height);c.clip();r && (u.beginPath(), u.rect(l.x1, l.y1, l.width, l.height), u.clip());for (var e = [], v = 0; v < a.dataSeriesIndexes.length; v++) {
	          var y = a.dataSeriesIndexes[v],
	              A = this.data[y],
	              z = A.dataPoints;A.dataPointIndexes = [];for (n = 0; n < z.length; n++) {
	            y = z[n].x.getTime ? z[n].x.getTime() : z[n].x, A.dataPointIndexes[y] = n, e[y] || (s.push(y), e[y] = !0);
	          }s.sort(Sa);
	        }for (v = 0; v < a.dataSeriesIndexes.length; v++) {
	          y = a.dataSeriesIndexes[v];A = this.data[y];z = A.dataPoints;C = !0;m = [];n = A.id;this._eventManager.objectMap[n] = { objectType: "dataSeries", dataSeriesIndex: y };n = N(n);u.fillStyle = n;if (0 < s.length) {
	            var e = A._colorSet[0],
	                aa = A.lineColor = A.options.lineColor || e,
	                T = aa;c.fillStyle = e;c.strokeStyle = aa;c.lineWidth = A.lineThickness;x = "solid";if (c.setLineDash) {
	              var Y = R(A.nullDataLineDashType, A.lineThickness);x = A.lineDashType;var ca = R(x, A.lineThickness);c.setLineDash(ca);
	            }for (var da = !0, n = 0; n < s.length; n++) {
	              var g = s[n],
	                  Z = null,
	                  Z = 0 <= A.dataPointIndexes[g] ? z[A.dataPointIndexes[g]] : { x: g, y: null };if (!(g < a.axisX.dataInfo.viewPortMin || g > a.axisX.dataInfo.viewPortMax && (!A.connectNullData || !da))) if ("number" !== typeof Z.y) A.connectNullData || da || C || d(), da = !0;else {
	                f = a.axisX.convertValueToPixel(g);var oa = w[g] ? w[g] : 0;if (a.axisY.logarithmic || a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length) {
	                  q[g] = Z.y + (q[g] ? q[g] : 0);if (0 >= q[g] && a.axisY.logarithmic) continue;h = a.axisY.convertValueToPixel(q[g]);
	                } else h = a.axisY.convertValueToPixel(Z.y), h -= oa;m.push({ x: f, y: p - oa });w[g] = p - h;C || da ? (!C && A.connectNullData ? (c.setLineDash && (A.options.nullDataLineDashType || x === A.lineDashType && A.lineDashType !== A.nullDataLineDashType) && (C = m.pop(), x = m[m.length - 1], d(), c.moveTo(t.x, t.y), m.push(x), m.push(C), x = A.nullDataLineDashType, c.setLineDash(Y)), c.lineTo(f, h), r && u.lineTo(f, h)) : (c.beginPath(), c.moveTo(f, h), r && (u.beginPath(), u.moveTo(f, h))), da = C = !1) : (c.lineTo(f, h), r && u.lineTo(f, h), 0 == n % 250 && (d(), c.moveTo(f, h), r && u.moveTo(f, h), m.push({ x: f, y: p - oa })));t = { x: f, y: h };n < z.length - 1 && (T !== (z[n].lineColor || aa) || x !== (z[n].lineDashType || A.lineDashType)) && (d(), c.beginPath(), c.moveTo(f, h), m.push({ x: f, y: p - oa }), T = z[n].lineColor || aa, c.strokeStyle = T, c.setLineDash && (z[n].lineDashType ? (x = z[n].lineDashType, c.setLineDash(R(x, A.lineThickness))) : (x = A.lineDashType, c.setLineDash(ca))));if (0 <= A.dataPointIndexes[g]) {
	                  var la = A.dataPointIds[A.dataPointIndexes[g]];this._eventManager.objectMap[la] = { id: la, objectType: "dataPoint", dataSeriesIndex: y, dataPointIndex: A.dataPointIndexes[g], x1: f, y1: h };
	                }0 <= A.dataPointIndexes[g] && 0 !== Z.markerSize && (0 < Z.markerSize || 0 < A.markerSize) && (oa = A.getMarkerProperties(A.dataPointIndexes[g], f, h, c), k.push(oa), g = N(la), r && k.push({ x: f, y: h, ctx: u, type: oa.type, size: oa.size, color: g, borderColor: g, borderThickness: oa.borderThickness }));
	                (Z.indexLabel || A.indexLabel || Z.indexLabelFormatter || A.indexLabelFormatter) && this._indexLabels.push({ chartType: "stackedArea", dataPoint: Z, dataSeries: A, point: { x: f, y: h }, direction: 0 > z[n].y === a.axisY.reversed ? 1 : -1, color: e });
	              }
	            }d();c.moveTo(f, h);r && u.moveTo(f, h);
	          }delete A.dataPointIndexes;
	        }ia.drawMarkers(k);r && (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.clearRect(l.x1, l.y1, l.width, l.height), u.restore());c.restore();return { source: b, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderStackedArea100 = function (a) {
	      function d() {
	        for (0 < A.lineThickness && c.stroke(); 0 < m.length;) {
	          var a = m.pop();c.lineTo(a.x, a.y);r && x.lineTo(a.x, a.y);
	        }c.closePath();c.globalAlpha = A.fillOpacity;c.fill();c.globalAlpha = 1;c.beginPath();r && (x.closePath(), x.fill(), x.beginPath());m = [];
	      }var b = a.targetCanvasCtx || this.plotArea.ctx,
	          c = r ? this._preRenderCtx : b;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = null,
	            g = null,
	            k = this.plotArea,
	            l = [],
	            w = [],
	            m = [],
	            s = [],
	            q = [],
	            n = 0,
	            f,
	            h,
	            p,
	            u,
	            t,
	            C = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            x = this._eventManager.ghostCtx;c.save();r && x.save();c.beginPath();c.rect(k.x1, k.y1, k.width, k.height);c.clip();r && (x.beginPath(), x.rect(k.x1, k.y1, k.width, k.height), x.clip());for (var e = [], v = 0; v < a.dataSeriesIndexes.length; v++) {
	          var y = a.dataSeriesIndexes[v],
	              A = this.data[y],
	              z = A.dataPoints;A.dataPointIndexes = [];for (n = 0; n < z.length; n++) {
	            y = z[n].x.getTime ? z[n].x.getTime() : z[n].x, A.dataPointIndexes[y] = n, e[y] || (s.push(y), e[y] = !0);
	          }s.sort(Sa);
	        }for (v = 0; v < a.dataSeriesIndexes.length; v++) {
	          y = a.dataSeriesIndexes[v];A = this.data[y];z = A.dataPoints;u = !0;e = A.id;this._eventManager.objectMap[e] = { objectType: "dataSeries", dataSeriesIndex: y };e = N(e);x.fillStyle = e;m = [];if (0 < s.length) {
	            var e = A._colorSet[n % A._colorSet.length],
	                aa = A.lineColor = A.options.lineColor || e,
	                T = aa;c.fillStyle = e;c.strokeStyle = aa;c.lineWidth = A.lineThickness;t = "solid";if (c.setLineDash) {
	              var Y = R(A.nullDataLineDashType, A.lineThickness);t = A.lineDashType;var ca = R(t, A.lineThickness);c.setLineDash(ca);
	            }for (var da = !0, n = 0; n < s.length; n++) {
	              var g = s[n],
	                  Z = null,
	                  Z = 0 <= A.dataPointIndexes[g] ? z[A.dataPointIndexes[g]] : { x: g, y: null };if (!(g < a.axisX.dataInfo.viewPortMin || g > a.axisX.dataInfo.viewPortMax && (!A.connectNullData || !da))) if ("number" !== typeof Z.y) A.connectNullData || da || u || d(), da = !0;else {
	                var oa;oa = 0 !== a.dataPointYSums[g] ? 100 * (Z.y / a.dataPointYSums[g]) : 0;f = a.axisX.convertValueToPixel(g);var la = w[g] ? w[g] : 0;if (a.axisY.logarithmic || a.axisY.scaleBreaks && 0 < a.axisY.scaleBreaks._appliedBreaks.length) {
	                  q[g] = oa + (q[g] ? q[g] : 0);if (0 >= q[g] && a.axisY.logarithmic) continue;h = a.axisY.convertValueToPixel(q[g]);
	                } else h = a.axisY.convertValueToPixel(oa), h -= la;m.push({ x: f, y: C - la });w[g] = C - h;u || da ? (!u && A.connectNullData ? (c.setLineDash && (A.options.nullDataLineDashType || t === A.lineDashType && A.lineDashType !== A.nullDataLineDashType) && (u = m.pop(), t = m[m.length - 1], d(), c.moveTo(p.x, p.y), m.push(t), m.push(u), t = A.nullDataLineDashType, c.setLineDash(Y)), c.lineTo(f, h), r && x.lineTo(f, h)) : (c.beginPath(), c.moveTo(f, h), r && (x.beginPath(), x.moveTo(f, h))), da = u = !1) : (c.lineTo(f, h), r && x.lineTo(f, h), 0 == n % 250 && (d(), c.moveTo(f, h), r && x.moveTo(f, h), m.push({ x: f, y: C - la })));p = { x: f, y: h };n < z.length - 1 && (T !== (z[n].lineColor || aa) || t !== (z[n].lineDashType || A.lineDashType)) && (d(), c.beginPath(), c.moveTo(f, h), m.push({ x: f, y: C - la }), T = z[n].lineColor || aa, c.strokeStyle = T, c.setLineDash && (z[n].lineDashType ? (t = z[n].lineDashType, c.setLineDash(R(t, A.lineThickness))) : (t = A.lineDashType, c.setLineDash(ca))));if (0 <= A.dataPointIndexes[g]) {
	                  var G = A.dataPointIds[A.dataPointIndexes[g]];this._eventManager.objectMap[G] = { id: G, objectType: "dataPoint", dataSeriesIndex: y, dataPointIndex: A.dataPointIndexes[g], x1: f, y1: h };
	                }0 <= A.dataPointIndexes[g] && 0 !== Z.markerSize && (0 < Z.markerSize || 0 < A.markerSize) && (la = A.getMarkerProperties(n, f, h, c), l.push(la), g = N(G), r && l.push({ x: f, y: h, ctx: x, type: la.type, size: la.size, color: g, borderColor: g, borderThickness: la.borderThickness }));(Z.indexLabel || A.indexLabel || Z.indexLabelFormatter || A.indexLabelFormatter) && this._indexLabels.push({ chartType: "stackedArea100", dataPoint: Z, dataSeries: A, point: { x: f, y: h }, direction: 0 > z[n].y === a.axisY.reversed ? 1 : -1, color: e });
	              }
	            }d();c.moveTo(f, h);r && x.moveTo(f, h);
	          }delete A.dataPointIndexes;
	        }ia.drawMarkers(l);r && (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.clearRect(k.x1, k.y1, k.width, k.height), x.restore());c.restore();return { source: b, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };
	    p.prototype.renderBubble = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = this.plotArea,
	            e = 0,
	            g,
	            k;b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(c.x1, c.y1, c.width, c.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());for (var l = -Infinity, w = Infinity, m = 0; m < a.dataSeriesIndexes.length; m++) {
	          for (var s = a.dataSeriesIndexes[m], q = this.data[s], n = q.dataPoints, f = 0, e = 0; e < n.length; e++) {
	            g = n[e].getTime ? g = n[e].x.getTime() : g = n[e].x, g < a.axisX.dataInfo.viewPortMin || g > a.axisX.dataInfo.viewPortMax || "undefined" === typeof n[e].z || (f = n[e].z, f > l && (l = f), f < w && (w = f));
	          }
	        }for (var h = 25 * Math.PI, p = Math.max(Math.pow(0.25 * Math.min(c.height, c.width) / 2, 2) * Math.PI, h), m = 0; m < a.dataSeriesIndexes.length; m++) {
	          if (s = a.dataSeriesIndexes[m], q = this.data[s], n = q.dataPoints, 0 < n.length) for (b.strokeStyle = "#4572A7 ", e = 0; e < n.length; e++) {
	            if (g = n[e].getTime ? g = n[e].x.getTime() : g = n[e].x, !(g < a.axisX.dataInfo.viewPortMin || g > a.axisX.dataInfo.viewPortMax) && "number" === typeof n[e].y) {
	              g = a.axisX.convertValueToPixel(g);k = a.axisY.convertValueToPixel(n[e].y);var f = n[e].z,
	                  u = 2 * Math.max(Math.sqrt((l === w ? p / 2 : h + (p - h) / (l - w) * (f - w)) / Math.PI) << 0, 1),
	                  f = q.getMarkerProperties(e, b);f.size = u;b.globalAlpha = q.fillOpacity;ia.drawMarker(g, k, b, f.type, f.size, f.color, f.borderColor, f.borderThickness);b.globalAlpha = 1;var t = q.dataPointIds[e];this._eventManager.objectMap[t] = { id: t, objectType: "dataPoint", dataSeriesIndex: s,
	                dataPointIndex: e, x1: g, y1: k, size: u };u = N(t);r && ia.drawMarker(g, k, this._eventManager.ghostCtx, f.type, f.size, u, u, f.borderThickness);(n[e].indexLabel || q.indexLabel || n[e].indexLabelFormatter || q.indexLabelFormatter) && this._indexLabels.push({ chartType: "bubble", dataPoint: n[e], dataSeries: q, point: { x: g, y: k }, direction: 1, bounds: { x1: g - f.size / 2, y1: k - f.size / 2, x2: g + f.size / 2, y2: k + f.size / 2 }, color: null });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderScatter = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = this.plotArea,
	            e = 0,
	            g,
	            k;b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(c.x1, c.y1, c.width, c.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var w = a.dataSeriesIndexes[l],
	              m = this.data[w],
	              s = m.dataPoints;if (0 < s.length) {
	            b.strokeStyle = "#4572A7 ";Math.pow(0.3 * Math.min(c.height, c.width) / 2, 2);for (var q = 0, n = 0, e = 0; e < s.length; e++) {
	              if (g = s[e].getTime ? g = s[e].x.getTime() : g = s[e].x, !(g < a.axisX.dataInfo.viewPortMin || g > a.axisX.dataInfo.viewPortMax) && "number" === typeof s[e].y) {
	                g = a.axisX.convertValueToPixel(g);k = a.axisY.convertValueToPixel(s[e].y);var f = m.getMarkerProperties(e, g, k, b);b.globalAlpha = m.fillOpacity;ia.drawMarker(f.x, f.y, f.ctx, f.type, f.size, f.color, f.borderColor, f.borderThickness);b.globalAlpha = 1;Math.sqrt((q - g) * (q - g) + (n - k) * (n - k)) < Math.min(f.size, 5) && s.length > Math.min(this.plotArea.width, this.plotArea.height) || (q = m.dataPointIds[e], this._eventManager.objectMap[q] = { id: q, objectType: "dataPoint", dataSeriesIndex: w, dataPointIndex: e, x1: g, y1: k }, q = N(q), r && ia.drawMarker(f.x, f.y, this._eventManager.ghostCtx, f.type, f.size, q, q, f.borderThickness), (s[e].indexLabel || m.indexLabel || s[e].indexLabelFormatter || m.indexLabelFormatter) && this._indexLabels.push({ chartType: "scatter", dataPoint: s[e], dataSeries: m, point: { x: g, y: k }, direction: 1, bounds: { x1: g - f.size / 2, y1: k - f.size / 2, x2: g + f.size / 2, y2: k + f.size / 2 }, color: null }), q = g, n = k);
	              }
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.restore());
	        b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderCandlestick = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d,
	          c = this._eventManager.ghostCtx;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = null,
	            g = null,
	            k = this.plotArea,
	            l = 0,
	            w,
	            m,
	            s,
	            q,
	            n,
	            f,
	            e = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1,
	            g = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.015 * this.width,
	            h = a.axisX.dataInfo.minDiff;isFinite(h) || (h = 0.3 * Math.abs(a.axisX.range));h = this.options.dataPointWidth ? this.dataPointWidth : 0.7 * k.width * (a.axisX.logarithmic ? Math.log(h) / Math.log(a.axisX.range) : Math.abs(h) / Math.abs(a.axisX.range)) << 0;this.dataPointMaxWidth && e > g && (e = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, g));!this.dataPointMaxWidth && this.dataPointMinWidth && g < e && (g = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, e));h < e && (h = e);h > g && (h = g);b.save();r && c.save();b.beginPath();b.rect(k.x1, k.y1, k.width, k.height);b.clip();r && (c.beginPath(), c.rect(k.x1, k.y1, k.width, k.height), c.clip());for (var p = 0; p < a.dataSeriesIndexes.length; p++) {
	          var v = a.dataSeriesIndexes[p],
	              t = this.data[v],
	              C = t.dataPoints;if (0 < C.length) for (var x = 5 < h && t.bevelEnabled ? !0 : !1, l = 0; l < C.length; l++) {
	            if (C[l].getTime ? f = C[l].x.getTime() : f = C[l].x, !(f < a.axisX.dataInfo.viewPortMin || f > a.axisX.dataInfo.viewPortMax) && !u(C[l].y) && C[l].y.length && "number" === typeof C[l].y[0] && "number" === typeof C[l].y[1] && "number" === typeof C[l].y[2] && "number" === typeof C[l].y[3]) {
	              w = a.axisX.convertValueToPixel(f);m = a.axisY.convertValueToPixel(C[l].y[0]);s = a.axisY.convertValueToPixel(C[l].y[1]);q = a.axisY.convertValueToPixel(C[l].y[2]);n = a.axisY.convertValueToPixel(C[l].y[3]);var z = w - h / 2 << 0,
	                  y = z + h << 0,
	                  g = t.options.fallingColor ? t.fallingColor : t._colorSet[0],
	                  e = C[l].color ? C[l].color : t._colorSet[0],
	                  A = Math.round(Math.max(1, 0.15 * h)),
	                  D = 0 === A % 2 ? 0 : 0.5,
	                  aa = t.dataPointIds[l];
	              this._eventManager.objectMap[aa] = { id: aa, objectType: "dataPoint", dataSeriesIndex: v, dataPointIndex: l, x1: z, y1: m, x2: y, y2: s, x3: w, y3: q, x4: w, y4: n, borderThickness: A, color: e };b.strokeStyle = e;b.beginPath();b.lineWidth = A;c.lineWidth = Math.max(A, 4);"candlestick" === t.type ? (b.moveTo(w - D, s), b.lineTo(w - D, Math.min(m, n)), b.stroke(), b.moveTo(w - D, Math.max(m, n)), b.lineTo(w - D, q), b.stroke(), ea(b, z, Math.min(m, n), y, Math.max(m, n), C[l].y[0] <= C[l].y[3] ? t.risingColor : g, A, e, x, x, !1, !1, t.fillOpacity), r && (e = N(aa), c.strokeStyle = e, c.moveTo(w - D, s), c.lineTo(w - D, Math.min(m, n)), c.stroke(), c.moveTo(w - D, Math.max(m, n)), c.lineTo(w - D, q), c.stroke(), ea(c, z, Math.min(m, n), y, Math.max(m, n), e, 0, null, !1, !1, !1, !1))) : "ohlc" === t.type && (b.moveTo(w - D, s), b.lineTo(w - D, q), b.stroke(), b.beginPath(), b.moveTo(w, m), b.lineTo(z, m), b.stroke(), b.beginPath(), b.moveTo(w, n), b.lineTo(y, n), b.stroke(), r && (e = N(aa), c.strokeStyle = e, c.moveTo(w - D, s), c.lineTo(w - D, q), c.stroke(), c.beginPath(), c.moveTo(w, m), c.lineTo(z, m), c.stroke(), c.beginPath(), c.moveTo(w, n), c.lineTo(y, n), c.stroke()));
	              (C[l].indexLabel || t.indexLabel || C[l].indexLabelFormatter || t.indexLabelFormatter) && this._indexLabels.push({ chartType: t.type, dataPoint: C[l], dataSeries: t, point: { x: z + (y - z) / 2, y: a.axisY.reversed ? q : s }, direction: 1, bounds: { x1: z, y1: Math.min(s, q), x2: y, y2: Math.max(s, q) }, color: e });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(k.x1, k.y1, k.width, k.height), c.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderBoxAndWhisker = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d,
	          c = this._eventManager.ghostCtx;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = null,
	            g = this.plotArea,
	            k = 0,
	            l,
	            w,
	            m,
	            s,
	            q,
	            n,
	            f,
	            e = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1,
	            k = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.015 * this.width,
	            h = a.axisX.dataInfo.minDiff;isFinite(h) || (h = 0.3 * Math.abs(a.axisX.range));h = this.options.dataPointWidth ? this.dataPointWidth : 0.7 * g.width * (a.axisX.logarithmic ? Math.log(h) / Math.log(a.axisX.range) : Math.abs(h) / Math.abs(a.axisX.range)) << 0;this.dataPointMaxWidth && e > k && (e = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, k));!this.dataPointMaxWidth && this.dataPointMinWidth && k < e && (k = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, e));h < e && (h = e);h > k && (h = k);b.save();r && c.save();b.beginPath();b.rect(g.x1, g.y1, g.width, g.height);b.clip();r && (c.beginPath(), c.rect(g.x1, g.y1, g.width, g.height), c.clip());for (var p = !1, p = !!a.axisY.reversed, v = 0; v < a.dataSeriesIndexes.length; v++) {
	          var t = a.dataSeriesIndexes[v],
	              C = this.data[t],
	              x = C.dataPoints;
	          if (0 < x.length) for (var z = 5 < h && C.bevelEnabled ? !0 : !1, k = 0; k < x.length; k++) {
	            if (x[k].getTime ? f = x[k].x.getTime() : f = x[k].x, !(f < a.axisX.dataInfo.viewPortMin || f > a.axisX.dataInfo.viewPortMax) && !u(x[k].y) && x[k].y.length && "number" === typeof x[k].y[0] && "number" === typeof x[k].y[1] && "number" === typeof x[k].y[2] && "number" === typeof x[k].y[3] && "number" === typeof x[k].y[4] && 5 === x[k].y.length) {
	              l = a.axisX.convertValueToPixel(f);w = a.axisY.convertValueToPixel(x[k].y[0]);m = a.axisY.convertValueToPixel(x[k].y[1]);s = a.axisY.convertValueToPixel(x[k].y[2]);
	              q = a.axisY.convertValueToPixel(x[k].y[3]);n = a.axisY.convertValueToPixel(x[k].y[4]);var y = l - h / 2 << 0,
	                  A = l + h / 2 << 0,
	                  e = x[k].color ? x[k].color : C._colorSet[0],
	                  D = Math.round(Math.max(1, 0.15 * h)),
	                  aa = 0 === D % 2 ? 0 : 0.5,
	                  T = x[k].whiskerColor ? x[k].whiskerColor : x[k].color ? C.whiskerColor ? C.whiskerColor : x[k].color : C.whiskerColor ? C.whiskerColor : e,
	                  Y = "number" === typeof x[k].whiskerThickness ? x[k].whiskerThickness : "number" === typeof C.options.whiskerThickness ? C.whiskerThickness : D,
	                  ca = x[k].whiskerDashType ? x[k].whiskerDashType : C.whiskerDashType,
	                  da = u(x[k].whiskerLength) ? u(C.options.whiskerLength) ? h : C.whiskerLength : x[k].whiskerLength,
	                  da = "number" === typeof da ? 0 >= da ? 0 : da >= h ? h : da : "string" === typeof da ? parseInt(da) * h / 100 > h ? h : parseInt(da) * h / 100 : h,
	                  Z = 1 === Math.round(Y) % 2 ? 0.5 : 0,
	                  oa = x[k].stemColor ? x[k].stemColor : x[k].color ? C.stemColor ? C.stemColor : x[k].color : C.stemColor ? C.stemColor : e,
	                  la = "number" === typeof x[k].stemThickness ? x[k].stemThickness : "number" === typeof C.options.stemThickness ? C.stemThickness : D,
	                  G = 1 === Math.round(la) % 2 ? 0.5 : 0,
	                  F = x[k].stemDashType ? x[k].stemDashType : C.stemDashType,
	                  E = x[k].lineColor ? x[k].lineColor : x[k].color ? C.lineColor ? C.lineColor : x[k].color : C.lineColor ? C.lineColor : e,
	                  H = "number" === typeof x[k].lineThickness ? x[k].lineThickness : "number" === typeof C.options.lineThickness ? C.lineThickness : D,
	                  I = x[k].lineDashType ? x[k].lineDashType : C.lineDashType,
	                  K = 1 === Math.round(H) % 2 ? 0.5 : 0,
	                  L = C.upperBoxColor,
	                  O = C.lowerBoxColor,
	                  Q = u(C.options.fillOpacity) ? 1 : C.fillOpacity,
	                  P = C.dataPointIds[k];this._eventManager.objectMap[P] = { id: P, objectType: "dataPoint", dataSeriesIndex: t, dataPointIndex: k,
	                x1: y, y1: w, x2: A, y2: m, x3: l, y3: s, x4: l, y4: q, y5: n, borderThickness: D, color: e, stemThickness: la, stemColor: oa, whiskerThickness: Y, whiskerLength: da, whiskerColor: T, lineThickness: H, lineColor: E };b.save();0 < la && (b.beginPath(), b.strokeStyle = oa, b.lineWidth = la, b.setLineDash && b.setLineDash(R(F, la)), b.moveTo(l - G, m), b.lineTo(l - G, w), b.stroke(), b.moveTo(l - G, q), b.lineTo(l - G, s), b.stroke());b.restore();c.lineWidth = Math.max(D, 4);b.beginPath();ea(b, y, Math.min(n, m), A, Math.max(m, n), O, 0, e, p ? z : !1, p ? !1 : z, !1, !1, Q);b.beginPath();ea(b, y, Math.min(s, n), A, Math.max(n, s), L, 0, e, p ? !1 : z, p ? z : !1, !1, !1, Q);b.beginPath();b.lineWidth = D;b.strokeStyle = e;b.rect(y - aa, Math.min(m, s) - aa, A - y + 2 * aa, Math.max(m, s) - Math.min(m, s) + 2 * aa);b.stroke();b.save();0 < H && (b.beginPath(), b.globalAlpha = 1, b.setLineDash && b.setLineDash(R(I, H)), b.strokeStyle = E, b.lineWidth = H, b.moveTo(y, n - K), b.lineTo(A, n - K), b.stroke());b.restore();b.save();0 < Y && (b.beginPath(), b.setLineDash && b.setLineDash(R(ca, Y)), b.strokeStyle = T, b.lineWidth = Y, b.moveTo(l - da / 2 << 0, q - Z), b.lineTo(l + da / 2 << 0, q - Z), b.stroke(), b.moveTo(l - da / 2 << 0, w + Z), b.lineTo(l + da / 2 << 0, w + Z), b.stroke());b.restore();r && (e = N(P), c.strokeStyle = e, c.lineWidth = la, 0 < la && (c.moveTo(l - aa - G, m), c.lineTo(l - aa - G, Math.max(w, q)), c.stroke(), c.moveTo(l - aa - G, Math.min(w, q)), c.lineTo(l - aa - G, s), c.stroke()), ea(c, y, Math.max(m, s), A, Math.min(m, s), e, 0, null, !1, !1, !1, !1), 0 < Y && (c.beginPath(), c.lineWidth = Y, c.moveTo(l + da / 2, q - Z), c.lineTo(l - da / 2, q - Z), c.stroke(), c.moveTo(l + da / 2, w + Z), c.lineTo(l - da / 2, w + Z), c.stroke()));(x[k].indexLabel || C.indexLabel || x[k].indexLabelFormatter || C.indexLabelFormatter) && this._indexLabels.push({ chartType: C.type, dataPoint: x[k], dataSeries: C, point: { x: y + (A - y) / 2, y: a.axisY.reversed ? w : q }, direction: 1, bounds: { x1: y, y1: Math.min(w, q), x2: A, y2: Math.max(w, q) }, color: e });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(g.x1, g.y1, g.width, g.height), c.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderRangeColumn = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = 0,
	            k,
	            l,
	            w,
	            g = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;k = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : 0.03 * this.width;var m = a.axisX.dataInfo.minDiff;isFinite(m) || (m = 0.3 * Math.abs(a.axisX.range));m = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.width * (a.axisX.logarithmic ? Math.log(m) / Math.log(a.axisX.range) : Math.abs(m) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;this.dataPointMaxWidth && g > k && (g = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, k));!this.dataPointMaxWidth && this.dataPointMinWidth && k < g && (k = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, g));m < g && (m = g);m > k && (m = k);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (var s = 0; s < a.dataSeriesIndexes.length; s++) {
	          var q = a.dataSeriesIndexes[s],
	              n = this.data[q],
	              f = n.dataPoints;if (0 < f.length) for (var h = 5 < m && n.bevelEnabled ? !0 : !1, g = 0; g < f.length; g++) {
	            if (f[g].getTime ? w = f[g].x.getTime() : w = f[g].x, !(w < a.axisX.dataInfo.viewPortMin || w > a.axisX.dataInfo.viewPortMax) && !u(f[g].y) && f[g].y.length && "number" === typeof f[g].y[0] && "number" === typeof f[g].y[1]) {
	              c = a.axisX.convertValueToPixel(w);k = a.axisY.convertValueToPixel(f[g].y[0]);l = a.axisY.convertValueToPixel(f[g].y[1]);var p = a.axisX.reversed ? c + a.plotType.totalDataSeries * m / 2 - (a.previousDataSeriesCount + s) * m << 0 : c - a.plotType.totalDataSeries * m / 2 + (a.previousDataSeriesCount + s) * m << 0,
	                  v = a.axisX.reversed ? p - m << 0 : p + m << 0,
	                  c = f[g].color ? f[g].color : n._colorSet[g % n._colorSet.length];if (k > l) {
	                var t = k;k = l;l = t;
	              }t = n.dataPointIds[g];this._eventManager.objectMap[t] = { id: t, objectType: "dataPoint", dataSeriesIndex: q, dataPointIndex: g, x1: p, y1: k, x2: v, y2: l };ea(b, p, k, v, l, c, 0, c, h, h, !1, !1, n.fillOpacity);c = N(t);r && ea(this._eventManager.ghostCtx, p, k, v, l, c, 0, null, !1, !1, !1, !1);if (f[g].indexLabel || n.indexLabel || f[g].indexLabelFormatter || n.indexLabelFormatter) this._indexLabels.push({ chartType: "rangeColumn",
	                dataPoint: f[g], dataSeries: n, indexKeyword: 0, point: { x: p + (v - p) / 2, y: f[g].y[1] >= f[g].y[0] ? l : k }, direction: f[g].y[1] >= f[g].y[0] ? -1 : 1, bounds: { x1: p, y1: Math.min(k, l), x2: v, y2: Math.max(k, l) }, color: c }), this._indexLabels.push({ chartType: "rangeColumn", dataPoint: f[g], dataSeries: n, indexKeyword: 1, point: { x: p + (v - p) / 2, y: f[g].y[1] >= f[g].y[0] ? k : l }, direction: f[g].y[1] >= f[g].y[0] ? 1 : -1, bounds: { x1: p, y1: Math.min(k, l), x2: v, y2: Math.max(k, l) }, color: c });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderError = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d,
	          c = a.axisY._position ? "left" === a.axisY._position || "right" === a.axisY._position ? !1 : !0 : !1;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = null,
	            g = !1,
	            k = this.plotArea,
	            l = 0,
	            w,
	            m,
	            s,
	            q,
	            n,
	            f,
	            h,
	            p = a.axisX.dataInfo.minDiff;isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(k.x1, k.y1, k.width, k.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(k.x1, k.y1, k.width, k.height), this._eventManager.ghostCtx.clip());for (var v = 0, t = 0; t < this.data.length; t++) {
	          !this.data[t].type.match(/(bar|column)/ig) || !this.data[t].visible || this.data[t].type.match(/(stacked)/ig) && v || v++;
	        }for (var C = 0; C < a.dataSeriesIndexes.length; C++) {
	          var x = a.dataSeriesIndexes[C],
	              z = this.data[x],
	              y = z.dataPoints,
	              A = u(z._linkedSeries) ? !1 : z._linkedSeries.type.match(/(bar|column)/ig) && z._linkedSeries.visible ? !0 : !1,
	              D = 0;if (A) for (e = z._linkedSeries.id, t = 0; t < e; t++) {
	            !this.data[t].type.match(/(bar|column)/ig) || !this.data[t].visible || this.data[t].type.match(/(stacked)/ig) && D || (this.data[t].type.match(/(range)/ig) && (g = !0), D++);
	          }e = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;l = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : c ? Math.min(0.15 * this.height, 0.9 * (this.plotArea.height / (A ? v : 1))) << 0 : 0.3 * this.width;g && (l = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : c ? Math.min(0.15 * this.height, 0.9 * (this.plotArea.height / (A ? v : 1))) << 0 : 0.03 * this.width);t = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * ((c ? k.height : k.width) * (a.axisX.logarithmic ? Math.log(p) / Math.log(a.axisX.range) : Math.abs(p) / Math.abs(a.axisX.range)) / (A ? v : 1)) << 0;this.dataPointMaxWidth && e > l && (e = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, l));!this.dataPointMaxWidth && this.dataPointMinWidth && l < e && (l = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, e));t < e && (t = e);t > l && (t = l);if (0 < y.length) for (var aa = z._colorSet, l = 0; l < y.length; l++) {
	            var e = z.lineColor = z.options.color ? z.options.color : aa[0],
	                T = { color: y[l].whiskerColor ? y[l].whiskerColor : y[l].color ? z.whiskerColor ? z.whiskerColor : y[l].color : z.whiskerColor ? z.whiskerColor : e, thickness: u(y[l].whiskerThickness) ? z.whiskerThickness : y[l].whiskerThickness, dashType: y[l].whiskerDashType ? y[l].whiskerDashType : z.whiskerDashType, length: u(y[l].whiskerLength) ? u(z.options.whiskerLength) ? t : z.options.whiskerLength : y[l].whiskerLength,
	              trimLength: u(y[l].whiskerLength) ? u(z.options.whiskerLength) ? 50 : 0 : 0 };T.length = "number" === typeof T.length ? 0 >= T.length ? 0 : T.length >= t ? t : T.length : "string" === typeof T.length ? parseInt(T.length) * t / 100 > t ? t : parseInt(T.length) * t / 100 > t : t;T.thickness = "number" === typeof T.thickness ? 0 > T.thickness ? 0 : Math.round(T.thickness) : 2;var Y = { color: y[l].stemColor ? y[l].stemColor : y[l].color ? z.stemColor ? z.stemColor : y[l].color : z.stemColor ? z.stemColor : e, thickness: y[l].stemThickness ? y[l].stemThickness : z.stemThickness, dashType: y[l].stemDashType ? y[l].stemDashType : z.stemDashType };Y.thickness = "number" === typeof Y.thickness ? 0 > Y.thickness ? 0 : Math.round(Y.thickness) : 2;y[l].getTime ? h = y[l].x.getTime() : h = y[l].x;if (!(h < a.axisX.dataInfo.viewPortMin || h > a.axisX.dataInfo.viewPortMax) && !u(y[l].y) && y[l].y.length && "number" === typeof y[l].y[0] && "number" === typeof y[l].y[1]) {
	              var ca = a.axisX.convertValueToPixel(h);c ? m = ca : w = ca;ca = a.axisY.convertValueToPixel(y[l].y[0]);c ? s = ca : n = ca;ca = a.axisY.convertValueToPixel(y[l].y[1]);c ? q = ca : f = ca;c ? (n = a.axisX.reversed ? m + (A ? v : 1) * t / 2 - (A ? D - 1 : 0) * t << 0 : m - (A ? v : 1) * t / 2 + (A ? D - 1 : 0) * t << 0, f = a.axisX.reversed ? n - t << 0 : n + t << 0) : (s = a.axisX.reversed ? w + (A ? v : 1) * t / 2 - (A ? D - 1 : 0) * t << 0 : w - (A ? v : 1) * t / 2 + (A ? D - 1 : 0) * t << 0, q = a.axisX.reversed ? s - t << 0 : s + t << 0);!c && n > f && (ca = n, n = f, f = ca);c && s > q && (ca = s, s = q, q = ca);ca = z.dataPointIds[l];this._eventManager.objectMap[ca] = { id: ca, objectType: "dataPoint", dataSeriesIndex: x, dataPointIndex: l, x1: Math.min(s, q), y1: Math.min(n, f), x2: Math.max(q, s), y2: Math.max(f, n), isXYSwapped: c, stemProperties: Y, whiskerProperties: T };E(b, Math.min(s, q), Math.min(n, f), Math.max(q, s), Math.max(f, n), e, T, Y, c);r && E(this._eventManager.ghostCtx, s, n, q, f, e, T, Y, c);if (y[l].indexLabel || z.indexLabel || y[l].indexLabelFormatter || z.indexLabelFormatter) this._indexLabels.push({ chartType: "error", dataPoint: y[l], dataSeries: z, indexKeyword: 0, point: { x: c ? y[l].y[1] >= y[l].y[0] ? s : q : s + (q - s) / 2, y: c ? n + (f - n) / 2 : y[l].y[1] >= y[l].y[0] ? f : n }, direction: y[l].y[1] >= y[l].y[0] ? -1 : 1, bounds: { x1: c ? Math.min(s, q) : s, y1: c ? n : Math.min(n, f), x2: c ? Math.max(s, q) : q, y2: c ? f : Math.max(n, f) }, color: e, axisSwapped: c }), this._indexLabels.push({ chartType: "error", dataPoint: y[l], dataSeries: z, indexKeyword: 1, point: { x: c ? y[l].y[1] >= y[l].y[0] ? q : s : s + (q - s) / 2, y: c ? n + (f - n) / 2 : y[l].y[1] >= y[l].y[0] ? n : f }, direction: y[l].y[1] >= y[l].y[0] ? 1 : -1, bounds: { x1: c ? Math.min(s, q) : s, y1: c ? n : Math.min(n, f), x2: c ? Math.max(s, q) : q, y2: c ? f : Math.max(n, f) }, color: e, axisSwapped: c });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(k.x1, k.y1, k.width, k.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderRangeBar = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = null,
	            e = this.plotArea,
	            g = 0,
	            k,
	            l,
	            w,
	            m,
	            g = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;k = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : Math.min(0.15 * this.height, 0.9 * (this.plotArea.height / a.plotType.totalDataSeries)) << 0;var s = a.axisX.dataInfo.minDiff;isFinite(s) || (s = 0.3 * Math.abs(a.axisX.range));s = this.options.dataPointWidth ? this.dataPointWidth : 0.9 * (e.height * (a.axisX.logarithmic ? Math.log(s) / Math.log(a.axisX.range) : Math.abs(s) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;this.dataPointMaxWidth && g > k && (g = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, k));!this.dataPointMaxWidth && this.dataPointMinWidth && k < g && (k = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, g));s < g && (s = g);s > k && (s = k);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1, e.y1, e.width, e.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.clip());for (var q = 0; q < a.dataSeriesIndexes.length; q++) {
	          var n = a.dataSeriesIndexes[q],
	              f = this.data[n],
	              h = f.dataPoints;if (0 < h.length) {
	            var p = 5 < s && f.bevelEnabled ? !0 : !1;b.strokeStyle = "#4572A7 ";for (g = 0; g < h.length; g++) {
	              if (h[g].getTime ? m = h[g].x.getTime() : m = h[g].x, !(m < a.axisX.dataInfo.viewPortMin || m > a.axisX.dataInfo.viewPortMax) && !u(h[g].y) && h[g].y.length && "number" === typeof h[g].y[0] && "number" === typeof h[g].y[1]) {
	                k = a.axisY.convertValueToPixel(h[g].y[0]);
	                l = a.axisY.convertValueToPixel(h[g].y[1]);w = a.axisX.convertValueToPixel(m);w = a.axisX.reversed ? w + a.plotType.totalDataSeries * s / 2 - (a.previousDataSeriesCount + q) * s << 0 : w - a.plotType.totalDataSeries * s / 2 + (a.previousDataSeriesCount + q) * s << 0;var v = a.axisX.reversed ? w - s << 0 : w + s << 0;k > l && (c = k, k = l, l = c);c = h[g].color ? h[g].color : f._colorSet[g % f._colorSet.length];ea(b, k, w, l, v, c, 0, null, p, !1, !1, !1, f.fillOpacity);c = f.dataPointIds[g];this._eventManager.objectMap[c] = { id: c, objectType: "dataPoint", dataSeriesIndex: n, dataPointIndex: g,
	                  x1: k, y1: w, x2: l, y2: v };c = N(c);r && ea(this._eventManager.ghostCtx, k, w, l, v, c, 0, null, !1, !1, !1, !1);if (h[g].indexLabel || f.indexLabel || h[g].indexLabelFormatter || f.indexLabelFormatter) this._indexLabels.push({ chartType: "rangeBar", dataPoint: h[g], dataSeries: f, indexKeyword: 0, point: { x: h[g].y[1] >= h[g].y[0] ? k : l, y: w + (v - w) / 2 }, direction: h[g].y[1] >= h[g].y[0] ? -1 : 1, bounds: { x1: Math.min(k, l), y1: w, x2: Math.max(k, l), y2: v }, color: c }), this._indexLabels.push({ chartType: "rangeBar", dataPoint: h[g], dataSeries: f, indexKeyword: 1, point: { x: h[g].y[1] >= h[g].y[0] ? l : k, y: w + (v - w) / 2 }, direction: h[g].y[1] >= h[g].y[0] ? 1 : -1, bounds: { x1: Math.min(k, l), y1: w, x2: Math.max(k, l), y2: v }, color: c });
	              }
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(e.x1, e.y1, e.width, e.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };p.prototype.renderRangeArea = function (a) {
	      function d() {
	        if (C) {
	          var a = null;0 < s.lineThickness && c.stroke();for (var b = w.length - 1; 0 <= b; b--) {
	            a = w[b], c.lineTo(a.x, a.y), e.lineTo(a.x, a.y);
	          }c.closePath();c.globalAlpha = s.fillOpacity;c.fill();c.globalAlpha = 1;e.fill();if (0 < s.lineThickness) {
	            c.beginPath();c.moveTo(a.x, a.y);for (b = 0; b < w.length; b++) {
	              a = w[b], c.lineTo(a.x, a.y);
	            }c.stroke();
	          }c.beginPath();c.moveTo(h, p);e.beginPath();e.moveTo(h, p);C = { x: h, y: p };w = [];w.push({ x: h, y: u });
	        }
	      }var b = a.targetCanvasCtx || this.plotArea.ctx,
	          c = r ? this._preRenderCtx : b;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = this._eventManager.ghostCtx,
	            g = [],
	            k = this.plotArea;c.save();r && e.save();c.beginPath();c.rect(k.x1, k.y1, k.width, k.height);c.clip();r && (e.beginPath(), e.rect(k.x1, k.y1, k.width, k.height), e.clip());for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var w = [],
	              m = a.dataSeriesIndexes[l],
	              s = this.data[m],
	              q = s.dataPoints,
	              g = s.id;this._eventManager.objectMap[g] = { objectType: "dataSeries", dataSeriesIndex: m };g = N(g);e.fillStyle = g;var g = [],
	              n = !0,
	              f = 0,
	              h,
	              p,
	              u,
	              t,
	              C = null;if (0 < q.length) {
	            var x = s._colorSet[f % s._colorSet.length],
	                v = s.lineColor = s.options.lineColor || x,
	                y = v;c.fillStyle = x;c.strokeStyle = v;c.lineWidth = s.lineThickness;var A = "solid";if (c.setLineDash) {
	              var z = R(s.nullDataLineDashType, s.lineThickness),
	                  A = s.lineDashType,
	                  D = R(A, s.lineThickness);c.setLineDash(D);
	            }for (var T = !0; f < q.length; f++) {
	              if (t = q[f].x.getTime ? q[f].x.getTime() : q[f].x, !(t < a.axisX.dataInfo.viewPortMin || t > a.axisX.dataInfo.viewPortMax && (!s.connectNullData || !T))) if (null !== q[f].y && q[f].y.length && "number" === typeof q[f].y[0] && "number" === typeof q[f].y[1]) {
	                h = a.axisX.convertValueToPixel(t);p = a.axisY.convertValueToPixel(q[f].y[0]);u = a.axisY.convertValueToPixel(q[f].y[1]);n || T ? (s.connectNullData && !n ? (c.setLineDash && (s.options.nullDataLineDashType || A === s.lineDashType && s.lineDashType !== s.nullDataLineDashType) && (w[w.length - 1].newLineDashArray = D, A = s.nullDataLineDashType, c.setLineDash(z)), c.lineTo(h, p), r && e.lineTo(h, p), w.push({ x: h, y: u })) : (c.beginPath(), c.moveTo(h, p), C = { x: h, y: p }, w = [], w.push({ x: h, y: u }), r && (e.beginPath(), e.moveTo(h, p))), T = n = !1) : (c.lineTo(h, p), w.push({ x: h, y: u }), r && e.lineTo(h, p), 0 == f % 250 && d());t = s.dataPointIds[f];this._eventManager.objectMap[t] = { id: t, objectType: "dataPoint", dataSeriesIndex: m, dataPointIndex: f, x1: h, y1: p, y2: u };f < q.length - 1 && (y !== (q[f].lineColor || v) || A !== (q[f].lineDashType || s.lineDashType)) && (d(), y = q[f].lineColor || v, w[w.length - 1].newStrokeStyle = y, c.strokeStyle = y, c.setLineDash && (q[f].lineDashType ? (A = q[f].lineDashType, w[w.length - 1].newLineDashArray = R(A, s.lineThickness), c.setLineDash(w[w.length - 1].newLineDashArray)) : (A = s.lineDashType, w[w.length - 1].newLineDashArray = D, c.setLineDash(D))));if (0 !== q[f].markerSize && (0 < q[f].markerSize || 0 < s.markerSize)) {
	                  var Y = s.getMarkerProperties(f, h, u, c);g.push(Y);var ca = N(t);r && g.push({ x: h, y: u, ctx: e, type: Y.type, size: Y.size, color: ca, borderColor: ca, borderThickness: Y.borderThickness });
	                  Y = s.getMarkerProperties(f, h, p, c);g.push(Y);ca = N(t);r && g.push({ x: h, y: p, ctx: e, type: Y.type, size: Y.size, color: ca, borderColor: ca, borderThickness: Y.borderThickness });
	                }if (q[f].indexLabel || s.indexLabel || q[f].indexLabelFormatter || s.indexLabelFormatter) this._indexLabels.push({ chartType: "rangeArea", dataPoint: q[f], dataSeries: s, indexKeyword: 0, point: { x: h, y: p }, direction: q[f].y[0] > q[f].y[1] === a.axisY.reversed ? -1 : 1, color: x }), this._indexLabels.push({ chartType: "rangeArea", dataPoint: q[f], dataSeries: s, indexKeyword: 1, point: { x: h,
	                    y: u }, direction: q[f].y[0] > q[f].y[1] === a.axisY.reversed ? 1 : -1, color: x });
	              } else T || n || d(), T = !0;
	            }d();ia.drawMarkers(g);
	          }
	        }r && (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.clearRect(k.x1, k.y1, k.width, k.height), this._eventManager.ghostCtx.restore());c.restore();return { source: b, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderRangeSplineArea = function (a) {
	      function d(a, b) {
	        var d = v(u, 2);if (0 < d.length) {
	          if (0 < m.lineThickness) {
	            c.strokeStyle = b;c.setLineDash && c.setLineDash(a);c.beginPath();c.moveTo(d[0].x, d[0].y);for (var f = 0; f < d.length - 3; f += 3) {
	              if (d[f].newStrokeStyle || d[f].newLineDashArray) c.stroke(), c.beginPath(), c.moveTo(d[f].x, d[f].y), d[f].newStrokeStyle && (c.strokeStyle = d[f].newStrokeStyle), d[f].newLineDashArray && c.setLineDash(d[f].newLineDashArray);c.bezierCurveTo(d[f + 1].x, d[f + 1].y, d[f + 2].x, d[f + 2].y, d[f + 3].x, d[f + 3].y);
	            }c.stroke();
	          }c.beginPath();c.moveTo(d[0].x, d[0].y);r && (e.beginPath(), e.moveTo(d[0].x, d[0].y));for (f = 0; f < d.length - 3; f += 3) {
	            c.bezierCurveTo(d[f + 1].x, d[f + 1].y, d[f + 2].x, d[f + 2].y, d[f + 3].x, d[f + 3].y), r && e.bezierCurveTo(d[f + 1].x, d[f + 1].y, d[f + 2].x, d[f + 2].y, d[f + 3].x, d[f + 3].y);
	          }d = v(z, 2);c.lineTo(z[z.length - 1].x, z[z.length - 1].y);for (f = d.length - 1; 2 < f; f -= 3) {
	            c.bezierCurveTo(d[f - 1].x, d[f - 1].y, d[f - 2].x, d[f - 2].y, d[f - 3].x, d[f - 3].y), r && e.bezierCurveTo(d[f - 1].x, d[f - 1].y, d[f - 2].x, d[f - 2].y, d[f - 3].x, d[f - 3].y);
	          }c.closePath();c.globalAlpha = m.fillOpacity;c.fill();r && (e.closePath(), e.fill());c.globalAlpha = 1;if (0 < m.lineThickness) {
	            c.strokeStyle = b;c.setLineDash && c.setLineDash(a);c.beginPath();c.moveTo(d[0].x, d[0].y);for (var g = f = 0; f < d.length - 3; f += 3, g++) {
	              if (u[g].newStrokeStyle || u[g].newLineDashArray) c.stroke(), c.beginPath(), c.moveTo(d[f].x, d[f].y), u[g].newStrokeStyle && (c.strokeStyle = u[g].newStrokeStyle), u[g].newLineDashArray && c.setLineDash(u[g].newLineDashArray);c.bezierCurveTo(d[f + 1].x, d[f + 1].y, d[f + 2].x, d[f + 2].y, d[f + 3].x, d[f + 3].y);
	            }c.stroke();
	          }c.beginPath();
	        }
	      }var b = a.targetCanvasCtx || this.plotArea.ctx,
	          c = r ? this._preRenderCtx : b;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var e = this._eventManager.ghostCtx,
	            g = [],
	            k = this.plotArea;c.save();r && e.save();c.beginPath();c.rect(k.x1, k.y1, k.width, k.height);c.clip();r && (e.beginPath(), e.rect(k.x1, k.y1, k.width, k.height), e.clip());for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
	          var w = a.dataSeriesIndexes[l],
	              m = this.data[w],
	              h = m.dataPoints,
	              g = m.id;this._eventManager.objectMap[g] = { objectType: "dataSeries", dataSeriesIndex: w };g = N(g);e.fillStyle = g;var g = [],
	              q = 0,
	              n,
	              f,
	              p,
	              u = [],
	              z = [];if (0 < h.length) {
	            var t = m._colorSet[q % m._colorSet.length],
	                C = m.lineColor = m.options.lineColor || t,
	                x = C;c.fillStyle = t;c.lineWidth = m.lineThickness;var F = "solid",
	                y;if (c.setLineDash) {
	              var A = R(m.nullDataLineDashType, m.lineThickness),
	                  F = m.lineDashType;y = R(F, m.lineThickness);
	            }for (f = !1; q < h.length; q++) {
	              if (n = h[q].x.getTime ? h[q].x.getTime() : h[q].x, !(n < a.axisX.dataInfo.viewPortMin || n > a.axisX.dataInfo.viewPortMax && (!m.connectNullData || !f))) if (null !== h[q].y && h[q].y.length && "number" === typeof h[q].y[0] && "number" === typeof h[q].y[1]) {
	                n = a.axisX.convertValueToPixel(n);f = a.axisY.convertValueToPixel(h[q].y[0]);p = a.axisY.convertValueToPixel(h[q].y[1]);var E = m.dataPointIds[q];this._eventManager.objectMap[E] = { id: E, objectType: "dataPoint", dataSeriesIndex: w, dataPointIndex: q,
	                  x1: n, y1: f, y2: p };u[u.length] = { x: n, y: f };z[z.length] = { x: n, y: p };q < h.length - 1 && (x !== (h[q].lineColor || C) || F !== (h[q].lineDashType || m.lineDashType)) && (x = h[q].lineColor || C, u[u.length - 1].newStrokeStyle = x, c.setLineDash && (h[q].lineDashType ? (F = h[q].lineDashType, u[u.length - 1].newLineDashArray = R(F, m.lineThickness)) : (F = m.lineDashType, u[u.length - 1].newLineDashArray = y)));if (0 !== h[q].markerSize && (0 < h[q].markerSize || 0 < m.markerSize)) {
	                  var aa = m.getMarkerProperties(q, n, f, c);g.push(aa);var T = N(E);r && g.push({ x: n, y: f, ctx: e,
	                    type: aa.type, size: aa.size, color: T, borderColor: T, borderThickness: aa.borderThickness });aa = m.getMarkerProperties(q, n, p, c);g.push(aa);T = N(E);r && g.push({ x: n, y: p, ctx: e, type: aa.type, size: aa.size, color: T, borderColor: T, borderThickness: aa.borderThickness });
	                }if (h[q].indexLabel || m.indexLabel || h[q].indexLabelFormatter || m.indexLabelFormatter) this._indexLabels.push({ chartType: "rangeSplineArea", dataPoint: h[q], dataSeries: m, indexKeyword: 0, point: { x: n, y: f }, direction: h[q].y[0] <= h[q].y[1] ? -1 : 1, color: t }), this._indexLabels.push({ chartType: "rangeSplineArea",
	                  dataPoint: h[q], dataSeries: m, indexKeyword: 1, point: { x: n, y: p }, direction: h[q].y[0] <= h[q].y[1] ? 1 : -1, color: t });f = !1;
	              } else 0 < q && !f && (m.connectNullData ? c.setLineDash && 0 < u.length && (m.options.nullDataLineDashType || !h[q - 1].lineDashType) && (u[u.length - 1].newLineDashArray = A, F = m.nullDataLineDashType) : (d(y, C), u = [], z = [])), f = !0;
	            }d(y, C);ia.drawMarkers(g);
	          }
	        }r && (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), c.clearRect(k.x1, k.y1, k.width, k.height), this._eventManager.ghostCtx.restore());c.restore();return { source: b, dest: this.plotArea.ctx, animationCallback: M.xClipAnimation, easingFunction: M.easing.linear, animationBase: 0 };
	      }
	    };p.prototype.renderWaterfall = function (a) {
	      var d = a.targetCanvasCtx || this.plotArea.ctx,
	          b = r ? this._preRenderCtx : d;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var c = this._eventManager.ghostCtx,
	            e = null,
	            g = this.plotArea,
	            k = 0,
	            l,
	            h,
	            m,
	            s,
	            q = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
	            k = this.options.dataPointMinWidth ? this.dataPointMinWidth : this.options.dataPointWidth ? this.dataPointWidth : 1;h = this.options.dataPointMaxWidth ? this.dataPointMaxWidth : this.options.dataPointWidth ? this.dataPointWidth : Math.min(0.15 * this.width, 0.9 * (this.plotArea.width / a.plotType.totalDataSeries)) << 0;var n = a.axisX.dataInfo.minDiff;isFinite(n) || (n = 0.3 * Math.abs(a.axisX.range));n = this.options.dataPointWidth ? this.dataPointWidth : 0.6 * (g.width * (a.axisX.logarithmic ? Math.log(n) / Math.log(a.axisX.range) : Math.abs(n) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;this.dataPointMaxWidth && k > h && (k = Math.min(this.options.dataPointWidth ? this.dataPointWidth : Infinity, h));!this.dataPointMaxWidth && this.dataPointMinWidth && h < k && (h = Math.max(this.options.dataPointWidth ? this.dataPointWidth : -Infinity, k));n < k && (n = k);
	        n > h && (n = h);b.save();r && this._eventManager.ghostCtx.save();b.beginPath();b.rect(g.x1, g.y1, g.width, g.height);b.clip();r && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height), this._eventManager.ghostCtx.clip());for (var f = 0; f < a.dataSeriesIndexes.length; f++) {
	          var p = a.dataSeriesIndexes[f],
	              u = this.data[p],
	              v = u.dataPoints,
	              e = u._colorSet[0];u.risingColor = u.options.risingColor ? u.options.risingColor : e;u.fallingColor = u.options.fallingColor ? u.options.fallingColor : "#e40a0a";
	          var t = "number" === typeof u.options.lineThickness ? Math.round(u.lineThickness) : 1,
	              C = 1 === Math.round(t) % 2 ? -0.5 : 0;if (0 < v.length) for (var x = 5 < n && u.bevelEnabled ? !0 : !1, z = !1, y = null, A = null, k = 0; k < v.length; k++) {
	            if (v[k].getTime ? s = v[k].x.getTime() : s = v[k].x, "number" !== typeof v[k].y) {
	              if (0 < k && !z && u.connectNullData) var D = u.options.nullDataLineDashType || !v[k - 1].lineDashType ? u.nullDataLineDashType : v[k - 1].lineDashType;z = !0;
	            } else {
	              l = a.axisX.convertValueToPixel(s);h = 0 === u.dataPointEOs[k].cumulativeSum ? q : a.axisY.convertValueToPixel(u.dataPointEOs[k].cumulativeSum);
	              m = 0 === u.dataPointEOs[k].cumulativeSumYStartValue ? q : a.axisY.convertValueToPixel(u.dataPointEOs[k].cumulativeSumYStartValue);l = a.axisX.reversed ? l + a.plotType.totalDataSeries * n / 2 - (a.previousDataSeriesCount + f) * n << 0 : l - a.plotType.totalDataSeries * n / 2 + (a.previousDataSeriesCount + f) * n << 0;var F = a.axisX.reversed ? l - n << 0 : l + n << 0;h > m && (e = h, h = m, m = e);a.axisY.reversed && (e = h, h = m, m = e);e = u.dataPointIds[k];this._eventManager.objectMap[e] = { id: e, objectType: "dataPoint", dataSeriesIndex: p, dataPointIndex: k, x1: l, y1: h, x2: F, y2: m };
	              var T = v[k].color ? v[k].color : 0 < v[k].y ? u.risingColor : u.fallingColor;ea(b, l, h, F, m, T, 0, T, x, x, !1, !1, u.fillOpacity);e = N(e);r && ea(this._eventManager.ghostCtx, l, h, F, m, e, 0, null, !1, !1, !1, !1);var Y,
	                  T = l;Y = "undefined" !== typeof v[k].isIntermediateSum && !0 === v[k].isIntermediateSum || "undefined" !== typeof v[k].isCumulativeSum && !0 === v[k].isCumulativeSum ? 0 < v[k].y ? h : m : 0 < v[k].y ? m : h;0 < k && y && (!z || u.connectNullData) && (z && b.setLineDash && b.setLineDash(R(D, t)), b.beginPath(), b.moveTo(y, A - C), b.lineTo(T, Y - C), 0 < t && b.stroke(), r && (c.beginPath(), c.moveTo(y, A - C), c.lineTo(T, Y - C), 0 < t && c.stroke()));z = !1;y = F;A = 0 < v[k].y ? h : m;T = v[k].lineDashType ? v[k].lineDashType : u.options.lineDashType ? u.options.lineDashType : "shortDash";b.strokeStyle = v[k].lineColor ? v[k].lineColor : u.options.lineColor ? u.options.lineColor : "#9e9e9e";b.lineWidth = t;b.setLineDash && (T = R(T, t), b.setLineDash(T));(v[k].indexLabel || u.indexLabel || v[k].indexLabelFormatter || u.indexLabelFormatter) && this._indexLabels.push({ chartType: "waterfall", dataPoint: v[k], dataSeries: u, point: { x: l + (F - l) / 2, y: 0 <= v[k].y ? h : m }, direction: 0 > v[k].y === a.axisY.reversed ? 1 : -1, bounds: { x1: l, y1: Math.min(h, m), x2: F, y2: Math.max(h, m) }, color: e });
	            }
	          }
	        }r && (d.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.globalCompositeOperation = "source-atop", a.axisX.maskCanvas && b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height), a.axisY.maskCanvas && b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height), this._breaksCanvasCtx && this._breaksCanvasCtx.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height), b.clearRect(g.x1, g.y1, g.width, g.height), this._eventManager.ghostCtx.restore());b.restore();return { source: d, dest: this.plotArea.ctx, animationCallback: M.fadeInAnimation, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	      }
	    };var ja = function ja(a, d, b, c, e, g, k, l, h) {
	      if (!(0 > b)) {
	        "undefined" === typeof l && (l = 1);if (!r) {
	          var m = Number((k % (2 * Math.PI)).toFixed(8));Number((g % (2 * Math.PI)).toFixed(8)) === m && (k -= 1E-4);
	        }a.save();a.globalAlpha = l;"pie" === e ? (a.beginPath(), a.moveTo(d.x, d.y), a.arc(d.x, d.y, b, g, k, !1), a.fillStyle = c, a.strokeStyle = "white", a.lineWidth = 2, a.closePath(), a.fill()) : "doughnut" === e && (a.beginPath(), a.arc(d.x, d.y, b, g, k, !1), 0 <= h && a.arc(d.x, d.y, h * b, k, g, !0), a.closePath(), a.fillStyle = c, a.strokeStyle = "white", a.lineWidth = 2, a.fill());a.globalAlpha = 1;a.restore();
	      }
	    };p.prototype.renderPie = function (a) {
	      function d() {
	        if (m && s) {
	          for (var a = 0, b = 0, c = 0, e = 0, d = 0; d < s.length; d++) {
	            var g = s[d],
	                l = m.dataPointIds[d];f[d].id = l;f[d].objectType = "dataPoint";f[d].dataPointIndex = d;f[d].dataSeriesIndex = 0;var k = f[d],
	                q = { percent: null, total: null },
	                p = null,
	                q = h.getPercentAndTotal(m, g);if (m.indexLabelFormatter || g.indexLabelFormatter) p = { chart: h.options, dataSeries: m, dataPoint: g, total: q.total, percent: q.percent };q = g.indexLabelFormatter ? g.indexLabelFormatter(p) : g.indexLabel ? h.replaceKeywordsWithValue(g.indexLabel, g, m, d) : m.indexLabelFormatter ? m.indexLabelFormatter(p) : m.indexLabel ? h.replaceKeywordsWithValue(m.indexLabel, g, m, d) : g.label ? g.label : "";h._eventManager.objectMap[l] = k;k.center = { x: x.x, y: x.y };k.y = g.y;k.radius = A;k.percentInnerRadius = F;k.indexLabelText = q;k.indexLabelPlacement = m.indexLabelPlacement;
	            k.indexLabelLineColor = g.indexLabelLineColor ? g.indexLabelLineColor : m.options.indexLabelLineColor ? m.options.indexLabelLineColor : g.color ? g.color : m._colorSet[d % m._colorSet.length];k.indexLabelLineThickness = u(g.indexLabelLineThickness) ? m.indexLabelLineThickness : g.indexLabelLineThickness;k.indexLabelLineDashType = g.indexLabelLineDashType ? g.indexLabelLineDashType : m.indexLabelLineDashType;k.indexLabelFontColor = g.indexLabelFontColor ? g.indexLabelFontColor : m.indexLabelFontColor;k.indexLabelFontStyle = g.indexLabelFontStyle ? g.indexLabelFontStyle : m.indexLabelFontStyle;k.indexLabelFontWeight = g.indexLabelFontWeight ? g.indexLabelFontWeight : m.indexLabelFontWeight;k.indexLabelFontSize = u(g.indexLabelFontSize) ? m.indexLabelFontSize : g.indexLabelFontSize;k.indexLabelFontFamily = g.indexLabelFontFamily ? g.indexLabelFontFamily : m.indexLabelFontFamily;k.indexLabelBackgroundColor = g.indexLabelBackgroundColor ? g.indexLabelBackgroundColor : m.options.indexLabelBackgroundColor ? m.options.indexLabelBackgroundColor : m.indexLabelBackgroundColor;k.indexLabelMaxWidth = g.indexLabelMaxWidth ? g.indexLabelMaxWidth : m.indexLabelMaxWidth ? m.indexLabelMaxWidth : 0.33 * n.width;k.indexLabelWrap = "undefined" !== typeof g.indexLabelWrap ? g.indexLabelWrap : m.indexLabelWrap;k.startAngle = 0 === d ? m.startAngle ? m.startAngle / 180 * Math.PI : 0 : f[d - 1].endAngle;k.startAngle = (k.startAngle + 2 * Math.PI) % (2 * Math.PI);k.endAngle = k.startAngle + 2 * Math.PI / z * Math.abs(g.y);g = (k.endAngle + k.startAngle) / 2;g = (g + 2 * Math.PI) % (2 * Math.PI);k.midAngle = g;if (k.midAngle > Math.PI / 2 - t && k.midAngle < Math.PI / 2 + t) {
	              if (0 === a || f[c].midAngle > k.midAngle) c = d;a++;
	            } else if (k.midAngle > 3 * Math.PI / 2 - t && k.midAngle < 3 * Math.PI / 2 + t) {
	              if (0 === b || f[e].midAngle > k.midAngle) e = d;b++;
	            }k.hemisphere = g > Math.PI / 2 && g <= 3 * Math.PI / 2 ? "left" : "right";k.indexLabelTextBlock = new ka(h.plotArea.ctx, { fontSize: k.indexLabelFontSize, fontFamily: k.indexLabelFontFamily, fontColor: k.indexLabelFontColor, fontStyle: k.indexLabelFontStyle, fontWeight: k.indexLabelFontWeight, horizontalAlign: "left", backgroundColor: k.indexLabelBackgroundColor, maxWidth: k.indexLabelMaxWidth, maxHeight: k.indexLabelWrap ? 5 * k.indexLabelFontSize : 1.5 * k.indexLabelFontSize, text: k.indexLabelText, padding: 0, textBaseline: "top" });k.indexLabelTextBlock.measureText();
	          }l = g = 0;q = !1;for (d = 0; d < s.length; d++) {
	            k = f[(c + d) % s.length], 1 < a && k.midAngle > Math.PI / 2 - t && k.midAngle < Math.PI / 2 + t && (g <= a / 2 && !q ? (k.hemisphere = "right", g++) : (k.hemisphere = "left", q = !0));
	          }q = !1;for (d = 0; d < s.length; d++) {
	            k = f[(e + d) % s.length], 1 < b && k.midAngle > 3 * Math.PI / 2 - t && k.midAngle < 3 * Math.PI / 2 + t && (l <= b / 2 && !q ? (k.hemisphere = "left", l++) : (k.hemisphere = "right", q = !0));
	          }
	        }
	      }function b(a) {
	        var b = h.plotArea.ctx;b.clearRect(n.x1, n.y1, n.width, n.height);b.fillStyle = h.backgroundColor;b.fillRect(n.x1, n.y1, n.width, n.height);for (b = 0; b < s.length; b++) {
	          var c = f[b].startAngle,
	              e = f[b].endAngle;if (e > c) {
	            var d = 0.07 * A * Math.cos(f[b].midAngle),
	                g = 0.07 * A * Math.sin(f[b].midAngle),
	                k = !1;if (s[b].exploded) {
	              if (1E-9 < Math.abs(f[b].center.x - (x.x + d)) || 1E-9 < Math.abs(f[b].center.y - (x.y + g))) f[b].center.x = x.x + d * a, f[b].center.y = x.y + g * a, k = !0;
	            } else if (0 < Math.abs(f[b].center.x - x.x) || 0 < Math.abs(f[b].center.y - x.y)) f[b].center.x = x.x + d * (1 - a), f[b].center.y = x.y + g * (1 - a), k = !0;k && (d = {}, d.dataSeries = m, d.dataPoint = m.dataPoints[b], d.index = b, h.toolTip.highlightObjects([d]));ja(h.plotArea.ctx, f[b].center, f[b].radius, s[b].color ? s[b].color : m._colorSet[b % m._colorSet.length], m.type, c, e, m.fillOpacity, f[b].percentInnerRadius);
	          }
	        }a = h.plotArea.ctx;a.save();a.fillStyle = "black";a.strokeStyle = "grey";a.textBaseline = "middle";a.lineJoin = "round";for (b = b = 0; b < s.length; b++) {
	          c = f[b], c.indexLabelText && (c.indexLabelTextBlock.y -= c.indexLabelTextBlock.height / 2, e = 0, e = "left" === c.hemisphere ? "inside" !== m.indexLabelPlacement ? -(c.indexLabelTextBlock.width + q) : -c.indexLabelTextBlock.width / 2 : "inside" !== m.indexLabelPlacement ? q : -c.indexLabelTextBlock.width / 2, c.indexLabelTextBlock.x += e, c.indexLabelTextBlock.render(!0), c.indexLabelTextBlock.x -= e, c.indexLabelTextBlock.y += c.indexLabelTextBlock.height / 2, "inside" !== c.indexLabelPlacement && 0 < c.indexLabelLineThickness && (e = c.center.x + A * Math.cos(c.midAngle), d = c.center.y + A * Math.sin(c.midAngle), a.strokeStyle = c.indexLabelLineColor, a.lineWidth = c.indexLabelLineThickness, a.setLineDash && a.setLineDash(R(c.indexLabelLineDashType, c.indexLabelLineThickness)), a.beginPath(), a.moveTo(e, d), a.lineTo(c.indexLabelTextBlock.x, c.indexLabelTextBlock.y), a.lineTo(c.indexLabelTextBlock.x + ("left" === c.hemisphere ? -q : q), c.indexLabelTextBlock.y), a.stroke()), a.lineJoin = "miter");
	        }a.save();
	      }function c(a, b) {
	        var c = 0,
	            c = a.indexLabelTextBlock.y - a.indexLabelTextBlock.height / 2,
	            e = a.indexLabelTextBlock.y + a.indexLabelTextBlock.height / 2,
	            d = b.indexLabelTextBlock.y - b.indexLabelTextBlock.height / 2,
	            f = b.indexLabelTextBlock.y + b.indexLabelTextBlock.height / 2;return c = b.indexLabelTextBlock.y > a.indexLabelTextBlock.y ? d - e : c - f;
	      }function e(a) {
	        for (var b = null, e = 1; e < s.length; e++) {
	          if (b = (a + e + f.length) % f.length, f[b].hemisphere !== f[a].hemisphere) {
	            b = null;break;
	          } else if (f[b].indexLabelText && b !== a && (0 > c(f[b], f[a]) || ("right" === f[a].hemisphere ? f[b].indexLabelTextBlock.y >= f[a].indexLabelTextBlock.y : f[b].indexLabelTextBlock.y <= f[a].indexLabelTextBlock.y))) break;else b = null;
	        }return b;
	      }function g(a, b, d) {
	        d = (d || 0) + 1;if (1E3 < d) return 0;b = b || 0;var k = 0,
	            m = x.y - 1 * r,
	            l = x.y + 1 * r;if (0 <= a && a < s.length) {
	          var n = f[a];if (0 > b && n.indexLabelTextBlock.y < m || 0 < b && n.indexLabelTextBlock.y > l) return 0;var h = 0,
	              q = 0,
	              q = h = h = 0;0 > b ? n.indexLabelTextBlock.y - n.indexLabelTextBlock.height / 2 > m && n.indexLabelTextBlock.y - n.indexLabelTextBlock.height / 2 + b < m && (b = -(m - (n.indexLabelTextBlock.y - n.indexLabelTextBlock.height / 2 + b))) : n.indexLabelTextBlock.y + n.indexLabelTextBlock.height / 2 < m && n.indexLabelTextBlock.y + n.indexLabelTextBlock.height / 2 + b > l && (b = n.indexLabelTextBlock.y + n.indexLabelTextBlock.height / 2 + b - l);b = n.indexLabelTextBlock.y + b;m = 0;m = "right" === n.hemisphere ? x.x + Math.sqrt(Math.pow(r, 2) - Math.pow(b - x.y, 2)) : x.x - Math.sqrt(Math.pow(r, 2) - Math.pow(b - x.y, 2));q = x.x + A * Math.cos(n.midAngle);h = x.y + A * Math.sin(n.midAngle);h = Math.sqrt(Math.pow(m - q, 2) + Math.pow(b - h, 2));q = Math.acos(A / r);h = Math.acos((r * r + A * A - h * h) / (2 * A * r));b = h < q ? b - n.indexLabelTextBlock.y : 0;m = null;for (l = 1; l < s.length; l++) {
	            if (m = (a - l + f.length) % f.length, f[m].hemisphere !== f[a].hemisphere) {
	              m = null;break;
	            } else if (f[m].indexLabelText && f[m].hemisphere === f[a].hemisphere && m !== a && (0 > c(f[m], f[a]) || ("right" === f[a].hemisphere ? f[m].indexLabelTextBlock.y <= f[a].indexLabelTextBlock.y : f[m].indexLabelTextBlock.y >= f[a].indexLabelTextBlock.y))) break;else m = null;
	          }q = m;h = e(a);l = m = 0;0 > b ? (l = "right" === n.hemisphere ? q : h, k = b, null !== l && (q = -b, b = n.indexLabelTextBlock.y - n.indexLabelTextBlock.height / 2 - (f[l].indexLabelTextBlock.y + f[l].indexLabelTextBlock.height / 2), b - q < p && (m = -q, l = g(l, m, d + 1), +l.toFixed(C) > +m.toFixed(C) && (k = b > p ? -(b - p) : -(q - (l - m)))))) : 0 < b && (l = "right" === n.hemisphere ? h : q, k = b, null !== l && (q = b, b = f[l].indexLabelTextBlock.y - f[l].indexLabelTextBlock.height / 2 - (n.indexLabelTextBlock.y + n.indexLabelTextBlock.height / 2), b - q < p && (m = q, l = g(l, m, d + 1), +l.toFixed(C) < +m.toFixed(C) && (k = b > p ? b - p : q - (m - l)))));k && (d = n.indexLabelTextBlock.y + k, b = 0, b = "right" === n.hemisphere ? x.x + Math.sqrt(Math.pow(r, 2) - Math.pow(d - x.y, 2)) : x.x - Math.sqrt(Math.pow(r, 2) - Math.pow(d - x.y, 2)), n.midAngle > Math.PI / 2 - t && n.midAngle < Math.PI / 2 + t ? (m = (a - 1 + f.length) % f.length, m = f[m], a = f[(a + 1 + f.length) % f.length], "left" === n.hemisphere && "right" === m.hemisphere && b > m.indexLabelTextBlock.x ? b = m.indexLabelTextBlock.x - 15 : "right" === n.hemisphere && "left" === a.hemisphere && b < a.indexLabelTextBlock.x && (b = a.indexLabelTextBlock.x + 15)) : n.midAngle > 3 * Math.PI / 2 - t && n.midAngle < 3 * Math.PI / 2 + t && (m = (a - 1 + f.length) % f.length, m = f[m], a = f[(a + 1 + f.length) % f.length], "right" === n.hemisphere && "left" === m.hemisphere && b < m.indexLabelTextBlock.x ? b = m.indexLabelTextBlock.x + 15 : "left" === n.hemisphere && "right" === a.hemisphere && b > a.indexLabelTextBlock.x && (b = a.indexLabelTextBlock.x - 15)), n.indexLabelTextBlock.y = d, n.indexLabelTextBlock.x = b, n.indexLabelAngle = Math.atan2(n.indexLabelTextBlock.y - x.y, n.indexLabelTextBlock.x - x.x));
	        }return k;
	      }function k() {
	        var a = h.plotArea.ctx;a.fillStyle = "grey";a.strokeStyle = "grey";a.font = "16px Arial";a.textBaseline = "middle";for (var b = a = 0, d = 0, k = !0, b = 0; 10 > b && (1 > b || 0 < d); b++) {
	          if (m.radius || !m.radius && "undefined" !== typeof m.innerRadius && null !== m.innerRadius && A - d <= D) k = !1;k && (A -= d);d = 0;if ("inside" !== m.indexLabelPlacement) {
	            r = A * v;for (a = 0; a < s.length; a++) {
	              var l = f[a];l.indexLabelTextBlock.x = x.x + r * Math.cos(l.midAngle);l.indexLabelTextBlock.y = x.y + r * Math.sin(l.midAngle);l.indexLabelAngle = l.midAngle;l.radius = A;l.percentInnerRadius = F;
	            }for (var t, u, a = 0; a < s.length; a++) {
	              var l = f[a],
	                  y = e(a);if (null !== y) {
	                t = f[a];u = f[y];var z = 0,
	                    z = c(t, u) - p;if (0 > z) {
	                  for (var E = u = 0, H = 0; H < s.length; H++) {
	                    H !== a && f[H].hemisphere === l.hemisphere && (f[H].indexLabelTextBlock.y < l.indexLabelTextBlock.y ? u++ : E++);
	                  }u = z / (u + E || 1) * E;var E = -1 * (z - u),
	                      I = H = 0;"right" === l.hemisphere ? (H = g(a, u), E = -1 * (z - H), I = g(y, E), +I.toFixed(C) < +E.toFixed(C) && +H.toFixed(C) <= +u.toFixed(C) && g(a, -(E - I))) : (H = g(y, u), E = -1 * (z - H), I = g(a, E), +I.toFixed(C) < +E.toFixed(C) && +H.toFixed(C) <= +u.toFixed(C) && g(y, -(E - I)));
	                }
	              }
	            }
	          } else for (a = 0; a < s.length; a++) {
	            l = f[a], r = "pie" === m.type ? 0.7 * A : 0.8 * A, y = x.x + r * Math.cos(l.midAngle), u = x.y + r * Math.sin(l.midAngle), l.indexLabelTextBlock.x = y, l.indexLabelTextBlock.y = u;
	          }for (a = 0; a < s.length; a++) {
	            if (l = f[a], y = l.indexLabelTextBlock.measureText(), 0 !== y.height && 0 !== y.width) y = y = 0, "right" === l.hemisphere ? (y = n.x2 - (l.indexLabelTextBlock.x + l.indexLabelTextBlock.width + q), y *= -1) : y = n.x1 - (l.indexLabelTextBlock.x - l.indexLabelTextBlock.width - q), 0 < y && (!k && l.indexLabelText && (u = "right" === l.hemisphere ? n.x2 - l.indexLabelTextBlock.x : l.indexLabelTextBlock.x - n.x1, 0.3 * l.indexLabelTextBlock.maxWidth > u ? l.indexLabelText = "" : l.indexLabelTextBlock.maxWidth = 0.85 * u, 0.3 * l.indexLabelTextBlock.maxWidth < u && (l.indexLabelTextBlock.x -= "right" === l.hemisphere ? 2 : -2)), Math.abs(l.indexLabelTextBlock.y - l.indexLabelTextBlock.height / 2 - x.y) < A || Math.abs(l.indexLabelTextBlock.y + l.indexLabelTextBlock.height / 2 - x.y) < A) && (y /= Math.abs(Math.cos(l.indexLabelAngle)), 9 < y && (y *= 0.3), y > d && (d = y)), y = y = 0, 0 < l.indexLabelAngle && l.indexLabelAngle < Math.PI ? (y = n.y2 - (l.indexLabelTextBlock.y + l.indexLabelTextBlock.height / 2 + 5), y *= -1) : y = n.y1 - (l.indexLabelTextBlock.y - l.indexLabelTextBlock.height / 2 - 5), 0 < y && (!k && l.indexLabelText && (u = 0 < l.indexLabelAngle && l.indexLabelAngle < Math.PI ? -1 : 1, 0 === g(a, y * u) && g(a, 2 * u)), Math.abs(l.indexLabelTextBlock.x - x.x) < A && (y /= Math.abs(Math.sin(l.indexLabelAngle)), 9 < y && (y *= 0.3), y > d && (d = y)));
	          }var K = function K(a, b, c) {
	            for (var e = [], d = 0; e.push(f[b]), b !== c; b = (b + 1 + s.length) % s.length) {}e.sort(function (a, b) {
	              return a.y - b.y;
	            });for (b = 0; b < e.length; b++) {
	              if (c = e[b], d < 0.7 * a) d += c.indexLabelTextBlock.height, c.indexLabelTextBlock.text = "", c.indexLabelText = "", c.indexLabelTextBlock.measureText();else break;
	            }
	          };(function () {
	            for (var a = -1, b = -1, d = 0, g = !1, l = 0; l < s.length; l++) {
	              if (g = !1, t = f[l], t.indexLabelText) {
	                var k = e(l);if (null !== k) {
	                  var m = f[k];z = 0;z = c(t, m);var n;if (n = 0 > z) {
	                    n = t.indexLabelTextBlock.x;var h = t.indexLabelTextBlock.y - t.indexLabelTextBlock.height / 2,
	                        w = t.indexLabelTextBlock.y + t.indexLabelTextBlock.height / 2,
	                        p = m.indexLabelTextBlock.y - m.indexLabelTextBlock.height / 2,
	                        u = m.indexLabelTextBlock.x + m.indexLabelTextBlock.width,
	                        r = m.indexLabelTextBlock.y + m.indexLabelTextBlock.height / 2;n = t.indexLabelTextBlock.x + t.indexLabelTextBlock.width < m.indexLabelTextBlock.x - q || n > u + q || h > r + q || w < p - q ? !1 : !0;
	                  }n ? (0 > a && (a = l), k !== a && (b = k, d += -z), 0 === l % Math.max(s.length / 10, 3) && (g = !0)) : g = !0;g && 0 < d && 0 <= a && 0 <= b && (K(d, a, b), b = a = -1, d = 0);
	                }
	              }
	            }0 < d && K(d, a, b);
	          })();
	        }
	      }function l() {
	        h.plotArea.layoutManager.reset();
	        h.title && (h.title.dockInsidePlotArea || "center" === h.title.horizontalAlign && "center" === h.title.verticalAlign) && h.title.render();if (h.subtitles) for (var a = 0; a < h.subtitles.length; a++) {
	          var b = h.subtitles[a];(b.dockInsidePlotArea || "center" === b.horizontalAlign && "center" === b.verticalAlign) && b.render();
	        }h.legend && (h.legend.dockInsidePlotArea || "center" === h.legend.horizontalAlign && "center" === h.legend.verticalAlign) && (h.legend.setLayout(), h.legend.render());
	      }var h = this;if (!(0 >= a.dataSeriesIndexes.length)) {
	        var m = this.data[a.dataSeriesIndexes[0]],
	            s = m.dataPoints,
	            q = 10,
	            n = this.plotArea,
	            f = m.dataPointEOs,
	            p = 2,
	            r,
	            v = 1.3,
	            t = 20 / 180 * Math.PI,
	            C = 6,
	            x = { x: (n.x2 + n.x1) / 2, y: (n.y2 + n.y1) / 2 },
	            z = 0;a = !1;for (var y = 0; y < s.length; y++) {
	          z += Math.abs(s[y].y), !a && "undefined" !== typeof s[y].indexLabel && null !== s[y].indexLabel && 0 < s[y].indexLabel.toString().length && (a = !0), !a && "undefined" !== typeof s[y].label && null !== s[y].label && 0 < s[y].label.toString().length && (a = !0);
	        }if (0 !== z) {
	          a = a || "undefined" !== typeof m.indexLabel && null !== m.indexLabel && 0 < m.indexLabel.toString().length;
	          var A = "inside" !== m.indexLabelPlacement && a ? 0.75 * Math.min(n.width, n.height) / 2 : 0.92 * Math.min(n.width, n.height) / 2;m.radius && (A = I(m.radius, A));var D = "undefined" !== typeof m.innerRadius && null !== m.innerRadius ? I(m.innerRadius, A) : 0.7 * A;m.radius = A;"doughnut" === m.type && (m.innerRadius = D);var F = Math.min(D / A, (A - 1) / A);this.pieDoughnutClickHandler = function (a) {
	            h.isAnimating || !u(a.dataSeries.explodeOnClick) && !a.dataSeries.explodeOnClick || (a = a.dataPoint, a.exploded = a.exploded ? !1 : !0, 1 < this.dataPoints.length && h._animator.animate(0, 500, function (a) {
	              b(a);l();
	            }));
	          };d();k();k();k();k();this.disableToolTip = !0;this._animator.animate(0, this.animatedRender ? this.animationDuration : 0, function (a) {
	            var b = h.plotArea.ctx;b.clearRect(n.x1, n.y1, n.width, n.height);b.fillStyle = h.backgroundColor;b.fillRect(n.x1, n.y1, n.width, n.height);a = f[0].startAngle + 2 * Math.PI * a;for (b = 0; b < s.length; b++) {
	              var c = 0 === b ? f[b].startAngle : e,
	                  e = c + (f[b].endAngle - f[b].startAngle),
	                  d = !1;e > a && (e = a, d = !0);var g = s[b].color ? s[b].color : m._colorSet[b % m._colorSet.length];e > c && ja(h.plotArea.ctx, f[b].center, f[b].radius, g, m.type, c, e, m.fillOpacity, f[b].percentInnerRadius);if (d) break;
	            }l();
	          }, function () {
	            h.disableToolTip = !1;h._animator.animate(0, h.animatedRender ? 500 : 0, function (a) {
	              b(a);l();
	            });
	          });
	        }
	      }
	    };var ra = function ra(a, d, b, c) {
	      "undefined" === typeof b && (b = 1);0 >= Math.round(d.y4 - d.y1) || (a.save(), a.globalAlpha = b, a.beginPath(), a.moveTo(Math.round(d.x1), Math.round(d.y1)), a.lineTo(Math.round(d.x2), Math.round(d.y2)), a.lineTo(Math.round(d.x3), Math.round(d.y3)), a.lineTo(Math.round(d.x4), Math.round(d.y4)), "undefined" !== d.x5 && (a.lineTo(Math.round(d.x5), Math.round(d.y5)), a.lineTo(Math.round(d.x6), Math.round(d.y6))), a.closePath(), a.fillStyle = c ? c : d.color, a.fill(), a.globalAplha = 1, a.restore());
	    };p.prototype.renderFunnel = function (a) {
	      function d() {
	        for (var a = 0, b = [], c = 0; c < C.length; c++) {
	          if ("undefined" === typeof C[c].y) return -1;C[c].y = "number" === typeof C[c].y ? C[c].y : 0;a += Math.abs(C[c].y);
	        }if (0 === a) return -1;for (c = b[0] = 0; c < C.length; c++) {
	          b.push(Math.abs(C[c].y) * F / a);
	        }return b;
	      }function b() {
	        var a = $,
	            b = V,
	            c = K,
	            e = ea,
	            d,
	            f;d = O;f = Z - N;e = Math.abs((f - d) * (b - a + (e - c)) / 2);c = ea - K;d = f - d;f = c * (f - Z);f = Math.abs(f);f = e + f;for (var e = [], g = 0, l = 0; l < C.length; l++) {
	          if ("undefined" === typeof C[l].y) return -1;C[l].y = "number" === typeof C[l].y ? C[l].y : 0;g += Math.abs(C[l].y);
	        }if (0 === g) return -1;for (var m = e[0] = 0, k = 0, n, h, b = b - a, m = !1, l = 0; l < C.length; l++) {
	          a = Math.abs(C[l].y) * f / g, m ? n = 0 == Number(c.toFixed(3)) ? 0 : a / c : (h = ba * ba * b * b - 4 * Math.abs(ba) * a, 0 > h ? (h = c, m = (b + h) * (d - k) / 2, a -= m, n = d - k, k += d - k, n += 0 == h ? 0 : a / h, k += a / h, m = !0) : (n = (Math.abs(ba) * b - Math.sqrt(h)) / 2, h = b - 2 * n / Math.abs(ba), k += n, k > d && (k -= n, h = c, m = (b + h) * (d - k) / 2, a -= m, n = d - k, k += d - k, n += a / h, k += a / h, m = !0), b = h)), e.push(n);
	        }return e;
	      }function c() {
	        if (t && C) {
	          for (var a, b, c, e, d, g, l, k, m, n, h, q, s, w, p = [], B = [], x = { percent: null, total: null }, v = null, y = 0; y < C.length; y++) {
	            w = P[y], w = "undefined" !== typeof w.x5 ? (w.y2 + w.y4) / 2 : (w.y2 + w.y3) / 2, w = f(w).x2 + 1, p[y] = L - w - S;
	          }w = 0.5 * S;for (var y = 0, A = C.length - 1; y < C.length || 0 <= A; y++, A--) {
	            b = t.reversed ? C[A] : C[y];a = b.color ? b.color : t.reversed ? t._colorSet[(C.length - 1 - y) % t._colorSet.length] : t._colorSet[y % t._colorSet.length];c = b.indexLabelPlacement || t.indexLabelPlacement || "outside";e = b.indexLabelBackgroundColor || t.indexLabelBackgroundColor || (r ? "transparent" : null);d = b.indexLabelFontColor || t.indexLabelFontColor || "#979797";g = u(b.indexLabelFontSize) ? t.indexLabelFontSize : b.indexLabelFontSize;l = b.indexLabelFontStyle || t.indexLabelFontStyle || "normal";k = b.indexLabelFontFamily || t.indexLabelFontFamily || "arial";m = b.indexLabelFontWeight || t.indexLabelFontWeight || "normal";a = b.indexLabelLineColor || t.options.indexLabelLineColor || a;n = "number" === typeof b.indexLabelLineThickness ? b.indexLabelLineThickness : "number" === typeof t.indexLabelLineThickness ? t.indexLabelLineThickness : 2;h = b.indexLabelLineDashType || t.indexLabelLineDashType || "solid";q = "undefined" !== typeof b.indexLabelWrap ? b.indexLabelWrap : "undefined" !== typeof t.indexLabelWrap ? t.indexLabelWrap : !0;s = t.dataPointIds[y];z._eventManager.objectMap[s] = { id: s, objectType: "dataPoint", dataPointIndex: y, dataSeriesIndex: 0, funnelSection: P[t.reversed ? C.length - 1 - y : y] };"inside" === t.indexLabelPlacement && (p[y] = y !== fa ? t.reversed ? P[y].x2 - P[y].x1 : P[y].x3 - P[y].x4 : P[y].x3 - P[y].x6, 20 > p[y] && (p[y] = y !== fa ? t.reversed ? P[y].x3 - P[y].x4 : P[y].x2 - P[y].x1 : P[y].x2 - P[y].x1, p[y] /= 2));s = b.indexLabelMaxWidth ? b.indexLabelMaxWidth : t.options.indexLabelMaxWidth ? t.indexLabelMaxWidth : p[y];if (s > p[y] || 0 > s) s = p[y];B[y] = "inside" === t.indexLabelPlacement ? P[y].height : !1;x = z.getPercentAndTotal(t, b);if (t.indexLabelFormatter || b.indexLabelFormatter) v = { chart: z.options, dataSeries: t, dataPoint: b, total: x.total, percent: x.percent };b = b.indexLabelFormatter ? b.indexLabelFormatter(v) : b.indexLabel ? z.replaceKeywordsWithValue(b.indexLabel, b, t, y) : t.indexLabelFormatter ? t.indexLabelFormatter(v) : t.indexLabel ? z.replaceKeywordsWithValue(t.indexLabel, b, t, y) : b.label ? b.label : "";0 >= n && (n = 0);1E3 > s && 1E3 - s < w && (s += 1E3 - s);Q.roundRect || Ea(Q);c = new ka(Q, { fontSize: g, fontFamily: k, fontColor: d, fontStyle: l, fontWeight: m, horizontalAlign: c, backgroundColor: e, maxWidth: s, maxHeight: !1 === B[y] ? q ? 4.28571429 * g : 1.5 * g : B[y], text: b, padding: ga });c.measureText();J.push({ textBlock: c, id: t.reversed ? A : y, isDirty: !1, lineColor: a, lineThickness: n,
	              lineDashType: h, height: c.height < c.maxHeight ? c.height : c.maxHeight, width: c.width < c.maxWidth ? c.width : c.maxWidth });
	          }
	        }
	      }function e() {
	        var a,
	            b,
	            c,
	            e,
	            d,
	            f = [];d = !1;c = 0;for (var g, l = L - V - S / 2, l = t.options.indexLabelMaxWidth ? t.indexLabelMaxWidth > l ? l : t.indexLabelMaxWidth : l, k = J.length - 1; 0 <= k; k--) {
	          g = C[J[k].id];c = J[k];e = c.textBlock;b = (a = n(k) < P.length ? J[n(k)] : null) ? a.textBlock : null;c = c.height;a && e.y + c + ga > b.y && (d = !0);c = g.indexLabelMaxWidth || l;if (c > l || 0 > c) c = l;f.push(c);
	        }if (d) for (k = J.length - 1; 0 <= k; k--) {
	          a = P[k], J[k].textBlock.maxWidth = f[f.length - (k + 1)], J[k].textBlock.measureText(), J[k].textBlock.x = L - l, c = J[k].textBlock.height < J[k].textBlock.maxHeight ? J[k].textBlock.height : J[k].textBlock.maxHeight, d = J[k].textBlock.width < J[k].textBlock.maxWidth ? J[k].textBlock.width : J[k].textBlock.maxWidth, J[k].height = c, J[k].width = d, c = "undefined" !== typeof a.x5 ? (a.y2 + a.y4) / 2 : (a.y2 + a.y3) / 2, J[k].textBlock.y = c - J[k].height / 2, t.reversed ? (J[k].textBlock.y + J[k].height > pa + D && (J[k].textBlock.y = pa + D - J[k].height), J[k].textBlock.y < wa - D && (J[k].textBlock.y = wa - D)) : (J[k].textBlock.y < pa - D && (J[k].textBlock.y = pa - D), J[k].textBlock.y + J[k].height > wa + D && (J[k].textBlock.y = wa + D - J[k].height));
	        }
	      }function g() {
	        var a, b, c, e;if ("inside" !== t.indexLabelPlacement) for (var d = 0; d < P.length; d++) {
	          0 == J[d].textBlock.text.length ? J[d].isDirty = !0 : (a = P[d], c = "undefined" !== typeof a.x5 ? (a.y2 + a.y4) / 2 : (a.y2 + a.y3) / 2, b = t.reversed ? "undefined" !== typeof a.x5 ? c > Da ? f(c).x2 + 1 : (a.x2 + a.x3) / 2 + 1 : (a.x2 + a.x3) / 2 + 1 : "undefined" !== typeof a.x5 ? c < Da ? f(c).x2 + 1 : (a.x4 + a.x3) / 2 + 1 : (a.x2 + a.x3) / 2 + 1, J[d].textBlock.x = b + S, J[d].textBlock.y = c - J[d].height / 2, t.reversed ? (J[d].textBlock.y + J[d].height > pa + D && (J[d].textBlock.y = pa + D - J[d].height), J[d].textBlock.y < wa - D && (J[d].textBlock.y = wa - D)) : (J[d].textBlock.y < pa - D && (J[d].textBlock.y = pa - D), J[d].textBlock.y + J[d].height > wa + D && (J[d].textBlock.y = wa + D - J[d].height)));
	        } else for (d = 0; d < P.length; d++) {
	          0 == J[d].textBlock.text.length ? J[d].isDirty = !0 : (a = P[d], b = a.height, c = J[d].height, e = J[d].width, b >= c ? (b = d != fa ? (a.x4 + a.x3) / 2 - e / 2 : (a.x5 + a.x4) / 2 - e / 2, c = d != fa ? (a.y1 + a.y3) / 2 - c / 2 : (a.y1 + a.y4) / 2 - c / 2, J[d].textBlock.x = b, J[d].textBlock.y = c) : J[d].isDirty = !0);
	        }
	      }function k() {
	        function a(b, c) {
	          var d;if (0 > b || b >= J.length) return 0;var e,
	              f = J[b].textBlock;if (0 > c) {
	            c *= -1;e = q(b);d = l(e, b);if (d >= c) return f.y -= c, c;if (0 == b) return 0 < d && (f.y -= d), d;d += a(e, -(c - d));0 < d && (f.y -= d);return d;
	          }e = n(b);d = l(b, e);if (d >= c) return f.y += c, c;if (b == P.length - 1) return 0 < d && (f.y += d), d;d += a(e, c - d);0 < d && (f.y += d);return d;
	        }function b() {
	          var a,
	              d,
	              e,
	              f,
	              g = 0,
	              k;f = (Z - O + 2 * D) / h;k = h;for (var l, m = 1; m < k; m++) {
	            e = m * f;for (var s = J.length - 1; 0 <= s; s--) {
	              !J[s].isDirty && J[s].textBlock.y < e && J[s].textBlock.y + J[s].height > e && (l = n(s), !(l >= J.length - 1) && J[s].textBlock.y + J[s].height + ga > J[l].textBlock.y && (J[s].textBlock.y = J[s].textBlock.y + J[s].height - e > e - J[s].textBlock.y ? e + 1 : e - J[s].height - 1));
	            }
	          }for (l = P.length - 1; 0 < l; l--) {
	            if (!J[l].isDirty) {
	              e = q(l);if (0 > e && (e = 0, J[e].isDirty)) break;if (J[l].textBlock.y < J[e].textBlock.y + J[e].height) {
	                d = d || l;f = l;for (k = 0; J[f].textBlock.y < J[e].textBlock.y + J[e].height + ga;) {
	                  a = a || J[f].textBlock.y + J[f].height;k += J[f].height;k += ga;f = e;if (0 >= f) {
	                    f = 0;k += J[f].height;break;
	                  }e = q(f);
	                  if (0 > e) {
	                    f = 0;k += J[f].height;break;
	                  }
	                }if (f != l) {
	                  g = J[f].textBlock.y;a -= g;a = k - a;g = c(a, d, f);break;
	                }
	              }
	            }
	          }return g;
	        }function c(a, b, d) {
	          var e = [],
	              f = 0,
	              g = 0;for (a = Math.abs(a); d <= b; d++) {
	            e.push(P[d]);
	          }e.sort(function (a, b) {
	            return a.height - b.height;
	          });for (d = 0; d < e.length; d++) {
	            if (b = e[d], f < a) g++, f += J[b.id].height + ga, J[b.id].textBlock.text = "", J[b.id].indexLabelText = "", J[b.id].isDirty = !0, J[b.id].textBlock.measureText();else break;
	          }return g;
	        }for (var d, e, f, g, k, m, h = 1, s = 0; s < 2 * h; s++) {
	          for (var w = J.length - 1; 0 <= w && !(0 <= q(w) && q(w), f = J[w], g = f.textBlock, m = (k = n(w) < P.length ? J[n(w)] : null) ? k.textBlock : null, d = +f.height.toFixed(6), e = +g.y.toFixed(6), !f.isDirty && k && e + d + ga > +m.y.toFixed(6) && (d = g.y + d + ga - m.y, e = a(w, -d), e < d && (0 < e && (d -= e), e = a(n(w), d), e != d))); w--) {}b();
	        }
	      }function l(a, b) {
	        return (b < P.length ? J[b].textBlock.y : t.reversed ? pa + D : wa + D) - (0 > a ? t.reversed ? wa - D : pa - D : J[a].textBlock.y + J[a].height + ga);
	      }function h(a, b, c) {
	        var d,
	            e,
	            f,
	            k = [],
	            l = D,
	            n = [];-1 !== b && (0 <= W.indexOf(b) ? (e = W.indexOf(b), W.splice(e, 1)) : (W.push(b), W = W.sort(function (a, b) {
	          return a - b;
	        })));if (0 === W.length) k = ia;else {
	          e = D * (1 != W.length || 0 != W[0] && W[0] != P.length - 1 ? 2 : 1) / m();for (var q = 0; q < P.length; q++) {
	            if (1 == W.length && 0 == W[0]) {
	              if (0 === q) {
	                k.push(ia[q]);d = l;continue;
	              }
	            } else 0 === q && (d = -1 * l);k.push(ia[q] + d);if (0 <= W.indexOf(q) || q < P.length && 0 <= W.indexOf(q + 1)) d += e;
	          }
	        }f = function () {
	          for (var a = [], b = 0; b < P.length; b++) {
	            a.push(k[b] - P[b].y1);
	          }return a;
	        }();var w = { startTime: new Date().getTime(), duration: c || 500, easingFunction: function easingFunction(a, b, c, d) {
	            return M.easing.easeOutQuart(a, b, c, d);
	          }, changeSection: function changeSection(a) {
	            for (var b, c, d = 0; d < P.length; d++) {
	              b = f[d], c = P[d], b *= a, "undefined" === typeof n[d] && (n[d] = 0), 0 > n && (n *= -1), c.y1 += b - n[d], c.y2 += b - n[d], c.y3 += b - n[d], c.y4 += b - n[d], c.y5 && (c.y5 += b - n[d], c.y6 += b - n[d]), n[d] = b;
	            }
	          } };a._animator.animate(0, c, function (c) {
	          var d = a.plotArea.ctx || a.ctx;ja = !0;d.clearRect(x.x1, x.y1, x.x2 - x.x1, x.y2 - x.y1);d.fillStyle = a.backgroundColor;d.fillRect(x.x1, x.y1, x.width, x.height);w.changeSection(c, b);var e = {};e.dataSeries = t;e.dataPoint = t.reversed ? t.dataPoints[C.length - 1 - b] : t.dataPoints[b];e.index = t.reversed ? C.length - 1 - b : b;a.toolTip.highlightObjects([e]);
	          for (e = 0; e < P.length; e++) {
	            ra(d, P[e], t.fillOpacity);
	          }v(d);H && ("inside" !== t.indexLabelPlacement ? s(d) : g(), p(d));1 <= c && (ja = !1);
	        }, null, M.easing.easeOutQuart);
	      }function m() {
	        for (var a = 0, b = 0; b < P.length - 1; b++) {
	          (0 <= W.indexOf(b) || 0 <= W.indexOf(b + 1)) && a++;
	        }return a;
	      }function s(a) {
	        for (var b, c, d, e, g = 0; g < P.length; g++) {
	          e = 1 === J[g].lineThickness % 2 ? 0.5 : 0, c = ((P[g].y2 + P[g].y4) / 2 << 0) + e, b = f(c).x2 - 1, d = J[g].textBlock.x, e = (J[g].textBlock.y + J[g].height / 2 << 0) + e, J[g].isDirty || 0 == J[g].lineThickness || (a.strokeStyle = J[g].lineColor, a.lineWidth = J[g].lineThickness, a.setLineDash && a.setLineDash(R(J[g].lineDashType, J[g].lineThickness)), a.beginPath(), a.moveTo(b, c), a.lineTo(d, e), a.stroke());
	        }
	      }function q(a) {
	        for (a -= 1; -1 <= a && -1 != a && J[a].isDirty; a--) {}return a;
	      }function n(a) {
	        for (a += 1; a <= P.length && a != P.length && J[a].isDirty; a++) {}return a;
	      }function f(a) {
	        for (var b, c = 0; c < C.length; c++) {
	          if (P[c].y1 < a && P[c].y4 > a) {
	            b = P[c];break;
	          }
	        }return b ? (a = b.y6 ? a > b.y6 ? b.x3 + (b.x4 - b.x3) / (b.y4 - b.y3) * (a - b.y3) : b.x2 + (b.x3 - b.x2) / (b.y3 - b.y2) * (a - b.y2) : b.x2 + (b.x3 - b.x2) / (b.y3 - b.y2) * (a - b.y2), { x1: a, x2: a }) : -1;
	      }function p(a) {
	        for (var b = 0; b < P.length; b++) {
	          J[b].isDirty || (a && (J[b].textBlock.ctx = a), J[b].textBlock.render(!0));
	        }
	      }function v(a) {
	        z.plotArea.layoutManager.reset();a.roundRect || Ea(a);z.title && (z.title.dockInsidePlotArea || "center" === z.title.horizontalAlign && "center" === z.title.verticalAlign) && (z.title.ctx = a, z.title.render());if (z.subtitles) for (var b = 0; b < z.subtitles.length; b++) {
	          var c = z.subtitles[b];if (c.dockInsidePlotArea || "center" === c.horizontalAlign && "center" === c.verticalAlign) z.subtitles.ctx = a, c.render();
	        }z.legend && (z.legend.dockInsidePlotArea || "center" === z.legend.horizontalAlign && "center" === z.legend.verticalAlign) && (z.legend.ctx = a, z.legend.setLayout(), z.legend.render());U.fNg && U.fNg(z);
	      }var z = this;if (!(0 >= a.dataSeriesIndexes.length)) {
	        for (var t = this.data[a.dataSeriesIndexes[0]], C = t.dataPoints, x = this.plotArea, D = 0.025 * x.width, y = 0.01 * x.width, A = 0, F = x.height - 2 * D, E = Math.min(x.width - 2 * y, 2.8 * x.height), H = !1, I = 0; I < C.length; I++) {
	          if (!H && "undefined" !== typeof C[I].indexLabel && null !== C[I].indexLabel && 0 < C[I].indexLabel.toString().length && (H = !0), !H && "undefined" !== typeof C[I].label && null !== C[I].label && 0 < C[I].label.toString().length && (H = !0), !H && "function" === typeof t.indexLabelFormatter || "function" === typeof C[I].indexLabelFormatter) H = !0;
	        }H = H || "undefined" !== typeof t.indexLabel && null !== t.indexLabel && 0 < t.indexLabel.toString().length;"inside" !== t.indexLabelPlacement && H || (y = (x.width - 0.75 * E) / 2);var I = x.x1 + y,
	            L = x.x2 - y,
	            O = x.y1 + D,
	            Z = x.y2 - D,
	            Q = a.targetCanvasCtx || this.plotArea.ctx || this.ctx;if (0 != t.length && t.dataPoints && t.visible && 0 !== C.length) {
	          var N, G;a = 75 * E / 100;var S = 30 * (L - a) / 100;"funnel" === t.type ? (N = u(t.options.neckHeight) ? 0.35 * F : t.neckHeight, G = u(t.options.neckWidth) ? 0.25 * a : t.neckWidth, "string" === typeof N && N.match(/%$/) ? (N = parseInt(N), N = N * F / 100) : N = parseInt(N), "string" === typeof G && G.match(/%$/) ? (G = parseInt(G), G = G * a / 100) : G = parseInt(G), N > F ? N = F : 0 >= N && (N = 0), G > a ? G = a - 0.5 : 0 >= G && (G = 0)) : "pyramid" === t.type && (G = N = 0, t.reversed = t.reversed ? !1 : !0);var y = I + a / 2,
	              $ = I,
	              V = I + a,
	              pa = t.reversed ? Z : O,
	              K = y - G / 2,
	              ea = y + G / 2,
	              Da = t.reversed ? O + N : Z - N,
	              wa = t.reversed ? O : Z;a = [];var y = [],
	              P = [],
	              E = [],
	              X = O,
	              fa,
	              ba = (Da - pa) / (K - $),
	              ha = -ba,
	              I = "area" === (t.valueRepresents ? t.valueRepresents : "height") ? b() : d();if (-1 !== I) {
	            if (t.reversed) for (E.push(X), G = I.length - 1; 0 < G; G--) {
	              X += I[G], E.push(X);
	            } else for (G = 0; G < I.length; G++) {
	              X += I[G], E.push(X);
	            }if (t.reversed) for (G = 0; G < I.length; G++) {
	              E[G] < Da ? (a.push(K), y.push(ea), fa = G) : (a.push((E[G] - pa + ba * $) / ba), y.push((E[G] - pa + ha * V) / ha));
	            } else for (G = 0; G < I.length; G++) {
	              E[G] < Da ? (a.push((E[G] - pa + ba * $) / ba), y.push((E[G] - pa + ha * V) / ha), fa = G) : (a.push(K), y.push(ea));
	            }for (G = 0; G < I.length - 1; G++) {
	              X = t.reversed ? C[C.length - 1 - G].color ? C[C.length - 1 - G].color : t._colorSet[(C.length - 1 - G) % t._colorSet.length] : C[G].color ? C[G].color : t._colorSet[G % t._colorSet.length], G === fa ? P.push({ x1: a[G], y1: E[G], x2: y[G], y2: E[G], x3: ea, y3: Da, x4: y[G + 1], y4: E[G + 1], x5: a[G + 1], y5: E[G + 1], x6: K, y6: Da, id: G, height: E[G + 1] - E[G], color: X }) : P.push({ x1: a[G], y1: E[G], x2: y[G], y2: E[G], x3: y[G + 1], y3: E[G + 1], x4: a[G + 1], y4: E[G + 1], id: G, height: E[G + 1] - E[G], color: X });
	            }var ga = 2,
	                J = [],
	                ja = !1,
	                W = [],
	                ia = [],
	                I = !1;a = a = 0;Fa(W);for (G = 0; G < C.length; G++) {
	              C[G].exploded && (I = !0, t.reversed ? W.push(C.length - 1 - G) : W.push(G));
	            }Q.clearRect(x.x1, x.y1, x.width, x.height);Q.fillStyle = z.backgroundColor;Q.fillRect(x.x1, x.y1, x.width, x.height);if (H && t.visible && (c(), g(), e(), "inside" !== t.indexLabelPlacement)) {
	              k();for (G = 0; G < C.length; G++) {
	                J[G].isDirty || (a = J[G].textBlock.x + J[G].width, a = (L - a) / 2, 0 == G && (A = a), A > a && (A = a));
	              }for (G = 0; G < P.length; G++) {
	                P[G].x1 += A, P[G].x2 += A, P[G].x3 += A, P[G].x4 += A, P[G].x5 && (P[G].x5 += A, P[G].x6 += A), J[G].textBlock.x += A;
	              }
	            }for (G = 0; G < P.length; G++) {
	              A = P[G], ra(Q, A, t.fillOpacity), ia.push(A.y1);
	            }v(Q);H && t.visible && ("inside" === t.indexLabelPlacement || z.animationEnabled || s(Q), z.animationEnabled || p());if (!H) for (G = 0; G < C.length; G++) {
	              A = t.dataPointIds[G], a = { id: A, objectType: "dataPoint", dataPointIndex: G, dataSeriesIndex: 0, funnelSection: P[t.reversed ? C.length - 1 - G : G] }, z._eventManager.objectMap[A] = a;
	            }!z.animationEnabled && I ? h(z, -1, 0) : z.animationEnabled && !z.animatedRender && h(z, -1, 0);this.funnelPyramidClickHandler = function (a) {
	              var b = -1;if (!ja && !z.isAnimating && (u(a.dataSeries.explodeOnClick) || a.dataSeries.explodeOnClick) && (b = t.reversed ? C.length - 1 - a.dataPointIndex : a.dataPointIndex, 0 <= b)) {
	                a = b;if ("funnel" === t.type || "pyramid" === t.type) t.reversed ? C[C.length - 1 - a].exploded = C[C.length - 1 - a].exploded ? !1 : !0 : C[a].exploded = C[a].exploded ? !1 : !0;h(z, b, 500);
	              }
	            };return { source: Q, dest: this.plotArea.ctx, animationCallback: function animationCallback(a, b) {
	                M.fadeInAnimation(a, b);1 <= a && (h(z, -1, 500), v(z.plotArea.ctx || z.ctx));
	              }, easingFunction: M.easing.easeInQuad, animationBase: 0 };
	          }
	        }
	      }
	    };p.prototype.requestAnimFrame = function () {
	      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (a) {
	        window.setTimeout(a, 1E3 / 60);
	      };
	    }();p.prototype.cancelRequestAnimFrame = window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout;p.prototype.set = function (a, d, b) {
	      b = "undefined" === typeof b ? !0 : b;"options" === a ? (this.options = d, b && this.render()) : p.base.set.call(this, a, d, b);
	    };p.prototype.exportChart = function (a) {
	      a = "undefined" === typeof a ? {} : a;var d = a.format ? a.format : "png",
	          b = a.fileName ? a.fileName : this.exportFileName;if (a.toDataURL) return this.canvas.toDataURL("image/" + d);Ta(this.canvas, d, b);
	    };p.prototype.print = function () {
	      var a = this.exportChart({ toDataURL: !0 }),
	          d = document.createElement("iframe");d.setAttribute("class", "canvasjs-chart-print-frame");d.setAttribute("style", "position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;");
	      d.style.height = this.height + "px";this._canvasJSContainer.appendChild(d);var b = this,
	          c = d.contentWindow || d.contentDocument.document || d.contentDocument;c.document.open();c.document.write('<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="' + a + '"/><body/></html>');c.document.close();setTimeout(function () {
	        c.focus();c.print();setTimeout(function () {
	          b._canvasJSContainer.removeChild(d);
	        }, 1E3);
	      }, 500);
	    };p.prototype.getPercentAndTotal = function (a, d) {
	      var b = null,
	          c = null,
	          e = null;if (0 <= a.type.indexOf("stacked")) c = 0, b = d.x.getTime ? d.x.getTime() : d.x, b in a.plotUnit.yTotals && (c = a.plotUnit.yTotals[b], e = isNaN(d.y) ? 0 : 100 * (d.y / c));else if ("pie" === a.type || "doughnut" === a.type || "funnel" === a.type || "pyramid" === a.type) {
	        for (b = c = 0; b < a.dataPoints.length; b++) {
	          isNaN(a.dataPoints[b].y) || (c += a.dataPoints[b].y);
	        }e = isNaN(d.y) ? 0 : 100 * (d.y / c);
	      }return { percent: e, total: c };
	    };p.prototype.replaceKeywordsWithValue = function (a, d, b, c, e) {
	      var g = this;e = "undefined" === typeof e ? 0 : e;if ((0 <= b.type.indexOf("stacked") || "pie" === b.type || "doughnut" === b.type || "funnel" === b.type || "pyramid" === b.type) && (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"))) {
	        var k = "#percent",
	            l = "#total",
	            h = this.getPercentAndTotal(b, d),
	            l = isNaN(h.total) ? l : h.total,
	            k = isNaN(h.percent) ? k : h.percent;do {
	          h = "";if (b.percentFormatString) h = b.percentFormatString;else {
	            var h = "#,##0.",
	                m = Math.max(Math.ceil(Math.log(1 / Math.abs(k)) / Math.LN10), 2);if (isNaN(m) || !isFinite(m)) m = 2;for (var s = 0; s < m; s++) {
	              h += "#";
	            }b.percentFormatString = h;
	          }a = a.replace("#percent", ba(k, h, g._cultureInfo));
	          a = a.replace("#total", ba(l, b.yValueFormatString ? b.yValueFormatString : "#,##0.########", g._cultureInfo));
	        } while (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"));
	      }return a.replace(/\{.*?\}|"[^"]*"|'[^']*'/g, function (a) {
	        if ('"' === a[0] && '"' === a[a.length - 1] || "'" === a[0] && "'" === a[a.length - 1]) return a.slice(1, a.length - 1);a = Ia(a.slice(1, a.length - 1));a = a.replace("#index", e);var k = null;try {
	          var f = a.match(/(.*?)\s*\[\s*(.*?)\s*\]/);f && 0 < f.length && (k = Ia(f[2]), a = Ia(f[1]));
	        } catch (l) {}f = null;if ("color" === a) return "waterfall" === b.type ? d.color ? d.color : 0 < d.y ? b.risingColor : b.fallingColor : "error" === b.type ? b.color ? b.color : b._colorSet[k % b._colorSet.length] : d.color ? d.color : b.color ? b.color : b._colorSet[c % b._colorSet.length];if (d.hasOwnProperty(a)) f = d;else if (b.hasOwnProperty(a)) f = b;else return "";f = f[a];null !== k && (f = f[k]);if ("x" === a) {
	          if ("dateTime" === b.axisX.valueType || "dateTime" === b.xValueType || d.x && d.x.getTime) {
	            if (g.plotInfo.plotTypes[0].plotUnits[0].axisX && !g.plotInfo.plotTypes[0].plotUnits[0].axisX.logarithmic) return Ca(f, d.xValueFormatString ? d.xValueFormatString : b.xValueFormatString ? b.xValueFormatString : b.xValueFormatString = g.axisX && g.axisX.autoValueFormatString ? g.axisX.autoValueFormatString : "DD MMM YY", g._cultureInfo);
	          } else return ba(f, d.xValueFormatString ? d.xValueFormatString : b.xValueFormatString ? b.xValueFormatString : b.xValueFormatString = "#,##0.########", g._cultureInfo);
	        } else return "y" === a ? ba(f, d.yValueFormatString ? d.yValueFormatString : b.yValueFormatString ? b.yValueFormatString : b.yValueFormatString = "#,##0.########", g._cultureInfo) : "z" === a ? ba(f, d.zValueFormatString ? d.zValueFormatString : b.zValueFormatString ? b.zValueFormatString : b.zValueFormatString = "#,##0.########", g._cultureInfo) : f;
	      });
	    };qa(H, V);H.prototype.setLayout = function () {
	      var a = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
	          d = a.layoutManager.getFreeSpace(),
	          b = null,
	          c = 0,
	          e = 0,
	          g = 0,
	          k = 0,
	          l = this.markerMargin = this.chart.options.legend && !u(this.chart.options.legend.markerMargin) ? this.chart.options.legend.markerMargin : 0.3 * this.fontSize;this.height = 0;var h = [],
	          m = [];"top" === this.verticalAlign || "bottom" === this.verticalAlign ? (this.orientation = "horizontal", b = this.verticalAlign, g = this.maxWidth = null !== this.maxWidth ? this.maxWidth : d.width, k = this.maxHeight = null !== this.maxHeight ? this.maxHeight : 0.5 * d.height) : "center" === this.verticalAlign && (this.orientation = "vertical", b = this.horizontalAlign, g = this.maxWidth = null !== this.maxWidth ? this.maxWidth : 0.5 * d.width, k = this.maxHeight = null !== this.maxHeight ? this.maxHeight : d.height);this.errorMarkerColor = [];for (var s = 0; s < this.dataSeries.length; s++) {
	        var q = this.dataSeries[s];
	        if (q.dataPoints && q.dataPoints.length) if ("pie" !== q.type && "doughnut" !== q.type && "funnel" !== q.type && "pyramid" !== q.type) {
	          var n = q.legendMarkerType = q.legendMarkerType ? q.legendMarkerType : "line" !== q.type && "stepLine" !== q.type && "spline" !== q.type && "scatter" !== q.type && "bubble" !== q.type || !q.markerType ? "error" === q.type && q._linkedSeries ? q._linkedSeries.legendMarkerType ? q._linkedSeries.legendMarkerType : F.getDefaultLegendMarker(q._linkedSeries.type) : F.getDefaultLegendMarker(q.type) : q.markerType,
	              f = q.legendText ? q.legendText : this.itemTextFormatter ? this.itemTextFormatter({ chart: this.chart, legend: this.options, dataSeries: q, dataPoint: null }) : q.name,
	              p = q.legendMarkerColor = q.legendMarkerColor ? q.legendMarkerColor : q.markerColor ? q.markerColor : "error" === q.type ? u(q.whiskerColor) ? q._colorSet[0] : q.whiskerColor : q._colorSet[0],
	              r = q.markerSize || "line" !== q.type && "stepLine" !== q.type && "spline" !== q.type ? 0.75 * this.lineHeight : 0,
	              v = q.legendMarkerBorderColor ? q.legendMarkerBorderColor : q.markerBorderColor,
	              t = q.legendMarkerBorderThickness ? q.legendMarkerBorderThickness : q.markerBorderThickness ? Math.max(1, Math.round(0.2 * r)) : 0;"error" === q.type && this.errorMarkerColor.push(p);f = this.chart.replaceKeywordsWithValue(f, q.dataPoints[0], q, s);n = { markerType: n, markerColor: p, text: f, textBlock: null, chartType: q.type, markerSize: r, lineColor: q._colorSet[0], dataSeriesIndex: q.index, dataPointIndex: null, markerBorderColor: v, markerBorderThickness: t };h.push(n);
	        } else for (var z = 0; z < q.dataPoints.length; z++) {
	          var x = q.dataPoints[z],
	              n = x.legendMarkerType ? x.legendMarkerType : q.legendMarkerType ? q.legendMarkerType : F.getDefaultLegendMarker(q.type),
	              f = x.legendText ? x.legendText : q.legendText ? q.legendText : this.itemTextFormatter ? this.itemTextFormatter({ chart: this.chart, legend: this.options, dataSeries: q, dataPoint: x }) : x.name ? x.name : "DataPoint: " + (z + 1),
	              p = x.legendMarkerColor ? x.legendMarkerColor : q.legendMarkerColor ? q.legendMarkerColor : x.color ? x.color : q.color ? q.color : q._colorSet[z % q._colorSet.length],
	              r = 0.75 * this.lineHeight,
	              v = x.legendMarkerBorderColor ? x.legendMarkerBorderColor : q.legendMarkerBorderColor ? q.legendMarkerBorderColor : x.markerBorderColor ? x.markerBorderColor : q.markerBorderColor,
	              t = x.legendMarkerBorderThickness ? x.legendMarkerBorderThickness : q.legendMarkerBorderThickness ? q.legendMarkerBorderThickness : x.markerBorderThickness || q.markerBorderThickness ? Math.max(1, Math.round(0.2 * r)) : 0,
	              f = this.chart.replaceKeywordsWithValue(f, x, q, z),
	              n = { markerType: n, markerColor: p, text: f, textBlock: null, chartType: q.type, markerSize: r, dataSeriesIndex: s, dataPointIndex: z, markerBorderColor: v, markerBorderThickness: t };(x.showInLegend || q.showInLegend && !1 !== x.showInLegend) && h.push(n);
	        }
	      }!0 === this.reversed && h.reverse();if (0 < h.length) {
	        q = null;p = f = x = z = 0;x = null !== this.itemWidth ? null !== this.itemMaxWidth ? Math.min(this.itemWidth, this.itemMaxWidth, g) : this.itemMaxWidth = Math.min(this.itemWidth, g) : null !== this.itemMaxWidth ? Math.min(this.itemMaxWidth, g) : this.itemMaxWidth = g;r = 0 === r ? 0.75 * this.lineHeight : r;x -= r + l;for (s = 0; s < h.length; s++) {
	          n = h[s];v = x;if ("line" === n.chartType || "spline" === n.chartType || "stepLine" === n.chartType) v -= 2 * 0.1 * this.lineHeight;if (!(0 >= k || "undefined" === typeof k || 0 >= v || "undefined" === typeof v)) {
	            if ("horizontal" === this.orientation) {
	              n.textBlock = new ka(this.ctx, { x: 0, y: 0, maxWidth: v, maxHeight: this.itemWrap ? k : this.lineHeight, angle: 0, text: n.text, horizontalAlign: "left", fontSize: this.fontSize, fontFamily: this.fontFamily, fontWeight: this.fontWeight, fontColor: this.fontColor, fontStyle: this.fontStyle, textBaseline: "middle" });n.textBlock.measureText();null !== this.itemWidth && (n.textBlock.width = this.itemWidth - (r + l + ("line" === n.chartType || "spline" === n.chartType || "stepLine" === n.chartType ? 2 * 0.1 * this.lineHeight : 0)));if (!q || q.width + Math.round(n.textBlock.width + r + l + (0 === q.width ? 0 : this.horizontalSpacing) + ("line" === n.chartType || "spline" === n.chartType || "stepLine" === n.chartType ? 2 * 0.1 * this.lineHeight : 0)) > g) q = { items: [], width: 0 }, m.push(q), this.height += f, f = 0;f = Math.max(f, n.textBlock.height);
	            } else n.textBlock = new ka(this.ctx, { x: 0, y: 0, maxWidth: x, maxHeight: !0 === this.itemWrap ? k : 1.5 * this.fontSize, angle: 0, text: n.text, horizontalAlign: "left", fontSize: this.fontSize, fontFamily: this.fontFamily,
	              fontWeight: this.fontWeight, fontColor: this.fontColor, fontStyle: this.fontStyle, textBaseline: "middle" }), n.textBlock.measureText(), null !== this.itemWidth && (n.textBlock.width = this.itemWidth - (r + l + ("line" === n.chartType || "spline" === n.chartType || "stepLine" === n.chartType ? 2 * 0.1 * this.lineHeight : 0))), this.height < k - this.lineHeight ? (q = { items: [], width: 0 }, m.push(q)) : (q = m[z], z = (z + 1) % m.length), this.height += n.textBlock.height;n.textBlock.x = q.width;n.textBlock.y = 0;q.width += Math.round(n.textBlock.width + r + l + (0 === q.width ? 0 : this.horizontalSpacing) + ("line" === n.chartType || "spline" === n.chartType || "stepLine" === n.chartType ? 2 * 0.1 * this.lineHeight : 0));q.items.push(n);this.width = Math.max(q.width, this.width);p = n.textBlock.width + (r + l + ("line" === n.chartType || "spline" === n.chartType || "stepLine" === n.chartType ? 2 * 0.1 * this.lineHeight : 0));
	          }
	        }this.itemWidth = p;this.height = !1 === this.itemWrap ? m.length * this.lineHeight : this.height + f;this.height = Math.min(k, this.height);this.width = Math.min(g, this.width);
	      }"top" === this.verticalAlign ? (e = "left" === this.horizontalAlign ? d.x1 : "right" === this.horizontalAlign ? d.x2 - this.width : d.x1 + d.width / 2 - this.width / 2, c = d.y1) : "center" === this.verticalAlign ? (e = "left" === this.horizontalAlign ? d.x1 : "right" === this.horizontalAlign ? d.x2 - this.width : d.x1 + d.width / 2 - this.width / 2, c = d.y1 + d.height / 2 - this.height / 2) : "bottom" === this.verticalAlign && (e = "left" === this.horizontalAlign ? d.x1 : "right" === this.horizontalAlign ? d.x2 - this.width : d.x1 + d.width / 2 - this.width / 2, c = d.y2 - this.height);this.items = h;for (s = 0; s < this.items.length; s++) {
	        n = h[s], n.id = ++this.chart._eventManager.lastObjectId, this.chart._eventManager.objectMap[n.id] = { id: n.id, objectType: "legendItem", legendItemIndex: s, dataSeriesIndex: n.dataSeriesIndex, dataPointIndex: n.dataPointIndex };
	      }this.markerSize = r;this.rows = m;0 < h.length && a.layoutManager.registerSpace(b, { width: this.width + 2 + 2, height: this.height + 5 + 5 });this.bounds = { x1: e, y1: c, x2: e + this.width, y2: c + this.height };
	    };H.prototype.render = function () {
	      var a = this.bounds.x1,
	          d = this.bounds.y1,
	          b = this.markerMargin,
	          c = this.maxWidth,
	          e = this.maxHeight,
	          g = this.markerSize,
	          k = this.rows;(0 < this.borderThickness && this.borderColor || this.backgroundColor) && this.ctx.roundRect(a, d, this.width, this.height, this.cornerRadius, this.borderThickness, this.backgroundColor, this.borderColor);for (var l = 0, h = 0; h < k.length; h++) {
	        for (var m = k[h], s = 0, q = 0; q < m.items.length; q++) {
	          var n = m.items[q],
	              f = n.textBlock.x + a + (0 === q ? 0.2 * g : this.horizontalSpacing),
	              p = d + l,
	              u = f;this.chart.data[n.dataSeriesIndex].visible || (this.ctx.globalAlpha = 0.5);this.ctx.save();this.ctx.beginPath();this.ctx.rect(a, d, c, Math.max(e - e % this.lineHeight, 0));this.ctx.clip();
	          if ("line" === n.chartType || "stepLine" === n.chartType || "spline" === n.chartType) this.ctx.strokeStyle = n.lineColor, this.ctx.lineWidth = Math.ceil(this.lineHeight / 8), this.ctx.beginPath(), this.ctx.moveTo(f - 0.1 * this.lineHeight, p + this.lineHeight / 2), this.ctx.lineTo(f + 0.85 * this.lineHeight, p + this.lineHeight / 2), this.ctx.stroke(), u -= 0.1 * this.lineHeight;if ("error" === n.chartType) {
	            this.ctx.strokeStyle = this.errorMarkerColor[0];this.ctx.lineWidth = g / 8;this.ctx.beginPath();var r = f - 0.08 * this.lineHeight + 0.1 * this.lineHeight,
	                t = p + 0.15 * this.lineHeight,
	                v = 0.7 * this.lineHeight,
	                x = v + 0.02 * this.lineHeight;this.ctx.moveTo(r, t);this.ctx.lineTo(r + v, t);this.ctx.stroke();this.ctx.beginPath();this.ctx.moveTo(r + v / 2, t);this.ctx.lineTo(r + v / 2, t + x);this.ctx.stroke();this.ctx.beginPath();this.ctx.moveTo(r, t + x);this.ctx.lineTo(r + v, t + x);this.ctx.stroke();this.errorMarkerColor.shift();
	          }ia.drawMarker(f + g / 2, p + this.lineHeight / 2, this.ctx, n.markerType, "error" === n.chartType || "line" === n.chartType || "spline" === n.chartType ? n.markerSize / 2 : n.markerSize, n.markerColor, n.markerBorderColor, n.markerBorderThickness);n.textBlock.x = f + b + g;if ("line" === n.chartType || "stepLine" === n.chartType || "spline" === n.chartType) n.textBlock.x += 0.1 * this.lineHeight;n.textBlock.y = Math.round(p + this.lineHeight / 2);n.textBlock.render(!0);this.ctx.restore();s = 0 < q ? Math.max(s, n.textBlock.height) : n.textBlock.height;this.chart.data[n.dataSeriesIndex].visible || (this.ctx.globalAlpha = 1);f = N(n.id);this.ghostCtx.fillStyle = f;this.ghostCtx.beginPath();this.ghostCtx.fillRect(u, n.textBlock.y - this.lineHeight / 2, n.textBlock.x + n.textBlock.width - u, n.textBlock.height);n.x1 = this.chart._eventManager.objectMap[n.id].x1 = u;n.y1 = this.chart._eventManager.objectMap[n.id].y1 = n.textBlock.y - this.lineHeight / 2;n.x2 = this.chart._eventManager.objectMap[n.id].x2 = n.textBlock.x + n.textBlock.width;n.y2 = this.chart._eventManager.objectMap[n.id].y2 = n.textBlock.y + n.textBlock.height - this.lineHeight / 2;
	        }l += s;
	      }
	    };qa(F, V);F.prototype.getDefaultAxisPlacement = function () {
	      var a = this.type;if ("column" === a || "line" === a || "stepLine" === a || "spline" === a || "area" === a || "stepArea" === a || "splineArea" === a || "stackedColumn" === a || "stackedLine" === a || "bubble" === a || "scatter" === a || "stackedArea" === a || "stackedColumn100" === a || "stackedLine100" === a || "stackedArea100" === a || "candlestick" === a || "ohlc" === a || "rangeColumn" === a || "rangeArea" === a || "rangeSplineArea" === a || "boxAndWhisker" === a || "waterfall" === a) return "normal";if ("bar" === a || "stackedBar" === a || "stackedBar100" === a || "rangeBar" === a) return "xySwapped";if ("pie" === a || "doughnut" === a || "funnel" === a || "pyramid" === a) return "none";
	      "error" !== a && window.console.log("Unknown Chart Type: " + a);return null;
	    };F.getDefaultLegendMarker = function (a) {
	      if ("column" === a || "stackedColumn" === a || "stackedLine" === a || "bar" === a || "stackedBar" === a || "stackedBar100" === a || "bubble" === a || "scatter" === a || "stackedColumn100" === a || "stackedLine100" === a || "stepArea" === a || "candlestick" === a || "ohlc" === a || "rangeColumn" === a || "rangeBar" === a || "rangeArea" === a || "rangeSplineArea" === a || "boxAndWhisker" === a || "waterfall" === a) return "square";if ("line" === a || "stepLine" === a || "spline" === a || "pie" === a || "doughnut" === a) return "circle";if ("area" === a || "splineArea" === a || "stackedArea" === a || "stackedArea100" === a || "funnel" === a || "pyramid" === a) return "triangle";if ("error" === a) return "none";window.console.log("Unknown Chart Type: " + a);return null;
	    };F.prototype.getDataPointAtX = function (a, d) {
	      if (!this.dataPoints || 0 === this.dataPoints.length) return null;var b = { dataPoint: null, distance: Infinity, index: NaN },
	          c = null,
	          e = 0,
	          g = 0,
	          k = 1,
	          l = Infinity,
	          h = 0,
	          m = 0,
	          s = 0;"none" !== this.chart.plotInfo.axisPlacement && (this.axisX.logarithmic ? (s = Math.log(this.dataPoints[this.dataPoints.length - 1].x / this.dataPoints[0].x), s = 1 < s ? Math.min(Math.max((this.dataPoints.length - 1) / s * Math.log(a / this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0) : (s = this.dataPoints[this.dataPoints.length - 1].x - this.dataPoints[0].x, s = 0 < s ? Math.min(Math.max((this.dataPoints.length - 1) / s * (a - this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0));for (;;) {
	        g = 0 < k ? s + e : s - e;if (0 <= g && g < this.dataPoints.length) {
	          var c = this.dataPoints[g],
	              q = this.axisX.logarithmic ? c.x > a ? c.x / a : a / c.x : Math.abs(c.x - a);q < b.distance && (b.dataPoint = c, b.distance = q, b.index = g);c = q;c <= l ? l = c : 0 < k ? h++ : m++;if (1E3 < h && 1E3 < m) break;
	        } else if (0 > s - e && s + e >= this.dataPoints.length) break;-1 === k ? (e++, k = 1) : k = -1;
	      }return d || b.dataPoint.x !== a ? d && null !== b.dataPoint ? b : null : b;
	    };F.prototype.getDataPointAtXY = function (a, d, b) {
	      if (!this.dataPoints || 0 === this.dataPoints.length || a < this.chart.plotArea.x1 || a > this.chart.plotArea.x2 || d < this.chart.plotArea.y1 || d > this.chart.plotArea.y2) return null;b = b || !1;var c = [],
	          e = 0,
	          g = 0,
	          k = 1,
	          l = !1,
	          h = Infinity,
	          m = 0,
	          s = 0,
	          q = 0;if ("none" !== this.chart.plotInfo.axisPlacement) if (q = (this.chart.axisX[0] ? this.chart.axisX[0] : this.chart.axisX2[0]).getXValueAt({ x: a, y: d }), this.axisX.logarithmic) var n = Math.log(this.dataPoints[this.dataPoints.length - 1].x / this.dataPoints[0].x),
	          q = 1 < n ? Math.min(Math.max((this.dataPoints.length - 1) / n * Math.log(q / this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0;else n = this.dataPoints[this.dataPoints.length - 1].x - this.dataPoints[0].x, q = 0 < n ? Math.min(Math.max((this.dataPoints.length - 1) / n * (q - this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0;for (;;) {
	        g = 0 < k ? q + e : q - e;if (0 <= g && g < this.dataPoints.length) {
	          var n = this.chart._eventManager.objectMap[this.dataPointIds[g]],
	              f = this.dataPoints[g],
	              p = null;if (n) {
	            switch (this.type) {case "column":case "stackedColumn":case "stackedColumn100":case "bar":case "stackedBar":case "stackedBar100":case "rangeColumn":case "rangeBar":case "waterfall":case "error":
	                a >= n.x1 && a <= n.x2 && d >= n.y1 && d <= n.y2 && (c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: Math.min(Math.abs(n.x1 - a), Math.abs(n.x2 - a), Math.abs(n.y1 - d), Math.abs(n.y2 - d)) }), l = !0);break;case "line":case "stepLine":case "spline":case "area":case "stepArea":case "stackedArea":case "stackedArea100":case "splineArea":case "scatter":
	                var u = na("markerSize", f, this) || 4,
	                    r = b ? 20 : u,
	                    p = Math.sqrt(Math.pow(n.x1 - a, 2) + Math.pow(n.y1 - d, 2));p <= r && c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: p });n = Math.abs(n.x1 - a);n <= h ? h = n : 0 < k ? m++ : s++;p <= u / 2 && (l = !0);break;case "rangeArea":case "rangeSplineArea":
	                u = na("markerSize", f, this) || 4;r = b ? 20 : u;p = Math.min(Math.sqrt(Math.pow(n.x1 - a, 2) + Math.pow(n.y1 - d, 2)), Math.sqrt(Math.pow(n.x1 - a, 2) + Math.pow(n.y2 - d, 2)));p <= r && c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: p });n = Math.abs(n.x1 - a);n <= h ? h = n : 0 < k ? m++ : s++;p <= u / 2 && (l = !0);break;case "bubble":
	                u = n.size;p = Math.sqrt(Math.pow(n.x1 - a, 2) + Math.pow(n.y1 - d, 2));p <= u / 2 && (c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: p }), l = !0);break;case "pie":case "doughnut":
	                u = n.center;r = "doughnut" === this.type ? n.percentInnerRadius * n.radius : 0;p = Math.sqrt(Math.pow(u.x - a, 2) + Math.pow(u.y - d, 2));p < n.radius && p > r && (p = Math.atan2(d - u.y, a - u.x), 0 > p && (p += 2 * Math.PI), p = Number(((180 * (p / Math.PI) % 360 + 360) % 360).toFixed(12)), u = Number(((180 * (n.startAngle / Math.PI) % 360 + 360) % 360).toFixed(12)), r = Number(((180 * (n.endAngle / Math.PI) % 360 + 360) % 360).toFixed(12)), 0 === r && 1 < n.endAngle && (r = 360), u >= r && 0 !== f.y && (r += 360, p < u && (p += 360)), p > u && p < r && (c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: 0 }), l = !0));break;case "funnel":case "pyramid":
	                p = n.funnelSection;
	                d > p.y1 && d < p.y4 && (p.y6 ? d > p.y6 ? (g = p.x6 + (p.x5 - p.x6) / (p.y5 - p.y6) * (d - p.y6), p = p.x3 + (p.x4 - p.x3) / (p.y4 - p.y3) * (d - p.y3)) : (g = p.x1 + (p.x6 - p.x1) / (p.y6 - p.y1) * (d - p.y1), p = p.x2 + (p.x3 - p.x2) / (p.y3 - p.y2) * (d - p.y2)) : (g = p.x1 + (p.x4 - p.x1) / (p.y4 - p.y1) * (d - p.y1), p = p.x2 + (p.x3 - p.x2) / (p.y3 - p.y2) * (d - p.y2)), a > g && a < p && (c.push({ dataPoint: f, dataPointIndex: n.dataPointIndex, dataSeries: this, distance: 0 }), l = !0));break;case "boxAndWhisker":
	                if (a >= n.x1 - n.borderThickness / 2 && a <= n.x2 + n.borderThickness / 2 && d >= n.y4 - n.borderThickness / 2 && d <= n.y1 + n.borderThickness / 2 || Math.abs(n.x2 - a + n.x1 - a) < n.borderThickness && d >= n.y1 && d <= n.y4) c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: Math.min(Math.abs(n.x1 - a), Math.abs(n.x2 - a), Math.abs(n.y2 - d), Math.abs(n.y3 - d)) }), l = !0;break;case "candlestick":
	                if (a >= n.x1 - n.borderThickness / 2 && a <= n.x2 + n.borderThickness / 2 && d >= n.y2 - n.borderThickness / 2 && d <= n.y3 + n.borderThickness / 2 || Math.abs(n.x2 - a + n.x1 - a) < n.borderThickness && d >= n.y1 && d <= n.y4) c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: Math.min(Math.abs(n.x1 - a), Math.abs(n.x2 - a), Math.abs(n.y2 - d), Math.abs(n.y3 - d)) }), l = !0;break;case "ohlc":
	                if (Math.abs(n.x2 - a + n.x1 - a) < n.borderThickness && d >= n.y2 && d <= n.y3 || a >= n.x1 && a <= (n.x2 + n.x1) / 2 && d >= n.y1 - n.borderThickness / 2 && d <= n.y1 + n.borderThickness / 2 || a >= (n.x1 + n.x2) / 2 && a <= n.x2 && d >= n.y4 - n.borderThickness / 2 && d <= n.y4 + n.borderThickness / 2) c.push({ dataPoint: f, dataPointIndex: g, dataSeries: this, distance: Math.min(Math.abs(n.x1 - a), Math.abs(n.x2 - a), Math.abs(n.y2 - d), Math.abs(n.y3 - d)) }), l = !0;}if (l || 1E3 < m && 1E3 < s) break;
	          }
	        } else if (0 > q - e && q + e >= this.dataPoints.length) break;-1 === k ? (e++, k = 1) : k = -1;
	      }a = null;for (d = 0; d < c.length; d++) {
	        a ? c[d].distance <= a.distance && (a = c[d]) : a = c[d];
	      }return a;
	    };F.prototype.getMarkerProperties = function (a, d, b, c) {
	      var e = this.dataPoints;return { x: d, y: b, ctx: c, type: e[a].markerType ? e[a].markerType : this.markerType, size: e[a].markerSize ? e[a].markerSize : this.markerSize, color: e[a].markerColor ? e[a].markerColor : this.markerColor ? this.markerColor : e[a].color ? e[a].color : this.color ? this.color : this._colorSet[a % this._colorSet.length], borderColor: e[a].markerBorderColor ? e[a].markerBorderColor : this.markerBorderColor ? this.markerBorderColor : null, borderThickness: e[a].markerBorderThickness ? e[a].markerBorderThickness : this.markerBorderThickness ? this.markerBorderThickness : null };
	    };qa(z, V);z.prototype.createExtraLabelsForLog = function (a) {
	      a = (a || 0) + 1;if (!(5 < a)) {
	        var d = this.logLabelValues[0] || this.intervalStartPosition;if (Math.log(this.range) / Math.log(d / this.viewportMinimum) < this.noTicks - 1) {
	          for (var b = z.getNiceNumber((d - this.viewportMinimum) / Math.min(Math.max(2, this.noTicks - this.logLabelValues.length), 3), !0), c = Math.ceil(this.viewportMinimum / b) * b; c < d; c += b) {
	            c < this.viewportMinimum || this.logLabelValues.push(c);
	          }this.logLabelValues.sort(Sa);this.createExtraLabelsForLog(a);
	        }
	      }
	    };z.prototype.createLabels = function () {
	      var a,
	          d,
	          b = 0,
	          c = 0,
	          e,
	          g = 0,
	          k = 0,
	          c = 0,
	          c = this.interval,
	          l = 0,
	          h,
	          m = 0.6 * this.chart.height,
	          p;a = !1;var q = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
	          n = q.length ? u(this.scaleBreaks.firstBreakIndex) ? 0 : this.scaleBreaks.firstBreakIndex : 0;if ("axisX" !== this.type || "dateTime" !== this.valueType || this.logarithmic) {
	        e = this.viewportMaximum;if (this.labels) {
	          a = Math.ceil(c);for (var c = Math.ceil(this.intervalStartPosition), f = !1, b = c; b < this.viewportMaximum; b += a) {
	            if (this.labels[b]) f = !0;else {
	              f = !1;break;
	            }
	          }f && (this.interval = a, this.intervalStartPosition = c);
	        }if (this.logarithmic && !this.equidistantInterval) for (this.logLabelValues || (this.logLabelValues = [], this.createExtraLabelsForLog()), c = 0, f = n; c < this.logLabelValues.length; c++) {
	          if (b = this.logLabelValues[c], b < this.viewportMinimum) c++;else {
	            for (; f < q.length && b > q[f].endValue; f++) {}a = f < q.length && b >= q[f].startValue && b <= q[f].endValue;p = b;a || (a = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.options, value: p, label: this.labels[p] ? this.labels[p] : null }) : "axisX" === this.type && this.labels[p] ? this.labels[p] : ba(p, this.valueFormatString, this.chart._cultureInfo), a = new ka(this.ctx, _defineProperty({ x: 0, y: 0, maxWidth: g, maxHeight: k, angle: this.labelAngle, text: this.prefix + a + this.suffix, backgroundColor: this.labelBackgroundColor, borderColor: this.labelBorderColor, borderThickness: this.labelBorderThickness, cornerRadius: this.labelCornerRadius,
	              horizontalAlign: "left", fontSize: this.labelFontSize, fontFamily: this.labelFontFamily, fontWeight: this.labelFontWeight, fontColor: this.labelFontColor, fontStyle: this.labelFontStyle, textBaseline: "middle" }, "borderThickness", 0)), this._labels.push({ position: p, textBlock: a, effectiveHeight: null }));
	          }
	        }f = n;for (b = this.intervalStartPosition; b <= e; b = parseFloat(1E-12 > this.interval ? this.logarithmic && this.equidistantInterval ? b * Math.pow(this.logarithmBase, this.interval) : b + this.interval : (this.logarithmic && this.equidistantInterval ? b * Math.pow(this.logarithmBase, this.interval) : b + this.interval).toFixed(12))) {
	          for (; f < q.length && b > q[f].endValue; f++) {}a = f < q.length && b >= q[f].startValue && b <= q[f].endValue;p = b;a || (a = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.options, value: p, label: this.labels[p] ? this.labels[p] : null }) : "axisX" === this.type && this.labels[p] ? this.labels[p] : ba(p, this.valueFormatString, this.chart._cultureInfo), a = new ka(this.ctx, { x: 0, y: 0, maxWidth: g, maxHeight: k, angle: this.labelAngle, text: this.prefix + a + this.suffix,
	            horizontalAlign: "left", backgroundColor: this.labelBackgroundColor, borderColor: this.labelBorderColor, borderThickness: this.labelBorderThickness, cornerRadius: this.labelCornerRadius, fontSize: this.labelFontSize, fontFamily: this.labelFontFamily, fontWeight: this.labelFontWeight, fontColor: this.labelFontColor, fontStyle: this.labelFontStyle, textBaseline: "middle" }), this._labels.push({ position: p, textBlock: a, effectiveHeight: null }));
	        }
	      } else for (this.intervalStartPosition = this.getLabelStartPoint(new Date(this.viewportMinimum), this.intervalType, this.interval), e = Ya(new Date(this.viewportMaximum), this.interval, this.intervalType), f = n, b = this.intervalStartPosition; b < e; Ya(b, c, this.intervalType)) {
	        for (a = b.getTime(); f < q.length && a > q[f].endValue; f++) {}p = a;a = f < q.length && a >= q[f].startValue && a <= q[f].endValue;a || (a = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.options, value: new Date(p), label: this.labels[p] ? this.labels[p] : null }) : "axisX" === this.type && this.labels[p] ? this.labels[p] : Ca(p, this.valueFormatString, this.chart._cultureInfo), a = new ka(this.ctx, { x: 0, y: 0, maxWidth: g, backgroundColor: this.labelBackgroundColor, borderColor: this.labelBorderColor, borderThickness: this.labelBorderThickness, cornerRadius: this.labelCornerRadius, maxHeight: k, angle: this.labelAngle, text: this.prefix + a + this.suffix, horizontalAlign: "left", fontSize: this.labelFontSize, fontFamily: this.labelFontFamily, fontWeight: this.labelFontWeight, fontColor: this.labelFontColor, fontStyle: this.labelFontStyle, textBaseline: "middle" }), this._labels.push({ position: p, textBlock: a, effectiveHeight: null,
	          breaksLabelType: void 0 }));
	      }if ("bottom" === this._position || "top" === this._position) l = this.logarithmic && !this.equidistantInterval && 2 <= this._labels.length ? this.lineCoordinates.width * Math.log(Math.min(this._labels[this._labels.length - 1].position / this._labels[this._labels.length - 2].position, this._labels[1].position / this._labels[0].position)) / Math.log(this.range) : this.lineCoordinates.width / (this.logarithmic && this.equidistantInterval ? Math.log(this.range) / Math.log(this.logarithmBase) : Math.abs(this.range)) * S[this.intervalType + "Duration"] * this.interval, g = "undefined" === typeof this.options.labelMaxWidth ? 0.5 * this.chart.width >> 0 : this.options.labelMaxWidth, this.chart.panEnabled || (k = "undefined" === typeof this.options.labelWrap || this.labelWrap ? 0.8 * this.chart.height >> 0 : 1.5 * this.labelFontSize);else if ("left" === this._position || "right" === this._position) l = this.logarithmic && !this.equidistantInterval && 2 <= this._labels.length ? this.lineCoordinates.height * Math.log(Math.min(this._labels[this._labels.length - 1].position / this._labels[this._labels.length - 2].position, this._labels[1].position / this._labels[0].position)) / Math.log(this.range) : this.lineCoordinates.height / (this.logarithmic && this.equidistantInterval ? Math.log(this.range) / Math.log(this.logarithmBase) : Math.abs(this.range)) * S[this.intervalType + "Duration"] * this.interval, this.chart.panEnabled || (g = "undefined" === typeof this.options.labelMaxWidth ? 0.3 * this.chart.width >> 0 : this.options.labelMaxWidth), k = "undefined" === typeof this.options.labelWrap || this.labelWrap ? 0.3 * this.chart.height >> 0 : 1.5 * this.labelFontSize;
	      for (c = 0; c < this._labels.length; c++) {
	        a = this._labels[c].textBlock;a.maxWidth = g;a.maxHeight = k;var B = a.measureText();h = B.height;
	      }e = [];n = q = 0;if (this.labelAutoFit || this.options.labelAutoFit) if (u(this.labelAngle) || (this.labelAngle = (this.labelAngle % 360 + 360) % 360, 90 < this.labelAngle && 270 > this.labelAngle ? this.labelAngle -= 180 : 270 <= this.labelAngle && 360 >= this.labelAngle && (this.labelAngle -= 360)), "bottom" === this._position || "top" === this._position) {
	        if (g = 0.9 * l >> 0, n = 0, !this.chart.panEnabled && 1 <= this._labels.length) {
	          this.sessionVariables.labelFontSize = this.labelFontSize;this.sessionVariables.labelMaxWidth = g;this.sessionVariables.labelMaxHeight = k;this.sessionVariables.labelAngle = this.labelAngle;this.sessionVariables.labelWrap = this.labelWrap;for (b = 0; b < this._labels.length; b++) {
	            if (!this._labels[b].breaksLabelType) {
	              a = this._labels[b].textBlock;for (var v, f = a.text.split(" "), c = 0; c < f.length; c++) {
	                p = f[c], this.ctx.font = a.fontStyle + " " + a.fontWeight + " " + a.fontSize + "px " + a.fontFamily, p = this.ctx.measureText(p), p.width > n && (v = b, n = p.width);
	              }
	            }
	          }b = 0;for (b = this.intervalStartPosition < this.viewportMinimum ? 1 : 0; b < this._labels.length; b++) {
	            if (!this._labels[b].breaksLabelType) {
	              a = this._labels[b].textBlock;B = a.measureText();for (f = b + 1; f < this._labels.length; f++) {
	                if (!this._labels[f].breaksLabelType) {
	                  d = this._labels[f].textBlock;d = d.measureText();break;
	                }
	              }e.push(a.height);this.sessionVariables.labelMaxHeight = Math.max.apply(Math, e);Math.cos(Math.PI / 180 * Math.abs(this.labelAngle));Math.sin(Math.PI / 180 * Math.abs(this.labelAngle));c = g * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (k - a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle));if (u(this.options.labelAngle) && isNaN(this.options.labelAngle) && 0 !== this.options.labelAngle) {
	                if (this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? k : Math.min((c - g * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), c), p = (m - (h + a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(-25))) / Math.sin(Math.PI / 180 * Math.abs(-25)), !u(this.options.labelWrap)) this.labelWrap ? u(this.options.labelMaxWidth) ? (this.sessionVariables.labelMaxWidth = Math.min(Math.max(g, n), p), this.sessionVariables.labelWrap = this.labelWrap, B.width + d.width >> 0 > 2 * g && (this.sessionVariables.labelAngle = -25)) : (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelAngle = this.sessionVariables.labelMaxWidth > g ? -25 : this.sessionVariables.labelAngle) : u(this.options.labelMaxWidth) ? (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelMaxWidth = g, B.width + d.width >> 0 > 2 * g && (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = p)) : (this.sessionVariables.labelAngle = this.sessionVariables.labelMaxWidth > g ? -25 : this.sessionVariables.labelAngle, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelWrap = this.labelWrap);else {
	                  if (u(this.options.labelWrap)) if (!u(this.options.labelMaxWidth)) this.options.labelMaxWidth < g ? (this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelMaxHeight = c) : (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelMaxHeight = k);else if (!u(d)) if (c = B.width + d.width >> 0, f = this.labelFontSize, n < g) c - 2 * g > q && (q = c - 2 * g, c >= 2 * g && c < 2.2 * g ? (this.sessionVariables.labelMaxWidth = g, u(this.options.labelFontSize) && 12 < f && (f = Math.floor(12 / 13 * f), a.measureText()), this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? f : this.options.labelFontSize, this.sessionVariables.labelAngle = this.labelAngle) : c >= 2.2 * g && c < 2.8 * g ? (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = p, this.sessionVariables.labelFontSize = f) : c >= 2.8 * g && c < 3.2 * g ? (this.sessionVariables.labelMaxWidth = Math.max(g, n), this.sessionVariables.labelWrap = !0, u(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? f : this.options.labelFontSize, this.sessionVariables.labelAngle = this.labelAngle) : c >= 3.2 * g && c < 3.6 * g ? (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelMaxWidth = p, this.sessionVariables.labelFontSize = this.labelFontSize) : c > 3.6 * g && c < 5 * g ? (u(this.options.labelFontSize) && 12 < f && (f = Math.floor(12 / 13 * f), a.measureText()), this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? f : this.options.labelFontSize, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = p) : c > 5 * g && (this.sessionVariables.labelWrap = !0, this.sessionVariables.labelMaxWidth = g, this.sessionVariables.labelFontSize = f, this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelAngle = this.labelAngle));else if (v === b && (0 === v && n + this._labels[v + 1].textBlock.measureText().width - 2 * g > q || v === this._labels.length - 1 && n + this._labels[v - 1].textBlock.measureText().width - 2 * g > q || 0 < v && v < this._labels.length - 1 && n + this._labels[v + 1].textBlock.measureText().width - 2 * g > q && n + this._labels[v - 1].textBlock.measureText().width - 2 * g > q)) q = 0 === v ? n + this._labels[v + 1].textBlock.measureText().width - 2 * g : n + this._labels[v - 1].textBlock.measureText().width - 2 * g, this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? f : this.options.labelFontSize, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = p;else if (0 === q) for (this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? f : this.options.labelFontSize, this.sessionVariables.labelWrap = !0, c = 0; c < this._labels.length; c++) {
	                    a = this._labels[c].textBlock, a.maxWidth = this.sessionVariables.labelMaxWidth = Math.min(Math.max(g, n), p), B = a.measureText(), c < this._labels.length - 1 && (f = c + 1, d = this._labels[f].textBlock, d.maxWidth = this.sessionVariables.labelMaxWidth = Math.min(Math.max(g, n), p), d = d.measureText(), B.width + d.width >> 0 > 2 * g && (this.sessionVariables.labelAngle = -25));
	                  }
	                }
	              } else (this.sessionVariables.labelAngle = this.labelAngle, this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? k : Math.min((c - g * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), c), p = 0 != this.labelAngle ? (m - (h + a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) : g, this.sessionVariables.labelMaxHeight = k = this.labelWrap ? (m - p * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)) : 1.5 * this.labelFontSize, u(this.options.labelWrap)) ? u(this.options.labelWrap) && (this.labelWrap && !u(this.options.labelMaxWidth) ? (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : p, this.sessionVariables.labelMaxHeight = k) : (this.sessionVariables.labelAngle = this.labelAngle, this.sessionVariables.labelMaxWidth = p, this.sessionVariables.labelMaxHeight = c < 0.9 * l ? 0.9 * l : c, this.sessionVariables.labelWrap = this.labelWrap)) : (this.options.labelWrap ? (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : p) : (u(this.options.labelMaxWidth), this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : p, this.sessionVariables.labelWrap = this.labelWrap), this.sessionVariables.labelMaxHeight = k);
	            }
	          }for (c = 0; c < this._labels.length; c++) {
	            a = this._labels[c].textBlock, a.maxWidth = this.labelMaxWidth = this.sessionVariables.labelMaxWidth, a.fontSize = this.sessionVariables.labelFontSize, a.angle = this.labelAngle = this.sessionVariables.labelAngle, a.wrap = this.labelWrap = this.sessionVariables.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText();
	          }
	        } else for (b = 0; b < this._labels.length; b++) {
	          a = this._labels[b].textBlock, a.maxWidth = this.labelMaxWidth = u(this.options.labelMaxWidth) ? this.sessionVariables.labelMaxWidth : this.options.labelMaxWidth, a.fontSize = this.labelFontSize = u(this.options.labelFontSize) ? this.sessionVariables.labelFontSize : this.options.labelFontSize, a.angle = this.labelAngle = u(this.options.labelAngle) ? this.sessionVariables.labelAngle : this.labelAngle, a.wrap = this.labelWrap = u(this.options.labelWrap) ? this.sessionVariables.labelWrap : this.options.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText();
	        }
	      } else if ("left" === this._position || "right" === this._position) if (g = u(this.options.labelMaxWidth) ? 0.3 * this.chart.width >> 0 : this.options.labelMaxWidth, k = "undefined" === typeof this.options.labelWrap || this.labelWrap ? 0.3 * this.chart.height >> 0 : 1.5 * this.labelFontSize, !this.chart.panEnabled && 1 <= this._labels.length) {
	        this.sessionVariables.labelFontSize = this.labelFontSize;this.sessionVariables.labelMaxWidth = g;this.sessionVariables.labelMaxHeight = k;this.sessionVariables.labelAngle = u(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle;this.sessionVariables.labelWrap = this.labelWrap;for (b = 0; b < this._labels.length; b++) {
	          if (!this._labels[b].breaksLabelType) {
	            a = this._labels[b].textBlock;B = a.measureText();for (f = b + 1; f < this._labels.length; f++) {
	              if (!this._labels[f].breaksLabelType) {
	                d = this._labels[f].textBlock;d = d.measureText();break;
	              }
	            }e.push(a.height);this.sessionVariables.labelMaxHeight = Math.max.apply(Math, e);c = g * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (k - a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle));Math.cos(Math.PI / 180 * Math.abs(this.labelAngle));Math.sin(Math.PI / 180 * Math.abs(this.labelAngle));u(this.options.labelAngle) && isNaN(this.options.labelAngle) && 0 !== this.options.labelAngle ? u(this.options.labelWrap) ? u(this.options.labelWrap) && (u(this.options.labelMaxWidth) ? u(d) || (l = B.height + d.height >> 0, l - 2 * k > n && (n = l - 2 * k, l >= 2 * k && l < 2.4 * k ? (u(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize) : l >= 2.4 * k && l < 2.8 * k ? (this.sessionVariables.labelMaxHeight = c, this.sessionVariables.labelFontSize = this.labelFontSize, this.sessionVariables.labelWrap = !0) : l >= 2.8 * k && l < 3.2 * k ? (this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelWrap = !0, u(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize, this.sessionVariables.labelAngle = u(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle) : l >= 3.2 * k && l < 3.6 * k ? (this.sessionVariables.labelMaxHeight = c, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelFontSize = this.labelFontSize) : l > 3.6 * k && l < 10 * k ? (u(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize, this.sessionVariables.labelMaxWidth = g, this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelAngle = u(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle) : l > 10 * k && l < 50 * k && (u(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = u(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize, this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelMaxWidth = g, this.sessionVariables.labelAngle = u(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle))) : (this.sessionVariables.labelMaxHeight = k, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth)) : (this.sessionVariables.labelMaxWidth = this.labelWrap ? this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth : this.labelMaxWidth ? this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth : g, this.sessionVariables.labelMaxHeight = k) : (this.sessionVariables.labelAngle = this.labelAngle, this.sessionVariables.labelMaxWidth = 0 === this.labelAngle ? g : Math.min((c - k * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), k), u(this.options.labelWrap)) ? u(this.options.labelWrap) && (this.labelWrap && !u(this.options.labelMaxWidth) ? (this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth > this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth, this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxHeight = c) : (this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : g, this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? k : c, u(this.options.labelMaxWidth) && (this.sessionVariables.labelAngle = this.labelAngle))) : this.options.labelWrap ? (this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? k : c, this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = g) : (this.sessionVariables.labelMaxHeight = k, u(this.options.labelMaxWidth), this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth, this.sessionVariables.labelWrap = this.labelWrap);
	          }
	        }for (c = 0; c < this._labels.length; c++) {
	          a = this._labels[c].textBlock, a.maxWidth = this.labelMaxWidth = this.sessionVariables.labelMaxWidth, a.fontSize = this.labelFontSize = this.sessionVariables.labelFontSize, a.angle = this.labelAngle = this.sessionVariables.labelAngle, a.wrap = this.labelWrap = this.sessionVariables.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText();
	        }
	      } else for (b = 0; b < this._labels.length; b++) {
	        a = this._labels[b].textBlock, a.maxWidth = this.labelMaxWidth = u(this.options.labelMaxWidth) ? this.sessionVariables.labelMaxWidth : this.options.labelMaxWidth, a.fontSize = this.labelFontSize = u(this.options.labelFontSize) ? this.sessionVariables.labelFontSize : this.options.labelFontSize, a.angle = this.labelAngle = u(this.options.labelAngle) ? this.sessionVariables.labelAngle : this.labelAngle, a.wrap = this.labelWrap = u(this.options.labelWrap) ? this.sessionVariables.labelWrap : this.options.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText();
	      }for (b = 0; b < this.stripLines.length; b++) {
	        var g = this.stripLines[b],
	            z;if ("outside" === g.labelPlacement) {
	          k = this.sessionVariables.labelMaxWidth;
	          if ("bottom" === this._position || "top" === this._position) z = u(g.options.labelWrap) ? this.sessionVariables.labelMaxHeight : g.labelWrap ? 0.8 * this.chart.height >> 0 : 1.5 * this.labelFontSize;if ("left" === this._position || "right" === this._position) z = u(g.options.labelWrap) ? this.sessionVariables.labelMaxHeight : g.labelWrap ? 0.8 * this.chart.width >> 0 : 1.5 * this.labelFontSize;u(g.labelBackgroundColor) && (g.labelBackgroundColor = "#EEEEEE");
	        } else k = "bottom" === this._position || "top" === this._position ? 0.9 * this.chart.width >> 0 : 0.9 * this.chart.height >> 0, z = u(g.options.labelWrap) || g.labelWrap ? "bottom" === this._position || "top" === this._position ? 0.8 * this.chart.width >> 0 : 0.8 * this.chart.height >> 0 : 1.5 * this.labelFontSize, u(g.labelBackgroundColor) && (u(g.startValue) && 0 !== g.startValue ? g.labelBackgroundColor = r ? "transparent" : null : g.labelBackgroundColor = "#EEEEEE");a = new ka(this.ctx, { x: 0, y: 0, backgroundColor: g.labelBackgroundColor, borderColor: g.labelBorderColor, borderThickness: g.labelBorderThickness, cornerRadius: g.labelCornerRadius, maxWidth: g.options.labelMaxWidth ? g.options.labelMaxWidth : k, maxHeight: z, angle: this.labelAngle, text: g.labelFormatter ? g.labelFormatter({ chart: this.chart, axis: this, stripLine: g }) : g.label, horizontalAlign: "left", fontSize: "outside" === g.labelPlacement ? g.options.labelFontSize ? g.labelFontSize : this.labelFontSize : g.labelFontSize, fontFamily: "outside" === g.labelPlacement ? g.options.labelFontFamily ? g.labelFontFamily : this.labelFontFamily : g.labelFontFamily, fontWeight: "outside" === g.labelPlacement ? g.options.labelFontWeight ? g.labelFontWeight : this.labelFontWeight : g.labelFontWeight, fontColor: g.labelFontColor || g.color, fontStyle: "outside" === g.labelPlacement ? g.options.labelFontStyle ? g.labelFontStyle : this.fontWeight : g.labelFontStyle, textBaseline: "middle" });this._stripLineLabels.push({ position: g.value, textBlock: a, effectiveHeight: null, stripLine: g });
	      }
	    };z.prototype.createLabelsAndCalculateWidth = function () {
	      var a = 0,
	          d = 0;this._labels = [];this._stripLineLabels = [];var b = this.chart.isNavigator ? 0 : 5;if ("left" === this._position || "right" === this._position) {
	        this.createLabels();for (d = 0; d < this._labels.length; d++) {
	          var c = this._labels[d].textBlock,
	              e = c.measureText(),
	              g = 0,
	              g = 0 === this.labelAngle ? e.width : e.width * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)) + (e.height - c.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle));a < g && (a = g);this._labels[d].effectiveWidth = g;
	        }for (d = 0; d < this._stripLineLabels.length; d++) {
	          "outside" === this._stripLineLabels[d].stripLine.labelPlacement && this._stripLineLabels[d].stripLine.value >= this.viewportMinimum && this._stripLineLabels[d].stripLine.value <= this.viewportMaximum && (c = this._stripLineLabels[d].textBlock, e = c.measureText(), g = 0 === this.labelAngle ? e.width : e.width * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)) + (e.height - c.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), a < g && (a = g), this._stripLineLabels[d].effectiveWidth = g);
	        }
	      }d = this.title ? this._titleTextBlock.measureText().height + 2 : 0;return c = "inside" === this.labelPlacement ? c = d + b : d + a + this.tickLength + b;
	    };z.prototype.createLabelsAndCalculateHeight = function () {
	      var a = 0;this._labels = [];this._stripLineLabels = [];var d,
	          b = 0,
	          c = this.chart.isNavigator ? 0 : 5;this.createLabels();if ("bottom" === this._position || "top" === this._position) {
	        for (b = 0; b < this._labels.length; b++) {
	          d = this._labels[b].textBlock;var e = d.measureText(),
	              g = 0,
	              g = 0 === this.labelAngle ? e.height : e.width * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (e.height - d.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle));a < g && (a = g);this._labels[b].effectiveHeight = g;
	        }for (b = 0; b < this._stripLineLabels.length; b++) {
	          "outside" === this._stripLineLabels[b].stripLine.labelPlacement && this._stripLineLabels[b].stripLine.value >= this.viewportMinimum && this._stripLineLabels[b].stripLine.value <= this.viewportMaximum && (d = this._stripLineLabels[b].textBlock, e = d.measureText(), g = 0 === this.labelAngle ? e.height : e.width * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (e.height - d.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), a < g && (a = g), this._stripLineLabels[b].effectiveHeight = g);
	        }
	      }d = this.title ? this._titleTextBlock.measureText().height + 2 : 0;return b = "inside" === this.labelPlacement ? b = d + c : d + a + this.tickLength + c;
	    };z.setLayout = function (a, d, b, c, e, g) {
	      var k,
	          l,
	          h,
	          m,
	          p = a[0] ? a[0].chart : d[0].chart,
	          q = p.isNavigator ? 0 : 10,
	          n = p._axes;if (a && 0 < a.length) for (var f = 0; f < a.length; f++) {
	        a[f] && a[f].calculateAxisParameters();
	      }if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	        d[f].calculateAxisParameters();
	      }if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	        b[f].calculateAxisParameters();
	      }if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	        c[f].calculateAxisParameters();
	      }for (f = 0; f < n.length; f++) {
	        if (n[f] && n[f].scaleBreaks && n[f].scaleBreaks._appliedBreaks.length) for (var r = n[f].scaleBreaks._appliedBreaks, v = 0; v < r.length && !(r[v].startValue > n[f].viewportMaximum); v++) {
	          r[v].endValue < n[f].viewportMinimum || (u(n[f].scaleBreaks.firstBreakIndex) && (n[f].scaleBreaks.firstBreakIndex = v), r[v].startValue >= n[f].viewPortMinimum && (n[f].scaleBreaks.lastBreakIndex = v));
	        }
	      }for (var z = v = 0, t = 0, C = 0, x = 0, D = 0, y = 0, A, E, F = l = 0, H, I, L, r = H = I = L = !1, f = 0; f < n.length; f++) {
	        n[f] && n[f].title && (n[f]._titleTextBlock = new ka(n[f].ctx, { text: n[f].title, horizontalAlign: "center", fontSize: n[f].titleFontSize, fontFamily: n[f].titleFontFamily,
	          fontWeight: n[f].titleFontWeight, fontColor: n[f].titleFontColor, fontStyle: n[f].titleFontStyle, borderColor: n[f].titleBorderColor, borderThickness: n[f].titleBorderThickness, backgroundColor: n[f].titleBackgroundColor, cornerRadius: n[f].titleCornerRadius, textBaseline: "top" }));
	      }for (f = 0; f < n.length; f++) {
	        if (n[f].title) switch (n[f]._position) {case "left":
	            n[f]._titleTextBlock.maxWidth = n[f].titleMaxWidth || g.height;n[f]._titleTextBlock.maxHeight = n[f].titleWrap ? 0.8 * g.width : 1.5 * n[f].titleFontSize;n[f]._titleTextBlock.angle = -90;break;case "right":
	            n[f]._titleTextBlock.maxWidth = n[f].titleMaxWidth || g.height;n[f]._titleTextBlock.maxHeight = n[f].titleWrap ? 0.8 * g.width : 1.5 * n[f].titleFontSize;n[f]._titleTextBlock.angle = 90;break;default:
	            n[f]._titleTextBlock.maxWidth = n[f].titleMaxWidth || g.width, n[f]._titleTextBlock.maxHeight = n[f].titleWrap ? 0.8 * g.height : 1.5 * n[f].titleFontSize, n[f]._titleTextBlock.angle = 0;}
	      }if ("normal" === e) {
	        for (var C = [], x = [], D = [], y = [], M = [], N = [], O = [], Q = []; 4 > v;) {
	          var G = 0,
	              R = 0,
	              S = 0,
	              U = 0,
	              W = e = 0,
	              K = 0,
	              $ = 0,
	              V = 0,
	              X = 0,
	              P = 0,
	              ba = 0;if (b && 0 < b.length) for (D = [], f = P = 0; f < b.length; f++) {
	            D.push(Math.ceil(b[f] ? b[f].createLabelsAndCalculateWidth() : 0)), P += D[f], K += b[f] && !p.isNavigator ? b[f].margin : 0;
	          } else D.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateWidth() : 0));O.push(D);if (c && 0 < c.length) for (y = [], f = ba = 0; f < c.length; f++) {
	            y.push(Math.ceil(c[f] ? c[f].createLabelsAndCalculateWidth() : 0)), ba += y[f], $ += c[f] ? c[f].margin : 0;
	          } else y.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateWidth() : 0));Q.push(y);k = Math.round(g.x1 + P + K);h = Math.round(g.x2 - ba - $ > p.width - q ? p.width - q : g.x2 - ba - $);if (a && 0 < a.length) for (C = [], f = V = 0; f < a.length; f++) {
	            a[f] && (a[f].lineCoordinates = {}), a[f].lineCoordinates.width = Math.abs(h - k), a[f].title && (a[f]._titleTextBlock.maxWidth = 0 < a[f].titleMaxWidth && a[f].titleMaxWidth < a[f].lineCoordinates.width ? a[f].titleMaxWidth : a[f].lineCoordinates.width), C.push(Math.ceil(a[f] ? a[f].createLabelsAndCalculateHeight() : 0)), V += C[f], e += a[f] && !p.isNavigator ? a[f].margin : 0;
	          } else C.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateHeight() : 0));M.push(C);if (d && 0 < d.length) for (x = [], f = X = 0; f < d.length; f++) {
	            d[f] && (d[f].lineCoordinates = {}), d[f].lineCoordinates.width = Math.abs(h - k), d[f].title && (d[f]._titleTextBlock.maxWidth = 0 < d[f].titleMaxWidth && d[f].titleMaxWidth < d[f].lineCoordinates.width ? d[f].titleMaxWidth : d[f].lineCoordinates.width), x.push(Math.ceil(d[f] ? d[f].createLabelsAndCalculateHeight() : 0)), X += x[f], W += d[f] && !p.isNavigator ? d[f].margin : 0;
	          } else x.push(Math.ceil(d[0] ? d[0].createLabelsAndCalculateHeight() : 0));N.push(x);if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	            a[f] && (a[f].lineCoordinates.x1 = k, h = Math.round(g.x2 - ba - $ > p.width - q ? p.width - q : g.x2 - ba - $), a[f]._labels && 1 < a[f]._labels.length && (l = m = 0, m = a[f]._labels[1], l = "dateTime" === a[f].valueType ? a[f]._labels[a[f]._labels.length - 2] : a[f]._labels[a[f]._labels.length - 1], z = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), t = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) + (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle))), !a[f] || !a[f].labelAutoFit || u(A) || u(E) || p.isNavigator || (l = 0, 0 < a[f].labelAngle ? E + t > h && (l += 0 < a[f].labelAngle ? E + t - h - ba : 0) : 0 > a[f].labelAngle ? A - z < k && A - z < a[f].viewportMinimum && (F = k - (K + a[f].tickLength + D + A - z + a[f].labelFontSize / 2)) : 0 === a[f].labelAngle && (E + t > h && (l = E + t / 2 - h - ba), A - z < k && A - z < a[f].viewportMinimum && (F = k - K - a[f].tickLength - D - A + z / 2)), a[f].viewportMaximum === a[f].maximum && a[f].viewportMinimum === a[f].minimum && 0 < a[f].labelAngle && 0 < l ? h -= l : a[f].viewportMaximum === a[f].maximum && a[f].viewportMinimum === a[f].minimum && 0 > a[f].labelAngle && 0 < F ? k += F : a[f].viewportMaximum === a[f].maximum && a[f].viewportMinimum === a[f].minimum && 0 === a[f].labelAngle && (0 < F && (k += F), 0 < l && (h -= l))), p.panEnabled ? V = p.sessionVariables.axisX.height : p.sessionVariables.axisX.height = V, l = Math.round(g.y2 - V - e + G), m = Math.round(g.y2), a[f].lineCoordinates.x2 = h, a[f].lineCoordinates.width = h - k, a[f].lineCoordinates.y1 = l, a[f].lineCoordinates.y2 = l, a[f].bounds = { x1: k, y1: l, x2: h, y2: m - (V + e - C[f] - G), width: h - k, height: m - l }), G += C[f] + a[f].margin;
	          }if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	            d[f].lineCoordinates.x1 = Math.round(g.x1 + P + K), d[f].lineCoordinates.x2 = Math.round(g.x2 - ba - $ > p.width - q ? p.width - q : g.x2 - ba - $), d[f].lineCoordinates.width = Math.abs(h - k), d[f]._labels && 1 < d[f]._labels.length && (m = d[f]._labels[1], l = "dateTime" === d[f].valueType ? d[f]._labels[d[f]._labels.length - 2] : d[f]._labels[d[f]._labels.length - 1], z = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), t = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) + (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle))), p.panEnabled ? X = p.sessionVariables.axisX2.height : p.sessionVariables.axisX2.height = X, l = Math.round(g.y1), m = Math.round(g.y2 + d[f].margin), d[f].lineCoordinates.y1 = l + X + W - R, d[f].lineCoordinates.y2 = l, d[f].bounds = { x1: k, y1: l + (X + W - x[f] - R), x2: h, y2: m, width: h - k, height: m - l }, R += x[f] + d[f].margin;
	          }if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	            K = p.isNavigator ? 0 : 10, b[f] && (k = Math.round(a[0] ? a[0].lineCoordinates.x1 : d[0].lineCoordinates.x1), K = b[f]._labels && 0 < b[f]._labels.length ? b[f]._labels[b[f]._labels.length - 1].textBlock.height / 2 : q, l = Math.round(g.y1 + X + W < Math.max(K, q) ? Math.max(K, q) : g.y1 + X + W), h = Math.round(a[0] ? a[0].lineCoordinates.x1 : d[0].lineCoordinates.x1), K = 0 < a.length ? 0 : b[f]._labels && 0 < b[f]._labels.length ? b[f]._labels[0].textBlock.height / 2 : q, m = Math.round(g.y2 - V - e - K), b[f].lineCoordinates = { x1: h - S, y1: l, x2: h - S, y2: m, height: Math.abs(m - l) }, b[f].bounds = { x1: k - (D[f] + S), y1: l, x2: h, y2: m, width: h - k, height: m - l }, b[f].title && (b[f]._titleTextBlock.maxWidth = 0 < b[f].titleMaxWidth && b[f].titleMaxWidth < b[f].lineCoordinates.height ? b[f].titleMaxWidth : b[f].lineCoordinates.height), S += D[f] + b[f].margin);
	          }if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	            c[f] && (k = Math.round(a[0] ? a[0].lineCoordinates.x2 : d[0].lineCoordinates.x2), h = Math.round(k), K = c[f]._labels && 0 < c[f]._labels.length ? c[f]._labels[c[f]._labels.length - 1].textBlock.height / 2 : 0, l = Math.round(g.y1 + X + W < Math.max(K, q) ? Math.max(K, q) : g.y1 + X + W), K = 0 < a.length ? 0 : c[f]._labels && 0 < c[f]._labels.length ? c[f]._labels[0].textBlock.height / 2 : 0, m = Math.round(g.y2 - (V + e + K)), c[f].lineCoordinates = { x1: k + U, y1: l, x2: k + U, y2: m, height: Math.abs(m - l) }, c[f].bounds = { x1: k, y1: l, x2: h + (y[f] + U), y2: m, width: h - k, height: m - l }, c[f].title && (c[f]._titleTextBlock.maxWidth = 0 < c[f].titleMaxWidth && c[f].titleMaxWidth < c[f].lineCoordinates.height ? c[f].titleMaxWidth : c[f].lineCoordinates.height), U += y[f] + c[f].margin);
	          }if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	            a[f] && (a[f].calculateValueToPixelConversionParameters(), a[f].calculateBreaksSizeInValues(), a[f]._labels && 1 < a[f]._labels.length && (A = (a[f].logarithmic ? Math.log(a[f]._labels[1].position / a[f].viewportMinimum) / a[f].conversionParameters.lnLogarithmBase : a[f]._labels[1].position - a[f].viewportMinimum) * Math.abs(a[f].conversionParameters.pixelPerUnit) + a[f].lineCoordinates.x1, k = a[f]._labels[a[f]._labels.length - ("dateTime" === a[f].valueType ? 2 : 1)].position, k = a[f].getApparentDifference(a[f].viewportMinimum, k), E = a[f].logarithmic ? (1 < k ? Math.log(k) / a[f].conversionParameters.lnLogarithmBase * Math.abs(a[f].conversionParameters.pixelPerUnit) : 0) + a[f].lineCoordinates.x1 : (0 < k ? k * Math.abs(a[f].conversionParameters.pixelPerUnit) : 0) + a[f].lineCoordinates.x1));
	          }if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	            d[f].calculateValueToPixelConversionParameters(), d[f].calculateBreaksSizeInValues(), d[f]._labels && 1 < d[f]._labels.length && (A = (d[f].logarithmic ? Math.log(d[f]._labels[1].position / d[f].viewportMinimum) / d[f].conversionParameters.lnLogarithmBase : d[f]._labels[1].position - d[f].viewportMinimum) * Math.abs(d[f].conversionParameters.pixelPerUnit) + d[f].lineCoordinates.x1, k = d[f]._labels[d[f]._labels.length - ("dateTime" === d[f].valueType ? 2 : 1)].position, k = d[f].getApparentDifference(d[f].viewportMinimum, k), E = d[f].logarithmic ? (1 < k ? Math.log(k) / d[f].conversionParameters.lnLogarithmBase * Math.abs(d[f].conversionParameters.pixelPerUnit) : 0) + d[f].lineCoordinates.x1 : (0 < k ? k * Math.abs(d[f].conversionParameters.pixelPerUnit) : 0) + d[f].lineCoordinates.x1);
	          }for (f = 0; f < n.length; f++) {
	            "axisY" === n[f].type && (n[f].calculateValueToPixelConversionParameters(), n[f].calculateBreaksSizeInValues());
	          }if (0 < v) {
	            if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	              r = M[v - 1][f] === M[v][f] ? !0 : !1;
	            } else r = !0;if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	              H = N[v - 1][f] === N[v][f] ? !0 : !1;
	            } else H = !0;if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	              I = O[v - 1][f] === O[v][f] ? !0 : !1;
	            } else I = !0;if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	              L = Q[v - 1][f] === Q[v][f] ? !0 : !1;
	            } else L = !0;
	          }if (r && H && I && L) break;v++;
	        }if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	          a[f].calculateStripLinesThicknessInValues(), a[f].calculateBreaksInPixels();
	        }if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	          d[f].calculateStripLinesThicknessInValues(), d[f].calculateBreaksInPixels();
	        }if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	          b[f].calculateStripLinesThicknessInValues(), b[f].calculateBreaksInPixels();
	        }if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	          c[f].calculateStripLinesThicknessInValues(), c[f].calculateBreaksInPixels();
	        }
	      } else {
	        q = [];A = [];F = [];z = [];E = [];t = [];M = [];for (N = []; 4 > v;) {
	          V = U = R = S = $ = K = W = e = Q = O = G = X = 0;if (a && 0 < a.length) for (F = [], f = U = 0; f < a.length; f++) {
	            F.push(Math.ceil(a[f] ? a[f].createLabelsAndCalculateWidth() : 0)), U += F[f], e += a[f] && !p.isNavigator ? a[f].margin : 0;
	          } else F.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateWidth() : 0));M.push(F);if (d && 0 < d.length) for (z = [], f = V = 0; f < d.length; f++) {
	            z.push(Math.ceil(d[f] ? d[f].createLabelsAndCalculateWidth() : 0)), V += z[f], W += d[f] ? d[f].margin : 0;
	          } else z.push(Math.ceil(d[0] ? d[0].createLabelsAndCalculateWidth() : 0));N.push(z);if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	            b[f].lineCoordinates = {}, k = Math.round(g.x1 + U + e), h = Math.round(g.x2 - V - W > p.width - 10 ? p.width - 10 : g.x2 - V - W), b[f].labelAutoFit && !u(C) && (0 < !a.length && (k = 0 > b[f].labelAngle ? Math.max(k, C) : 0 === b[f].labelAngle ? Math.max(k, C / 2) : k), 0 < !d.length && (h = 0 < b[f].labelAngle ? h - x / 2 : 0 === b[f].labelAngle ? h - x / 2 : h)), b[f].lineCoordinates.x1 = k, b[f].lineCoordinates.x2 = h, b[f].lineCoordinates.width = Math.abs(h - k), b[f].title && (b[f]._titleTextBlock.maxWidth = 0 < b[f].titleMaxWidth && b[f].titleMaxWidth < b[f].lineCoordinates.width ? b[f].titleMaxWidth : b[f].lineCoordinates.width);
	          }if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	            c[f].lineCoordinates = {}, k = Math.round(g.x1 + U + e), h = Math.round(g.x2 - V - W > c[f].chart.width - 10 ? c[f].chart.width - 10 : g.x2 - V - W), c[f] && c[f].labelAutoFit && !u(D) && (0 < !a.length && (k = 0 < c[f].labelAngle ? Math.max(k, D) : 0 === c[f].labelAngle ? Math.max(k, D / 2) : k), 0 < !d.length && (h -= y / 2)), c[f].lineCoordinates.x1 = k, c[f].lineCoordinates.x2 = h, c[f].lineCoordinates.width = Math.abs(h - k), c[f].title && (c[f]._titleTextBlock.maxWidth = 0 < c[f].titleMaxWidth && c[f].titleMaxWidth < c[f].lineCoordinates.width ? c[f].titleMaxWidth : c[f].lineCoordinates.width);
	          }if (b && 0 < b.length) for (q = [], f = S = 0; f < b.length; f++) {
	            q.push(Math.ceil(b[f] ? b[f].createLabelsAndCalculateHeight() : 0)), S += q[f] + b[f].margin, K += b[f].margin;
	          } else q.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateHeight() : 0));E.push(q);if (c && 0 < c.length) for (A = [], f = R = 0; f < c.length; f++) {
	            A.push(Math.ceil(c[f] ? c[f].createLabelsAndCalculateHeight() : 0)), R += A[f], $ += c[f].margin;
	          } else A.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateHeight() : 0));t.push(A);if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	            0 < b[f]._labels.length && (m = b[f]._labels[0], l = b[f]._labels[b[f]._labels.length - 1], C = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), x = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) + (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle)));
	          }if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	            c[f] && 0 < c[f]._labels.length && (m = c[f]._labels[0], l = c[f]._labels[c[f]._labels.length - 1], D = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), y = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) + (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle)));
	          }if (p.panEnabled) for (f = 0; f < b.length; f++) {
	            q[f] = p.sessionVariables.axisY.height;
	          } else for (f = 0; f < b.length; f++) {
	            p.sessionVariables.axisY.height = q[f];
	          }if (b && 0 < b.length) for (f = b.length - 1; 0 <= f; f--) {
	            l = Math.round(g.y2), m = Math.round(g.y2 > b[f].chart.height - 10 ? b[f].chart.height - 10 : g.y2), b[f].lineCoordinates.y1 = l - (q[f] + b[f].margin + X), b[f].lineCoordinates.y2 = l - (q[f] + b[f].margin + X), b[f].bounds = { x1: k, y1: l - (q[f] + X + b[f].margin), x2: h, y2: m - (X + b[f].margin), width: h - k, height: q[f] }, b[f].title && (b[f]._titleTextBlock.maxWidth = 0 < b[f].titleMaxWidth && b[f].titleMaxWidth < b[f].lineCoordinates.width ? b[f].titleMaxWidth : b[f].lineCoordinates.width), X += q[f] + b[f].margin;
	          }if (c && 0 < c.length) for (f = c.length - 1; 0 <= f; f--) {
	            c[f] && (l = Math.round(g.y1), m = Math.round(g.y1 + (A[f] + c[f].margin + G)), c[f].lineCoordinates.y1 = m, c[f].lineCoordinates.y2 = m, c[f].bounds = { x1: k, y1: l + (c[f].margin + G), x2: h, y2: m, width: h - k, height: R }, c[f].title && (c[f]._titleTextBlock.maxWidth = 0 < c[f].titleMaxWidth && c[f].titleMaxWidth < c[f].lineCoordinates.width ? c[f].titleMaxWidth : c[f].lineCoordinates.width), G += A[f] + c[f].margin);
	          }if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	            K = a[f]._labels && 0 < a[f]._labels.length ? a[f]._labels[0].textBlock.fontSize / 2 : 0;k = Math.round(g.x1 + e);l = c && 0 < c.length ? Math.round(c[0] ? c[0].lineCoordinates.y2 : g.y1 < Math.max(K, 10) ? Math.max(K, 10) : g.y1) : g.y1 < Math.max(K, 10) ? Math.max(K, 10) : g.y1;
	            h = Math.round(g.x1 + U + e);m = b && 0 < b.length ? Math.round(b[0] ? b[0].lineCoordinates.y1 : g.y2 - S > p.height - Math.max(K, 10) ? p.height - Math.max(K, 10) : g.y2 - S) : g.y2 > p.height - Math.max(K, 10) ? p.height - Math.max(K, 10) : g.y2;if (b && 0 < b.length) for (K = 0; K < b.length; K++) {
	              b[K] && b[K].labelAutoFit && (h = 0 > b[K].labelAngle ? Math.max(h, C) : 0 === b[K].labelAngle ? Math.max(h, C / 2) : h, k = 0 > b[K].labelAngle || 0 === b[K].labelAngle ? h - U : k);
	            }if (c && 0 < c.length) for (K = 0; K < c.length; K++) {
	              c[K] && c[K].labelAutoFit && (h = c[K].lineCoordinates.x1, k = h - U);
	            }a[f].lineCoordinates = { x1: h - O, y1: l, x2: h - O, y2: m, height: Math.abs(m - l) };a[f].bounds = { x1: h - (F[f] + O), y1: l, x2: h, y2: m, width: h - k, height: m - l };a[f].title && (a[f]._titleTextBlock.maxWidth = 0 < a[f].titleMaxWidth && a[f].titleMaxWidth < a[f].lineCoordinates.height ? a[f].titleMaxWidth : a[f].lineCoordinates.height);a[f].calculateValueToPixelConversionParameters();a[f].calculateBreaksSizeInValues();O += F[f] + a[f].margin;
	          }if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	            K = d[f]._labels && 0 < d[f]._labels.length ? d[f]._labels[0].textBlock.fontSize / 2 : 0;k = Math.round(g.x1 - e);l = c && 0 < c.length ? Math.round(c[0] ? c[0].lineCoordinates.y2 : g.y1 < Math.max(K, 10) ? Math.max(K, 10) : g.y1) : g.y1 < Math.max(K, 10) ? Math.max(K, 10) : g.y1;h = Math.round(g.x2 - V - W);m = b && 0 < b.length ? Math.round(b[0] ? b[0].lineCoordinates.y1 : g.y2 - S > p.height - Math.max(K, 10) ? p.height - Math.max(K, 10) : g.y2 - S) : g.y2 > p.height - Math.max(K, 10) ? p.height - Math.max(K, 10) : g.y2;if (b && 0 < b.length) for (K = 0; K < b.length; K++) {
	              b[K] && b[K].labelAutoFit && (h = 0 > b[K].labelAngle ? Math.max(h, C) : 0 === b[K].labelAngle ? Math.max(h, C / 2) : h, k = 0 > b[K].labelAngle || 0 === b[K].labelAngle ? h - V : k);
	            }if (c && 0 < c.length) for (K = 0; K < c.length; K++) {
	              c[K] && c[K].labelAutoFit && (h = c[K].lineCoordinates.x2, k = h - V);
	            }d[f].lineCoordinates = { x1: h + Q, y1: l, x2: h + Q, y2: m, height: Math.abs(m - l) };d[f].bounds = { x1: k, y1: l, x2: h + z[f] + Q, y2: m, width: h - k, height: m - l };d[f].title && (d[f]._titleTextBlock.maxWidth = 0 < d[f].titleMaxWidth && d[f].titleMaxWidth < d[f].lineCoordinates.height ? d[f].titleMaxWidth : d[f].lineCoordinates.height);d[f].calculateValueToPixelConversionParameters();d[f].calculateBreaksSizeInValues();Q += z[f] + d[f].margin;
	          }for (f = 0; f < n.length; f++) {
	            "axisY" === n[f].type && (n[f].calculateValueToPixelConversionParameters(), n[f].calculateBreaksSizeInValues());
	          }if (0 < v) {
	            if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	              r = M[v - 1][f] === M[v][f] ? !0 : !1;
	            } else r = !0;if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	              H = N[v - 1][f] === N[v][f] ? !0 : !1;
	            } else H = !0;if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	              I = E[v - 1][f] === E[v][f] ? !0 : !1;
	            } else I = !0;if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	              L = t[v - 1][f] === t[v][f] ? !0 : !1;
	            } else L = !0;
	          }if (r && H && I && L) break;v++;
	        }if (b && 0 < b.length) for (f = 0; f < b.length; f++) {
	          b[f].calculateStripLinesThicknessInValues(), b[f].calculateBreaksInPixels();
	        }if (c && 0 < c.length) for (f = 0; f < c.length; f++) {
	          c[f].calculateStripLinesThicknessInValues(), c[f].calculateBreaksInPixels();
	        }if (a && 0 < a.length) for (f = 0; f < a.length; f++) {
	          a[f].calculateStripLinesThicknessInValues(), a[f].calculateBreaksInPixels();
	        }if (d && 0 < d.length) for (f = 0; f < d.length; f++) {
	          d[f].calculateStripLinesThicknessInValues(), d[f].calculateBreaksInPixels();
	        }
	      }
	    };z.render = function (a, d, b, c, e) {
	      var g = a[0] ? a[0].chart : d[0].chart;
	      e = g.ctx;var k = g._axes;g.alignVerticalAxes && g.alignVerticalAxes();e.save();e.beginPath();a[0] && e.rect(5, a[0].bounds.y1, a[0].chart.width - 10, a[0].bounds.height);d[0] && e.rect(5, d[d.length - 1].bounds.y1, d[0].chart.width - 10, d[0].bounds.height);e.clip();if (a && 0 < a.length) for (var l = 0; l < a.length; l++) {
	        a[l].renderLabelsTicksAndTitle();
	      }if (d && 0 < d.length) for (l = 0; l < d.length; l++) {
	        d[l].renderLabelsTicksAndTitle();
	      }e.restore();if (b && 0 < b.length) for (l = 0; l < b.length; l++) {
	        b[l].renderLabelsTicksAndTitle();
	      }if (c && 0 < c.length) for (l = 0; l < c.length; l++) {
	        c[l].renderLabelsTicksAndTitle();
	      }g.preparePlotArea();g = g.plotArea;e.save();e.beginPath();e.rect(g.x1, g.y1, Math.abs(g.x2 - g.x1), Math.abs(g.y2 - g.y1));e.clip();if (a && 0 < a.length) for (l = 0; l < k.length; l++) {
	        k[l].renderStripLinesOfThicknessType("value");
	      }if (d && 0 < d.length) for (l = 0; l < d.length; l++) {
	        d[l].renderStripLinesOfThicknessType("value");
	      }if (b && 0 < b.length) for (l = 0; l < b.length; l++) {
	        b[l].renderStripLinesOfThicknessType("value");
	      }if (c && 0 < c.length) for (l = 0; l < c.length; l++) {
	        c[l].renderStripLinesOfThicknessType("value");
	      }if (a && 0 < a.length) for (l = 0; l < a.length; l++) {
	        a[l].renderInterlacedColors();
	      }if (d && 0 < d.length) for (l = 0; l < d.length; l++) {
	        d[l].renderInterlacedColors();
	      }if (b && 0 < b.length) for (l = 0; l < b.length; l++) {
	        b[l].renderInterlacedColors();
	      }if (c && 0 < c.length) for (l = 0; l < c.length; l++) {
	        c[l].renderInterlacedColors();
	      }e.restore();if (a && 0 < a.length) for (l = 0; l < a.length; l++) {
	        a[l].renderGrid(), r && (a[l].createMask(), a[l].renderBreaksBackground());
	      }if (d && 0 < d.length) for (l = 0; l < d.length; l++) {
	        d[l].renderGrid(), r && (d[l].createMask(), d[l].renderBreaksBackground());
	      }if (b && 0 < b.length) for (l = 0; l < b.length; l++) {
	        b[l].renderGrid(), r && (b[l].createMask(), b[l].renderBreaksBackground());
	      }if (c && 0 < c.length) for (l = 0; l < c.length; l++) {
	        c[l].renderGrid(), r && (c[l].createMask(), c[l].renderBreaksBackground());
	      }if (a && 0 < a.length) for (l = 0; l < a.length; l++) {
	        a[l].renderAxisLine();
	      }if (d && 0 < d.length) for (l = 0; l < d.length; l++) {
	        d[l].renderAxisLine();
	      }if (b && 0 < b.length) for (l = 0; l < b.length; l++) {
	        b[l].renderAxisLine();
	      }if (c && 0 < c.length) for (l = 0; l < c.length; l++) {
	        c[l].renderAxisLine();
	      }if (a && 0 < a.length) for (l = 0; l < a.length; l++) {
	        a[l].renderStripLinesOfThicknessType("pixel");
	      }if (d && 0 < d.length) for (l = 0; l < d.length; l++) {
	        d[l].renderStripLinesOfThicknessType("pixel");
	      }if (b && 0 < b.length) for (l = 0; l < b.length; l++) {
	        b[l].renderStripLinesOfThicknessType("pixel");
	      }if (c && 0 < c.length) for (l = 0; l < c.length; l++) {
	        c[l].renderStripLinesOfThicknessType("pixel");
	      }
	    };z.prototype.calculateStripLinesThicknessInValues = function () {
	      for (var a = 0; a < this.stripLines.length; a++) {
	        if (null !== this.stripLines[a].startValue && null !== this.stripLines[a].endValue) {
	          var d = Math.min(this.stripLines[a].startValue, this.stripLines[a].endValue),
	              b = Math.max(this.stripLines[a].startValue, this.stripLines[a].endValue),
	              d = this.getApparentDifference(d, b);this.stripLines[a].value = this.logarithmic ? this.stripLines[a].value * Math.sqrt(Math.log(this.stripLines[a].endValue / this.stripLines[a].startValue) / Math.log(d)) : this.stripLines[a].value + (Math.abs(this.stripLines[a].endValue - this.stripLines[a].startValue) - d) / 2;this.stripLines[a].thickness = d;this.stripLines[a]._thicknessType = "value";
	        }
	      }
	    };z.prototype.calculateBreaksSizeInValues = function () {
	      for (var a = "left" === this._position || "right" === this._position ? this.lineCoordinates.height || this.chart.height : this.lineCoordinates.width || this.chart.width, d = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [], b = this.conversionParameters.pixelPerUnit || a / (this.logarithmic ? this.conversionParameters.maximum / this.conversionParameters.minimum : this.conversionParameters.maximum - this.conversionParameters.minimum), c = this.scaleBreaks && !u(this.scaleBreaks.options.spacing), e, g = 0; g < d.length; g++) {
	        e = c || !u(d[g].options.spacing), d[g].spacing = I(d[g].spacing, a, 8, e ? 0.1 * a : 8, e ? 0 : 3) << 0, d[g].size = 0 > d[g].spacing ? 0 : Math.abs(d[g].spacing / b), this.logarithmic && (d[g].size = Math.pow(this.logarithmBase, d[g].size));
	      }
	    };z.prototype.calculateBreaksInPixels = function () {
	      if (!(this.scaleBreaks && 0 >= this.scaleBreaks._appliedBreaks.length)) {
	        var a = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];a.length && (this.scaleBreaks.firstBreakIndex = this.scaleBreaks.lastBreakIndex = null);for (var d = 0; d < a.length && !(a[d].startValue > this.conversionParameters.maximum); d++) {
	          a[d].endValue < this.conversionParameters.minimum || (u(this.scaleBreaks.firstBreakIndex) && (this.scaleBreaks.firstBreakIndex = d), a[d].startValue >= this.conversionParameters.minimum && (a[d].startPixel = this.convertValueToPixel(a[d].startValue), this.scaleBreaks.lastBreakIndex = d), a[d].endValue <= this.conversionParameters.maximum && (a[d].endPixel = this.convertValueToPixel(a[d].endValue)));
	        }
	      }
	    };z.prototype.renderLabelsTicksAndTitle = function () {
	      var a = this,
	          d = !1,
	          b = 0,
	          c = 0,
	          e = 1,
	          g = 0;0 !== this.labelAngle && 360 !== this.labelAngle && (e = 1.2);if ("undefined" === typeof this.options.interval) {
	        if ("bottom" === this._position || "top" === this._position) if (this.logarithmic && !this.equidistantInterval && this.labelAutoFit) {
	          for (var b = [], e = 0 !== this.labelAngle && 360 !== this.labelAngle ? 1 : 1.2, k, l = this.viewportMaximum, h = this.lineCoordinates.width / Math.log(this.range), m = this._labels.length - 1; 0 <= m; m--) {
	            q = this._labels[m];if (q.position < this.viewportMinimum) break;q.position > this.viewportMaximum || !(m === this._labels.length - 1 || k < Math.log(l / q.position) * h / e) || (b.push(q), l = q.position, k = q.textBlock.width * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + q.textBlock.height * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)));
	          }this._labels = b;
	        } else {
	          for (m = 0; m < this._labels.length; m++) {
	            q = this._labels[m], q.position < this.viewportMinimum || (k = q.textBlock.width * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + q.textBlock.height * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)), b += k);
	          }b > this.lineCoordinates.width * e && this.labelAutoFit && (d = !0);
	        }if ("left" === this._position || "right" === this._position) if (this.logarithmic && !this.equidistantInterval && this.labelAutoFit) {
	          for (var b = [], p, l = this.viewportMaximum, h = this.lineCoordinates.height / Math.log(this.range), m = this._labels.length - 1; 0 <= m; m--) {
	            q = this._labels[m];if (q.position < this.viewportMinimum) break;q.position > this.viewportMaximum || !(m === this._labels.length - 1 || p < Math.log(l / q.position) * h) || (b.push(q), l = q.position, p = q.textBlock.height * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + q.textBlock.width * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)));
	          }this._labels = b;
	        } else {
	          for (m = 0; m < this._labels.length; m++) {
	            q = this._labels[m], q.position < this.viewportMinimum || (p = q.textBlock.height * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + q.textBlock.width * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)), c += p);
	          }c > this.lineCoordinates.height * e && this.labelAutoFit && (d = !0);
	        }
	      }this.logarithmic && !this.equidistantInterval && this.labelAutoFit && this._labels.sort(function (a, b) {
	        return a.position - b.position;
	      });var m = 0,
	          q,
	          n;if ("bottom" === this._position) {
	        for (m = 0; m < this._labels.length; m++) {
	          q = this._labels[m], q.position < this.viewportMinimum || q.position > this.viewportMaximum || d && 0 !== g++ % 2 && this.labelAutoFit || (n = this.getPixelCoordinatesOnAxis(q.position), this.tickThickness && "inside" != this.labelPlacement && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (n.x << 0) + 0.5 : n.x << 0, this.ctx.beginPath(), this.ctx.moveTo(c, n.y << 0), this.ctx.lineTo(c, n.y + this.tickLength << 0), this.ctx.stroke()), 0 === q.textBlock.angle ? (n.x -= q.textBlock.width / 2, n.y = "inside" === this.labelPlacement ? n.y - (this.tickLength + q.textBlock.fontSize / 2) : n.y + this.tickLength + q.textBlock.fontSize / 2) : (n.x = "inside" === this.labelPlacement ? 0 > this.labelAngle ? n.x : n.x - q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : n.x - (0 > this.labelAngle ? q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0), n.y = "inside" === this.labelPlacement ? 0 > this.labelAngle ? n.y - this.tickLength - 5 : n.y - this.tickLength - Math.abs(q.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) + 5) : n.y + this.tickLength + Math.abs(0 > this.labelAngle ? q.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) - 5 : 5)), q.textBlock.x = n.x, q.textBlock.y = n.y);
	        }"inside" === this.labelPlacement && this.chart.addEventListener("dataAnimationIterationEnd", function () {
	          for (m = 0; m < a._labels.length; m++) {
	            if (q = a._labels[m], !(q.position < a.viewportMinimum || q.position > a.viewportMaximum || d && 0 !== g++ % 2 && a.labelAutoFit) && (n = a.getPixelCoordinatesOnAxis(q.position), a.tickThickness)) {
	              a.ctx.lineWidth = a.tickThickness;a.ctx.strokeStyle = a.tickColor;var b = 1 === a.ctx.lineWidth % 2 ? (n.x << 0) + 0.5 : n.x << 0;a.ctx.save();
	              a.ctx.beginPath();a.ctx.moveTo(b, n.y << 0);a.ctx.lineTo(b, n.y - a.tickLength << 0);a.ctx.stroke();a.ctx.restore();
	            }
	          }
	        }, this);this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.lineCoordinates.x1 + this.lineCoordinates.width / 2 - this._titleTextBlock.width / 2, this._titleTextBlock.y = this.bounds.y2 - this._titleTextBlock.height - 3, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0));
	      } else if ("top" === this._position) {
	        for (m = 0; m < this._labels.length; m++) {
	          q = this._labels[m], q.position < this.viewportMinimum || q.position > this.viewportMaximum || d && 0 !== g++ % 2 && this.labelAutoFit || (n = this.getPixelCoordinatesOnAxis(q.position), this.tickThickness && "inside" != this.labelPlacement && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (n.x << 0) + 0.5 : n.x << 0, this.ctx.beginPath(), this.ctx.moveTo(c, n.y << 0), this.ctx.lineTo(c, n.y - this.tickLength << 0), this.ctx.stroke()), 0 === q.textBlock.angle ? (n.x -= q.textBlock.width / 2, n.y = "inside" === this.labelPlacement ? n.y + this.labelFontSize / 2 + this.tickLength + 5 : n.y - (this.tickLength + q.textBlock.height - q.textBlock.fontSize / 2)) : (n.x = "inside" === this.labelPlacement ? 0 < this.labelAngle ? n.x : n.x - q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : n.x + (q.textBlock.height - this.tickLength - this.labelFontSize) * Math.sin(Math.PI / 180 * this.labelAngle) - (0 < this.labelAngle ? q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0), n.y = "inside" === this.labelPlacement ? 0 < this.labelAngle ? n.y + this.tickLength + 5 : n.y - q.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) + this.tickLength + 5 : n.y - (this.tickLength + ((q.textBlock.height - q.textBlock.fontSize / 2) * Math.cos(Math.PI / 180 * this.labelAngle) + (0 < this.labelAngle ? q.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) : 0)))), q.textBlock.x = n.x, q.textBlock.y = n.y);
	        }"inside" === this.labelPlacement && this.chart.addEventListener("dataAnimationIterationEnd", function () {
	          for (m = 0; m < a._labels.length; m++) {
	            if (q = a._labels[m], !(q.position < a.viewportMinimum || q.position > a.viewportMaximum || d && 0 !== g++ % 2 && a.labelAutoFit) && (n = a.getPixelCoordinatesOnAxis(q.position), a.tickThickness)) {
	              a.ctx.lineWidth = a.tickThickness;a.ctx.strokeStyle = a.tickColor;var b = 1 === this.ctx.lineWidth % 2 ? (n.x << 0) + 0.5 : n.x << 0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(b, n.y << 0);a.ctx.lineTo(b, n.y + a.tickLength << 0);a.ctx.stroke();a.ctx.restore();
	            }
	          }
	        }, this);this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.lineCoordinates.x1 + this.lineCoordinates.width / 2 - this._titleTextBlock.width / 2, this._titleTextBlock.y = this.bounds.y1 + 1, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0));
	      } else if ("left" === this._position) {
	        for (m = 0; m < this._labels.length; m++) {
	          q = this._labels[m], q.position < this.viewportMinimum || q.position > this.viewportMaximum || d && 0 !== g++ % 2 && this.labelAutoFit || (n = this.getPixelCoordinatesOnAxis(q.position), this.tickThickness && "inside" != this.labelPlacement && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (n.y << 0) + 0.5 : n.y << 0, this.ctx.beginPath(), this.ctx.moveTo(n.x << 0, c), this.ctx.lineTo(n.x - this.tickLength << 0, c), this.ctx.stroke()), 0 === this.labelAngle ? (q.textBlock.y = n.y, q.textBlock.x = "inside" === this.labelPlacement ? n.x + this.tickLength + 5 : n.x - q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5) : (q.textBlock.y = "inside" === this.labelPlacement ? n.y : n.y - q.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle), q.textBlock.x = "inside" === this.labelPlacement ? n.x + this.tickLength + 5 : 0 < this.labelAngle ? n.x - q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : n.x - q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) + (q.textBlock.height - q.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) - this.tickLength));
	        }"inside" === this.labelPlacement && this.chart.addEventListener("dataAnimationIterationEnd", function () {
	          for (m = 0; m < a._labels.length; m++) {
	            if (q = a._labels[m], !(q.position < a.viewportMinimum || q.position > a.viewportMaximum || d && 0 !== g++ % 2 && a.labelAutoFit) && (n = a.getPixelCoordinatesOnAxis(q.position), a.tickThickness)) {
	              a.ctx.lineWidth = a.tickThickness;
	              a.ctx.strokeStyle = a.tickColor;var b = 1 === a.ctx.lineWidth % 2 ? (n.y << 0) + 0.5 : n.y << 0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(n.x << 0, b);a.ctx.lineTo(n.x + a.tickLength << 0, b);a.ctx.stroke();a.ctx.restore();
	            }
	          }
	        }, this);this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.bounds.x1 + 1, this._titleTextBlock.y = this.lineCoordinates.height / 2 + this._titleTextBlock.width / 2 + this.lineCoordinates.y1, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0));
	      } else if ("right" === this._position) {
	        for (m = 0; m < this._labels.length; m++) {
	          q = this._labels[m], q.position < this.viewportMinimum || q.position > this.viewportMaximum || d && 0 !== g++ % 2 && this.labelAutoFit || (n = this.getPixelCoordinatesOnAxis(q.position), this.tickThickness && "inside" != this.labelPlacement && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (n.y << 0) + 0.5 : n.y << 0, this.ctx.beginPath(), this.ctx.moveTo(n.x << 0, c), this.ctx.lineTo(n.x + this.tickLength << 0, c), this.ctx.stroke()), 0 === this.labelAngle ? (q.textBlock.y = n.y, q.textBlock.x = "inside" === this.labelPlacement ? n.x - q.textBlock.width - this.tickLength - 5 : n.x + this.tickLength + 5) : (q.textBlock.y = "inside" === this.labelPlacement ? n.y - q.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) : 0 > this.labelAngle ? n.y : n.y - (q.textBlock.height - q.textBlock.fontSize / 2 - 5) * Math.cos(Math.PI / 180 * this.labelAngle), q.textBlock.x = "inside" === this.labelPlacement ? n.x - q.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : 0 < this.labelAngle ? n.x + (q.textBlock.height - q.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) + this.tickLength : n.x + this.tickLength + 5));
	        }"inside" === this.labelPlacement && this.chart.addEventListener("dataAnimationIterationEnd", function () {
	          for (m = 0; m < a._labels.length; m++) {
	            if (q = a._labels[m], !(q.position < a.viewportMinimum || q.position > a.viewportMaximum || d && 0 !== g++ % 2 && a.labelAutoFit) && (n = a.getPixelCoordinatesOnAxis(q.position), a.tickThickness)) {
	              a.ctx.lineWidth = a.tickThickness;a.ctx.strokeStyle = a.tickColor;var b = 1 === a.ctx.lineWidth % 2 ? (n.y << 0) + 0.5 : n.y << 0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(n.x << 0, b);a.ctx.lineTo(n.x - a.tickLength << 0, b);a.ctx.stroke();a.ctx.restore();
	            }
	          }
	        }, this);this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.bounds.x2 - 1, this._titleTextBlock.y = this.lineCoordinates.height / 2 - this._titleTextBlock.width / 2 + this.lineCoordinates.y1, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0));
	      }g = 0;if ("inside" === this.labelPlacement) this.chart.addEventListener("dataAnimationIterationEnd", function () {
	        for (m = 0; m < a._labels.length; m++) {
	          q = a._labels[m], q.position < a.viewportMinimum || q.position > a.viewportMaximum || d && 0 !== g++ % 2 && a.labelAutoFit || (a.ctx.save(), a.ctx.beginPath(), q.textBlock.render(!0), a.ctx.restore());
	        }
	      }, this);else for (m = 0; m < this._labels.length; m++) {
	        q = this._labels[m], q.position < this.viewportMinimum || q.position > this.viewportMaximum || d && 0 !== g++ % 2 && this.labelAutoFit || q.textBlock.render(!0);
	      }
	    };z.prototype.renderInterlacedColors = function () {
	      var a = this.chart.plotArea.ctx,
	          d,
	          b,
	          c = this.chart.plotArea,
	          e = 0;d = !0;if (("bottom" === this._position || "top" === this._position) && this.interlacedColor) for (a.fillStyle = this.interlacedColor, e = 0; e < this._labels.length; e++) {
	        d ? (d = this.getPixelCoordinatesOnAxis(this._labels[e].position), b = e + 1 > this._labels.length - 1 ? this.getPixelCoordinatesOnAxis(this.viewportMaximum) : this.getPixelCoordinatesOnAxis(this._labels[e + 1].position), a.fillRect(Math.min(b.x, d.x), c.y1, Math.abs(b.x - d.x), Math.abs(c.y1 - c.y2)), d = !1) : d = !0;
	      } else if (("left" === this._position || "right" === this._position) && this.interlacedColor) for (a.fillStyle = this.interlacedColor, e = 0; e < this._labels.length; e++) {
	        d ? (b = this.getPixelCoordinatesOnAxis(this._labels[e].position), d = e + 1 > this._labels.length - 1 ? this.getPixelCoordinatesOnAxis(this.viewportMaximum) : this.getPixelCoordinatesOnAxis(this._labels[e + 1].position), a.fillRect(c.x1, Math.min(b.y, d.y), Math.abs(c.x1 - c.x2), Math.abs(d.y - b.y)), d = !1) : d = !0;
	      }a.beginPath();
	    };z.prototype.renderStripLinesOfThicknessType = function (a) {
	      if (this.stripLines && 0 < this.stripLines.length && a) {
	        for (var d = this, b, c = 0, e = 0, g = !1, k = !1, l = [], h = [], k = !1, c = 0; c < this.stripLines.length; c++) {
	          var m = this.stripLines[c];m._thicknessType === a && ("pixel" === a && (m.value < this.viewportMinimum || m.value > this.viewportMaximum || u(m.value) || isNaN(this.range)) || l.push(m));
	        }for (c = 0; c < this._stripLineLabels.length; c++) {
	          if (m = this.stripLines[c], b = this._stripLineLabels[c], !(b.position < this.viewportMinimum || b.position > this.viewportMaximum || isNaN(this.range))) {
	            a = this.getPixelCoordinatesOnAxis(b.position);if ("outside" === b.stripLine.labelPlacement) {
	              if (m && (this.ctx.strokeStyle = m.color, "pixel" === m._thicknessType && (this.ctx.lineWidth = m.thickness)), "bottom" === this._position) {
	                var p = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0;this.ctx.beginPath();this.ctx.moveTo(p, a.y << 0);this.ctx.lineTo(p, a.y + this.tickLength << 0);this.ctx.stroke();0 === this.labelAngle ? (a.x -= b.textBlock.width / 2, a.y += this.tickLength + b.textBlock.fontSize / 2) : (a.x -= 0 > this.labelAngle ? b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0, a.y += this.tickLength + Math.abs(0 > this.labelAngle ? b.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) - 5 : 5));
	              } else "top" === this._position ? (p = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0, this.ctx.beginPath(), this.ctx.moveTo(p, a.y << 0), this.ctx.lineTo(p, a.y - this.tickLength << 0), this.ctx.stroke(), 0 === this.labelAngle ? (a.x -= b.textBlock.width / 2, a.y -= this.tickLength + b.textBlock.height) : (a.x += (b.textBlock.height - this.tickLength - this.labelFontSize / 2) * Math.sin(Math.PI / 180 * this.labelAngle) - (0 < this.labelAngle ? b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0), a.y -= this.tickLength + (b.textBlock.height * Math.cos(Math.PI / 180 * this.labelAngle) + (0 < this.labelAngle ? b.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) : 0)))) : "left" === this._position ? (p = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0, this.ctx.beginPath(), this.ctx.moveTo(a.x << 0, p), this.ctx.lineTo(a.x - this.tickLength << 0, p), this.ctx.stroke(), 0 === this.labelAngle ? a.x = a.x - b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : (a.y -= b.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle), a.x = 0 < this.labelAngle ? a.x - b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : a.x - b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) + (b.textBlock.height - b.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) - this.tickLength)) : "right" === this._position && (p = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0, this.ctx.beginPath(), this.ctx.moveTo(a.x << 0, p), this.ctx.lineTo(a.x + this.tickLength << 0, p), this.ctx.stroke(), 0 === this.labelAngle ? a.x = a.x + this.tickLength + 5 : (a.y = 0 > this.labelAngle ? a.y : a.y - (b.textBlock.height - b.textBlock.fontSize / 2 - 5) * Math.cos(Math.PI / 180 * this.labelAngle), a.x = 0 < this.labelAngle ? a.x + (b.textBlock.height - b.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) + this.tickLength : a.x + this.tickLength + 5));
	            } else b.textBlock.angle = -90, "bottom" === this._position ? (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.height - 3, b.textBlock.measureText(), a.x - b.textBlock.height > this.chart.plotArea.x1 ? u(m.startValue) ? a.x -= b.textBlock.height - b.textBlock.fontSize / 2 : a.x -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3 : (b.textBlock.angle = 90, u(m.startValue) ? a.x += b.textBlock.height - b.textBlock.fontSize / 2 : a.x += b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3), a.y = -90 === b.textBlock.angle ? "near" === b.stripLine.labelAlign ? this.chart.plotArea.y2 - 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 + b.textBlock.width) / 2 : this.chart.plotArea.y1 + b.textBlock.width + 3 : "near" === b.stripLine.labelAlign ? this.chart.plotArea.y2 - b.textBlock.width - 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 - b.textBlock.width) / 2 : this.chart.plotArea.y1 + 3) : "top" === this._position ? (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.height - 3, b.textBlock.measureText(), a.x - b.textBlock.height > this.chart.plotArea.x1 ? u(m.startValue) ? a.x -= b.textBlock.height - b.textBlock.fontSize / 2 : a.x -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3 : (b.textBlock.angle = 90, u(m.startValue) ? a.x += b.textBlock.height - b.textBlock.fontSize / 2 : a.x += b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3), a.y = -90 === b.textBlock.angle ? "near" === b.stripLine.labelAlign ? this.chart.plotArea.y1 + b.textBlock.width + 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 + b.textBlock.width) / 2 : this.chart.plotArea.y2 - 3 : "near" === b.stripLine.labelAlign ? this.chart.plotArea.y1 + 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 - b.textBlock.width) / 2 : this.chart.plotArea.y2 - b.textBlock.width - 3) : "left" === this._position ? (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.width - 3, b.textBlock.angle = 0, b.textBlock.measureText(), a.y - b.textBlock.height > this.chart.plotArea.y1 ? u(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize + 3 : a.y - b.textBlock.height < this.chart.plotArea.y2 ? a.y += b.textBlock.fontSize / 2 + 3 : u(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize + 3, a.x = "near" === b.stripLine.labelAlign ? this.chart.plotArea.x1 + 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) / 2 - b.textBlock.width / 2 : this.chart.plotArea.x2 - b.textBlock.width - 3) : "right" === this._position && (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.width - 3, b.textBlock.angle = 0, b.textBlock.measureText(), a.y - +b.textBlock.height > this.chart.plotArea.y1 ? u(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 - 3 : a.y - b.textBlock.height < this.chart.plotArea.y2 ? a.y += b.textBlock.fontSize / 2 + 3 : u(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3, a.x = "near" === b.stripLine.labelAlign ? this.chart.plotArea.x2 - b.textBlock.width - 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) / 2 - b.textBlock.width / 2 : this.chart.plotArea.x1 + 3);b.textBlock.x = a.x;b.textBlock.y = a.y;h.push(b);
	          }
	        }if (!k) {
	          k = !1;this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1, this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height);this.ctx.clip();for (c = 0; c < l.length; c++) {
	            m = l[c], m.showOnTop ? g || (g = !0, this.chart.addEventListener("dataAnimationIterationEnd", function () {
	              this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1, this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height);this.ctx.clip();
	              for (e = 0; e < l.length; e++) {
	                m = l[e], m.showOnTop && m.render();
	              }this.ctx.restore();
	            }, m)) : m.render();
	          }for (c = 0; c < h.length; c++) {
	            b = h[c], b.stripLine.showOnTop ? k || (k = !0, this.chart.addEventListener("dataAnimationIterationEnd", function () {
	              for (e = 0; e < h.length; e++) {
	                b = h[e], "inside" === b.stripLine.labelPlacement && b.stripLine.showOnTop && (d.ctx.save(), d.ctx.beginPath(), d.ctx.rect(d.chart.plotArea.x1, d.chart.plotArea.y1, d.chart.plotArea.width, d.chart.plotArea.height), d.ctx.clip(), b.textBlock.render(!0), d.ctx.restore());
	              }
	            }, b.textBlock)) : "inside" === b.stripLine.labelPlacement && b.textBlock.render(!0);
	          }this.ctx.restore();k = !0;
	        }if (k) for (k = !1, c = 0; c < h.length; c++) {
	          b = h[c], b.stripLine.showOnTop ? k || (k = !0, this.chart.addEventListener("dataAnimationIterationEnd", function () {
	            for (e = 0; e < h.length; e++) {
	              b = h[e], "outside" === b.stripLine.labelPlacement && b.stripLine.showOnTop && b.textBlock.render(!0);
	            }
	          }, b.textBlock)) : "outside" === b.stripLine.labelPlacement && b.textBlock.render(!0);
	        }
	      }
	    };z.prototype.renderBreaksBackground = function () {
	      this.chart._breaksCanvas && this.scaleBreaks && 0 < this.scaleBreaks._appliedBreaks.length && this.maskCanvas && (this.chart._breaksCanvasCtx.save(), this.chart._breaksCanvasCtx.beginPath(), this.chart._breaksCanvasCtx.rect(this.chart.plotArea.x1, this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height), this.chart._breaksCanvasCtx.clip(), this.chart._breaksCanvasCtx.drawImage(this.maskCanvas, 0, 0, this.chart.width, this.chart.height), this.chart._breaksCanvasCtx.restore());
	    };z.prototype.createMask = function () {
	      if (this.scaleBreaks && 0 < this.scaleBreaks._appliedBreaks.length) {
	        var a = this.scaleBreaks._appliedBreaks;r ? (this.maskCanvas = ta(this.chart.width, this.chart.height), this.maskCtx = this.maskCanvas.getContext("2d")) : (this.maskCanvas = this.chart.plotArea.canvas, this.maskCtx = this.chart.plotArea.ctx);this.maskCtx.save();this.maskCtx.beginPath();this.maskCtx.rect(this.chart.plotArea.x1, this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height);this.maskCtx.clip();for (var d = 0; d < a.length; d++) {
	          a[d].endValue < this.viewportMinimum || a[d].startValue > this.viewportMaximum || isNaN(this.range) || a[d].render(this.maskCtx);
	        }this.maskCtx.restore();
	      }
	    };z.prototype.renderCrosshair = function (a, d) {
	      this.crosshair.render(a, d);
	    };z.prototype.renderGrid = function () {
	      if (this.gridThickness && 0 < this.gridThickness) {
	        var a = this.chart.ctx;a.save();var d,
	            b = this.chart.plotArea;a.lineWidth = this.gridThickness;a.strokeStyle = this.gridColor;a.setLineDash && a.setLineDash(R(this.gridDashType, this.gridThickness));if ("bottom" === this._position || "top" === this._position) for (c = 0; c < this._labels.length; c++) {
	          this._labels[c].position < this.viewportMinimum || this._labels[c].position > this.viewportMaximum || this._labels[c].breaksLabelType || (a.beginPath(), d = this.getPixelCoordinatesOnAxis(this._labels[c].position), d = 1 === a.lineWidth % 2 ? (d.x << 0) + 0.5 : d.x << 0, a.moveTo(d, b.y1 << 0), a.lineTo(d, b.y2 << 0), a.stroke());
	        } else if ("left" === this._position || "right" === this._position) for (var c = 0; c < this._labels.length; c++) {
	          this._labels[c].position < this.viewportMinimum || this._labels[c].position > this.viewportMaximum || this._labels[c].breaksLabelType || (a.beginPath(), d = this.getPixelCoordinatesOnAxis(this._labels[c].position), d = 1 === a.lineWidth % 2 ? (d.y << 0) + 0.5 : d.y << 0, a.moveTo(b.x1 << 0, d), a.lineTo(b.x2 << 0, d), a.stroke());
	        }a.restore();
	      }
	    };z.prototype.renderAxisLine = function () {
	      var a = this.chart.ctx,
	          d = r ? this.chart._preRenderCtx : a,
	          b = Math.ceil(this.tickThickness / (this.reversed ? -2 : 2)),
	          c = Math.ceil(this.tickThickness / (this.reversed ? 2 : -2)),
	          e,
	          g;d.save();if ("bottom" === this._position || "top" === this._position) {
	        if (this.lineThickness) {
	          this.reversed ? (e = this.lineCoordinates.x2, g = this.lineCoordinates.x1) : (e = this.lineCoordinates.x1, g = this.lineCoordinates.x2);d.lineWidth = this.lineThickness;d.strokeStyle = this.lineColor ? this.lineColor : "black";d.setLineDash && d.setLineDash(R(this.lineDashType, this.lineThickness));var k = 1 === this.lineThickness % 2 ? (this.lineCoordinates.y1 << 0) + 0.5 : this.lineCoordinates.y1 << 0;d.beginPath();if (this.scaleBreaks && !u(this.scaleBreaks.firstBreakIndex)) if (u(this.scaleBreaks.lastBreakIndex)) e = this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex].endPixel + c;else for (var l = this.scaleBreaks.firstBreakIndex; l <= this.scaleBreaks.lastBreakIndex; l++) {
	            d.moveTo(e, k), d.lineTo(this.scaleBreaks._appliedBreaks[l].startPixel + b, k), e = this.scaleBreaks._appliedBreaks[l].endPixel + c;
	          }e && (d.moveTo(e, k), d.lineTo(g, k));d.stroke();
	        }
	      } else if (("left" === this._position || "right" === this._position) && this.lineThickness) {
	        this.reversed ? (e = this.lineCoordinates.y1, g = this.lineCoordinates.y2) : (e = this.lineCoordinates.y2, g = this.lineCoordinates.y1);d.lineWidth = this.lineThickness;d.strokeStyle = this.lineColor;
	        d.setLineDash && d.setLineDash(R(this.lineDashType, this.lineThickness));k = 1 === this.lineThickness % 2 ? (this.lineCoordinates.x1 << 0) + 0.5 : this.lineCoordinates.x1 << 0;d.beginPath();if (this.scaleBreaks && !u(this.scaleBreaks.firstBreakIndex)) if (u(this.scaleBreaks.lastBreakIndex)) e = this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex].endPixel + b;else for (l = this.scaleBreaks.firstBreakIndex; l <= this.scaleBreaks.lastBreakIndex; l++) {
	          d.moveTo(k, e), d.lineTo(k, this.scaleBreaks._appliedBreaks[l].startPixel + c), e = this.scaleBreaks._appliedBreaks[l].endPixel + b;
	        }e && (d.moveTo(k, e), d.lineTo(k, g));d.stroke();
	      }r && (a.drawImage(this.chart._preRenderCanvas, 0, 0, this.chart.width, this.chart.height), this.chart._breaksCanvasCtx && this.chart._breaksCanvasCtx.drawImage(this.chart._preRenderCanvas, 0, 0, this.chart.width, this.chart.height), d.clearRect(0, 0, this.chart.width, this.chart.height));d.restore();
	    };z.prototype.getPixelCoordinatesOnAxis = function (a) {
	      var d = {};if ("bottom" === this._position || "top" === this._position) d.x = this.convertValueToPixel(a), d.y = this.lineCoordinates.y1;if ("left" === this._position || "right" === this._position) d.y = this.convertValueToPixel(a), d.x = this.lineCoordinates.x2;return d;
	    };z.prototype.convertPixelToValue = function (a) {
	      if ("undefined" === typeof a) return null;var d = 0,
	          b = 0,
	          c,
	          d = !0,
	          e = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
	          b = "number" === typeof a ? a : "left" === this._position || "right" === this._position ? a.y : a.x;if (this.logarithmic) {
	        a = c = Math.pow(this.logarithmBase, (b - this.conversionParameters.reference) / this.conversionParameters.pixelPerUnit);
	        if (b <= this.conversionParameters.reference === ("left" === this._position || "right" === this._position) !== this.reversed) for (b = 0; b < e.length; b++) {
	          if (!(e[b].endValue < this.conversionParameters.minimum)) if (d) {
	            if (e[b].startValue < this.conversionParameters.minimum) {
	              if (1 < e[b].size && this.conversionParameters.minimum * Math.pow(e[b].endValue / e[b].startValue, Math.log(c) / Math.log(e[b].size)) < e[b].endValue) {
	                a = Math.pow(e[b].endValue / e[b].startValue, Math.log(c) / Math.log(e[b].size));break;
	              } else a *= e[b].endValue / this.conversionParameters.minimum / Math.pow(e[b].size, Math.log(e[b].endValue / this.conversionParameters.minimum) / Math.log(e[b].endValue / e[b].startValue)), c /= Math.pow(e[b].size, Math.log(e[b].endValue / this.conversionParameters.minimum) / Math.log(e[b].endValue / e[b].startValue));d = !1;
	            } else if (c > e[b].startValue / this.conversionParameters.minimum) {
	              c /= e[b].startValue / this.conversionParameters.minimum;if (c < e[b].size) {
	                a *= Math.pow(e[b].endValue / e[b].startValue, 1 === e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)) / c;break;
	              } else a *= e[b].endValue / e[b].startValue / e[b].size;c /= e[b].size;d = !1;
	            } else break;
	          } else if (c > e[b].startValue / e[b - 1].endValue) {
	            c /= e[b].startValue / e[b - 1].endValue;if (c < e[b].size) {
	              a *= Math.pow(e[b].endValue / e[b].startValue, 1 === e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)) / c;break;
	            } else a *= e[b].endValue / e[b].startValue / e[b].size;c /= e[b].size;
	          } else break;
	        } else for (b = e.length - 1; 0 <= b; b--) {
	          if (!(e[b].startValue > this.conversionParameters.minimum)) if (d) {
	            if (e[b].endValue > this.conversionParameters.minimum) {
	              if (1 < e[b].size && this.conversionParameters.minimum * Math.pow(e[b].endValue / e[b].startValue, Math.log(c) / Math.log(e[b].size)) > e[b].startValue) {
	                a = Math.pow(e[b].endValue / e[b].startValue, Math.log(c) / Math.log(e[b].size));break;
	              } else a *= e[b].startValue / this.conversionParameters.minimum * Math.pow(e[b].size, Math.log(e[b].startValue / this.conversionParameters.minimum) / Math.log(e[b].endValue / e[b].startValue)) * c, c *= Math.pow(e[b].size, Math.log(this.conversionParameters.minimum / e[b].startValue) / Math.log(e[b].endValue / e[b].startValue));d = !1;
	            } else if (c < e[b].endValue / this.conversionParameters.minimum) {
	              c /= e[b].endValue / this.conversionParameters.minimum;if (c > 1 / e[b].size) {
	                a *= Math.pow(e[b].endValue / e[b].startValue, 1 >= e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)) * c;break;
	              } else a /= e[b].endValue / e[b].startValue / e[b].size;c *= e[b].size;d = !1;
	            } else break;
	          } else if (c < e[b].endValue / e[b + 1].startValue) {
	            c /= e[b].endValue / e[b + 1].startValue;if (c > 1 / e[b].size) {
	              a *= Math.pow(e[b].endValue / e[b].startValue, 1 >= e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)) * c;break;
	            } else a /= e[b].endValue / e[b].startValue / e[b].size;c *= e[b].size;
	          } else break;
	        }d = a * this.viewportMinimum;
	      } else {
	        a = c = (b - this.conversionParameters.reference) / this.conversionParameters.pixelPerUnit;if (b <= this.conversionParameters.reference === ("left" === this._position || "right" === this._position) !== this.reversed) for (b = 0; b < e.length; b++) {
	          if (!(e[b].endValue < this.conversionParameters.minimum)) if (d) {
	            if (e[b].startValue < this.conversionParameters.minimum) {
	              if (e[b].size && this.conversionParameters.minimum + c * (e[b].endValue - e[b].startValue) / e[b].size < e[b].endValue) {
	                a = 0 >= e[b].size ? 0 : c * (e[b].endValue - e[b].startValue) / e[b].size;break;
	              } else a += e[b].endValue - this.conversionParameters.minimum - e[b].size * (e[b].endValue - this.conversionParameters.minimum) / (e[b].endValue - e[b].startValue), c -= e[b].size * (e[b].endValue - this.conversionParameters.minimum) / (e[b].endValue - e[b].startValue);d = !1;
	            } else if (c > e[b].startValue - this.conversionParameters.minimum) {
	              c -= e[b].startValue - this.conversionParameters.minimum;if (c < e[b].size) {
	                a += (e[b].endValue - e[b].startValue) * (0 === e[b].size ? 1 : c / e[b].size) - c;break;
	              } else a += e[b].endValue - e[b].startValue - e[b].size;c -= e[b].size;d = !1;
	            } else break;
	          } else if (c > e[b].startValue - e[b - 1].endValue) {
	            c -= e[b].startValue - e[b - 1].endValue;if (c < e[b].size) {
	              a += (e[b].endValue - e[b].startValue) * (0 === e[b].size ? 1 : c / e[b].size) - c;break;
	            } else a += e[b].endValue - e[b].startValue - e[b].size;c -= e[b].size;
	          } else break;
	        } else for (b = e.length - 1; 0 <= b; b--) {
	          if (!(e[b].startValue > this.conversionParameters.minimum)) if (d) {
	            if (e[b].endValue > this.conversionParameters.minimum) {
	              if (e[b].size && this.conversionParameters.minimum + c * (e[b].endValue - e[b].startValue) / e[b].size > e[b].startValue) {
	                a = 0 >= e[b].size ? 0 : c * (e[b].endValue - e[b].startValue) / e[b].size;break;
	              } else a += e[b].startValue - this.conversionParameters.minimum + e[b].size * (this.conversionParameters.minimum - e[b].startValue) / (e[b].endValue - e[b].startValue), c += e[b].size * (this.conversionParameters.minimum - e[b].startValue) / (e[b].endValue - e[b].startValue), d = !1;
	            } else if (c < e[b].endValue - this.conversionParameters.minimum) {
	              c -= e[b].endValue - this.conversionParameters.minimum;if (c > -1 * e[b].size) {
	                a += (e[b].endValue - e[b].startValue) * (0 === e[b].size ? 1 : c / e[b].size) + c;break;
	              } else a -= e[b].endValue - e[b].startValue - e[b].size;c += e[b].size;d = !1;
	            } else break;
	          } else if (c < e[b].endValue - e[b + 1].startValue) {
	            c -= e[b].endValue - e[b + 1].startValue;if (c > -1 * e[b].size) {
	              a += (e[b].endValue - e[b].startValue) * (0 === e[b].size ? 1 : c / e[b].size) + c;break;
	            } else a -= e[b].endValue - e[b].startValue - e[b].size;c += e[b].size;
	          } else break;
	        }d = this.conversionParameters.minimum + a;
	      }return d;
	    };z.prototype.convertValueToPixel = function (a) {
	      a = this.getApparentDifference(this.conversionParameters.minimum, a, a);return this.logarithmic ? this.conversionParameters.reference + this.conversionParameters.pixelPerUnit * Math.log(a / this.conversionParameters.minimum) / this.conversionParameters.lnLogarithmBase + 0.5 << 0 : "axisX" === this.type ? this.conversionParameters.reference + this.conversionParameters.pixelPerUnit * (a - this.conversionParameters.minimum) + 0.5 << 0 : this.conversionParameters.reference + this.conversionParameters.pixelPerUnit * (a - this.conversionParameters.minimum) + 0.5;
	    };z.prototype.getApparentDifference = function (a, d, b, c) {
	      var e = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];if (this.logarithmic) {
	        b = u(b) ? d / a : b;for (var g = 0; g < e.length && !(d < e[g].startValue); g++) {
	          a > e[g].endValue || (a <= e[g].startValue && d >= e[g].endValue ? b = b / e[g].endValue * e[g].startValue * e[g].size : a >= e[g].startValue && d >= e[g].endValue ? b = b / e[g].endValue * a * Math.pow(e[g].size, Math.log(e[g].endValue / a) / Math.log(e[g].endValue / e[g].startValue)) : a <= e[g].startValue && d <= e[g].endValue ? b = b / d * e[g].startValue * Math.pow(e[g].size, Math.log(d / e[g].startValue) / Math.log(e[g].endValue / e[g].startValue)) : !c && a > e[g].startValue && d < e[g].endValue && (b = a * Math.pow(e[g].size, Math.log(d / a) / Math.log(e[g].endValue / e[g].startValue))));
	        }
	      } else for (b = u(b) ? Math.abs(d - a) : b, g = 0; g < e.length && !(d < e[g].startValue); g++) {
	        a > e[g].endValue || (a <= e[g].startValue && d >= e[g].endValue ? b = b - e[g].endValue + e[g].startValue + e[g].size : a > e[g].startValue && d >= e[g].endValue ? b = b - e[g].endValue + a + e[g].size * (e[g].endValue - a) / (e[g].endValue - e[g].startValue) : a <= e[g].startValue && d < e[g].endValue ? b = b - d + e[g].startValue + e[g].size * (d - e[g].startValue) / (e[g].endValue - e[g].startValue) : !c && a > e[g].startValue && d < e[g].endValue && (b = a + e[g].size * (d - a) / (e[g].endValue - e[g].startValue)));
	      }return b;
	    };z.prototype.setViewPortRange = function (a, d) {
	      this.sessionVariables.newViewportMinimum = this.viewportMinimum = Math.min(a, d);this.sessionVariables.newViewportMaximum = this.viewportMaximum = Math.max(a, d);
	    };z.prototype.getXValueAt = function (a) {
	      if (!a) return null;var d = null;"left" === this._position ? d = this.convertPixelToValue(a.y) : "bottom" === this._position && (d = this.convertPixelToValue(a.x));
	      return d;
	    };z.prototype.calculateValueToPixelConversionParameters = function (a) {
	      a = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];var d = { pixelPerUnit: null, minimum: null, reference: null },
	          b = this.lineCoordinates.width,
	          c = this.lineCoordinates.height,
	          b = "bottom" === this._position || "top" === this._position ? b : c,
	          c = Math.abs(this.range);if (this.logarithmic) for (var e = 0; e < a.length && !(this.viewportMaximum < a[e].startValue); e++) {
	        this.viewportMinimum > a[e].endValue || (this.viewportMinimum >= a[e].startValue && this.viewportMaximum <= a[e].endValue ? b = 0 : this.viewportMinimum <= a[e].startValue && this.viewportMaximum >= a[e].endValue ? (c = c / a[e].endValue * a[e].startValue, b = 0 < a[e].spacing.toString().indexOf("%") ? b * (1 - parseFloat(a[e].spacing) / 100) : b - Math.min(a[e].spacing, 0.1 * b)) : this.viewportMinimum > a[e].startValue && this.viewportMaximum >= a[e].endValue ? (c = c / a[e].endValue * this.viewportMinimum, b = 0 < a[e].spacing.toString().indexOf("%") ? b * (1 - parseFloat(a[e].spacing) / 100 * Math.log(a[e].endValue / this.viewportMinimum) / Math.log(a[e].endValue / a[e].startValue)) : b - Math.min(a[e].spacing, 0.1 * b) * Math.log(a[e].endValue / this.viewportMinimum) / Math.log(a[e].endValue / a[e].startValue)) : this.viewportMinimum <= a[e].startValue && this.viewportMaximum < a[e].endValue && (c = c / this.viewportMaximum * a[e].startValue, b = 0 < a[e].spacing.toString().indexOf("%") ? b * (1 - parseFloat(a[e].spacing) / 100 * Math.log(this.viewportMaximum / a[e].startValue) / Math.log(a[e].endValue / a[e].startValue)) : b - Math.min(a[e].spacing, 0.1 * b) * Math.log(this.viewportMaximum / a[e].startValue) / Math.log(a[e].endValue / a[e].startValue)));
	      } else for (e = 0; e < a.length && !(this.viewportMaximum < a[e].startValue); e++) {
	        this.viewportMinimum > a[e].endValue || (this.viewportMinimum >= a[e].startValue && this.viewportMaximum <= a[e].endValue ? b = 0 : this.viewportMinimum <= a[e].startValue && this.viewportMaximum >= a[e].endValue ? (c = c - a[e].endValue + a[e].startValue, b = 0 < a[e].spacing.toString().indexOf("%") ? b * (1 - parseFloat(a[e].spacing) / 100) : b - Math.min(a[e].spacing, 0.1 * b)) : this.viewportMinimum > a[e].startValue && this.viewportMaximum >= a[e].endValue ? (c = c - a[e].endValue + this.viewportMinimum, b = 0 < a[e].spacing.toString().indexOf("%") ? b * (1 - parseFloat(a[e].spacing) / 100 * (a[e].endValue - this.viewportMinimum) / (a[e].endValue - a[e].startValue)) : b - Math.min(a[e].spacing, 0.1 * b) * (a[e].endValue - this.viewportMinimum) / (a[e].endValue - a[e].startValue)) : this.viewportMinimum <= a[e].startValue && this.viewportMaximum < a[e].endValue && (c = c - this.viewportMaximum + a[e].startValue, b = 0 < a[e].spacing.toString().indexOf("%") ? b * (1 - parseFloat(a[e].spacing) / 100 * (this.viewportMaximum - a[e].startValue) / (a[e].endValue - a[e].startValue)) : b - Math.min(a[e].spacing, 0.1 * b) * (this.viewportMaximum - a[e].startValue) / (a[e].endValue - a[e].startValue)));
	      }d.minimum = this.viewportMinimum;d.maximum = this.viewportMaximum;d.range = c;if ("bottom" === this._position || "top" === this._position) this.logarithmic ? (d.lnLogarithmBase = Math.log(this.logarithmBase), d.pixelPerUnit = (this.reversed ? -1 : 1) * b * d.lnLogarithmBase / Math.log(Math.abs(c))) : d.pixelPerUnit = (this.reversed ? -1 : 1) * b / Math.abs(c), d.reference = this.reversed ? this.lineCoordinates.x2 : this.lineCoordinates.x1;if ("left" === this._position || "right" === this._position) this.logarithmic ? (d.lnLogarithmBase = Math.log(this.logarithmBase), d.pixelPerUnit = (this.reversed ? 1 : -1) * b * d.lnLogarithmBase / Math.log(Math.abs(c))) : d.pixelPerUnit = (this.reversed ? 1 : -1) * b / Math.abs(c), d.reference = this.reversed ? this.lineCoordinates.y1 : this.lineCoordinates.y2;this.conversionParameters = d;
	    };z.prototype.calculateAxisParameters = function () {
	      if (this.logarithmic) this.calculateLogarithmicAxisParameters();else {
	        var a = this.chart.layoutManager.getFreeSpace(),
	            d = !1,
	            b = !1;"bottom" === this._position || "top" === this._position ? (this.maxWidth = a.width, this.maxHeight = a.height) : (this.maxWidth = a.height, this.maxHeight = a.width);var a = "axisX" === this.type ? "xySwapped" === this.chart.plotInfo.axisPlacement ? 62 : 70 : "xySwapped" === this.chart.plotInfo.axisPlacement ? 50 : 40,
	            c = 4;"axisX" === this.type && (c = 600 > this.maxWidth ? 8 : 6);var a = Math.max(c, Math.floor(this.maxWidth / a)),
	            e,
	            g,
	            k,
	            c = 0;!u(this.options.viewportMinimum) && !u(this.options.viewportMaximum) && this.options.viewportMinimum >= this.options.viewportMaximum && (this.viewportMinimum = this.viewportMaximum = null);if (u(this.options.viewportMinimum) && !u(this.sessionVariables.newViewportMinimum) && !isNaN(this.sessionVariables.newViewportMinimum)) this.viewportMinimum = this.sessionVariables.newViewportMinimum;else if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = this.minimum;if (u(this.options.viewportMaximum) && !u(this.sessionVariables.newViewportMaximum) && !isNaN(this.sessionVariables.newViewportMaximum)) this.viewportMaximum = this.sessionVariables.newViewportMaximum;else if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = this.maximum;if (this.scaleBreaks) for (c = 0; c < this.scaleBreaks._appliedBreaks.length; c++) {
	          if ((!u(this.sessionVariables.newViewportMinimum) && this.sessionVariables.newViewportMinimum >= this.scaleBreaks._appliedBreaks[c].startValue || !u(this.options.minimum) && this.options.minimum >= this.scaleBreaks._appliedBreaks[c].startValue || !u(this.options.viewportMinimum) && this.viewportMinimum >= this.scaleBreaks._appliedBreaks[c].startValue) && (!u(this.sessionVariables.newViewportMaximum) && this.sessionVariables.newViewportMaximum <= this.scaleBreaks._appliedBreaks[c].endValue || !u(this.options.maximum) && this.options.maximum <= this.scaleBreaks._appliedBreaks[c].endValue || !u(this.options.viewportMaximum) && this.viewportMaximum <= this.scaleBreaks._appliedBreaks[c].endValue)) {
	            this.scaleBreaks._appliedBreaks.splice(c, 1);break;
	          }
	        }if ("axisX" === this.type) {
	          if (this.dataSeries && 0 < this.dataSeries.length) for (e = 0; e < this.dataSeries.length; e++) {
	            "dateTime" === this.dataSeries[e].xValueType && (b = !0);
	          }e = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin;g = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax;0 === g - e && (c = "undefined" === typeof this.options.interval ? 0.4 : this.options.interval, g += c, e -= c);Infinity !== this.dataInfo.minDiff ? k = this.dataInfo.minDiff : 1 < g - e ? k = 0.5 * Math.abs(g - e) : (k = 1, b && (d = !0));
	        } else "axisY" === this.type && (e = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin, g = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax, isFinite(e) || isFinite(g) ? isFinite(e) ? isFinite(g) || (g = e) : e = g : (g = "undefined" === typeof this.options.interval ? -Infinity : this.options.interval, e = "undefined" !== typeof this.options.interval || isFinite(this.dataInfo.minDiff) ? 0 : Infinity), 0 === e && 0 === g ? (g += 9, e = 0) : 0 === g - e ? (c = Math.min(Math.abs(0.01 * Math.abs(g)), 5), g += c, e -= c) : e > g ? (c = Math.min(0.01 * Math.abs(this.getApparentDifference(g, e, null, !0)), 5), 0 <= g ? e = g - c : g = isFinite(e) ? e + c : 0) : (c = Math.min(0.01 * Math.abs(this.getApparentDifference(e, g, null, !0)), 0.05), 0 !== g && (g += c), 0 !== e && (e -= c)), k = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : 1 < g - e ? 0.5 * Math.abs(g - e) : 1, this.includeZero && (null === this.viewportMinimum || isNaN(this.viewportMinimum)) && 0 < e && (e = 0), this.includeZero && (null === this.viewportMaximum || isNaN(this.viewportMaximum)) && 0 > g && (g = 0));c = this.getApparentDifference(isNaN(this.viewportMinimum) || null === this.viewportMinimum ? e : this.viewportMinimum, isNaN(this.viewportMaximum) || null === this.viewportMaximum ? g : this.viewportMaximum, null, !0);if ("axisX" === this.type && b) {
	          this.intervalType || (c / 1 <= a ? (this.interval = 1, this.intervalType = "millisecond") : c / 2 <= a ? (this.interval = 2, this.intervalType = "millisecond") : c / 5 <= a ? (this.interval = 5, this.intervalType = "millisecond") : c / 10 <= a ? (this.interval = 10, this.intervalType = "millisecond") : c / 20 <= a ? (this.interval = 20, this.intervalType = "millisecond") : c / 50 <= a ? (this.interval = 50, this.intervalType = "millisecond") : c / 100 <= a ? (this.interval = 100, this.intervalType = "millisecond") : c / 200 <= a ? (this.interval = 200, this.intervalType = "millisecond") : c / 250 <= a ? (this.interval = 250, this.intervalType = "millisecond") : c / 300 <= a ? (this.interval = 300, this.intervalType = "millisecond") : c / 400 <= a ? (this.interval = 400, this.intervalType = "millisecond") : c / 500 <= a ? (this.interval = 500, this.intervalType = "millisecond") : c / (1 * S.secondDuration) <= a ? (this.interval = 1, this.intervalType = "second") : c / (2 * S.secondDuration) <= a ? (this.interval = 2, this.intervalType = "second") : c / (5 * S.secondDuration) <= a ? (this.interval = 5, this.intervalType = "second") : c / (10 * S.secondDuration) <= a ? (this.interval = 10, this.intervalType = "second") : c / (15 * S.secondDuration) <= a ? (this.interval = 15, this.intervalType = "second") : c / (20 * S.secondDuration) <= a ? (this.interval = 20, this.intervalType = "second") : c / (30 * S.secondDuration) <= a ? (this.interval = 30, this.intervalType = "second") : c / (1 * S.minuteDuration) <= a ? (this.interval = 1, this.intervalType = "minute") : c / (2 * S.minuteDuration) <= a ? (this.interval = 2, this.intervalType = "minute") : c / (5 * S.minuteDuration) <= a ? (this.interval = 5, this.intervalType = "minute") : c / (10 * S.minuteDuration) <= a ? (this.interval = 10, this.intervalType = "minute") : c / (15 * S.minuteDuration) <= a ? (this.interval = 15, this.intervalType = "minute") : c / (20 * S.minuteDuration) <= a ? (this.interval = 20, this.intervalType = "minute") : c / (30 * S.minuteDuration) <= a ? (this.interval = 30, this.intervalType = "minute") : c / (1 * S.hourDuration) <= a ? (this.interval = 1, this.intervalType = "hour") : c / (2 * S.hourDuration) <= a ? (this.interval = 2, this.intervalType = "hour") : c / (3 * S.hourDuration) <= a ? (this.interval = 3, this.intervalType = "hour") : c / (6 * S.hourDuration) <= a ? (this.interval = 6, this.intervalType = "hour") : c / (1 * S.dayDuration) <= a ? (this.interval = 1, this.intervalType = "day") : c / (2 * S.dayDuration) <= a ? (this.interval = 2, this.intervalType = "day") : c / (4 * S.dayDuration) <= a ? (this.interval = 4, this.intervalType = "day") : c / (1 * S.weekDuration) <= a ? (this.interval = 1, this.intervalType = "week") : c / (2 * S.weekDuration) <= a ? (this.interval = 2, this.intervalType = "week") : c / (3 * S.weekDuration) <= a ? (this.interval = 3, this.intervalType = "week") : c / (1 * S.monthDuration) <= a ? (this.interval = 1, this.intervalType = "month") : c / (2 * S.monthDuration) <= a ? (this.interval = 2, this.intervalType = "month") : c / (3 * S.monthDuration) <= a ? (this.interval = 3, this.intervalType = "month") : c / (6 * S.monthDuration) <= a ? (this.interval = 6, this.intervalType = "month") : (this.interval = c / (1 * S.yearDuration) <= a ? 1 : c / (2 * S.yearDuration) <= a ? 2 : c / (4 * S.yearDuration) <= a ? 4 : Math.floor(z.getNiceNumber(c / (a - 1), !0) / S.yearDuration), this.intervalType = "year"));if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = e - k / 2;if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = g + k / 2;d ? this.autoValueFormatString = "MMM DD YYYY HH:mm" : "year" === this.intervalType ? this.autoValueFormatString = "YYYY" : "month" === this.intervalType ? this.autoValueFormatString = "MMM YYYY" : "week" === this.intervalType ? this.autoValueFormatString = "MMM DD YYYY" : "day" === this.intervalType ? this.autoValueFormatString = "MMM DD YYYY" : "hour" === this.intervalType ? this.autoValueFormatString = "hh:mm TT" : "minute" === this.intervalType ? this.autoValueFormatString = "hh:mm TT" : "second" === this.intervalType ? this.autoValueFormatString = "hh:mm:ss TT" : "millisecond" === this.intervalType && (this.autoValueFormatString = "fff'ms'");this.valueFormatString || (this.valueFormatString = this.autoValueFormatString);
	        } else {
	          this.intervalType = "number";c = z.getNiceNumber(c, !1);this.interval = this.options && 0 < this.options.interval ? this.options.interval : z.getNiceNumber(c / (a - 1), !0);if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = "axisX" === this.type ? e - k / 2 : Math.floor(e / this.interval) * this.interval;if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = "axisX" === this.type ? g + k / 2 : Math.ceil(g / this.interval) * this.interval;0 === this.viewportMaximum && 0 === this.viewportMinimum && (0 === this.options.viewportMinimum ? this.viewportMaximum += 10 : 0 === this.options.viewportMaximum && (this.viewportMinimum -= 10), this.options && "undefined" === typeof this.options.interval && (this.interval = z.getNiceNumber((this.viewportMaximum - this.viewportMinimum) / (a - 1), !0)));
	        }if (null === this.minimum || null === this.maximum) if ("axisX" === this.type ? (e = null !== this.minimum ? this.minimum : this.dataInfo.min, g = null !== this.maximum ? this.maximum : this.dataInfo.max, 0 === g - e && (c = "undefined" === typeof this.options.interval ? 0.4 : this.options.interval, g += c, e -= c), k = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : 1 < g - e ? 0.5 * Math.abs(g - e) : 1) : "axisY" === this.type && (e = null !== this.minimum ? this.minimum : this.dataInfo.min, g = null !== this.maximum ? this.maximum : this.dataInfo.max, isFinite(e) || isFinite(g) ? 0 === e && 0 === g ? (g += 9, e = 0) : 0 === g - e ? (c = Math.min(Math.abs(0.01 * Math.abs(g)), 5), g += c, e -= c) : e > g ? (c = Math.min(0.01 * Math.abs(this.getApparentDifference(g, e, null, !0)), 5), 0 <= g ? e = g - c : g = isFinite(e) ? e + c : 0) : (c = Math.min(0.01 * Math.abs(this.getApparentDifference(e, g, null, !0)), 0.05), 0 !== g && (g += c), 0 !== e && (e -= c)) : (g = "undefined" === typeof this.options.interval ? -Infinity : this.options.interval, e = "undefined" !== typeof this.options.interval || isFinite(this.dataInfo.minDiff) ? 0 : Infinity), k = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : 1 < g - e ? 0.5 * Math.abs(g - e) : 1, this.includeZero && (null === this.minimum || isNaN(this.minimum)) && 0 < e && (e = 0), this.includeZero && (null === this.maximum || isNaN(this.maximum)) && 0 > g && (g = 0)), Math.abs(this.getApparentDifference(e, g, null, !0)), "axisX" === this.type && b) {
	          this.valueType = "dateTime";if (null === this.minimum || isNaN(this.minimum)) this.minimum = e - k / 2;if (null === this.maximum || isNaN(this.maximum)) this.maximum = g + k / 2;
	        } else this.intervalType = this.valueType = "number", null === this.minimum && (this.minimum = "axisX" === this.type ? e - k / 2 : Math.floor(e / this.interval) * this.interval, this.minimum = Math.min(this.minimum, null === this.sessionVariables.viewportMinimum || isNaN(this.sessionVariables.viewportMinimum) ? Infinity : this.sessionVariables.viewportMinimum)), null === this.maximum && (this.maximum = "axisX" === this.type ? g + k / 2 : Math.ceil(g / this.interval) * this.interval, this.maximum = Math.max(this.maximum, null === this.sessionVariables.viewportMaximum || isNaN(this.sessionVariables.viewportMaximum) ? -Infinity : this.sessionVariables.viewportMaximum)), 0 === this.maximum && 0 === this.minimum && (0 === this.options.minimum ? this.maximum += 10 : 0 === this.options.maximum && (this.minimum -= 10));u(this.sessionVariables.newViewportMinimum) && (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));u(this.sessionVariables.newViewportMaximum) && (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));this.range = this.viewportMaximum - this.viewportMinimum;this.intervalStartPosition = "axisX" === this.type && b ? this.getLabelStartPoint(new Date(this.viewportMinimum), this.intervalType, this.interval) : Math.floor((this.viewportMinimum + 0.2 * this.interval) / this.interval) * this.interval;this.valueFormatString || (this.valueFormatString = z.generateValueFormatString(this.range, 2));
	      }
	    };z.prototype.calculateLogarithmicAxisParameters = function () {
	      var a = this.chart.layoutManager.getFreeSpace(),
	          d = Math.log(this.logarithmBase),
	          b;"bottom" === this._position || "top" === this._position ? (this.maxWidth = a.width, this.maxHeight = a.height) : (this.maxWidth = a.height, this.maxHeight = a.width);var a = "axisX" === this.type ? 500 > this.maxWidth ? 7 : Math.max(7, Math.floor(this.maxWidth / 100)) : Math.max(Math.floor(this.maxWidth / 50), 3),
	          c,
	          e,
	          g,
	          k;k = 1;if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = this.minimum;if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = this.maximum;if (this.scaleBreaks) for (k = 0; k < this.scaleBreaks._appliedBreaks.length; k++) {
	        if ((!u(this.sessionVariables.newViewportMinimum) && this.sessionVariables.newViewportMinimum >= this.scaleBreaks._appliedBreaks[k].startValue || !u(this.options.minimum) && this.options.minimum >= this.scaleBreaks._appliedBreaks[k].startValue || !u(this.options.viewportMinimum) && this.viewportMinimum >= this.scaleBreaks._appliedBreaks[k].startValue) && (!u(this.sessionVariables.newViewportMaximum) && this.sessionVariables.newViewportMaximum <= this.scaleBreaks._appliedBreaks[k].endValue || !u(this.options.maximum) && this.options.maximum <= this.scaleBreaks._appliedBreaks[k].endValue || !u(this.options.viewportMaximum) && this.viewportMaximum <= this.scaleBreaks._appliedBreaks[k].endValue)) {
	          this.scaleBreaks._appliedBreaks.splice(k, 1);break;
	        }
	      }"axisX" === this.type ? (c = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin, e = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax, 1 === e / c && (k = Math.pow(this.logarithmBase, "undefined" === typeof this.options.interval ? 0.4 : this.options.interval), e *= k, c /= k), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : e / c > this.logarithmBase ? e / c * Math.pow(this.logarithmBase, 0.5) : this.logarithmBase) : "axisY" === this.type && (c = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin, e = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax, 0 >= c && !isFinite(e) ? (e = "undefined" === typeof this.options.interval ? 0 : this.options.interval, c = 1) : 0 >= c ? c = e : isFinite(e) || (e = c), 1 === c && 1 === e ? (e *= this.logarithmBase - 1 / this.logarithmBase, c = 1) : 1 === e / c ? (k = Math.min(e * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 5)), e *= k, c /= k) : c > e ? (k = Math.min(c / e * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 5)), 1 <= e ? c = e / k : e = c * k) : (k = Math.min(e / c * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 0.04)), 1 !== e && (e *= k), 1 !== c && (c /= k)), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : e / c > this.logarithmBase ? e / c * Math.pow(this.logarithmBase, 0.5) : this.logarithmBase, this.includeZero && (null === this.viewportMinimum || isNaN(this.viewportMinimum)) && 1 < c && (c = 1), this.includeZero && (null === this.viewportMaximum || isNaN(this.viewportMaximum)) && 1 > e && (e = 1));k = (isNaN(this.viewportMaximum) || null === this.viewportMaximum ? e : this.viewportMaximum) / (isNaN(this.viewportMinimum) || null === this.viewportMinimum ? c : this.viewportMinimum);var l = (isNaN(this.viewportMaximum) || null === this.viewportMaximum ? e : this.viewportMaximum) - (isNaN(this.viewportMinimum) || null === this.viewportMinimum ? c : this.viewportMinimum);this.intervalType = "number";k = Math.pow(this.logarithmBase, z.getNiceNumber(Math.abs(Math.log(k) / d), !1));this.options && 0 < this.options.interval ? this.interval = this.options.interval : (this.interval = z.getNiceExponent(Math.log(k) / d / (a - 1), !0), b = z.getNiceNumber(l / (a - 1), !0));if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = "axisX" === this.type ? c / Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.floor(Math.log(c) / d / this.interval));if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = "axisX" === this.type ? e * Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.ceil(Math.log(e) / d / this.interval));1 === this.viewportMaximum && 1 === this.viewportMinimum && (1 === this.options.viewportMinimum ? this.viewportMaximum *= this.logarithmBase - 1 / this.logarithmBase : 1 === this.options.viewportMaximum && (this.viewportMinimum /= this.logarithmBase - 1 / this.logarithmBase), this.options && "undefined" === typeof this.options.interval && (this.interval = z.getNiceExponent(Math.ceil(Math.log(k) / d) / (a - 1)), b = z.getNiceNumber((this.viewportMaximum - this.viewportMinimum) / (a - 1), !0)));if (null === this.minimum || null === this.maximum) "axisX" === this.type ? (c = null !== this.minimum ? this.minimum : this.dataInfo.min, e = null !== this.maximum ? this.maximum : this.dataInfo.max, 1 === e / c && (k = Math.pow(this.logarithmBase, "undefined" === typeof this.options.interval ? 0.4 : this.options.interval), e *= k, c /= k), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : e / c > this.logarithmBase ? e / c * Math.pow(this.logarithmBase, 0.5) : this.logarithmBase) : "axisY" === this.type && (c = null !== this.minimum ? this.minimum : this.dataInfo.min, e = null !== this.maximum ? this.maximum : this.dataInfo.max, isFinite(c) || isFinite(e) ? 1 === c && 1 === e ? (e *= this.logarithmBase, c /= this.logarithmBase) : 1 === e / c ? (k = Math.pow(this.logarithmBase, this.interval), e *= k, c /= k) : c > e ? (k = Math.min(0.01 * (c / e), 5), 1 <= e ? c = e / k : e = c * k) : (k = Math.min(e / c * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 0.04)), 1 !== e && (e *= k), 1 !== c && (c /= k)) : (e = "undefined" === typeof this.options.interval ? 0 : this.options.interval, c = 1), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : e / c > this.logarithmBase ? e / c * Math.pow(this.logarithmBase, 0.5) : this.logarithmBase, this.includeZero && (null === this.minimum || isNaN(this.minimum)) && 1 < c && (c = 1), this.includeZero && (null === this.maximum || isNaN(this.maximum)) && 1 > e && (e = 1)), this.intervalType = "number", null === this.minimum && (this.minimum = "axisX" === this.type ? c / Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.floor(Math.log(c) / d / this.interval)), this.minimum = Math.min(this.minimum, null === this.sessionVariables.viewportMinimum || isNaN(this.sessionVariables.viewportMinimum) ? "undefined" === typeof this.sessionVariables.newViewportMinimum ? Infinity : this.sessionVariables.newViewportMinimum : this.sessionVariables.viewportMinimum)), null === this.maximum && (this.maximum = "axisX" === this.type ? e * Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.ceil(Math.log(e) / d / this.interval)), this.maximum = Math.max(this.maximum, null === this.sessionVariables.viewportMaximum || isNaN(this.sessionVariables.viewportMaximum) ? "undefined" === typeof this.sessionVariables.newViewportMaximum ? 0 : this.sessionVariables.newViewportMaximum : this.sessionVariables.viewportMaximum)), 1 === this.maximum && 1 === this.minimum && (1 === this.options.minimum ? this.maximum *= this.logarithmBase - 1 / this.logarithmBase : 1 === this.options.maximum && (this.minimum /= this.logarithmBase - 1 / this.logarithmBase));this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum);this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum);this.viewportMinimum > this.viewportMaximum && (!this.options.viewportMinimum && !this.options.minimum || this.options.viewportMaximum || this.options.maximum ? this.options.viewportMinimum || this.options.minimum || !this.options.viewportMaximum && !this.options.maximum || (this.viewportMinimum = this.minimum = (this.options.viewportMaximum || this.options.maximum) / Math.pow(this.logarithmBase, 2 * Math.ceil(this.interval))) : this.viewportMaximum = this.maximum = this.options.viewportMinimum || this.options.minimum);c = Math.pow(this.logarithmBase, Math.floor(Math.log(this.viewportMinimum) / (d * this.interval) + 0.2) * this.interval);this.range = this.viewportMaximum / this.viewportMinimum;this.noTicks = a;if (!this.options.interval && this.range < Math.pow(this.logarithmBase, 8 > this.viewportMaximum || 3 > a ? 2 : 3)) {
	        for (d = Math.floor(this.viewportMinimum / b + 0.5) * b; d < this.viewportMinimum;) {
	          d += b;
	        }this.equidistantInterval = !1;this.intervalStartPosition = d;this.interval = b;
	      } else this.options.interval || (b = Math.ceil(this.interval), this.range > this.interval && (this.interval = b, c = Math.pow(this.logarithmBase, Math.floor(Math.log(this.viewportMinimum) / (d * this.interval) + 0.2) * this.interval))), this.equidistantInterval = !0, this.intervalStartPosition = c;if (!this.valueFormatString && (this.valueFormatString = "#,##0.##", 1 > this.viewportMinimum)) {
	        d = Math.floor(Math.abs(Math.log(this.viewportMinimum) / Math.LN10)) + 2;if (isNaN(d) || !isFinite(d)) d = 2;if (2 < d) for (k = 0; k < d - 2; k++) {
	          this.valueFormatString += "#";
	        }
	      }
	    };z.generateValueFormatString = function (a, d) {
	      var b = "#,##0.",
	          c = d;1 > a && (c += Math.floor(Math.abs(Math.log(a) / Math.LN10)), isNaN(c) || !isFinite(c)) && (c = d);for (var e = 0; e < c; e++) {
	        b += "#";
	      }return b;
	    };z.getNiceExponent = function (a, d) {
	      var b = Math.floor(Math.log(a) / Math.LN10),
	          c = a / Math.pow(10, b),
	          c = 0 > b ? 1 >= c ? 1 : 5 >= c ? 5 : 10 : Math.max(Math.floor(c), 1);return -20 > b ? Number(c * Math.pow(10, b)) : Number((c * Math.pow(10, b)).toFixed(20));
	    };z.getNiceNumber = function (a, d) {
	      var b = Math.floor(Math.log(a) / Math.LN10),
	          c = a / Math.pow(10, b),
	          c = d ? 1.5 > c ? 1 : 3 > c ? 2 : 7 > c ? 5 : 10 : 1 >= c ? 1 : 2 >= c ? 2 : 5 >= c ? 5 : 10;return -20 > b ? Number(c * Math.pow(10, b)) : Number((c * Math.pow(10, b)).toFixed(20));
	    };z.prototype.getLabelStartPoint = function () {
	      var a = S[this.intervalType + "Duration"] * this.interval,
	          a = new Date(Math.floor(this.viewportMinimum / a) * a);if ("millisecond" !== this.intervalType) if ("second" === this.intervalType) 0 < a.getMilliseconds() && (a.setSeconds(a.getSeconds() + 1), a.setMilliseconds(0));else if ("minute" === this.intervalType) {
	        if (0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setMinutes(a.getMinutes() + 1), a.setSeconds(0), a.setMilliseconds(0);
	      } else if ("hour" === this.intervalType) {
	        if (0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setHours(a.getHours() + 1), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0);
	      } else if ("day" === this.intervalType) {
	        if (0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setDate(a.getDate() + 1), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0);
	      } else if ("week" === this.intervalType) {
	        if (0 < a.getDay() || 0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setDate(a.getDate() + (7 - a.getDay())), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0);
	      } else if ("month" === this.intervalType) {
	        if (1 < a.getDate() || 0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setMonth(a.getMonth() + 1), a.setDate(1), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0);
	      } else "year" === this.intervalType && (0 < a.getMonth() || 1 < a.getDate() || 0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) && (a.setFullYear(a.getFullYear() + 1), a.setMonth(0), a.setDate(1), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0));return a;
	    };qa(Q, V);qa(L, V);L.prototype.createUserOptions = function (a) {
	      if ("undefined" !== typeof a || this.options._isPlaceholder) {
	        var d = 0;this.parent.options._isPlaceholder && this.parent.createUserOptions();this.options._isPlaceholder || (Fa(this.parent[this.optionsName]), d = this.parent.options[this.optionsName].indexOf(this.options));
	        this.options = "undefined" === typeof a ? {} : a;this.parent.options[this.optionsName][d] = this.options;
	      }
	    };L.prototype.render = function (a) {
	      if (0 !== this.spacing || 0 !== this.options.lineThickness && ("undefined" !== typeof this.options.lineThickness || 0 !== this.parent.lineThickness)) {
	        var d = this.ctx,
	            b = this.ctx.globalAlpha;this.ctx = a || this.ctx;this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1, this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height);this.ctx.clip();var c = this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.startValue),
	            e = this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.endValue);this.ctx.strokeStyle = this.lineColor;this.ctx.fillStyle = this.color;this.ctx.beginPath();this.ctx.globalAlpha = 1;N(this.id);var g, k, l, h, m, p;a = Math.max(this.spacing, 3);var q = Math.max(0, this.lineThickness);this.ctx.lineWidth = q;this.ctx.setLineDash && this.ctx.setLineDash(R(this.lineDashType, q));if ("bottom" === this.scaleBreaks.parent._position || "top" === this.scaleBreaks.parent._position) {
	          if (c = 1 === q % 2 ? (c.x << 0) + 0.5 : c.x << 0, k = 1 === q % 2 ? (e.x << 0) + 0.5 : e.x << 0, "top" === this.scaleBreaks.parent._position ? (e = this.chart.plotArea.y1, l = this.chart.plotArea.y2 + q / 2 + 0.5 << 0) : (e = this.chart.plotArea.y2, l = this.chart.plotArea.y1 - q / 2 + 0.5 << 0, a *= -1), this.bounds = { x1: c - q / 2, y1: e, x2: k + q / 2, y2: l }, this.ctx.moveTo(c, e), "straight" === this.type || "top" === this.scaleBreaks.parent._position && 0 >= a || "bottom" === this.scaleBreaks.parent._position && 0 <= a) this.ctx.lineTo(c, l), this.ctx.lineTo(k, l), this.ctx.lineTo(k, e);else if ("wavy" === this.type) {
	            h = c;m = e;g = 0.5;p = (l - m) / a / 3;for (var n = 0; n < p; n++) {
	              this.ctx.bezierCurveTo(h + g * a, m + a, h + g * a, m + 2 * a, h, m + 3 * a), m += 3 * a, g *= -1;
	            }this.ctx.bezierCurveTo(h + g * a, m + a, h + g * a, m + 2 * a, h, m + 3 * a);h = k;g *= -1;this.ctx.lineTo(h, m);for (n = 0; n < p; n++) {
	              this.ctx.bezierCurveTo(h + g * a, m - a, h + g * a, m - 2 * a, h, m - 3 * a), m -= 3 * a, g *= -1;
	            }
	          } else {
	            if ("zigzag" === this.type) {
	              g = -1;m = e + a;h = c + a;p = (l - m) / a / 2;for (n = 0; n < p; n++) {
	                this.ctx.lineTo(h, m), h += 2 * g * a, m += 2 * a, g *= -1;
	              }this.ctx.lineTo(h, m);h += k - c;for (n = 0; n < p + 1; n++) {
	                this.ctx.lineTo(h, m), h += 2 * g * a, m -= 2 * a, g *= -1;
	              }this.ctx.lineTo(h + g * a, m + a);
	            }
	          }
	        } else if ("left" === this.scaleBreaks.parent._position || "right" === this.scaleBreaks.parent._position) if (e = 1 === q % 2 ? (e.y << 0) + 0.5 : e.y << 0, l = 1 === q % 2 ? (c.y << 0) + 0.5 : c.y << 0, "left" === this.scaleBreaks.parent._position ? (c = this.chart.plotArea.x1, k = this.chart.plotArea.x2 + q / 2 + 0.5 << 0) : (c = this.chart.plotArea.x2, k = this.chart.plotArea.x1 - q / 2 + 0.5 << 0, a *= -1), this.bounds = { x1: c, y1: e - q / 2, x2: k, y2: l + q / 2 }, this.ctx.moveTo(c, e), "straight" === this.type || "left" === this.scaleBreaks.parent._position && 0 >= a || "right" === this.scaleBreaks.parent._position && 0 <= a) this.ctx.lineTo(k, e), this.ctx.lineTo(k, l), this.ctx.lineTo(c, l);else if ("wavy" === this.type) {
	          h = c;m = e;g = 0.5;p = (k - h) / a / 3;for (n = 0; n < p; n++) {
	            this.ctx.bezierCurveTo(h + a, m + g * a, h + 2 * a, m + g * a, h + 3 * a, m), h += 3 * a, g *= -1;
	          }this.ctx.bezierCurveTo(h + a, m + g * a, h + 2 * a, m + g * a, h + 3 * a, m);m = l;g *= -1;this.ctx.lineTo(h, m);for (n = 0; n < p; n++) {
	            this.ctx.bezierCurveTo(h - a, m + g * a, h - 2 * a, m + g * a, h - 3 * a, m), h -= 3 * a, g *= -1;
	          }
	        } else if ("zigzag" === this.type) {
	          g = 1;m = e - a;h = c + a;p = (k - h) / a / 2;for (n = 0; n < p; n++) {
	            this.ctx.lineTo(h, m), m += 2 * g * a, h += 2 * a, g *= -1;
	          }this.ctx.lineTo(h, m);m += l - e;for (n = 0; n < p + 1; n++) {
	            this.ctx.lineTo(h, m), m += 2 * g * a, h -= 2 * a, g *= -1;
	          }this.ctx.lineTo(h + a, m + g * a);
	        }0 < q && this.ctx.stroke();this.ctx.closePath();this.ctx.globalAlpha = this.fillOpacity;this.ctx.globalCompositeOperation = "destination-over";this.ctx.fill();this.ctx.restore();this.ctx.globalAlpha = b;this.ctx = d;
	      }
	    };qa(X, V);X.prototype.createUserOptions = function (a) {
	      if ("undefined" !== typeof a || this.options._isPlaceholder) {
	        var d = 0;this.parent.options._isPlaceholder && this.parent.createUserOptions();this.options._isPlaceholder || (Fa(this.parent.stripLines), d = this.parent.options.stripLines.indexOf(this.options));
	        this.options = "undefined" === typeof a ? {} : a;this.parent.options.stripLines[d] = this.options;
	      }
	    };X.prototype.render = function () {
	      this.ctx.save();var a = this.parent.getPixelCoordinatesOnAxis(this.value),
	          d = Math.abs("pixel" === this._thicknessType ? this.thickness : this.parent.conversionParameters.pixelPerUnit * this.thickness);if (0 < d) {
	        var b = null === this.opacity ? 1 : this.opacity;this.ctx.strokeStyle = this.color;this.ctx.beginPath();var c = this.ctx.globalAlpha;this.ctx.globalAlpha = b;N(this.id);var e, g, k, l;this.ctx.lineWidth = d;this.ctx.setLineDash && this.ctx.setLineDash(R(this.lineDashType, d));if ("bottom" === this.parent._position || "top" === this.parent._position) e = g = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0, k = this.chart.plotArea.y1, l = this.chart.plotArea.y2, this.bounds = { x1: e - d / 2, y1: k, x2: g + d / 2, y2: l };else if ("left" === this.parent._position || "right" === this.parent._position) k = l = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0, e = this.chart.plotArea.x1, g = this.chart.plotArea.x2, this.bounds = { x1: e, y1: k - d / 2, x2: g, y2: l + d / 2 };this.ctx.moveTo(e, k);this.ctx.lineTo(g, l);this.ctx.stroke();this.ctx.globalAlpha = c;
	      }this.ctx.restore();
	    };qa(fa, V);fa.prototype.render = function (a, d) {
	      var b,
	          c,
	          e,
	          g,
	          k = null,
	          l = k = null,
	          h = "";if (!this.valueFormatString) if ("dateTime" === this.parent.valueType) this.valueFormatString = this.parent.valueFormatString;else {
	        var m = 0,
	            m = "xySwapped" === this.chart.plotInfo.axisPlacement ? 50 < this.parent.range ? 0 : 500 < this.chart.width && 25 > this.parent.range ? 2 : Math.floor(Math.abs(Math.log(this.parent.range) / Math.LN10)) + (5 > this.parent.range ? 2 : 10 > this.parent.range ? 1 : 0) : 50 < this.parent.range ? 0 : Math.floor(Math.abs(Math.log(this.parent.range) / Math.LN10)) + (5 > this.parent.range ? 2 : 10 > this.parent.range ? 1 : 0);this.valueFormatString = z.generateValueFormatString(this.parent.range, m);
	      }var l = null === this.opacity ? 1 : this.opacity,
	          m = Math.abs("pixel" === this._thicknessType ? this.thickness : this.parent.conversionParameters.pixelPerUnit * this.thickness),
	          p = this.chart.overlaidCanvasCtx,
	          q = p.globalAlpha;p.globalAlpha = l;p.beginPath();p.strokeStyle = this.color;p.lineWidth = m;p.save();this.labelFontSize = u(this.options.labelFontSize) ? this.parent.labelFontSize : this.labelFontSize;if ("left" === this.parent._position || "right" === this.parent._position) this.labelMaxWidth = u(this.options.labelMaxWidth) ? this.parent.bounds.x2 - this.parent.bounds.x1 : this.labelMaxWidth, this.labelMaxHeight = u(this.options.labelWrap) || this.labelWrap ? 3 * this.chart.height : 2 * this.labelFontSize;else if ("top" === this.parent._position || "bottom" === this.parent._position) this.labelMaxWidth = u(this.options.labelMaxWidth) ? 3 * this.chart.width : this.labelMaxWidth, this.labelMaxHeight = u(this.options.labelWrap) || this.labelWrap ? this.parent.bounds.height : 2 * this.labelFontSize;0 < m && p.setLineDash && p.setLineDash(R(this.lineDashType, m));l = new ka(p, { x: 0, y: 0, padding: { top: 2, right: 3, bottom: 2, left: 4 }, backgroundColor: this.labelBackgroundColor, borderColor: this.labelBorderColor, borderThickness: this.labelBorderThickness, cornerRadius: this.labelCornerRadius, maxWidth: this.labelMaxWidth, maxHeight: this.labelMaxHeight, angle: this.labelAngle, text: h, horizontalAlign: "left", fontSize: this.labelFontSize,
	        fontFamily: this.labelFontFamily, fontWeight: this.labelFontWeight, fontColor: this.labelFontColor, fontStyle: this.labelFontStyle, textBaseline: "middle" });if (this.snapToDataPoint) {
	        var n = 0,
	            k = [];if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
	          var f = null;if ("bottom" === this.parent._position || "top" === this.parent._position) n = this.parent.dataSeries[0].axisX.convertPixelToValue({ y: d });else if ("left" === this.parent._position || "right" === this.parent._position) n = this.parent.convertPixelToValue({ y: d });for (var r = 0; r < this.parent.dataSeries.length; r++) {
	            (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (f.dataSeries = this.parent.dataSeries[r], null !== f.dataPoint.y && k.push(f));
	          }f = null;if (0 === k.length) return;k.sort(function (a, b) {
	            return a.distance - b.distance;
	          });f = Math.abs(a - this.parent.convertValueToPixel(k[0].dataPoint.y));r = 0;if ("rangeBar" === k[0].dataSeries.type || "error" === k[0].dataSeries.type) for (var f = Math.abs(a - this.parent.convertValueToPixel(k[r].dataPoint.y[0])), v = 0, n = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(a - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else v = Math.abs(a - this.parent.convertValueToPixel(k[n].dataPoint.y)), v < f && (f = v, r = n);
	          } else if ("stackedBar" === k[0].dataSeries.type) for (var f = Math.abs(a - this.parent.convertValueToPixel(k[0].dataPoint.y)), D = v = 0, n = r = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(a - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else D += k[n].dataPoint.y, v = Math.abs(a - this.parent.convertValueToPixel(D)), v < f && (f = v, r = n);
	          } else if ("stackedBar100" === k[0].dataSeries.type) for (var f = Math.abs(a - this.parent.convertValueToPixel(k[0].dataPoint.y)), t = D = v = 0, n = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(a - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else D += k[n].dataPoint.y, t = k[n].dataPoint.x.getTime ? k[n].dataPoint.x.getTime() : k[n].dataPoint.x, t = 100 * (D / k[n].dataSeries.plotUnit.dataPointYSums[t]), v = Math.abs(a - this.parent.convertValueToPixel(t)), v < f && (f = v, r = n);
	          } else for (f = Math.abs(a - this.parent.convertValueToPixel(k[0].dataPoint.y)), n = r = v = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(a - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else v = Math.abs(a - this.parent.convertValueToPixel(k[n].dataPoint.y)), v < f && (f = v, r = n);
	          }h = k[r];if ("bottom" === this.parent._position || "top" === this.parent._position) {
	            b = 0;if ("rangeBar" === this.parent.dataSeries[r].type || "error" === this.parent.dataSeries[r].type) {
	              f = Math.abs(a - this.parent.convertValueToPixel(h.dataPoint.y[0]));for (n = v = 0; n < h.dataPoint.y.length; n++) {
	                v = Math.abs(a - this.parent.convertValueToPixel(h.dataPoint.y[n])), v < f && (f = v, b = n);
	              }k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataPoint.y[b]) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataPoint.y[b]) << 0;l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart,
	                axis: this.parent.options, crosshair: this.options, value: h.dataPoint.y[b] }) : u(this.options.label) ? ba(h.dataPoint.y[b], this.valueFormatString, this.chart._cultureInfo) : this.label;
	            } else if ("stackedBar" === this.parent.dataSeries[r].type) {
	              f = Math.abs(a - this.parent.convertValueToPixel(k[0].dataPoint.y));D = v = 0;for (n = r; 0 <= n; n--) {
	                D += k[n].dataPoint.y, v = Math.abs(a - this.parent.convertValueToPixel(D)), v < f && (f = v, b = n);
	              }k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(D) << 0) + 0.5 : this.parent.convertValueToPixel(D) << 0;
	              l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.y }) : u(this.options.label) ? ba(h.dataPoint.y, this.valueFormatString, this.chart._cultureInfo) : this.label;
	            } else if ("stackedBar100" === this.parent.dataSeries[r].type) {
	              f = Math.abs(a - this.parent.convertValueToPixel(k[0].dataPoint.y));t = D = v = 0;for (n = r; 0 <= n; n--) {
	                D += k[n].dataPoint.y, t = k[n].dataPoint.x.getTime ? k[n].dataPoint.x.getTime() : k[n].dataPoint.x, t = 100 * (D / k[n].dataSeries.plotUnit.dataPointYSums[t]), v = Math.abs(a - this.parent.convertValueToPixel(t)), v < f && (f = v, b = n);
	              }k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(t) << 0) + 0.5 : this.parent.convertValueToPixel(t) << 0;l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: t }) : u(this.options.label) ? ba(t, this.valueFormatString, this.chart._cultureInfo) : this.label;
	            } else k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataPoint.y) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataPoint.y) << 0, l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.y }) : u(this.options.label) ? ba(h.dataPoint.y, this.valueFormatString, this.chart._cultureInfo) : this.label;b = c = k;e = this.chart.plotArea.y1;g = this.chart.plotArea.y2;this.bounds = { x1: b - m / 2, y1: e, x2: c + m / 2, y2: g };l.x = b - l.measureText().width / 2;l.x + l.width > this.chart.bounds.x2 ? l.x = this.chart.bounds.x2 - l.width : l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1);l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2;
	          } else if ("left" === this.parent._position || "right" === this.parent._position) {
	            e = g = k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataPoint.x) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataPoint.x) << 0;b = this.chart.plotArea.x1;c = this.chart.plotArea.x2;this.bounds = { x1: b, y1: e - m / 2, x2: c, y2: g + m / 2 };t = !1;if (this.parent.labels) for (k = Math.ceil(this.parent.interval), n = 0; n < this.parent.viewportMaximum; n += k) {
	              if (this.parent.labels[n]) t = !0;else {
	                t = !1;break;
	              }
	            }if (t) {
	              if ("axisX" === this.parent.type) for (n = this.parent.convertPixelToValue({ y: d }), f = null, r = 0; r < this.parent.dataSeries.length; r++) {
	                (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.x }) : u(this.options.label) ? f.dataPoint.label : this.label);
	              }
	            } else "dateTime" === this.parent.valueType ? l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.x }) : u(this.options.label) ? Ca(h.dataPoint.x, this.valueFormatString, this.chart._cultureInfo) : this.label : "number" === this.parent.valueType && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.x }) : u(this.options.label) ? ba(h.dataPoint.x, this.valueFormatString, this.chart._cultureInfo) : this.label);l.y = g + l.fontSize / 2 - l.measureText().height / 2 + 2;l.y - l.fontSize / 2 < this.chart.bounds.y1 ? l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2 : l.y + l.measureText().height - l.fontSize / 2 > this.chart.bounds.y2 && (l.y = this.chart.bounds.y2 - l.measureText().height + l.fontSize / 2);"left" === this.parent._position ? l.x = this.parent.lineCoordinates.x2 - l.measureText().width : "right" === this.parent._position && (l.x = this.parent.lineCoordinates.x2);
	          }
	        } else if ("bottom" === this.parent._position || "top" === this.parent._position) {
	          n = this.parent.convertPixelToValue({ x: a });for (r = 0; r < this.parent.dataSeries.length; r++) {
	            (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (f.dataSeries = this.parent.dataSeries[r], null !== f.dataPoint.y && k.push(f));
	          }if (0 === k.length) return;k.sort(function (a, b) {
	            return a.distance - b.distance;
	          });h = k[0];b = c = k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataPoint.x) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataPoint.x) << 0;e = this.chart.plotArea.y1;g = this.chart.plotArea.y2;this.bounds = { x1: b - m / 2, y1: e, x2: c + m / 2, y2: g };t = !1;if (this.parent.labels) for (k = Math.ceil(this.parent.interval), n = 0; n < this.parent.viewportMaximum; n += k) {
	            if (this.parent.labels[n]) t = !0;else {
	              t = !1;break;
	            }
	          }if (t) {
	            if ("axisX" === this.parent.type) for (n = this.parent.convertPixelToValue({ x: a }), f = null, r = 0; r < this.parent.dataSeries.length; r++) {
	              (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.x }) : u(this.options.label) ? f.dataPoint.label : this.label);
	            }
	          } else "dateTime" === this.parent.valueType ? l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options,
	            value: h.dataPoint.x }) : u(this.options.label) ? Ca(h.dataPoint.x, this.valueFormatString, this.chart._cultureInfo) : this.label : "number" === this.parent.valueType && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.x }) : u(this.options.label) ? ba(h.dataPoint.x, this.valueFormatString, this.chart._cultureInfo) : this.label);l.x = b - l.measureText().width / 2;l.x + l.width > this.chart.bounds.x2 && (l.x = this.chart.bounds.x2 - l.width);l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1);"bottom" === this.parent._position ? l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2 : "top" === this.parent._position && (l.y = this.parent.lineCoordinates.y1 - l.height + l.fontSize / 2 + 2);
	        } else if ("left" === this.parent._position || "right" === this.parent._position) {
	          !u(this.parent.dataSeries) && 0 < this.parent.dataSeries.length && (n = this.parent.dataSeries[0].axisX.convertPixelToValue({ x: a }));for (r = 0; r < this.parent.dataSeries.length; r++) {
	            (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (f.dataSeries = this.parent.dataSeries[r], null !== f.dataPoint.y && k.push(f));
	          }if (0 === k.length) return;k.sort(function (a, b) {
	            return a.distance - b.distance;
	          });r = 0;if ("rangeColumn" === k[0].dataSeries.type || "rangeArea" === k[0].dataSeries.type || "error" === k[0].dataSeries.type || "rangeSplineArea" === k[0].dataSeries.type || "candlestick" === k[0].dataSeries.type || "ohlc" === k[0].dataSeries.type || "boxAndWhisker" === k[0].dataSeries.type) for (f = Math.abs(d - this.parent.convertValueToPixel(k[0].dataPoint.y[0])), n = v = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(d - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else v = Math.abs(d - this.parent.convertValueToPixel(k[n].dataPoint.y)), v < f && (f = v, r = n);
	          } else if ("stackedColumn" === k[0].dataSeries.type || "stackedArea" === k[0].dataSeries.type) for (f = Math.abs(d - this.parent.convertValueToPixel(k[0].dataPoint.y)), n = D = v = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(d - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else D += k[n].dataPoint.y, v = Math.abs(d - this.parent.convertValueToPixel(D)), v < f && (f = v, r = n);
	          } else if ("stackedColumn100" === k[0].dataSeries.type || "stackedArea100" === k[0].dataSeries.type) for (f = Math.abs(d - this.parent.convertValueToPixel(k[0].dataPoint.y)), n = t = D = v = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(d - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else D += k[n].dataPoint.y, t = k[n].dataPoint.x.getTime ? k[n].dataPoint.x.getTime() : k[n].dataPoint.x, t = 100 * (D / k[n].dataSeries.plotUnit.dataPointYSums[t]), v = Math.abs(d - this.parent.convertValueToPixel(t)), v < f && (f = v, r = n);
	          } else for (f = Math.abs(d - this.parent.convertValueToPixel(k[0].dataPoint.y)), n = v = 0; n < k.length; n++) {
	            if (k[n].dataPoint.y && k[n].dataPoint.y.length) for (h = 0; h < k[n].dataPoint.y.length; h++) {
	              v = Math.abs(d - this.parent.convertValueToPixel(k[n].dataPoint.y[h])), v < f && (f = v, r = n);
	            } else v = Math.abs(d - this.parent.convertValueToPixel(k[n].dataPoint.y)), v < f && (f = v, r = n);
	          }h = k[r];b = 0;if ("rangeColumn" === this.parent.dataSeries[r].type || "rangeArea" === this.parent.dataSeries[r].type || "error" === this.parent.dataSeries[r].type || "rangeSplineArea" === this.parent.dataSeries[r].type || "candlestick" === this.parent.dataSeries[r].type || "ohlc" === this.parent.dataSeries[r].type || "boxAndWhisker" === this.parent.dataSeries[r].type) {
	            f = Math.abs(d - this.parent.convertValueToPixel(h.dataPoint.y[0]));for (n = v = 0; n < h.dataPoint.y.length; n++) {
	              v = Math.abs(d - this.parent.convertValueToPixel(h.dataPoint.y[n])), v < f && (f = v, b = n);
	            }k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataPoint.y[b]) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataPoint.y[b]) << 0;l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.y[b] }) : u(this.options.label) ? ba(h.dataPoint.y[b], this.valueFormatString, this.chart._cultureInfo) : this.label;
	          } else if ("stackedColumn" === this.parent.dataSeries[r].type || "stackedArea" === this.parent.dataSeries[r].type) {
	            f = Math.abs(d - this.parent.convertValueToPixel(k[0].dataPoint.y));D = v = 0;for (n = r; 0 <= n; n--) {
	              D += k[n].dataPoint.y, v = Math.abs(d - this.parent.convertValueToPixel(D)), v < f && (f = v, b = n);
	            }k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(D) << 0) + 0.5 : this.parent.convertValueToPixel(D) << 0;l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.y }) : u(this.options.label) ? ba(h.dataPoint.y, this.valueFormatString, this.chart._cultureInfo) : this.label;
	          } else if ("stackedColumn100" === this.parent.dataSeries[r].type || "stackedArea100" === this.parent.dataSeries[r].type) {
	            f = Math.abs(d - this.parent.convertValueToPixel(k[0].dataPoint.y));D = v = 0;for (n = r; 0 <= n; n--) {
	              D += k[n].dataPoint.y, t = k[n].dataPoint.x.getTime ? k[n].dataPoint.x.getTime() : k[n].dataPoint.x, t = 100 * (D / k[n].dataSeries.plotUnit.dataPointYSums[t]), v = Math.abs(d - this.parent.convertValueToPixel(t)), v < f && (f = v, b = n);
	            }k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(t) << 0) + 0.5 : this.parent.convertValueToPixel(t) << 0;l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: t }) : u(this.options.label) ? ba(t, this.valueFormatString, this.chart._cultureInfo) : this.label;
	          } else "waterfall" === this.parent.dataSeries[r].type ? (k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataSeries.dataPointEOs[h.index].cumulativeSum) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataSeries.dataPointEOs[h.index].cumulativeSum) << 0, l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options,
	            crosshair: this.options, value: h.dataSeries.dataPointEOs[h.index].cumulativeSum }) : u(this.options.label) ? ba(h.dataSeries.dataPointEOs[h.index].cumulativeSum, this.valueFormatString, this.chart._cultureInfo) : this.label) : (k = 1 === p.lineWidth % 2 ? (this.parent.convertValueToPixel(h.dataPoint.y) << 0) + 0.5 : this.parent.convertValueToPixel(h.dataPoint.y) << 0, l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: h.dataPoint.y }) : u(this.options.label) ? ba(h.dataPoint.y, this.valueFormatString, this.chart._cultureInfo) : this.label);e = g = k;b = this.chart.plotArea.x1;c = this.chart.plotArea.x2;this.bounds = { x1: b, y1: e - m / 2, x2: c, y2: g + m / 2 };l.y = g + l.fontSize / 2 - l.measureText().height / 2 + 2;l.y - l.fontSize / 2 < this.chart.bounds.y1 ? l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2 : l.y + l.measureText().height - l.fontSize / 2 > this.chart.bounds.y2 && (l.y = this.chart.bounds.y2 - l.measureText().height + l.fontSize / 2);"left" === this.parent._position ? l.x = this.parent.lineCoordinates.x2 - l.measureText().width : "right" === this.parent._position && (l.x = this.parent.lineCoordinates.x2);
	        }k = null;("bottom" === this.parent._position || "top" === this.parent._position) && b >= this.parent.convertValueToPixel(this.parent.viewportMinimum) && c <= this.parent.convertValueToPixel(this.parent.viewportMaximum) && (0 < m && (p.moveTo(b, e), p.lineTo(c, g), p.stroke()), p.restore(), !u(l.text) && ("number" === typeof l.text.valueOf() || 0 < l.text.length) && l.render(!0));("left" === this.parent._position || "right" === this.parent._position) && g >= this.parent.convertValueToPixel(this.parent.viewportMaximum) && e <= this.parent.convertValueToPixel(this.parent.viewportMinimum) && (0 < m && (p.moveTo(b, e), p.lineTo(c, g), p.stroke()), p.restore(), !u(l.text) && ("number" === typeof l.text.valueOf() || 0 < l.text.length) && l.render(!0));
	      } else {
	        if ("bottom" === this.parent._position || "top" === this.parent._position) b = c = k = 1 === p.lineWidth % 2 ? (a << 0) + 0.5 : a << 0, e = this.chart.plotArea.y1, g = this.chart.plotArea.y2, this.bounds = { x1: b - m / 2, y1: e, x2: c + m / 2, y2: g };else if ("left" === this.parent._position || "right" === this.parent._position) e = g = k = 1 === p.lineWidth % 2 ? (d << 0) + 0.5 : d << 0, b = this.chart.plotArea.x1, c = this.chart.plotArea.x2, this.bounds = { x1: b, y1: e - m / 2, x2: c, y2: g + m / 2 };if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
	          if ("left" === this.parent._position || "right" === this.parent._position) {
	            t = !1;if (this.parent.labels) for (k = Math.ceil(this.parent.interval), n = 0; n < this.parent.viewportMaximum; n += k) {
	              if (this.parent.labels[n]) t = !0;else {
	                t = !1;break;
	              }
	            }if (t) {
	              if ("axisX" === this.parent.type) for (n = this.parent.convertPixelToValue({ y: d }), f = null, r = 0; r < this.parent.dataSeries.length; r++) {
	                (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(a) }) : u(this.options.label) ? f.dataPoint.label : this.label);
	              }
	            } else "dateTime" === this.parent.valueType ? l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(d) }) : u(this.options.label) ? Ca(this.parent.convertPixelToValue(d), this.valueFormatString, this.chart._cultureInfo) : this.label : "number" === this.parent.valueType && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(d) }) : u(this.options.label) ? ba(this.parent.convertPixelToValue(d), this.valueFormatString, this.chart._cultureInfo) : this.label);l.y = d + l.fontSize / 2 - l.measureText().height / 2 + 2;l.y - l.fontSize / 2 < this.chart.bounds.y1 ? l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2 : l.y + l.measureText().height - l.fontSize / 2 > this.chart.bounds.y2 && (l.y = this.chart.bounds.y2 - l.measureText().height + l.fontSize / 2);"left" === this.parent._position ? l.x = this.parent.lineCoordinates.x1 - l.measureText().width : "right" === this.parent._position && (l.x = this.parent.lineCoordinates.x2);
	          } else {
	            if ("bottom" === this.parent._position || "top" === this.parent._position) l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(a) }) : u(this.options.label) ? ba(this.parent.convertPixelToValue(a), this.valueFormatString, this.chart._cultureInfo) : this.label, l.x = b - l.measureText().width / 2, l.x + l.width > this.chart.bounds.x2 && (l.x = this.chart.bounds.x2 - l.width), l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1), "bottom" === this.parent._position && (l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2), "top" === this.parent._position && (l.y = this.parent.lineCoordinates.y1 - l.height + l.fontSize / 2 + 2);
	          }
	        } else if ("bottom" === this.parent._position || "top" === this.parent._position) {
	          t = !1;h = "";if (this.parent.labels) for (k = Math.ceil(this.parent.interval), n = 0; n < this.parent.viewportMaximum; n += k) {
	            if (this.parent.labels[n]) t = !0;else {
	              t = !1;break;
	            }
	          }if (t) {
	            if ("axisX" === this.parent.type) for (n = this.parent.convertPixelToValue({ x: a }), f = null, r = 0; r < this.parent.dataSeries.length; r++) {
	              (f = this.parent.dataSeries[r].getDataPointAtX(n, !0)) && 0 <= f.index && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(a) }) : u(this.options.label) ? f.dataPoint.label : this.label);
	            }
	          } else "dateTime" === this.parent.valueType ? l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(a) }) : u(this.options.label) ? Ca(this.parent.convertPixelToValue(a), this.valueFormatString, this.chart._cultureInfo) : this.label : "number" === this.parent.valueType && (l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options,
	            value: 0 < this.parent.dataSeries.length ? this.parent.convertPixelToValue(a) : "" }) : u(this.options.label) ? ba(this.parent.convertPixelToValue(a), this.valueFormatString, this.chart._cultureInfo) : this.label);l.x = b - l.measureText().width / 2;l.x + l.width > this.chart.bounds.x2 && (l.x = this.chart.bounds.x2 - l.width);l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1);"bottom" === this.parent._position ? l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2 : "top" === this.parent._position && (l.y = this.parent.lineCoordinates.y1 - l.height + l.fontSize / 2 + 2);
	        } else if ("left" === this.parent._position || "right" === this.parent._position) l.text = this.labelFormatter ? this.labelFormatter({ chart: this.chart, axis: this.parent.options, crosshair: this.options, value: this.parent.convertPixelToValue(d) }) : u(this.options.label) ? ba(this.parent.convertPixelToValue(d), this.valueFormatString, this.chart._cultureInfo) : this.label, l.y = d + l.fontSize / 2 - l.measureText().height / 2 + 2, l.y - l.fontSize / 2 < this.chart.bounds.y1 ? l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2 : l.y + l.measureText().height - l.fontSize / 2 > this.chart.bounds.y2 && (l.y = this.chart.bounds.y2 - l.measureText().height + l.fontSize / 2), "left" === this.parent._position ? l.x = this.parent.lineCoordinates.x2 - l.measureText().width : "right" === this.parent._position && (l.x = this.parent.lineCoordinates.x2);0 < m && (p.moveTo(b, e), p.lineTo(c, g), p.stroke());p.restore();!u(l.text) && ("number" === typeof l.text.valueOf() || 0 < l.text.length) && l.render(!0);
	      }p.globalAlpha = q;
	    };qa($, V);$.prototype._initialize = function () {
	      if (this.enabled) {
	        this.container = document.createElement("div");
	        this.container.setAttribute("class", "canvasjs-chart-tooltip");this.container.style.position = "absolute";this.container.style.height = "auto";this.container.style.boxShadow = "1px 1px 2px 2px rgba(0,0,0,0.1)";this.container.style.zIndex = "1000";this.container.style.pointerEvents = "none";this.container.style.display = "none";var a;a = '<div style=" width: auto;height: auto;min-width: 50px;';a += "line-height: auto;";a += "margin: 0px 0px 0px 0px;";a += "padding: 5px;";a += "font-family: Calibri, Arial, Georgia, serif;";
	        a += "font-weight: normal;";a += "font-style: " + (r ? "italic;" : "normal;");a += "font-size: 14px;";a += "color: #000000;";a += "text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);";a += "text-align: left;";a += "border: 2px solid gray;";a += r ? "background: rgba(255,255,255,.9);" : "background: rgb(255,255,255);";a += "text-indent: 0px;";a += "white-space: nowrap;";a += "border-radius: 5px;";a += "-moz-user-select:none;";a += "-khtml-user-select: none;";a += "-webkit-user-select: none;";a += "-ms-user-select: none;";a += "user-select: none;";
	        r || (a += "filter: alpha(opacity = 90);", a += "filter: progid:DXImageTransform.Microsoft.Shadow(Strength=3, Direction=135, Color='#666666');");a += '} "> Sample Tooltip</div>';this.container.innerHTML = a;this.contentDiv = this.container.firstChild;this.container.style.borderRadius = this.contentDiv.style.borderRadius;this.chart._canvasJSContainer.appendChild(this.container);
	      }
	    };$.prototype.mouseMoveHandler = function (a, d) {
	      this._lastUpdated && 4 > new Date().getTime() - this._lastUpdated || (this._lastUpdated = new Date().getTime(), this.chart.resetOverlayedCanvas(), this._updateToolTip(a, d));
	    };$.prototype._updateToolTip = function (a, d, b) {
	      b = "undefined" === typeof b ? !0 : b;this.container || this._initialize();this.enabled || this.hide();if (!this.chart.disableToolTip) {
	        if ("undefined" === typeof a || "undefined" === typeof d) {
	          if (isNaN(this._prevX) || isNaN(this._prevY)) return;a = this._prevX;d = this._prevY;
	        } else this._prevX = a, this._prevY = d;var c = null,
	            e = null,
	            g = [],
	            k = 0;if (this.shared && this.enabled && "none" !== this.chart.plotInfo.axisPlacement) {
	          if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
	            var l = [];if (this.chart.axisX) for (var h = 0; h < this.chart.axisX.length; h++) {
	              for (var k = this.chart.axisX[h].convertPixelToValue({ y: d }), m = null, c = 0; c < this.chart.axisX[h].dataSeries.length; c++) {
	                (m = this.chart.axisX[h].dataSeries[c].getDataPointAtX(k, b)) && 0 <= m.index && (m.dataSeries = this.chart.axisX[h].dataSeries[c], null !== m.dataPoint.y && l.push(m));
	              }m = null;
	            }if (this.chart.axisX2) for (h = 0; h < this.chart.axisX2.length; h++) {
	              k = this.chart.axisX2[h].convertPixelToValue({ y: d });m = null;for (c = 0; c < this.chart.axisX2[h].dataSeries.length; c++) {
	                (m = this.chart.axisX2[h].dataSeries[c].getDataPointAtX(k, b)) && 0 <= m.index && (m.dataSeries = this.chart.axisX2[h].dataSeries[c], null !== m.dataPoint.y && l.push(m));
	              }m = null;
	            }
	          } else {
	            l = [];if (this.chart.axisX) for (h = 0; h < this.chart.axisX.length; h++) {
	              for (k = this.chart.axisX[h].convertPixelToValue({ x: a }), m = null, c = 0; c < this.chart.axisX[h].dataSeries.length; c++) {
	                (m = this.chart.axisX[h].dataSeries[c].getDataPointAtX(k, b)) && 0 <= m.index && (m.dataSeries = this.chart.axisX[h].dataSeries[c], null !== m.dataPoint.y && l.push(m));
	              }
	            }if (this.chart.axisX2) for (h = 0; h < this.chart.axisX2.length; h++) {
	              for (k = this.chart.axisX2[h].convertPixelToValue({ x: a }), m = null, c = 0; c < this.chart.axisX2[h].dataSeries.length; c++) {
	                (m = this.chart.axisX2[h].dataSeries[c].getDataPointAtX(k, b)) && 0 <= m.index && (m.dataSeries = this.chart.axisX2[h].dataSeries[c], null !== m.dataPoint.y && l.push(m));
	              }
	            }
	          }if (0 === l.length) return;l.sort(function (a, b) {
	            return a.distance - b.distance;
	          });b = l[0];for (c = 0; c < l.length; c++) {
	            l[c].dataPoint.x.valueOf() === b.dataPoint.x.valueOf() && g.push(l[c]);
	          }l = null;
	        } else {
	          if (m = this.chart.getDataPointAtXY(a, d, b)) this.currentDataPointIndex = m.dataPointIndex, this.currentSeriesIndex = m.dataSeries.index;else if (r) {
	            if (m = ab(a, d, this.chart._eventManager.ghostCtx), 0 < m && "undefined" !== typeof this.chart._eventManager.objectMap[m]) {
	              m = this.chart._eventManager.objectMap[m];if ("legendItem" === m.objectType) return;this.currentSeriesIndex = m.dataSeriesIndex;this.currentDataPointIndex = 0 <= m.dataPointIndex ? m.dataPointIndex : -1;
	            } else this.currentDataPointIndex = -1;
	          } else this.currentDataPointIndex = -1;if (0 <= this.currentSeriesIndex) {
	            e = this.chart.data[this.currentSeriesIndex];m = {};if (0 <= this.currentDataPointIndex) c = e.dataPoints[this.currentDataPointIndex], m.dataSeries = e, m.dataPoint = c, m.index = this.currentDataPointIndex, m.distance = Math.abs(c.x - k), "waterfall" === e.type && (m.cumulativeSumYStartValue = e.dataPointEOs[this.currentDataPointIndex].cumulativeSumYStartValue, m.cumulativeSum = e.dataPointEOs[this.currentDataPointIndex].cumulativeSum);else {
	              if (!this.enabled || "line" !== e.type && "stepLine" !== e.type && "spline" !== e.type && "area" !== e.type && "stepArea" !== e.type && "splineArea" !== e.type && "stackedArea" !== e.type && "stackedArea100" !== e.type && "rangeArea" !== e.type && "rangeSplineArea" !== e.type && "candlestick" !== e.type && "ohlc" !== e.type && "boxAndWhisker" !== e.type) return;k = e.axisX.convertPixelToValue({ x: a });m = e.getDataPointAtX(k, b);u(m) || (m.dataSeries = e, this.currentDataPointIndex = m.index, c = m.dataPoint);
	            }if (!u(m) && !u(m.dataPoint) && !u(m.dataPoint.y)) if (m.dataSeries.axisY) {
	              if (0 < m.dataPoint.y.length) {
	                for (c = b = 0; c < m.dataPoint.y.length; c++) {
	                  m.dataPoint.y[c] < m.dataSeries.axisY.viewportMinimum ? b-- : m.dataPoint.y[c] > m.dataSeries.axisY.viewportMaximum && b++;
	                }b < m.dataPoint.y.length && b > -m.dataPoint.y.length && g.push(m);
	              } else "column" === e.type || "bar" === e.type ? 0 > m.dataPoint.y ? 0 > m.dataSeries.axisY.viewportMinimum && m.dataSeries.axisY.viewportMaximum >= m.dataPoint.y && g.push(m) : m.dataSeries.axisY.viewportMinimum <= m.dataPoint.y && 0 <= m.dataSeries.axisY.viewportMaximum && g.push(m) : "bubble" === e.type ? (b = this.chart._eventManager.objectMap[e.dataPointIds[m.index]].size / 2, m.dataPoint.y >= m.dataSeries.axisY.viewportMinimum - b && m.dataPoint.y <= m.dataSeries.axisY.viewportMaximum + b && g.push(m)) : "waterfall" === e.type ? (b = 0, m.cumulativeSumYStartValue < m.dataSeries.axisY.viewportMinimum ? b-- : m.cumulativeSumYStartValue > m.dataSeries.axisY.viewportMaximum && b++, m.cumulativeSum < m.dataSeries.axisY.viewportMinimum ? b-- : m.cumulativeSum > m.dataSeries.axisY.viewportMaximum && b++, 2 > b && -2 < b && g.push(m)) : (0 <= m.dataSeries.type.indexOf("100") || "stackedColumn" === e.type || "stackedBar" === e.type || m.dataPoint.y >= m.dataSeries.axisY.viewportMinimum && m.dataPoint.y <= m.dataSeries.axisY.viewportMaximum) && g.push(m);
	            } else g.push(m);
	          }
	        }if (0 < g.length) {
	          if (this.highlightObjects(g), this.enabled) if (b = "", b = this.getToolTipInnerHTML({ entries: g }), null !== b) {
	            this.contentDiv.innerHTML = b;b = !1;"none" === this.container.style.display && (b = !0, this.container.style.display = "block");try {
	              this.contentDiv.style.background = this.backgroundColor ? this.backgroundColor : r ? "rgba(255,255,255,.9)" : "rgb(255,255,255)", this.borderColor = "waterfall" === g[0].dataSeries.type ? this.contentDiv.style.borderRightColor = this.contentDiv.style.borderLeftColor = this.contentDiv.style.borderColor = this.options.borderColor ? this.options.borderColor : g[0].dataPoint.color ? g[0].dataPoint.color : 0 < g[0].dataPoint.y ? g[0].dataSeries.risingColor : g[0].dataSeries.fallingColor : "error" === g[0].dataSeries.type ? this.contentDiv.style.borderRightColor = this.contentDiv.style.borderLeftColor = this.contentDiv.style.borderColor = this.options.borderColor ? this.options.borderColor : g[0].dataSeries.color ? g[0].dataSeries.color : g[0].dataSeries._colorSet[e.index % g[0].dataSeries._colorSet.length] : this.contentDiv.style.borderRightColor = this.contentDiv.style.borderLeftColor = this.contentDiv.style.borderColor = this.options.borderColor ? this.options.borderColor : g[0].dataPoint.color ? g[0].dataPoint.color : g[0].dataSeries.color ? g[0].dataSeries.color : g[0].dataSeries._colorSet[g[0].index % g[0].dataSeries._colorSet.length], this.contentDiv.style.borderWidth = this.borderThickness || 0 === this.borderThickness ? this.borderThickness + "px" : "2px", this.contentDiv.style.borderRadius = this.cornerRadius || 0 === this.cornerRadius ? this.cornerRadius + "px" : "5px", this.container.style.borderRadius = this.contentDiv.style.borderRadius, this.contentDiv.style.fontSize = this.fontSize || 0 === this.fontSize ? this.fontSize + "px" : "14px", this.contentDiv.style.color = this.fontColor ? this.fontColor : "#000000", this.contentDiv.style.fontFamily = this.fontFamily ? this.fontFamily : "Calibri, Arial, Georgia, serif;", this.contentDiv.style.fontWeight = this.fontWeight ? this.fontWeight : "normal", this.contentDiv.style.fontStyle = this.fontStyle ? this.fontStyle : r ? "italic" : "normal";
	            } catch (p) {}"pie" === g[0].dataSeries.type || "doughnut" === g[0].dataSeries.type || "funnel" === g[0].dataSeries.type || "pyramid" === g[0].dataSeries.type || "bar" === g[0].dataSeries.type || "rangeBar" === g[0].dataSeries.type || "stackedBar" === g[0].dataSeries.type || "stackedBar100" === g[0].dataSeries.type ? a = a - 10 - this.container.clientWidth : (a = g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x) - this.container.clientWidth << 0, a -= 10);0 > a && (a += this.container.clientWidth + 20);a + this.container.clientWidth > Math.max(this.chart.container.clientWidth, this.chart.width) && (a = Math.max(0, Math.max(this.chart.container.clientWidth, this.chart.width) - this.container.clientWidth));d = 1 !== g.length || this.shared || "line" !== g[0].dataSeries.type && "stepLine" !== g[0].dataSeries.type && "spline" !== g[0].dataSeries.type && "area" !== g[0].dataSeries.type && "stepArea" !== g[0].dataSeries.type && "splineArea" !== g[0].dataSeries.type ? "bar" === g[0].dataSeries.type || "rangeBar" === g[0].dataSeries.type || "stackedBar" === g[0].dataSeries.type || "stackedBar100" === g[0].dataSeries.type ? g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x) : d : g[0].dataSeries.axisY.convertValueToPixel(g[0].dataPoint.y);d = -d + 10;0 < d + this.container.clientHeight + 5 && (d -= d + this.container.clientHeight + 5 - 0);this.fixMozTransitionDelay(a, d);!this.animationEnabled || b ? this.disableAnimation() : (this.enableAnimation(), this.container.style.MozTransition = this.mozContainerTransition);this.container.style.left = a + "px";this.container.style.bottom = d + "px";
	          } else this.hide(!1);
	        } else this.hide();
	      }
	    };
	    $.prototype.highlightObjects = function (a) {
	      var d = this.chart.overlaidCanvasCtx;this.chart.resetOverlayedCanvas();d.clearRect(0, 0, this.chart.width, this.chart.height);d.save();var b = this.chart.plotArea,
	          c = 0;d.beginPath();d.rect(b.x1, b.y1, b.x2 - b.x1, b.y2 - b.y1);d.clip();for (b = 0; b < a.length; b++) {
	        var e = a[b];if ((e = this.chart._eventManager.objectMap[e.dataSeries.dataPointIds[e.index]]) && e.objectType && "dataPoint" === e.objectType) {
	          var c = this.chart.data[e.dataSeriesIndex],
	              g = c.dataPoints[e.dataPointIndex],
	              k = e.dataPointIndex;
	          !1 === g.highlightEnabled || !0 !== c.highlightEnabled && !0 !== g.highlightEnabled || ("line" === c.type || "stepLine" === c.type || "spline" === c.type || "scatter" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "stackedArea" === c.type || "stackedArea100" === c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type ? (g = c.getMarkerProperties(k, e.x1, e.y1, this.chart.overlaidCanvasCtx), g.size = Math.max(1.5 * g.size << 0, 10), g.borderColor = g.borderColor || "#FFFFFF", g.borderThickness = g.borderThickness || Math.ceil(0.1 * g.size), ia.drawMarkers([g]), "undefined" !== typeof e.y2 && (g = c.getMarkerProperties(k, e.x1, e.y2, this.chart.overlaidCanvasCtx), g.size = Math.max(1.5 * g.size << 0, 10), g.borderColor = g.borderColor || "#FFFFFF", g.borderThickness = g.borderThickness || Math.ceil(0.1 * g.size), ia.drawMarkers([g]))) : "bubble" === c.type ? (g = c.getMarkerProperties(k, e.x1, e.y1, this.chart.overlaidCanvasCtx), g.size = e.size, g.color = "white", g.borderColor = "white", d.globalAlpha = 0.3, ia.drawMarkers([g]), d.globalAlpha = 1) : "column" === c.type || "stackedColumn" === c.type || "stackedColumn100" === c.type || "bar" === c.type || "rangeBar" === c.type || "stackedBar" === c.type || "stackedBar100" === c.type || "rangeColumn" === c.type || "waterfall" === c.type ? ea(d, e.x1, e.y1, e.x2, e.y2, "white", 0, null, !1, !1, !1, !1, 0.3) : "pie" === c.type || "doughnut" === c.type ? ja(d, e.center, e.radius, "white", c.type, e.startAngle, e.endAngle, 0.3, e.percentInnerRadius) : "funnel" === c.type || "pyramid" === c.type ? ra(d, e.funnelSection, 0.3, "white") : "candlestick" === c.type ? (d.globalAlpha = 1, d.strokeStyle = e.color, d.lineWidth = 2 * e.borderThickness, c = 0 === d.lineWidth % 2 ? 0 : 0.5, d.beginPath(), d.moveTo(e.x3 - c, Math.min(e.y2, e.y3)), d.lineTo(e.x3 - c, Math.min(e.y1, e.y4)), d.stroke(), d.beginPath(), d.moveTo(e.x3 - c, Math.max(e.y1, e.y4)), d.lineTo(e.x3 - c, Math.max(e.y2, e.y3)), d.stroke(), ea(d, e.x1, Math.min(e.y1, e.y4), e.x2, Math.max(e.y1, e.y4), "transparent", 2 * e.borderThickness, e.color, !1, !1, !1, !1), d.globalAlpha = 1) : "ohlc" === c.type ? (d.globalAlpha = 1, d.strokeStyle = e.color, d.lineWidth = 2 * e.borderThickness, c = 0 === d.lineWidth % 2 ? 0 : 0.5, d.beginPath(), d.moveTo(e.x3 - c, e.y2), d.lineTo(e.x3 - c, e.y3), d.stroke(), d.beginPath(), d.moveTo(e.x3, e.y1), d.lineTo(e.x1, e.y1), d.stroke(), d.beginPath(), d.moveTo(e.x3, e.y4), d.lineTo(e.x2, e.y4), d.stroke(), d.globalAlpha = 1) : "boxAndWhisker" === c.type ? (d.save(), d.globalAlpha = 1, d.strokeStyle = e.stemColor, d.lineWidth = 2 * e.stemThickness, 0 < e.stemThickness && (d.beginPath(), d.moveTo(e.x3, e.y2 + e.borderThickness / 2), d.lineTo(e.x3, e.y1 + e.whiskerThickness / 2), d.stroke(), d.beginPath(), d.moveTo(e.x3, e.y4 - e.whiskerThickness / 2), d.lineTo(e.x3, e.y3 - e.borderThickness / 2), d.stroke()), d.beginPath(), ea(d, e.x1 - e.borderThickness / 2, Math.max(e.y2 + e.borderThickness / 2, e.y3 + e.borderThickness / 2), e.x2 + e.borderThickness / 2, Math.min(e.y2 - e.borderThickness / 2, e.y3 - e.borderThickness / 2), "transparent", e.borderThickness, e.color, !1, !1, !1, !1), d.globalAlpha = 1, d.strokeStyle = e.whiskerColor, d.lineWidth = 2 * e.whiskerThickness, 0 < e.whiskerThickness && (d.beginPath(), d.moveTo(Math.floor(e.x3 - e.whiskerLength / 2), e.y4), d.lineTo(Math.ceil(e.x3 + e.whiskerLength / 2), e.y4), d.stroke(), d.beginPath(), d.moveTo(Math.floor(e.x3 - e.whiskerLength / 2), e.y1), d.lineTo(Math.ceil(e.x3 + e.whiskerLength / 2), e.y1), d.stroke()), d.globalAlpha = 1, d.strokeStyle = e.lineColor, d.lineWidth = 2 * e.lineThickness, 0 < e.lineThickness && (d.beginPath(), d.moveTo(e.x1, e.y5), d.lineTo(e.x2, e.y5), d.stroke()), d.restore(), d.globalAlpha = 1) : "error" === c.type && E(d, e.x1, e.y1, e.x2, e.y2, "white", e.whiskerProperties, e.stemProperties, e.isXYSwapped, 0.3));
	        }
	      }d.restore();d.globalAlpha = 1;d.beginPath();
	    };$.prototype.getToolTipInnerHTML = function (a) {
	      a = a.entries;for (var d = null, b = null, c = null, e = 0, g = "", k = !0, h = 0; h < a.length; h++) {
	        if (a[h].dataSeries.toolTipContent || a[h].dataPoint.toolTipContent) {
	          k = !1;break;
	        }
	      }if (k && (this.content && "function" === typeof this.content || this.contentFormatter)) a = { chart: this.chart, toolTip: this.options, entries: a }, d = this.contentFormatter ? this.contentFormatter(a) : this.content(a);else if (this.shared && "none" !== this.chart.plotInfo.axisPlacement) {
	        for (var p = null, m = "", h = 0; h < a.length; h++) {
	          b = a[h].dataSeries, c = a[h].dataPoint, e = a[h].index, g = "", 0 === h && k && !this.content && (this.chart.axisX && 0 < this.chart.axisX.length ? m += "undefined" !== typeof this.chart.axisX[0].labels[c.x] ? this.chart.axisX[0].labels[c.x] : "{x}" : this.chart.axisX2 && 0 < this.chart.axisX2.length && (m += "undefined" !== typeof this.chart.axisX2[0].labels[c.x] ? this.chart.axisX2[0].labels[c.x] : "{x}"), m += "</br>", m = this.chart.replaceKeywordsWithValue(m, c, b, e)), null === c.toolTipContent || "undefined" === typeof c.toolTipContent && null === b.options.toolTipContent || ("line" === b.type || "stepLine" === b.type || "spline" === b.type || "area" === b.type || "stepArea" === b.type || "splineArea" === b.type || "column" === b.type || "bar" === b.type || "scatter" === b.type || "stackedColumn" === b.type || "stackedColumn100" === b.type || "stackedBar" === b.type || "stackedBar100" === b.type || "stackedArea" === b.type || "stackedArea100" === b.type || "waterfall" === b.type ? (this.chart.axisX && 1 < this.chart.axisX.length && (g += p != b.axisXIndex ? b.axisX.title ? b.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), g += c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span>&nbsp;&nbsp;{y}", p = b.axisXIndex) : "bubble" === b.type ? (this.chart.axisX && 1 < this.chart.axisX.length && (g += p != b.axisXIndex ? b.axisX.title ? b.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), g += c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}") : "rangeColumn" === b.type || "rangeBar" === b.type || "rangeArea" === b.type || "rangeSplineArea" === b.type || "error" === b.type ? (this.chart.axisX && 1 < this.chart.axisX.length && (g += p != b.axisXIndex ? b.axisX.title ? b.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), g += c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span>&nbsp;&nbsp;{y[0]},&nbsp;{y[1]}") : "candlestick" === b.type || "ohlc" === b.type ? (this.chart.axisX && 1 < this.chart.axisX.length && (g += p != b.axisXIndex ? b.axisX.title ? b.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), g += c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low:&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}") : "boxAndWhisker" === b.type && (this.chart.axisX && 1 < this.chart.axisX.length && (g += p != b.axisXIndex ? b.axisX.title ? b.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), g += c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}"), null === d && (d = ""), !0 === this.reversed ? (d = this.chart.replaceKeywordsWithValue(g, c, b, e) + d, h < a.length - 1 && (d = "</br>" + d)) : (d += this.chart.replaceKeywordsWithValue(g, c, b, e), h < a.length - 1 && (d += "</br>")));
	        }null !== d && (d = m + d);
	      } else {
	        b = a[0].dataSeries;c = a[0].dataPoint;e = a[0].index;if (null === c.toolTipContent || "undefined" === typeof c.toolTipContent && null === b.options.toolTipContent) return null;"line" === b.type || "stepLine" === b.type || "spline" === b.type || "area" === b.type || "stepArea" === b.type || "splineArea" === b.type || "column" === b.type || "bar" === b.type || "scatter" === b.type || "stackedColumn" === b.type || "stackedColumn100" === b.type || "stackedBar" === b.type || "stackedBar100" === b.type || "stackedArea" === b.type || "stackedArea100" === b.type || "waterfall" === b.type ? g = c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (c.label ? "{label}" : "{x}") + ":</span>&nbsp;&nbsp;{y}" : "bubble" === b.type ? g = c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (c.label ? "{label}" : "{x}") + ":</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}" : "pie" === b.type || "doughnut" === b.type || "funnel" === b.type || "pyramid" === b.type ? g = c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (c.name ? "{name}:</span>&nbsp;&nbsp;" : c.label ? "{label}:</span>&nbsp;&nbsp;" : "</span>") + "{y}" : "rangeColumn" === b.type || "rangeBar" === b.type || "rangeArea" === b.type || "rangeSplineArea" === b.type || "error" === b.type ? g = c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (c.label ? "{label}" : "{x}") + " :</span>&nbsp;&nbsp;{y[0]}, &nbsp;{y[1]}" : "candlestick" === b.type || "ohlc" === b.type ? g = c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (c.label ? "{label}" : "{x}") + "</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low: &nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}" : "boxAndWhisker" === b.type && (g = c.toolTipContent ? c.toolTipContent : b.toolTipContent ? b.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (c.label ? "{label}" : "{x}") + "</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}");
	        null === d && (d = "");d += this.chart.replaceKeywordsWithValue(g, c, b, e);
	      }return d;
	    };$.prototype.enableAnimation = function () {
	      if (!this.container.style.WebkitTransition) {
	        var a = this.getContainerTransition(this.containerTransitionDuration);this.container.style.WebkitTransition = a;this.container.style.MsTransition = a;this.container.style.transition = a;this.container.style.MozTransition = this.mozContainerTransition;
	      }
	    };$.prototype.disableAnimation = function () {
	      this.container.style.WebkitTransition && (this.container.style.WebkitTransition = "", this.container.style.MozTransition = "", this.container.style.MsTransition = "", this.container.style.transition = "");
	    };$.prototype.hide = function (a) {
	      this.container && (this.container.style.display = "none", this.currentSeriesIndex = -1, this._prevY = this._prevX = NaN, ("undefined" === typeof a || a) && this.chart.resetOverlayedCanvas());
	    };$.prototype.show = function (a, d, b) {
	      this._updateToolTip(a, d, "undefined" === typeof b ? !1 : b);
	    };$.prototype.fixMozTransitionDelay = function (a, d) {
	      if (20 < this.chart._eventManager.lastObjectId) this.mozContainerTransition = this.getContainerTransition(0);else {
	        var b = parseFloat(this.container.style.left),
	            b = isNaN(b) ? 0 : b,
	            c = parseFloat(this.container.style.bottom),
	            c = isNaN(c) ? 0 : c;10 < Math.sqrt(Math.pow(b - a, 2) + Math.pow(c - d, 2)) ? this.mozContainerTransition = this.getContainerTransition(0.1) : this.mozContainerTransition = this.getContainerTransition(0);
	      }
	    };$.prototype.getContainerTransition = function (a) {
	      return "left " + a + "s ease-out 0s, bottom " + a + "s ease-out 0s";
	    };ha.prototype.reset = function () {
	      this.lastObjectId = 0;this.objectMap = [];this.rectangularRegionEventSubscriptions = [];this.previousDataPointEventObject = null;this.eventObjects = [];r && (this.ghostCtx.clearRect(0, 0, this.chart.width, this.chart.height), this.ghostCtx.beginPath());
	    };ha.prototype.getNewObjectTrackingId = function () {
	      return ++this.lastObjectId;
	    };ha.prototype.mouseEventHandler = function (a) {
	      if ("mousemove" === a.type || "click" === a.type) {
	        var d = [],
	            b = Ra(a),
	            c = null;if ((c = this.chart.getObjectAtXY(b.x, b.y, !1)) && "undefined" !== typeof this.objectMap[c]) if (c = this.objectMap[c], "dataPoint" === c.objectType) {
	          var e = this.chart.data[c.dataSeriesIndex],
	              g = e.dataPoints[c.dataPointIndex],
	              h = c.dataPointIndex;c.eventParameter = { x: b.x, y: b.y, dataPoint: g, dataSeries: e.options, dataPointIndex: h, dataSeriesIndex: e.index, chart: this.chart };c.eventContext = { context: g, userContext: g, mouseover: "mouseover", mousemove: "mousemove", mouseout: "mouseout", click: "click" };d.push(c);c = this.objectMap[e.id];c.eventParameter = { x: b.x, y: b.y, dataPoint: g, dataSeries: e.options, dataPointIndex: h, dataSeriesIndex: e.index, chart: this.chart };c.eventContext = { context: e, userContext: e.options, mouseover: "mouseover",
	            mousemove: "mousemove", mouseout: "mouseout", click: "click" };d.push(this.objectMap[e.id]);
	        } else "legendItem" === c.objectType && (e = this.chart.data[c.dataSeriesIndex], g = null !== c.dataPointIndex ? e.dataPoints[c.dataPointIndex] : null, c.eventParameter = { x: b.x, y: b.y, dataSeries: e.options, dataPoint: g, dataPointIndex: c.dataPointIndex, dataSeriesIndex: c.dataSeriesIndex, chart: this.chart }, c.eventContext = { context: this.chart.legend, userContext: this.chart.legend.options, mouseover: "itemmouseover", mousemove: "itemmousemove", mouseout: "itemmouseout",
	          click: "itemclick" }, d.push(c));e = [];for (b = 0; b < this.mouseoveredObjectMaps.length; b++) {
	          g = !0;for (c = 0; c < d.length; c++) {
	            if (d[c].id === this.mouseoveredObjectMaps[b].id) {
	              g = !1;break;
	            }
	          }g ? this.fireEvent(this.mouseoveredObjectMaps[b], "mouseout", a) : e.push(this.mouseoveredObjectMaps[b]);
	        }this.mouseoveredObjectMaps = e;for (b = 0; b < d.length; b++) {
	          e = !1;for (c = 0; c < this.mouseoveredObjectMaps.length; c++) {
	            if (d[b].id === this.mouseoveredObjectMaps[c].id) {
	              e = !0;break;
	            }
	          }e || (this.fireEvent(d[b], "mouseover", a), this.mouseoveredObjectMaps.push(d[b]));
	          "click" === a.type ? this.fireEvent(d[b], "click", a) : "mousemove" === a.type && this.fireEvent(d[b], "mousemove", a);
	        }
	      }
	    };ha.prototype.fireEvent = function (a, d, b) {
	      if (a && d) {
	        var c = a.eventParameter,
	            e = a.eventContext,
	            g = a.eventContext.userContext;g && e && g[e[d]] && g[e[d]].call(g, c);"mouseout" !== d ? g.cursor && g.cursor !== b.target.style.cursor && (b.target.style.cursor = g.cursor) : (b.target.style.cursor = this.chart._defaultCursor, delete a.eventParameter, delete a.eventContext);"click" === d && "dataPoint" === a.objectType && this.chart.pieDoughnutClickHandler && this.chart.pieDoughnutClickHandler.call(this.chart.data[a.dataSeriesIndex], c);"click" === d && "dataPoint" === a.objectType && this.chart.funnelPyramidClickHandler && this.chart.funnelPyramidClickHandler.call(this.chart.data[a.dataSeriesIndex], c);
	      }
	    };ga.prototype.animate = function (a, d, b, c, e) {
	      var g = this;this.chart.isAnimating = !0;e = e || M.easing.linear;b && this.animations.push({ startTime: new Date().getTime() + (a ? a : 0), duration: d, animationCallback: b, onComplete: c });for (a = []; 0 < this.animations.length;) {
	        if (d = this.animations.shift(), b = new Date().getTime(), c = 0, d.startTime <= b && (c = e(Math.min(b - d.startTime, d.duration), 0, 1, d.duration), c = Math.min(c, 1), isNaN(c) || !isFinite(c)) && (c = 1), 1 > c && a.push(d), d.animationCallback(c), 1 <= c && d.onComplete) d.onComplete();
	      }this.animations = a;0 < this.animations.length ? this.animationRequestId = this.chart.requestAnimFrame.call(window, function () {
	        g.animate.call(g);
	      }) : this.chart.isAnimating = !1;
	    };ga.prototype.cancelAllAnimations = function () {
	      this.animations = [];this.animationRequestId && this.chart.cancelRequestAnimFrame.call(window, this.animationRequestId);this.animationRequestId = null;this.chart.isAnimating = !1;
	    };var M = { yScaleAnimation: function yScaleAnimation(a, d) {
	        if (0 !== a) {
	          var b = d.dest,
	              c = d.source.canvas,
	              e = d.animationBase;b.drawImage(c, 0, 0, c.width, c.height, 0, e - e * a, b.canvas.width / W, a * b.canvas.height / W);
	        }
	      }, xScaleAnimation: function xScaleAnimation(a, d) {
	        if (0 !== a) {
	          var b = d.dest,
	              c = d.source.canvas,
	              e = d.animationBase;b.drawImage(c, 0, 0, c.width, c.height, e - e * a, 0, a * b.canvas.width / W, b.canvas.height / W);
	        }
	      }, xClipAnimation: function xClipAnimation(a, d) {
	        if (0 !== a) {
	          var b = d.dest,
	              c = d.source.canvas;
	          b.save();0 < a && b.drawImage(c, 0, 0, c.width * a, c.height, 0, 0, c.width * a / W, c.height / W);b.restore();
	        }
	      }, fadeInAnimation: function fadeInAnimation(a, d) {
	        if (0 !== a) {
	          var b = d.dest,
	              c = d.source.canvas;b.save();b.globalAlpha = a;b.drawImage(c, 0, 0, c.width, c.height, 0, 0, b.canvas.width / W, b.canvas.height / W);b.restore();
	        }
	      }, easing: { linear: function linear(a, d, b, c) {
	          return b * a / c + d;
	        }, easeOutQuad: function easeOutQuad(a, d, b, c) {
	          return -b * (a /= c) * (a - 2) + d;
	        }, easeOutQuart: function easeOutQuart(a, d, b, c) {
	          return -b * ((a = a / c - 1) * a * a * a - 1) + d;
	        }, easeInQuad: function easeInQuad(a, d, b, c) {
	          return b * (a /= c) * a + d;
	        }, easeInQuart: function easeInQuart(a, d, b, c) {
	          return b * (a /= c) * a * a * a + d;
	        } } },
	        ia = { drawMarker: function drawMarker(a, d, b, c, e, g, h, l) {
	        if (b) {
	          var p = 1;b.fillStyle = g ? g : "#000000";b.strokeStyle = h ? h : "#000000";b.lineWidth = l ? l : 0;b.setLineDash && b.setLineDash(R("solid", l));"circle" === c ? (b.moveTo(a, d), b.beginPath(), b.arc(a, d, e / 2, 0, 2 * Math.PI, !1), g && b.fill(), l && (h ? b.stroke() : (p = b.globalAlpha, b.globalAlpha = 0.15, b.strokeStyle = "black", b.stroke(), b.globalAlpha = p))) : "square" === c ? (b.beginPath(), b.rect(a - e / 2, d - e / 2, e, e), g && b.fill(), l && (h ? b.stroke() : (p = b.globalAlpha, b.globalAlpha = 0.15, b.strokeStyle = "black", b.stroke(), b.globalAlpha = p))) : "triangle" === c ? (b.beginPath(), b.moveTo(a - e / 2, d + e / 2), b.lineTo(a + e / 2, d + e / 2), b.lineTo(a, d - e / 2), b.closePath(), g && b.fill(), l && (h ? b.stroke() : (p = b.globalAlpha, b.globalAlpha = 0.15, b.strokeStyle = "black", b.stroke(), b.globalAlpha = p)), b.beginPath()) : "cross" === c && (b.strokeStyle = g, b.lineWidth = e / 4, b.beginPath(), b.moveTo(a - e / 2, d - e / 2), b.lineTo(a + e / 2, d + e / 2), b.stroke(), b.moveTo(a + e / 2, d - e / 2), b.lineTo(a - e / 2, d + e / 2), b.stroke());
	        }
	      }, drawMarkers: function drawMarkers(a) {
	        for (var d = 0; d < a.length; d++) {
	          var b = a[d];ia.drawMarker(b.x, b.y, b.ctx, b.type, b.size, b.color, b.borderColor, b.borderThickness);
	        }
	      } };return p;
	  }();Na.Chart.version = "v2.3.2 GA";
	})();
	
	/*
	  excanvas is used to support IE678 which do not implement HTML5 Canvas Element. You can safely remove the following excanvas code if you don't need to support older browsers.
	
	  Copyright 2006 Google Inc. https://code.google.com/p/explorercanvas/
	  Licensed under the Apache License, Version 2.0
	*/
	document.createElement("canvas").getContext || function () {
	  function V() {
	    return this.context_ || (this.context_ = new C(this));
	  }function W(a, b, c) {
	    var g = M.call(arguments, 2);return function () {
	      return a.apply(b, g.concat(M.call(arguments)));
	    };
	  }function N(a) {
	    return String(a).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
	  }function O(a) {
	    a.namespaces.g_vml_ || a.namespaces.add("g_vml_", "urn:schemas-microsoft-com:vml", "#default#VML");a.namespaces.g_o_ || a.namespaces.add("g_o_", "urn:schemas-microsoft-com:office:office", "#default#VML");
	    a.styleSheets.ex_canvas_ || (a = a.createStyleSheet(), a.owningElement.id = "ex_canvas_", a.cssText = "canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}");
	  }function X(a) {
	    var b = a.srcElement;switch (a.propertyName) {case "width":
	        b.getContext().clearRect();b.style.width = b.attributes.width.nodeValue + "px";b.firstChild.style.width = b.clientWidth + "px";break;case "height":
	        b.getContext().clearRect(), b.style.height = b.attributes.height.nodeValue + "px", b.firstChild.style.height = b.clientHeight + "px";}
	  }function Y(a) {
	    a = a.srcElement;a.firstChild && (a.firstChild.style.width = a.clientWidth + "px", a.firstChild.style.height = a.clientHeight + "px");
	  }function D() {
	    return [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
	  }function t(a, b) {
	    for (var c = D(), g = 0; 3 > g; g++) {
	      for (var e = 0; 3 > e; e++) {
	        for (var f = 0, d = 0; 3 > d; d++) {
	          f += a[g][d] * b[d][e];
	        }c[g][e] = f;
	      }
	    }return c;
	  }function P(a, b) {
	    b.fillStyle = a.fillStyle;b.lineCap = a.lineCap;b.lineJoin = a.lineJoin;b.lineWidth = a.lineWidth;b.miterLimit = a.miterLimit;b.shadowBlur = a.shadowBlur;b.shadowColor = a.shadowColor;b.shadowOffsetX = a.shadowOffsetX;b.shadowOffsetY = a.shadowOffsetY;b.strokeStyle = a.strokeStyle;b.globalAlpha = a.globalAlpha;b.font = a.font;b.textAlign = a.textAlign;b.textBaseline = a.textBaseline;b.arcScaleX_ = a.arcScaleX_;b.arcScaleY_ = a.arcScaleY_;b.lineScale_ = a.lineScale_;
	  }function Q(a) {
	    var b = a.indexOf("(", 3),
	        c = a.indexOf(")", b + 1),
	        b = a.substring(b + 1, c).split(",");if (4 != b.length || "a" != a.charAt(3)) b[3] = 1;return b;
	  }function E(a, b, c) {
	    return Math.min(c, Math.max(b, a));
	  }function F(a, b, c) {
	    0 > c && c++;1 < c && c--;return 1 > 6 * c ? a + 6 * (b - a) * c : 1 > 2 * c ? b : 2 > 3 * c ? a + 6 * (b - a) * (2 / 3 - c) : a;
	  }function G(a) {
	    if (a in H) return H[a];var b,
	        c = 1;a = String(a);if ("#" == a.charAt(0)) b = a;else if (/^rgb/.test(a)) {
	      c = Q(a);b = "#";for (var g, e = 0; 3 > e; e++) {
	        g = -1 != c[e].indexOf("%") ? Math.floor(255 * (parseFloat(c[e]) / 100)) : +c[e], b += v[E(g, 0, 255)];
	      }c = +c[3];
	    } else if (/^hsl/.test(a)) {
	      e = c = Q(a);b = parseFloat(e[0]) / 360 % 360;0 > b && b++;g = E(parseFloat(e[1]) / 100, 0, 1);e = E(parseFloat(e[2]) / 100, 0, 1);if (0 == g) g = e = b = e;else {
	        var f = 0.5 > e ? e * (1 + g) : e + g - e * g,
	            d = 2 * e - f;g = F(d, f, b + 1 / 3);e = F(d, f, b);b = F(d, f, b - 1 / 3);
	      }b = "#" + v[Math.floor(255 * g)] + v[Math.floor(255 * e)] + v[Math.floor(255 * b)];c = c[3];
	    } else b = Z[a] || a;return H[a] = { color: b, alpha: c };
	  }function C(a) {
	    this.m_ = D();this.mStack_ = [];this.aStack_ = [];this.currentPath_ = [];this.fillStyle = this.strokeStyle = "#000";this.lineWidth = 1;this.lineJoin = "miter";this.lineCap = "butt";this.miterLimit = 1 * q;this.globalAlpha = 1;this.font = "10px sans-serif";this.textAlign = "left";this.textBaseline = "alphabetic";this.canvas = a;var b = "width:" + a.clientWidth + "px;height:" + a.clientHeight + "px;overflow:hidden;position:absolute",
	        c = a.ownerDocument.createElement("div");c.style.cssText = b;a.appendChild(c);b = c.cloneNode(!1);b.style.backgroundColor = "red";b.style.filter = "alpha(opacity=0)";a.appendChild(b);this.element_ = c;this.lineScale_ = this.arcScaleY_ = this.arcScaleX_ = 1;
	  }function R(a, b, c, g) {
	    a.currentPath_.push({ type: "bezierCurveTo", cp1x: b.x, cp1y: b.y, cp2x: c.x, cp2y: c.y, x: g.x, y: g.y });a.currentX_ = g.x;a.currentY_ = g.y;
	  }function S(a, b) {
	    var c = G(a.strokeStyle),
	        g = c.color,
	        c = c.alpha * a.globalAlpha,
	        e = a.lineScale_ * a.lineWidth;1 > e && (c *= e);b.push("<g_vml_:stroke", ' opacity="', c, '"', ' joinstyle="', a.lineJoin, '"', ' miterlimit="', a.miterLimit, '"', ' endcap="', $[a.lineCap] || "square", '"', ' weight="', e, 'px"', ' color="', g, '" />');
	  }function T(a, b, c, g) {
	    var e = a.fillStyle,
	        f = a.arcScaleX_,
	        d = a.arcScaleY_,
	        k = g.x - c.x,
	        n = g.y - c.y;if (e instanceof w) {
	      var h = 0,
	          l = g = 0,
	          u = 0,
	          m = 1;if ("gradient" == e.type_) {
	        h = e.x1_ / f;c = e.y1_ / d;var p = s(a, e.x0_ / f, e.y0_ / d),
	            h = s(a, h, c),
	            h = 180 * Math.atan2(h.x - p.x, h.y - p.y) / Math.PI;0 > h && (h += 360);1E-6 > h && (h = 0);
	      } else p = s(a, e.x0_, e.y0_), g = (p.x - c.x) / k, l = (p.y - c.y) / n, k /= f * q, n /= d * q, m = x.max(k, n), u = 2 * e.r0_ / m, m = 2 * e.r1_ / m - u;f = e.colors_;f.sort(function (a, b) {
	        return a.offset - b.offset;
	      });d = f.length;p = f[0].color;c = f[d - 1].color;k = f[0].alpha * a.globalAlpha;a = f[d - 1].alpha * a.globalAlpha;for (var n = [], r = 0; r < d; r++) {
	        var t = f[r];n.push(t.offset * m + u + " " + t.color);
	      }b.push('<g_vml_:fill type="', e.type_, '"', ' method="none" focus="100%"', ' color="', p, '"', ' color2="', c, '"', ' colors="', n.join(","), '"', ' opacity="', a, '"', ' g_o_:opacity2="', k, '"', ' angle="', h, '"', ' focusposition="', g, ",", l, '" />');
	    } else e instanceof I ? k && n && b.push("<g_vml_:fill", ' position="', -c.x / k * f * f, ",", -c.y / n * d * d, '"', ' type="tile"', ' src="', e.src_, '" />') : (e = G(a.fillStyle), b.push('<g_vml_:fill color="', e.color, '" opacity="', e.alpha * a.globalAlpha, '" />'));
	  }function s(a, b, c) {
	    a = a.m_;return { x: q * (b * a[0][0] + c * a[1][0] + a[2][0]) - r, y: q * (b * a[0][1] + c * a[1][1] + a[2][1]) - r };
	  }function z(a, b, c) {
	    isFinite(b[0][0]) && isFinite(b[0][1]) && isFinite(b[1][0]) && isFinite(b[1][1]) && isFinite(b[2][0]) && isFinite(b[2][1]) && (a.m_ = b, c && (a.lineScale_ = aa(ba(b[0][0] * b[1][1] - b[0][1] * b[1][0]))));
	  }function w(a) {
	    this.type_ = a;this.r1_ = this.y1_ = this.x1_ = this.r0_ = this.y0_ = this.x0_ = 0;this.colors_ = [];
	  }function I(a, b) {
	    if (!a || 1 != a.nodeType || "IMG" != a.tagName) throw new A("TYPE_MISMATCH_ERR");if ("complete" != a.readyState) throw new A("INVALID_STATE_ERR");switch (b) {case "repeat":case null:case "":
	        this.repetition_ = "repeat";break;case "repeat-x":case "repeat-y":case "no-repeat":
	        this.repetition_ = b;break;default:
	        throw new A("SYNTAX_ERR");}this.src_ = a.src;this.width_ = a.width;this.height_ = a.height;
	  }
	  function A(a) {
	    this.code = this[a];this.message = a + ": DOM Exception " + this.code;
	  }var x = Math,
	      k = x.round,
	      J = x.sin,
	      K = x.cos,
	      ba = x.abs,
	      aa = x.sqrt,
	      q = 10,
	      r = q / 2;navigator.userAgent.match(/MSIE ([\d.]+)?/);var M = Array.prototype.slice;O(document);var U = { init: function init(a) {
	      a = a || document;a.createElement("canvas");a.attachEvent("onreadystatechange", W(this.init_, this, a));
	    }, init_: function init_(a) {
	      a = a.getElementsByTagName("canvas");for (var b = 0; b < a.length; b++) {
	        this.initElement(a[b]);
	      }
	    }, initElement: function initElement(a) {
	      if (!a.getContext) {
	        a.getContext = V;O(a.ownerDocument);a.innerHTML = "";a.attachEvent("onpropertychange", X);a.attachEvent("onresize", Y);var b = a.attributes;b.width && b.width.specified ? a.style.width = b.width.nodeValue + "px" : a.width = a.clientWidth;b.height && b.height.specified ? a.style.height = b.height.nodeValue + "px" : a.height = a.clientHeight;
	      }return a;
	    } };U.init();for (var v = [], d = 0; 16 > d; d++) {
	    for (var B = 0; 16 > B; B++) {
	      v[16 * d + B] = d.toString(16) + B.toString(16);
	    }
	  }var Z = { aliceblue: "#F0F8FF", antiquewhite: "#FAEBD7", aquamarine: "#7FFFD4", azure: "#F0FFFF", beige: "#F5F5DC",
	    bisque: "#FFE4C4", black: "#000000", blanchedalmond: "#FFEBCD", blueviolet: "#8A2BE2", brown: "#A52A2A", burlywood: "#DEB887", cadetblue: "#5F9EA0", chartreuse: "#7FFF00", chocolate: "#D2691E", coral: "#FF7F50", cornflowerblue: "#6495ED", cornsilk: "#FFF8DC", crimson: "#DC143C", cyan: "#00FFFF", darkblue: "#00008B", darkcyan: "#008B8B", darkgoldenrod: "#B8860B", darkgray: "#A9A9A9", darkgreen: "#006400", darkgrey: "#A9A9A9", darkkhaki: "#BDB76B", darkmagenta: "#8B008B", darkolivegreen: "#556B2F", darkorange: "#FF8C00", darkorchid: "#9932CC", darkred: "#8B0000",
	    darksalmon: "#E9967A", darkseagreen: "#8FBC8F", darkslateblue: "#483D8B", darkslategray: "#2F4F4F", darkslategrey: "#2F4F4F", darkturquoise: "#00CED1", darkviolet: "#9400D3", deeppink: "#FF1493", deepskyblue: "#00BFFF", dimgray: "#696969", dimgrey: "#696969", dodgerblue: "#1E90FF", firebrick: "#B22222", floralwhite: "#FFFAF0", forestgreen: "#228B22", gainsboro: "#DCDCDC", ghostwhite: "#F8F8FF", gold: "#FFD700", goldenrod: "#DAA520", grey: "#808080", greenyellow: "#ADFF2F", honeydew: "#F0FFF0", hotpink: "#FF69B4", indianred: "#CD5C5C", indigo: "#4B0082",
	    ivory: "#FFFFF0", khaki: "#F0E68C", lavender: "#E6E6FA", lavenderblush: "#FFF0F5", lawngreen: "#7CFC00", lemonchiffon: "#FFFACD", lightblue: "#ADD8E6", lightcoral: "#F08080", lightcyan: "#E0FFFF", lightgoldenrodyellow: "#FAFAD2", lightgreen: "#90EE90", lightgrey: "#D3D3D3", lightpink: "#FFB6C1", lightsalmon: "#FFA07A", lightseagreen: "#20B2AA", lightskyblue: "#87CEFA", lightslategray: "#778899", lightslategrey: "#778899", lightsteelblue: "#B0C4DE", lightyellow: "#FFFFE0", limegreen: "#32CD32", linen: "#FAF0E6", magenta: "#FF00FF", mediumaquamarine: "#66CDAA",
	    mediumblue: "#0000CD", mediumorchid: "#BA55D3", mediumpurple: "#9370DB", mediumseagreen: "#3CB371", mediumslateblue: "#7B68EE", mediumspringgreen: "#00FA9A", mediumturquoise: "#48D1CC", mediumvioletred: "#C71585", midnightblue: "#191970", mintcream: "#F5FFFA", mistyrose: "#FFE4E1", moccasin: "#FFE4B5", navajowhite: "#FFDEAD", oldlace: "#FDF5E6", olivedrab: "#6B8E23", orange: "#FFA500", orangered: "#FF4500", orchid: "#DA70D6", palegoldenrod: "#EEE8AA", palegreen: "#98FB98", paleturquoise: "#AFEEEE", palevioletred: "#DB7093", papayawhip: "#FFEFD5",
	    peachpuff: "#FFDAB9", peru: "#CD853F", pink: "#FFC0CB", plum: "#DDA0DD", powderblue: "#B0E0E6", rosybrown: "#BC8F8F", royalblue: "#4169E1", saddlebrown: "#8B4513", salmon: "#FA8072", sandybrown: "#F4A460", seagreen: "#2E8B57", seashell: "#FFF5EE", sienna: "#A0522D", skyblue: "#87CEEB", slateblue: "#6A5ACD", slategray: "#708090", slategrey: "#708090", snow: "#FFFAFA", springgreen: "#00FF7F", steelblue: "#4682B4", tan: "#D2B48C", thistle: "#D8BFD8", tomato: "#FF6347", turquoise: "#40E0D0", violet: "#EE82EE", wheat: "#F5DEB3", whitesmoke: "#F5F5F5", yellowgreen: "#9ACD32" },
	      H = {},
	      L = {},
	      $ = { butt: "flat", round: "round" },
	      d = C.prototype;d.clearRect = function () {
	    this.textMeasureEl_ && (this.textMeasureEl_.removeNode(!0), this.textMeasureEl_ = null);this.element_.innerHTML = "";
	  };d.beginPath = function () {
	    this.currentPath_ = [];
	  };d.moveTo = function (a, b) {
	    var c = s(this, a, b);this.currentPath_.push({ type: "moveTo", x: c.x, y: c.y });this.currentX_ = c.x;this.currentY_ = c.y;
	  };d.lineTo = function (a, b) {
	    var c = s(this, a, b);this.currentPath_.push({ type: "lineTo", x: c.x, y: c.y });this.currentX_ = c.x;this.currentY_ = c.y;
	  };d.bezierCurveTo = function (a, b, c, g, e, f) {
	    e = s(this, e, f);a = s(this, a, b);c = s(this, c, g);R(this, a, c, e);
	  };d.quadraticCurveTo = function (a, b, c, g) {
	    a = s(this, a, b);c = s(this, c, g);g = { x: this.currentX_ + 2 / 3 * (a.x - this.currentX_), y: this.currentY_ + 2 / 3 * (a.y - this.currentY_) };R(this, g, { x: g.x + (c.x - this.currentX_) / 3, y: g.y + (c.y - this.currentY_) / 3 }, c);
	  };d.arc = function (a, b, c, g, e, f) {
	    c *= q;var d = f ? "at" : "wa",
	        k = a + K(g) * c - r,
	        n = b + J(g) * c - r;g = a + K(e) * c - r;e = b + J(e) * c - r;k != g || f || (k += 0.125);a = s(this, a, b);k = s(this, k, n);g = s(this, g, e);this.currentPath_.push({ type: d,
	      x: a.x, y: a.y, radius: c, xStart: k.x, yStart: k.y, xEnd: g.x, yEnd: g.y });
	  };d.rect = function (a, b, c, g) {
	    this.moveTo(a, b);this.lineTo(a + c, b);this.lineTo(a + c, b + g);this.lineTo(a, b + g);this.closePath();
	  };d.strokeRect = function (a, b, c, g) {
	    var e = this.currentPath_;this.beginPath();this.moveTo(a, b);this.lineTo(a + c, b);this.lineTo(a + c, b + g);this.lineTo(a, b + g);this.closePath();this.stroke();this.currentPath_ = e;
	  };d.fillRect = function (a, b, c, g) {
	    var e = this.currentPath_;this.beginPath();this.moveTo(a, b);this.lineTo(a + c, b);this.lineTo(a + c, b + g);this.lineTo(a, b + g);this.closePath();this.fill();this.currentPath_ = e;
	  };d.createLinearGradient = function (a, b, c, g) {
	    var e = new w("gradient");e.x0_ = a;e.y0_ = b;e.x1_ = c;e.y1_ = g;return e;
	  };d.createRadialGradient = function (a, b, c, g, e, f) {
	    var d = new w("gradientradial");d.x0_ = a;d.y0_ = b;d.r0_ = c;d.x1_ = g;d.y1_ = e;d.r1_ = f;return d;
	  };d.drawImage = function (a, b) {
	    var c, g, e, d, r, y, n, h;e = a.runtimeStyle.width;d = a.runtimeStyle.height;a.runtimeStyle.width = "auto";a.runtimeStyle.height = "auto";var l = a.width,
	        u = a.height;a.runtimeStyle.width = e;a.runtimeStyle.height = d;if (3 == arguments.length) c = arguments[1], g = arguments[2], r = y = 0, n = e = l, h = d = u;else if (5 == arguments.length) c = arguments[1], g = arguments[2], e = arguments[3], d = arguments[4], r = y = 0, n = l, h = u;else if (9 == arguments.length) r = arguments[1], y = arguments[2], n = arguments[3], h = arguments[4], c = arguments[5], g = arguments[6], e = arguments[7], d = arguments[8];else throw Error("Invalid number of arguments");var m = s(this, c, g),
	        p = [];p.push(" <g_vml_:group", ' coordsize="', 10 * q, ",", 10 * q, '"', ' coordorigin="0,0"', ' style="width:', 10, "px;height:", 10, "px;position:absolute;");if (1 != this.m_[0][0] || this.m_[0][1] || 1 != this.m_[1][1] || this.m_[1][0]) {
	      var t = [];t.push("M11=", this.m_[0][0], ",", "M12=", this.m_[1][0], ",", "M21=", this.m_[0][1], ",", "M22=", this.m_[1][1], ",", "Dx=", k(m.x / q), ",", "Dy=", k(m.y / q), "");var v = s(this, c + e, g),
	          w = s(this, c, g + d);c = s(this, c + e, g + d);m.x = x.max(m.x, v.x, w.x, c.x);m.y = x.max(m.y, v.y, w.y, c.y);p.push("padding:0 ", k(m.x / q), "px ", k(m.y / q), "px 0;filter:progid:DXImageTransform.Microsoft.Matrix(", t.join(""), ", sizingmethod='clip');");
	    } else p.push("top:", k(m.y / q), "px;left:", k(m.x / q), "px;");p.push(' ">', '<g_vml_:image src="', a.src, '"', ' style="width:', q * e, "px;", " height:", q * d, 'px"', ' cropleft="', r / l, '"', ' croptop="', y / u, '"', ' cropright="', (l - r - n) / l, '"', ' cropbottom="', (u - y - h) / u, '"', " />", "</g_vml_:group>");this.element_.insertAdjacentHTML("BeforeEnd", p.join(""));
	  };d.stroke = function (a) {
	    var b = [];b.push("<g_vml_:shape", ' filled="', !!a, '"', ' style="position:absolute;width:', 10, "px;height:", 10, 'px;"', ' coordorigin="0,0"', ' coordsize="', 10 * q, ",", 10 * q, '"', ' stroked="', !a, '"', ' path="');for (var c = { x: null, y: null }, d = { x: null, y: null }, e = 0; e < this.currentPath_.length; e++) {
	      var f = this.currentPath_[e];switch (f.type) {case "moveTo":
	          b.push(" m ", k(f.x), ",", k(f.y));break;case "lineTo":
	          b.push(" l ", k(f.x), ",", k(f.y));break;case "close":
	          b.push(" x ");f = null;break;case "bezierCurveTo":
	          b.push(" c ", k(f.cp1x), ",", k(f.cp1y), ",", k(f.cp2x), ",", k(f.cp2y), ",", k(f.x), ",", k(f.y));break;case "at":case "wa":
	          b.push(" ", f.type, " ", k(f.x - this.arcScaleX_ * f.radius), ",", k(f.y - this.arcScaleY_ * f.radius), " ", k(f.x + this.arcScaleX_ * f.radius), ",", k(f.y + this.arcScaleY_ * f.radius), " ", k(f.xStart), ",", k(f.yStart), " ", k(f.xEnd), ",", k(f.yEnd));}if (f) {
	        if (null == c.x || f.x < c.x) c.x = f.x;if (null == d.x || f.x > d.x) d.x = f.x;if (null == c.y || f.y < c.y) c.y = f.y;if (null == d.y || f.y > d.y) d.y = f.y;
	      }
	    }b.push(' ">');a ? T(this, b, c, d) : S(this, b);b.push("</g_vml_:shape>");this.element_.insertAdjacentHTML("beforeEnd", b.join(""));
	  };d.fill = function () {
	    this.stroke(!0);
	  };d.closePath = function () {
	    this.currentPath_.push({ type: "close" });
	  };d.save = function () {
	    var a = {};P(this, a);this.aStack_.push(a);this.mStack_.push(this.m_);this.m_ = t(D(), this.m_);
	  };d.restore = function () {
	    this.aStack_.length && (P(this.aStack_.pop(), this), this.m_ = this.mStack_.pop());
	  };d.translate = function (a, b) {
	    z(this, t([[1, 0, 0], [0, 1, 0], [a, b, 1]], this.m_), !1);
	  };d.rotate = function (a) {
	    var b = K(a);a = J(a);z(this, t([[b, a, 0], [-a, b, 0], [0, 0, 1]], this.m_), !1);
	  };d.scale = function (a, b) {
	    this.arcScaleX_ *= a;this.arcScaleY_ *= b;z(this, t([[a, 0, 0], [0, b, 0], [0, 0, 1]], this.m_), !0);
	  };d.transform = function (a, b, c, d, e, f) {
	    z(this, t([[a, b, 0], [c, d, 0], [e, f, 1]], this.m_), !0);
	  };d.setTransform = function (a, b, c, d, e, f) {
	    z(this, [[a, b, 0], [c, d, 0], [e, f, 1]], !0);
	  };d.drawText_ = function (a, b, c, d, e) {
	    var f = this.m_;d = 0;var r = 1E3,
	        t = 0,
	        n = [],
	        h;h = this.font;if (L[h]) h = L[h];else {
	      var l = document.createElement("div").style;try {
	        l.font = h;
	      } catch (u) {}h = L[h] = { style: l.fontStyle || "normal", variant: l.fontVariant || "normal", weight: l.fontWeight || "normal", size: l.fontSize || 10, family: l.fontFamily || "sans-serif" };
	    }var l = h,
	        m = this.element_;h = {};for (var p in l) {
	      h[p] = l[p];
	    }p = parseFloat(m.currentStyle.fontSize);
	    m = parseFloat(l.size);"number" == typeof l.size ? h.size = l.size : -1 != l.size.indexOf("px") ? h.size = m : -1 != l.size.indexOf("em") ? h.size = p * m : -1 != l.size.indexOf("%") ? h.size = p / 100 * m : -1 != l.size.indexOf("pt") ? h.size = m / 0.75 : h.size = p;h.size *= 0.981;p = h.style + " " + h.variant + " " + h.weight + " " + h.size + "px " + h.family;m = this.element_.currentStyle;l = this.textAlign.toLowerCase();switch (l) {case "left":case "center":case "right":
	        break;case "end":
	        l = "ltr" == m.direction ? "right" : "left";break;case "start":
	        l = "rtl" == m.direction ? "right" : "left";break;default:
	        l = "left";}switch (this.textBaseline) {case "hanging":case "top":
	        t = h.size / 1.75;break;case "middle":
	        break;default:case null:case "alphabetic":case "ideographic":case "bottom":
	        t = -h.size / 2.25;}switch (l) {case "right":
	        d = 1E3;r = 0.05;break;case "center":
	        d = r = 500;}b = s(this, b + 0, c + t);n.push('<g_vml_:line from="', -d, ' 0" to="', r, ' 0.05" ', ' coordsize="100 100" coordorigin="0 0"', ' filled="', !e, '" stroked="', !!e, '" style="position:absolute;width:1px;height:1px;">');e ? S(this, n) : T(this, n, { x: -d, y: 0 }, { x: r, y: h.size });e = f[0][0].toFixed(3) + "," + f[1][0].toFixed(3) + "," + f[0][1].toFixed(3) + "," + f[1][1].toFixed(3) + ",0,0";b = k(b.x / q) + "," + k(b.y / q);n.push('<g_vml_:skew on="t" matrix="', e, '" ', ' offset="', b, '" origin="', d, ' 0" />', '<g_vml_:path textpathok="true" />', '<g_vml_:textpath on="true" string="', N(a), '" style="v-text-align:', l, ";font:", N(p), '" /></g_vml_:line>');this.element_.insertAdjacentHTML("beforeEnd", n.join(""));
	  };d.fillText = function (a, b, c, d) {
	    this.drawText_(a, b, c, d, !1);
	  };d.strokeText = function (a, b, c, d) {
	    this.drawText_(a, b, c, d, !0);
	  };d.measureText = function (a) {
	    this.textMeasureEl_ || (this.element_.insertAdjacentHTML("beforeEnd", '<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>'), this.textMeasureEl_ = this.element_.lastChild);var b = this.element_.ownerDocument;this.textMeasureEl_.innerHTML = "";this.textMeasureEl_.style.font = this.font;this.textMeasureEl_.appendChild(b.createTextNode(a));return { width: this.textMeasureEl_.offsetWidth };
	  };d.clip = function () {};
	  d.arcTo = function () {};d.createPattern = function (a, b) {
	    return new I(a, b);
	  };w.prototype.addColorStop = function (a, b) {
	    b = G(b);this.colors_.push({ offset: a, color: b.color, alpha: b.alpha });
	  };d = A.prototype = Error();d.INDEX_SIZE_ERR = 1;d.DOMSTRING_SIZE_ERR = 2;d.HIERARCHY_REQUEST_ERR = 3;d.WRONG_DOCUMENT_ERR = 4;d.INVALID_CHARACTER_ERR = 5;d.NO_DATA_ALLOWED_ERR = 6;d.NO_MODIFICATION_ALLOWED_ERR = 7;d.NOT_FOUND_ERR = 8;d.NOT_SUPPORTED_ERR = 9;d.INUSE_ATTRIBUTE_ERR = 10;d.INVALID_STATE_ERR = 11;d.SYNTAX_ERR = 12;d.INVALID_MODIFICATION_ERR = 13;d.NAMESPACE_ERR = 14;d.INVALID_ACCESS_ERR = 15;d.VALIDATION_ERR = 16;d.TYPE_MISMATCH_ERR = 17;G_vmlCanvasManager = U;CanvasRenderingContext2D = C;CanvasGradient = w;CanvasPattern = I;DOMException = A;
	}();
	/*eslint-enable*/
	/*jshint ignore:end*/

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var CanvasJS = __webpack_require__(84);
	CanvasJS = CanvasJS.Chart ? CanvasJS : window.CanvasJS;
	
	var CanvasJSChart = function (_React$Component) {
		_inherits(CanvasJSChart, _React$Component);
	
		function CanvasJSChart(props) {
			_classCallCheck(this, CanvasJSChart);
	
			var _this = _possibleConstructorReturn(this, (CanvasJSChart.__proto__ || Object.getPrototypeOf(CanvasJSChart)).call(this, props));
	
			_this.options = props.options ? props.options : {};
			_this.containerProps = props.containerProps ? props.containerProps : { width: "100%", position: "relative" };
			_this.containerProps.height = props.containerProps && props.containerProps.height ? props.containerProps.height : _this.options.height ? _this.options.height + "px" : "550px";
			_this.chartContainerId = "canvasjs-react-chart-container-" + CanvasJSChart._cjsContainerId++;
			return _this;
		}
	
		_createClass(CanvasJSChart, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				//Create Chart and Render		
				this.chart = new CanvasJS.Chart(this.chartContainerId, this.options);
				this.chart.render();
	
				if (this.props.onRef) this.props.onRef(this.chart);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				//Check if Chart-options has changed and determine if component has to be updated
				return !(nextProps.options === this.options);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//Update Chart Options & Render
				this.chart.options = this.props.options;
				this.chart.render();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				//Destroy chart and remove reference
				this.chart.destroy();
				if (this.props.onRef) this.props.onRef(undefined);
			}
		}, {
			key: 'render',
			value: function render() {
				//return React.createElement('div', { id: this.chartContainerId, style: this.containerProps });		
				return React.createElement('div', { id: this.chartContainerId, style: this.containerProps });
			}
		}]);
	
		return CanvasJSChart;
	}(React.Component);
	
	CanvasJSChart._cjsContainerId = 0;
	
	
	var CanvasJSReact = {
		CanvasJSChart: CanvasJSChart,
		CanvasJS: CanvasJS
	};
	
	exports.default = CanvasJSReact;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMaterialize = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dropdown = function Dropdown(props) {
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            _reactMaterialize.Select,
	            { onChange: props.onSelect,
	                id: 'Select-9', multiple: false,
	                options: {
	                    classes: '',
	                    dropdownOptions: {
	                        alignment: 'left',
	                        autoTrigger: true,
	                        closeOnClick: true,
	                        constrainWidth: true,
	                        coverTrigger: true,
	                        hover: false,
	                        inDuration: 150,
	                        onCloseEnd: null,
	                        onCloseStart: null,
	                        onOpenEnd: null,
	                        onOpenStart: null,
	                        outDuration: 250
	                    }
	                },
	                value: props.category
	            },
	            _react2.default.createElement(
	                'option',
	                { disabled: true, value: '' },
	                'Choose Category'
	            ),
	            _react2.default.createElement(
	                'option',
	                { value: 'All Categories' },
	                'All Categories'
	            ),
	            props.bills.map(function (bill) {
	                return _react2.default.createElement(
	                    'option',
	                    { value: bill.category },
	                    bill.category
	                );
	            })
	        )
	    );
	};
	
	exports.default = Dropdown;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(24);
	
	__webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBar = function (_Component) {
	  _inherits(NavBar, _Component);
	
	  function NavBar() {
	    _classCallCheck(this, NavBar);
	
	    return _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).apply(this, arguments));
	  }
	
	  _createClass(NavBar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'nav',
	          { className: 'navbar-expand-lg navbar-light bg-light' },
	          _react2.default.createElement(
	            'div',
	            { id: 'navbarTogglerDemo02' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'link', to: '/' },
	                  'Bill Dashboard'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'link', to: '/add' },
	                  'Add a Bill'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'link', to: '/chart' },
	                  'Billing Cycle'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavBar;
	}(_react.Component);
	
	exports.default = NavBar;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(77);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "GET_BILLS":
	      return Object.assign({}, state, {
	        bills: action.payload
	      });
	    case "DELETE_BILL":
	      return Object.assign({}, state, {
	        bills: state.bills.filter(function (bill) {
	          return bill.id !== action.payload;
	        })
	      });
	    case "ADD_BILL":
	      console.log(action.payload);
	      return Object.assign({}, state, {
	        bills: [].concat(_toConsumableArray(state.bills), [action.payload])
	      });
	    case "UPDATE_BILL":
	      return Object.assign({}, state, {
	        bills: state.bills.map(function (bill) {
	          return bill.id === action.payload.id ? bill = action.payload : bill;
	        })
	      });
	    case "GET_BILL":
	      console.log(action.payload);
	      return Object.assign({}, state, {
	        bill: action.payload
	      });
	    case "GET_CAT_BILLS":
	      return Object.assign({}, state, {
	        category_bills: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  bills: [],
	  bill: {},
	  category_bills: []
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(25);
	
	var _billReducers = __webpack_require__(89);
	
	var _billReducers2 = _interopRequireDefault(_billReducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  bill: _billReducers2.default
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(25);
	
	var _reduxThunk = __webpack_require__(163);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(90);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var middleware = [_reduxThunk2.default];
	
	var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()));
	
	exports.default = store;

/***/ },
/* 92 */
36,
/* 93 */
36,
/* 94 */
36,
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(165)),valueEqual=_interopDefault(__webpack_require__(171));__webpack_require__(15);var invariant=_interopDefault(__webpack_require__(26));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var React=__webpack_require__(1),_inheritsLoose=__webpack_require__(55),PropTypes=__webpack_require__(2),warning=__webpack_require__(15);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var _inheritsLoose__default=/*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var warning__default=/*#__PURE__*/_interopDefaultLegacy(warning);var MAX_SIGNED_31_BIT_INT = 1073741823;
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
	
	function getUniqueId() {
	  var key = '__global_unique_id__';
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	}
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + getUniqueId() + '__';
	
	  var Provider = /*#__PURE__*/function (_Component) {
	    _inheritsLoose__default['default'](Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning__default['default']((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes__default['default'].object.isRequired, _Provider$childContex);
	
	  var Consumer = /*#__PURE__*/function (_Component2) {
	    _inheritsLoose__default['default'](Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes__default['default'].object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default['default'].createContext || createReactContext;module.exports=index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 97 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(39);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(39);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(101);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v17.0.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),m=__webpack_require__(18),r=__webpack_require__(167);function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
	function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
	var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
	ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
	pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
	D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
	function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
	if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
	var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
	function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
	f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
	function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
	function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
	return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
	function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
	function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
	function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
	function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
	function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
	function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
	function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
	function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
	function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
	typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
	function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
	function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
	function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
	function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
	function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
	function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
	function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
	function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
	function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
	function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
	fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
	var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
	"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
	function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
	F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
	function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
	function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
	function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
	function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
	function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
	function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
	function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
	(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
	var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
	a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
	Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
	119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
	var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
	deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
	function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
	function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
	var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
	function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
	function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
	function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
	function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
	Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
	0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
	ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
	da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
	function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
	function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
	function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
	function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
	function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
	function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
	a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
	Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
	t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
	x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
	gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
	K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
	case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
	"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
	function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
	function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
	function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
	function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
	function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
	var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
	function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
	function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
	function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
	function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
	function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
	b;c.lastBaseUpdate=b}
	function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
	next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
	f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
	function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
	var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
	b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
	function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
	function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
	function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
	function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
	function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
	c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
	a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
	null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
	n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
	h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
	u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
	d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
	Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
	function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
	function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
	function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
	function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
	function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
	function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
	function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
	function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
	eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
	function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
	e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
	function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
	function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
	function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
	function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
	function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
	function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
	var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
	b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
	wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
	void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
	a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
	a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
	function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
	function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
	function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
	"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
	h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
	function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
	var si={dehydrated:null,retryLane:0};
	function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
	b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
	{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
	function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
	function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
	function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
	function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
	Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
	Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
	l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
	(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
	c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
	b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
	jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
	e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
	gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
	break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
	c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
	4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
	null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
	f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
	64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
	function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
	function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
	function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
	function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
	function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
	b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
	return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
	function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
	a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
	f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
	function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
	c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
	function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
	function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
	function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
	8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
	function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
	2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
	b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
	function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
	function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
	function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
	c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
	function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
	a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
	c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
	function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
	function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
	function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
	function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
	(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
	void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
	g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
	function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
	function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
	function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
	Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
	break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
	Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
	J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
	g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
	0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
	Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
	function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
	function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
	null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
	function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
	function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
	ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
	b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
	typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
	a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
	d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
	ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
	c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
	k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
	f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
	};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
	function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
	function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
	c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
	typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
	function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
	function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
	d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
	function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
	qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
	function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
	function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
	gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
	yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
	Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.1",rendererPackageName:"react-dom"};
	var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
	pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
	exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
	exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.1";


/***/ },
/* 103 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Badge = function Badge(_ref) {
	  var className = _ref.className,
	      newIcon = _ref.newIcon,
	      caption = _ref.caption,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["className", "newIcon", "caption", "children"]);
	
	  var classes = {
	    badge: true,
	    new: newIcon
	  };
	  return /*#__PURE__*/_react.default.createElement("span", _extends({}, props, {
	    "data-badge-caption": caption,
	    className: (0, _classnames.default)(classes, className)
	  }), children);
	};
	
	Badge.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	
	  /**
	   * Add the <b>new</b> class name
	   */
	  newIcon: _propTypes.default.bool,
	
	  /**
	   * One can explicitly set the caption in a badge using the caption prop
	   */
	  caption: _propTypes.default.string
	};
	var _default = Badge;
	exports.default = _default;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Col = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function Breadcrumb(_ref) {
	  var cols = _ref.cols,
	      children = _ref.children,
	      className = _ref.className;
	  return /*#__PURE__*/_react.default.createElement("nav", {
	    className: (0, _classnames.default)('row', className)
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: "nav-wrapper"
	  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
	    s: cols
	  }, _react.default.Children.map(children, function (item) {
	    return _react.default.cloneElement(item, {
	      className: 'breadcrumb'
	    });
	  }))));
	};
	
	Breadcrumb.propTypes = {
	  children: _propTypes.default.node,
	
	  /**
	   * responsive col value
	   * @default 12
	   */
	  cols: _propTypes.default.number,
	  className: _propTypes.default.string
	};
	Breadcrumb.defaultProps = {
	  cols: 12
	};
	var _default = Breadcrumb;
	exports.default = _default;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Caption = function Caption(_ref) {
	  var className = _ref.className,
	      placement = _ref.placement,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["className", "placement", "children"]);
	
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    className: (0, _classnames.default)('caption', "".concat(placement, "-align"), className)
	  }, props), children);
	};
	
	Caption.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	
	  /**
	   * Placement of the caption
	   * @default 'center'
	   */
	  placement: _propTypes.default.oneOf(_constants.default.PLACEMENTS)
	};
	Caption.defaultProps = {
	  placement: 'center'
	};
	var _default = Caption;
	exports.default = _default;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	// eslint-disable-next-line react/prop-types
	var Wrapper = function Wrapper(_ref) {
	  var condition = _ref.condition,
	      children = _ref.children;
	  return condition ? /*#__PURE__*/_react.default.createElement("div", {
	    className: "card-stacked"
	  }, children) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
	};
	
	var Card = function Card(_ref2) {
	  var title = _ref2.title,
	      header = _ref2.header,
	      className = _ref2.className,
	      textClassName = _ref2.textClassName,
	      actions = _ref2.actions,
	      reveal = _ref2.reveal,
	      children = _ref2.children,
	      horizontal = _ref2.horizontal,
	      closeIcon = _ref2.closeIcon,
	      revealIcon = _ref2.revealIcon,
	      other = _objectWithoutProperties(_ref2, ["title", "header", "className", "textClassName", "actions", "reveal", "children", "horizontal", "closeIcon", "revealIcon"]);
	
	  var classes = {
	    card: true,
	    horizontal: horizontal
	  };
	  return /*#__PURE__*/_react.default.createElement("div", _extends({}, other, {
	    className: (0, _classnames.default)(className, classes)
	  }), header, /*#__PURE__*/_react.default.createElement(Wrapper, {
	    condition: horizontal
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)('card-content', textClassName)
	  }, title && /*#__PURE__*/_react.default.createElement("span", {
	    className: (0, _classnames.default)('card-title', {
	      activator: reveal
	    })
	  }, title, reveal && (0, _react.cloneElement)(revealIcon, {
	    right: true
	  })), /*#__PURE__*/_react.default.createElement("div", null, children)), /*#__PURE__*/_react.default.createElement("div", {
	    className: "card-reveal"
	  }, /*#__PURE__*/_react.default.createElement("span", {
	    className: "card-title"
	  }, title, (0, _react.cloneElement)(closeIcon, {
	    right: true
	  })), reveal), actions && /*#__PURE__*/_react.default.createElement("div", {
	    className: "card-action"
	  }, actions)));
	};
	
	Card.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  title: _propTypes.default.string,
	  textClassName: _propTypes.default.string,
	  reveal: _propTypes.default.element,
	  header: _propTypes.default.element,
	  // The buttons to be displayed at the action area
	  actions: _propTypes.default.arrayOf(_propTypes.default.element),
	  horizontal: _propTypes.default.bool,
	
	  /**
	   * @default <Icon>close</Icon>
	   */
	  closeIcon: _propTypes.default.node,
	
	  /**
	   * @default <Icon>more_vert</Icon>
	   */
	  revealIcon: _propTypes.default.node
	};
	Card.defaultProps = {
	  closeIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "close"),
	  revealIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "more_vert")
	};
	var _default = Card;
	exports.default = _default;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var CardPanel = function CardPanel(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["className", "children"]);
	
	  var classes = {
	    'card-panel': true
	  };
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    className: (0, _classnames.default)(classes, className)
	  }, props), children);
	};
	
	CardPanel.propTypes = {
	  className: _propTypes.default.string,
	  children: _propTypes.default.node
	};
	var _default = CardPanel;
	exports.default = _default;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var CardTitle = function CardTitle(_ref) {
	  var image = _ref.image,
	      reveal = _ref.reveal,
	      waves = _ref.waves,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["image", "reveal", "waves", "children"]);
	
	  var classes = (0, _classnames.default)(_defineProperty({
	    'card-image': true,
	    'waves-effect': waves,
	    'waves-block': waves
	  }, "waves-".concat(waves), waves));
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    className: (0, _classnames.default)(classes)
	  }, props), /*#__PURE__*/_react.default.createElement("img", {
	    className: (0, _classnames.default)({
	      activator: reveal
	    }),
	    src: image
	  }), /*#__PURE__*/_react.default.createElement("span", {
	    className: (0, _classnames.default)('card-title')
	  }, children));
	};
	
	CardTitle.propTypes = {
	  children: _propTypes.default.node,
	  // Whether the image serves as activator for the reveal
	  reveal: _propTypes.default.bool,
	  // the waves effect
	  waves: _propTypes.default.oneOf(_constants.default.WAVES),
	  // The path to the image
	  image: _propTypes.default.string.isRequired
	};
	var _default = CardTitle;
	exports.default = _default;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Carousel = function Carousel(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      carouselId = _ref.carouselId,
	      fixedItem = _ref.fixedItem,
	      images = _ref.images,
	      centerImages = _ref.centerImages,
	      options = _ref.options;
	  var carouselRef = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    var instance = M.Carousel.init(carouselRef.current, options);
	    return function () {
	      return instance.destroy();
	    };
	  }, [options, children, images]);
	  var elemsToRender = children || images || [];
	  var classes = (0, _classnames.default)('carousel', {
	    'carousel-slider': options.fullWidth
	  }, className);
	  return /*#__PURE__*/_react.default.createElement("div", {
	    id: carouselId,
	    ref: carouselRef,
	    className: classes
	  }, Boolean(fixedItem) && /*#__PURE__*/_react.default.createElement("div", {
	    className: "carousel-fixed-item center"
	  }, fixedItem), _react.default.Children.map(elemsToRender, function (child) {
	    var classes = (0, _classnames.default)('carousel-item', {
	      'valign-wrapper': centerImages
	    });
	
	    if (typeof child === 'string') {
	      return /*#__PURE__*/_react.default.createElement("a", {
	        className: classes
	      }, /*#__PURE__*/_react.default.createElement("img", {
	        src: child,
	        alt: child
	      }));
	    }
	
	    return _react.default.cloneElement(child, {
	      className: (0, _classnames.default)(classes, child.props.className)
	    });
	  }));
	};
	
	Carousel.propTypes = {
	  /**
	   * Children to render as carousel elements
	   */
	  children: _propTypes.default.any,
	
	  /**
	   * Array of image url's
	   */
	  images: _propTypes.default.arrayOf(_propTypes.default.string),
	
	  /**
	   * Makes the images centered inside the carousel using '.valign-wrapper' CSS helper
	   */
	  centerImages: _propTypes.default.bool,
	
	  /**
	   * Fixed element on slider
	   */
	  fixedItem: _propTypes.default.node,
	
	  /**
	   * Additional classNames for carousel wrapper
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Carousel ID for jQuery manipulating
	   */
	  carouselId: _propTypes.default.string,
	
	  /**
	   * Carousel initialization options
	   * <a href="http://materializecss.com/carousel.html">http://materializecss.com/carousel.html</a>
	   */
	  options: _propTypes.default.shape({
	    /**
	     * Transition duration in milliseconds. (Default: 200)
	     */
	    duration: _propTypes.default.number,
	
	    /**
	     * Perspective zoom. If 0, all items are the same size. (Default: -100)
	     */
	    dist: _propTypes.default.number,
	
	    /**
	     * Set the spacing of the center item. (Default: 0)
	     */
	    shift: _propTypes.default.number,
	
	    /**
	     * Set the padding between non center items. (Default: 0)
	     */
	    padding: _propTypes.default.number,
	
	    /**
	     * Set the number of visible items. (Default: 5)
	     */
	    numVisible: _propTypes.default.number,
	
	    /**
	     * Make the carousel a full width slider. (Default: false)
	     */
	    fullWidth: _propTypes.default.bool,
	
	    /**
	     * Set to true to show indicators. (Default: false)
	     */
	    indicators: _propTypes.default.bool,
	
	    /**
	     * Don't wrap around and cycle through items. (Default: false)
	     */
	    noWrap: _propTypes.default.bool,
	
	    /**
	     * Callback for when a new slide is cycled to. (Default: null)
	     */
	    onCycleTo: _propTypes.default.func
	  })
	};
	Carousel.defaultProps = {
	  carouselId: "Carousel-".concat((0, _idgen.default)()),
	  options: {
	    duration: 200,
	    dist: -100,
	    shift: 0,
	    padding: 0,
	    numVisible: 5,
	    fullWidth: false,
	    indicators: false,
	    noWrap: false,
	    onCycleTo: null
	  }
	};
	var _default = Carousel;
	exports.default = _default;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Checkbox = function Checkbox(_ref) {
	  var id = _ref.id,
	      className = _ref.className,
	      indeterminate = _ref.indeterminate,
	      filledIn = _ref.filledIn,
	      label = _ref.label,
	      _onChange = _ref.onChange,
	      props = _objectWithoutProperties(_ref, ["id", "className", "indeterminate", "filledIn", "label", "onChange"]);
	
	  var _useState = (0, _react.useState)(props.checked),
	      _useState2 = _slicedToArray(_useState, 2),
	      checked = _useState2[0],
	      setChecked = _useState2[1];
	
	  var _input = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    if (_input.current) {
	      _input.current.indeterminate = indeterminate;
	      _input.current.checked = false;
	      setChecked(false);
	    }
	  }, [indeterminate]);
	  (0, _react.useEffect)(function () {
	    setChecked(props.checked);
	    _input.current.checked = props.checked;
	  }, [props.checked]);
	  return /*#__PURE__*/_react.default.createElement("label", {
	    htmlFor: id
	  }, /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
	    id: id,
	    className: (0, _classnames.default)({
	      'filled-in': filledIn
	    }, className),
	    type: "checkbox",
	    ref: _input,
	    checked: checked,
	    onChange: function onChange(e) {
	      setChecked(function (prevChecked) {
	        return !prevChecked;
	      });
	      _onChange && _onChange(e);
	    }
	  })), /*#__PURE__*/_react.default.createElement("span", null, label));
	};
	
	Checkbox.propTypes = {
	  className: _propTypes.default.string,
	
	  /**
	   * checkbox value
	   */
	  value: _propTypes.default.string.isRequired,
	
	  /**
	   * filled-in styled checkbox
	   */
	  filledIn: _propTypes.default.bool,
	
	  /**
	   * label next to checkbox
	   */
	  label: _propTypes.default.string.isRequired,
	
	  /**
	   * Indeterminate Style
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * onChange callback
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * override id
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * disabled input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * A Boolean attribute indicating whether or not this checkbox is checked
	   */
	  checked: _propTypes.default.bool
	};
	Checkbox.defaultProps = {
	  id: "Checkbox_".concat((0, _idgen.default)())
	};
	var _default = Checkbox;
	exports.default = _default;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	var _Autocomplete = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Chip = function Chip(_ref) {
	  var children = _ref.children,
	      close = _ref.close,
	      closeIcon = _ref.closeIcon,
	      className = _ref.className,
	      options = _ref.options,
	      other = _objectWithoutProperties(_ref, ["children", "close", "closeIcon", "className", "options"]);
	
	  var instance = (0, _react.useRef)(null);
	  var chipRef = (0, _react.useRef)(null);
	  var classes = (0, _classnames.default)(className, {
	    chip: !options,
	    chips: options
	  });
	  var chipContent = options ? null : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children, Boolean(close) && closeIcon);
	  (0, _react.useEffect)(function () {
	    if (options) {
	      instance.current = M.Chips.init(chipRef.current, options);
	    }
	
	    return function () {
	      if (instance.current) {
	        instance.current.destroy();
	      }
	    };
	  }, [options, children]);
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    className: classes
	  }, other, {
	    ref: chipRef
	  }), chipContent);
	};
	
	Chip.propTypes = {
	  className: _propTypes.default.string,
	  children: _propTypes.default.node,
	
	  /**
	   * Shows a close icon
	   */
	  close: _propTypes.default.bool,
	  closeIcon: _propTypes.default.node,
	
	  /**
	   * Options object for the Chip Javascript Plugin
	   */
	  options: _propTypes.default.shape({
	    /**
	     * Set the chip data
	     */
	    data: _propTypes.default.arrayOf(_propTypes.default.objectOf(_propTypes.default.string)),
	
	    /**
	     * Set first placeholder when there are no tags.
	     */
	    placeholder: _propTypes.default.string,
	
	    /**
	     * Set second placeholder when adding additional tags.
	     */
	    secondaryPlaceholder: _propTypes.default.string,
	
	    /**
	     * Set chips limit.
	     */
	    limit: _propTypes.default.number,
	
	    /**
	     * Callback for chip add.
	     */
	    onChipAdd: _propTypes.default.func,
	
	    /**
	     * Callback for chip select.
	     */
	    onChipSelect: _propTypes.default.func,
	
	    /**
	     * Callback for chip delete.
	     */
	    onChipDelete: _propTypes.default.func,
	
	    /**
	     * Set autocomplete options.
	     * Note: onAutocomplete does not work in Chip
	     */
	    autocompleteOptions: _Autocomplete.autocompleteOptions
	  })
	};
	Chip.defaultProps = {
	  close: false,
	  closeIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
	    className: "close"
	  }, "close"),
	  options: null
	};
	var _default = Chip;
	exports.default = _default;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Collapsible = function Collapsible(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      accordion = _ref.accordion,
	      options = _ref.options,
	      defaultActiveKey = _ref.defaultActiveKey,
	      popout = _ref.popout,
	      onSelect = _ref.onSelect,
	      props = _objectWithoutProperties(_ref, ["children", "className", "accordion", "options", "defaultActiveKey", "popout", "onSelect"]);
	
	  var _collapsible = (0, _react.useRef)(null);
	
	  var collapsible = accordion ? 'accordion' : 'expandable';
	
	  var _useState = (0, _react.useState)(defaultActiveKey),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeKey = _useState2[0],
	      setActiveKey = _useState2[1];
	
	  var renderItem = function renderItem(child, key) {
	    if (!child) return null; // Extend with props if child is a react component
	
	    if (typeof child.type === 'function') {
	      Object.assign(props, {
	        expanded: activeKey === key || child.props.expanded,
	        eventKey: key
	      });
	    }
	
	    return _react.default.cloneElement(child, {
	      onSelect: function onSelect() {
	        return handleSelect(key);
	      }
	    });
	  };
	
	  var handleSelect = function handleSelect(key) {
	    if (onSelect) {
	      onSelect(key);
	    }
	
	    if (activeKey === key) {
	      setActiveKey(null);
	    }
	
	    if (accordion) {
	      setActiveKey(key);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (typeof M !== 'undefined') {
	      var instance = M.Collapsible.init(_collapsible.current, _objectSpread({
	        accordion: accordion
	      }, options));
	      return function () {
	        instance && instance.destroy();
	      };
	    }
	  }, [_collapsible, accordion, options, children]);
	  return /*#__PURE__*/_react.default.createElement("ul", _extends({
	    ref: _collapsible,
	    className: (0, _classnames.default)(className, {
	      collapsible: collapsible,
	      expandable: accordion !== true,
	      popout: popout
	    }),
	    "data-collapsible": collapsible
	  }, props), _react.Children.map(children, renderItem));
	};
	
	Collapsible.propTypes = {
	  /**
	   * There are two ways a collapsible can behave. It can either allow multiple sections to stay open,
	   * or it can only allow one section to stay open at a time, which is called an accordion.
	   * @default true
	   */
	  accordion: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  children: _propTypes.default.node,
	
	  /**
	   * Enable popout style
	   */
	  popout: _propTypes.default.bool,
	
	  /**
	   * The default CollapsibleItem that should be expanded. This value should match the specified
	   * item's eventKey value. Ignored if accordion is false.
	   */
	  defaultActiveKey: _propTypes.default.any,
	  onSelect: _propTypes.default.func,
	
	  /**
	   * Options passed to initializer
	   */
	  options: _propTypes.default.any
	};
	Collapsible.defaultProps = {
	  accordion: true
	};
	var _default = Collapsible;
	exports.default = _default;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var CollapsibleItem = function CollapsibleItem(_ref) {
	  var className = _ref.className,
	      eventKey = _ref.eventKey,
	      expanded = _ref.expanded,
	      header = _ref.header,
	      children = _ref.children,
	      icon = _ref.icon,
	      iconClassName = _ref.iconClassName,
	      Node = _ref.node,
	      onSelect = _ref.onSelect,
	      props = _objectWithoutProperties(_ref, ["className", "eventKey", "expanded", "header", "children", "icon", "iconClassName", "node", "onSelect"]);
	
	  return /*#__PURE__*/_react.default.createElement("li", _extends({
	    className: (0, _classnames.default)(className, {
	      active: expanded
	    })
	  }, props), /*#__PURE__*/_react.default.createElement(Node, {
	    className: (0, _classnames.default)('collapsible-header', {
	      active: expanded
	    }),
	    onClick: function onClick() {
	      return onSelect(eventKey);
	    }
	  }, icon, header), /*#__PURE__*/_react.default.createElement("div", {
	    className: "collapsible-body"
	  }, children));
	};
	
	CollapsibleItem.propTypes = {
	  header: _propTypes.default.any.isRequired,
	  icon: _propTypes.default.node,
	  iconClassName: _propTypes.default.string,
	  children: _propTypes.default.node,
	  onSelect: _propTypes.default.func,
	
	  /**
	   * If the item is expanded by default. Overridden if the parent Collapsible is an accordion.
	   * @default false
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The value to pass to the onSelect callback.
	   */
	  eventKey: _propTypes.default.any,
	  className: _propTypes.default.string,
	
	  /**
	   * The node type of the header
	   * @default a
	   */
	  node: _propTypes.default.node
	};
	CollapsibleItem.defaultProps = {
	  expanded: false,
	  node: 'div'
	};
	var _default = CollapsibleItem;
	exports.default = _default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Collection = function Collection(_ref) {
	  var children = _ref.children,
	      header = _ref.header,
	      className = _ref.className,
	      other = _objectWithoutProperties(_ref, ["children", "header", "className"]);
	
	  var getNodeType = (0, _react.useMemo)(function () {
	    return _react.default.Children.toArray(children).some(function (child) {
	      return child.props.href;
	    }) ? 'div' : 'ul';
	  }, [children]);
	  var renderHeader = (0, _react.useMemo)(function () {
	    var _header;
	
	    if (_react.default.isValidElement(header)) {
	      _header = header;
	    } else {
	      _header = /*#__PURE__*/_react.default.createElement("h4", null, header);
	    }
	
	    return /*#__PURE__*/_react.default.createElement("li", {
	      className: "collection-header"
	    }, _header);
	  }, [header]);
	  var C = getNodeType;
	  return /*#__PURE__*/_react.default.createElement(C, _extends({}, other, {
	    className: (0, _classnames.default)('collection', {
	      'with-header': !!header
	    }, className)
	  }), header ? renderHeader : null, children);
	};
	
	Collection.propTypes = {
	  children: _propTypes.default.node,
	  header: _propTypes.default.node,
	  className: _propTypes.default.string
	};
	var _default = Collection;
	exports.default = _default;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var CollectionItem = function CollectionItem(_ref) {
	  var active = _ref.active,
	      children = _ref.children,
	      className = _ref.className,
	      href = _ref.href,
	      other = _objectWithoutProperties(_ref, ["active", "children", "className", "href"]);
	
	  var item = /*#__PURE__*/_react.default.createElement("li", _extends({}, other, {
	    className: (0, _classnames.default)('collection-item', className)
	  }), children);
	
	  if (href) {
	    item = /*#__PURE__*/_react.default.createElement("a", _extends({}, other, {
	      href: href,
	      className: (0, _classnames.default)('collection-item', {
	        active: active
	      }, className)
	    }), children);
	  }
	
	  return item;
	};
	
	CollectionItem.propTypes = {
	  active: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	
	  /**
	   * Default: false
	   * For more information refer to : https://materializecss.com/collections.html#links
	   */
	  href: _propTypes.default.string
	};
	var _default = CollectionItem;
	exports.default = _default;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Container = function Container(_ref) {
	  var className = _ref.className,
	      props = _objectWithoutProperties(_ref, ["className"]);
	
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    className: (0, _classnames.default)('container', className)
	  }, props));
	};
	
	Container.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string
	};
	var _default = Container;
	exports.default = _default;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _TextInput = _interopRequireDefault(__webpack_require__(14));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var DatePicker = function DatePicker(_ref) {
	  var options = _ref.options,
	      onChange = _ref.onChange,
	      rest = _objectWithoutProperties(_ref, ["options", "onChange"]);
	
	  var dateEl = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    var _options = onChange ? _objectSpread({}, options, {
	      onSelect: onChange
	    }) : options;
	
	    var instance = M.Datepicker.init(dateEl.current, _options);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [options, onChange]);
	  return /*#__PURE__*/_react.default.createElement(_TextInput.default, _extends({
	    ref: dateEl,
	    inputClassName: "datepicker"
	  }, rest));
	};
	
	DatePicker.propTypes = {
	  /**
	   * Event called when Time has been selected
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * id passed to datepicker, also used for init method
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * options passed to init method
	   * more info: https://materializecss.com/pickers.html#date-picker
	   */
	  options: _propTypes.default.shape({
	    /**
	     * Automatically close picker when date is selected.
	     */
	    autoClose: _propTypes.default.bool,
	
	    /**
	     * The date output format for the input field value.
	     * @default 'mmm dd, yyyy'
	     */
	    format: _propTypes.default.string,
	
	    /**
	     * Used to create date object from current input string.
	     * @default null
	     */
	    parse: _propTypes.default.func,
	
	    /**
	     * The initial date to view when first opened.
	     * @default null
	     */
	    defaultDate: _propTypes.default.any,
	
	    /**
	     * Make the defaultDate the initial selected value.
	     * @default false
	     */
	    setDefaultDate: _propTypes.default.bool,
	
	    /**
	     * Prevent selection of any date on the weekend.
	     * @default false
	     */
	    disableWeekends: _propTypes.default.bool,
	
	    /**
	     * Custom function to disable certain days.
	     * @default null
	     */
	    disableDayFn: _propTypes.default.func,
	
	    /**
	     * First day of week (0: Sunday, 1: Monday etc).
	     * @default 0
	     */
	    firstDay: _propTypes.default.number,
	
	    /**
	     * The earliest date that can be selected.
	     * @default null
	     */
	    minDate: _propTypes.default.any,
	
	    /**
	     * The latest date that can be selected.
	     * @default null
	     */
	    maxDate: _propTypes.default.any,
	
	    /**
	     * Number of years either side, or array of upper/lower range.
	     * @default 10
	     */
	    yearRange: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
	
	    /**
	     * Changes Datepicker to RTL.
	     * @default false
	     */
	    isRTL: _propTypes.default.bool,
	
	    /**
	     * Show month after year in Datepicker title.
	     * @default false
	     */
	    showMonthAfterYear: _propTypes.default.bool,
	
	    /**
	     * Render days of the calendar grid that fall in the next or previous month.
	     * @default false
	     */
	    showDaysInNextAndPreviousMonths: _propTypes.default.bool,
	
	    /**
	     * Specify a DOM element to render the calendar in, by default it will be placed before the input.
	     * @default null
	     */
	    container: _propTypes.default.any,
	
	    /**
	     * Show the clear button in the datepicker.
	     * @default false
	     */
	    showClearBtn: _propTypes.default.bool,
	
	    /**
	     * Internationalization options.
	     * @default See i18n documentation.
	     */
	    i18n: _propTypes.default.shape({
	      cancel: _propTypes.default.string,
	      clear: _propTypes.default.string,
	      done: _propTypes.default.string,
	      previousMonth: _propTypes.default.string,
	      nextMonth: _propTypes.default.string,
	      months: _propTypes.default.arrayOf(_propTypes.default.string),
	      monthsShort: _propTypes.default.arrayOf(_propTypes.default.string),
	      weekdays: _propTypes.default.arrayOf(_propTypes.default.string),
	      weekdaysShort: _propTypes.default.arrayOf(_propTypes.default.string),
	      weekdaysAbbrev: _propTypes.default.arrayOf(_propTypes.default.string)
	    }),
	
	    /**
	     * An array of string returned by `Date.toDateString()`, indicating there are events in the specified days.
	     * @default []
	     */
	    events: _propTypes.default.arrayOf(_propTypes.default.string),
	
	    /**
	     * Callback function when date is selected, first parameter is the newly selected date.
	     * @default null
	     */
	    onSelect: _propTypes.default.func,
	
	    /**
	     * Callback function when Datepicker is opened.
	     * @default null
	     */
	    onOpen: _propTypes.default.func,
	
	    /**
	     * Callback function when Datepicker is closed.
	     * @default null
	     */
	    onClose: _propTypes.default.func,
	
	    /**
	     * Callback function when Datepicker HTML is refreshed.
	     * @default null
	     */
	    onDraw: _propTypes.default.func
	  })
	};
	DatePicker.defaultProps = {
	  id: "DatePicker-".concat((0, _idgen.default)()),
	  options: {
	    autoClose: false,
	    format: 'mmm dd, yyyy',
	    parse: null,
	    defaultDate: null,
	    setDefaultDate: false,
	    disableWeekends: false,
	    disableDayFn: null,
	    firstDay: 0,
	    minDate: null,
	    maxDate: null,
	    yearRange: 10,
	    isRTL: false,
	    showMonthAfterYear: false,
	    showDaysInNextAndPreviousMonths: false,
	    container: null,
	    showClearBtn: false,
	    i18n: {
	      cancel: 'Cancel',
	      clear: 'Clear',
	      done: 'Ok',
	      previousMonth: '‹',
	      nextMonth: '›',
	      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
	    },
	    events: [],
	    onSelect: null,
	    onOpen: null,
	    onClose: null,
	    onDraw: null
	  }
	};
	var _default = DatePicker;
	exports.default = _default;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider() {
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: "divider"
	  });
	};
	
	var _default = Divider;
	exports.default = _default;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Row = _interopRequireDefault(__webpack_require__(22));
	
	var _Col = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Footer = function Footer(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      copyrights = _ref.copyrights,
	      links = _ref.links,
	      moreLinks = _ref.moreLinks,
	      props = _objectWithoutProperties(_ref, ["children", "className", "copyrights", "links", "moreLinks"]);
	
	  var classes = {
	    'page-footer': true
	  };
	  return /*#__PURE__*/_react.default.createElement("footer", _extends({
	    className: (0, _classnames.default)(classes, className)
	  }, props), /*#__PURE__*/_react.default.createElement("div", {
	    className: "container"
	  }, /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, {
	    l: 6,
	    s: 12
	  }, children), /*#__PURE__*/_react.default.createElement(_Col.default, {
	    l: 4,
	    s: 12,
	    offset: "l2"
	  }, links))), /*#__PURE__*/_react.default.createElement("div", {
	    className: "footer-copyright"
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: "container"
	  }, copyrights, moreLinks)));
	};
	
	Footer.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  copyrights: _propTypes.default.string,
	  links: _propTypes.default.node,
	  moreLinks: _propTypes.default.node
	};
	var _default = Footer;
	exports.default = _default;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var MediaBox = function MediaBox(_ref) {
	  var id = _ref.id,
	      options = _ref.options,
	      children = _ref.children,
	      className = _ref.className,
	      caption = _ref.caption,
	      props = _objectWithoutProperties(_ref, ["id", "options", "children", "className", "caption"]);
	
	  var mediaBoxRef = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    var instance = M.Materialbox.init(mediaBoxRef.current, options);
	    return function () {
	      if (instance) {
	        instance.destroy();
	      }
	    };
	  }, [id, options, children]);
	  return _react.default.cloneElement(children, _objectSpread({
	    id: id,
	    ref: mediaBoxRef,
	    className: (0, _classnames.default)('materialboxed', className),
	    'data-caption': caption
	  }, props));
	};
	
	MediaBox.propTypes = {
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * override id
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	  className: _propTypes.default.string,
	
	  /**
	   * The caption shown below the image when opened
	   */
	  caption: _propTypes.default.string,
	  options: _propTypes.default.shape({
	    /**
	     * Transition in duration in milliseconds.
	     */
	    inDuration: _propTypes.default.number,
	
	    /**
	     * Transition out duration in milliseconds.
	     */
	    outDuration: _propTypes.default.number,
	
	    /**
	     * Callback function called before materialbox is opened.
	     */
	    onOpenStart: _propTypes.default.func,
	
	    /**
	     * Callback function called after materialbox is opened.
	     */
	    onOpenEnd: _propTypes.default.func,
	
	    /**
	     * Callback function called before materialbox is closed.
	     */
	    onCloseStart: _propTypes.default.func,
	
	    /**
	     * Callback function called after materialbox is closed.
	     */
	    onCloseEnd: _propTypes.default.func
	  })
	};
	MediaBox.defaultProps = {
	  id: "MediaBox_".concat((0, _idgen.default)()),
	  options: {
	    inDuration: 275,
	    outDuration: 200,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null
	  }
	};
	var _default = MediaBox;
	exports.default = _default;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(19);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	var _Button = _interopRequireDefault(__webpack_require__(21));
	
	var _utils = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Modal = function Modal(_ref) {
	  var actions = _ref.actions,
	      bottomSheet = _ref.bottomSheet,
	      children = _ref.children,
	      fixedFooter = _ref.fixedFooter,
	      header = _ref.header,
	      className = _ref.className,
	      trigger = _ref.trigger,
	      options = _ref.options,
	      open = _ref.open,
	      root = _ref.root,
	      props = _objectWithoutProperties(_ref, ["actions", "bottomSheet", "children", "fixedFooter", "header", "className", "trigger", "options", "open", "root"]);
	
	  var _modalRoot = (0, _react.useRef)(null);
	
	  var _modalInstance = (0, _react.useRef)(null);
	
	  var _modalRef = (0, _react.useRef)(null);
	
	  if (root === null) {
	    console.warn('React Materialize: root should be a valid node element to render a Modal');
	  }
	
	  (0, _react.useEffect)(function () {
	    var modalRoot = _modalRoot.current;
	
	    if (!_modalInstance.current) {
	      _modalInstance.current = M.Modal.init(_modalRef.current, options);
	    }
	
	    return function () {
	      if (root.contains(modalRoot)) {
	        root.removeChild(modalRoot);
	      }
	
	      _modalInstance.current.destroy();
	    }; // deep comparing options object
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [(0, _utils.safeJSONStringify)(options), root]);
	  (0, _react.useEffect)(function () {
	    if (open) {
	      showModal();
	    } else {
	      hideModal();
	    }
	  }, [open]);
	
	  var showModal = function showModal(e) {
	    e && e.preventDefault();
	    _modalInstance.current && _modalInstance.current.open();
	  };
	
	  var hideModal = function hideModal(e) {
	    e && e.preventDefault();
	    _modalInstance.current && _modalInstance.current.close();
	  };
	
	  var classes = (0, _classnames.default)('modal', {
	    'modal-fixed-footer': fixedFooter,
	    'bottom-sheet': bottomSheet
	  }, className);
	
	  var renderModalPortal = function renderModalPortal() {
	    if (!_modalRoot.current) {
	      _modalRoot.current = document.createElement('div');
	      root.appendChild(_modalRoot.current);
	    }
	
	    return (0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", _extends({
	      className: classes,
	      ref: _modalRef
	    }, props), /*#__PURE__*/_react.default.createElement("div", {
	      className: "modal-content"
	    }, /*#__PURE__*/_react.default.createElement("h4", null, header), children), /*#__PURE__*/_react.default.createElement("div", {
	      className: "modal-footer"
	    }, _react.Children.toArray(actions))), _modalRoot.current);
	  };
	
	  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, trigger && (0, _react.cloneElement)(trigger, {
	    onClick: showModal
	  }), renderModalPortal());
	};
	
	Modal.propTypes = {
	  /**
	   * Options
	   * Object with options for modal
	   */
	  options: _propTypes.default.shape({
	    /**
	     * Opacity of the modal overlay.
	     */
	    opacity: _propTypes.default.number,
	
	    /**
	     * Transition in duration in milliseconds.
	     */
	    inDuration: _propTypes.default.number,
	
	    /**
	     * Transition out duration in milliseconds.
	     */
	    outDuration: _propTypes.default.number,
	
	    /**
	     * Callback function called before modal is opened.
	     */
	    onOpenStart: _propTypes.default.func,
	
	    /**
	     * Callback function called after modal is opened.
	     */
	    onOpenEnd: _propTypes.default.func,
	
	    /**
	     * Callback function called before modal is closed.
	     */
	    onCloseStart: _propTypes.default.func,
	
	    /**
	     * Callback function called after modal is closed.
	     */
	    onCloseEnd: _propTypes.default.func,
	
	    /**
	     * Prevent page from scrolling while modal is open.
	     */
	    preventScrolling: _propTypes.default.bool,
	
	    /**
	     * Allow modal to be dismissed by keyboard or overlay click.
	     */
	    dismissible: _propTypes.default.bool,
	
	    /**
	     * Starting top offset
	     */
	    startingTop: _propTypes.default.string,
	
	    /**
	     * Ending top offset
	     */
	    endingTop: _propTypes.default.string
	  }),
	
	  /**
	   * Extra class to added to the Modal
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Modal is opened on mount
	   * @default false
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * BottomSheet styled modal
	   * @default false
	   */
	  bottomSheet: _propTypes.default.bool,
	
	  /**
	   * Component children
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * FixedFooter styled modal
	   * @default false
	   */
	  fixedFooter: _propTypes.default.bool,
	
	  /**
	   * Text to shown in the header of the modal
	   */
	  header: _propTypes.default.string,
	
	  /**
	   * The button to trigger the display of the modal
	   */
	  trigger: _propTypes.default.node,
	
	  /**
	   * The buttons to show in the footer of the modal
	   * @default <Button>Close</Button>
	   */
	  actions: _propTypes.default.node,
	
	  /**
	   * The ID to trigger the modal opening/closing
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Root node where modal should be injected
	   * @default document.body
	   */
	  root: _propTypes.default.any
	};
	Modal.defaultProps = {
	  id: "Modal-".concat((0, _idgen.default)()),
	  root: typeof window !== 'undefined' ? document.body : null,
	  open: false,
	  options: {
	    opacity: 0.5,
	    inDuration: 250,
	    outDuration: 250,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    preventScrolling: true,
	    dismissible: true,
	    startingTop: '4%',
	    endingTop: '10%'
	  },
	  fixedFooter: false,
	  bottomSheet: false,
	  actions: [/*#__PURE__*/_react.default.createElement(_Button.default, {
	    waves: "green",
	    modal: "close",
	    flat: true
	  }, "Close")]
	};
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var NavItem = function NavItem(_ref) {
	  var divider = _ref.divider,
	      props = _objectWithoutProperties(_ref, ["divider"]);
	
	  if (divider) return /*#__PURE__*/_react.default.createElement("li", {
	    className: "divider"
	  });
	  return /*#__PURE__*/_react.default.createElement("a", props);
	};
	
	NavItem.propTypes = {
	  /**
	   * children can be a string value or a node
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
	  divider: _propTypes.default.bool,
	  href: _propTypes.default.string,
	
	  /**
	   * NavItem can have onClick. If it does have, href
	   * will not be rendered
	   */
	  onClick: _propTypes.default.func
	};
	var _default = NavItem;
	exports.default = _default;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	var _SearchForm = _interopRequireDefault(__webpack_require__(43));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Navbar = function Navbar(_ref) {
	  var id = _ref.id,
	      children = _ref.children,
	      brand = _ref.brand,
	      className = _ref.className,
	      extendWith = _ref.extendWith,
	      fixed = _ref.fixed,
	      alignLinks = _ref.alignLinks,
	      centerLogo = _ref.centerLogo,
	      search = _ref.search,
	      menuIcon = _ref.menuIcon,
	      sidenav = _ref.sidenav,
	      options = _ref.options,
	      centerChildren = _ref.centerChildren,
	      props = _objectWithoutProperties(_ref, ["id", "children", "brand", "className", "extendWith", "fixed", "alignLinks", "centerLogo", "search", "menuIcon", "sidenav", "options", "centerChildren"]);
	
	  var _sidenav = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var instance = M.Sidenav.init(_sidenav.current, options);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [options, children]);
	  var brandClasses = (0, _classnames.default)({
	    'brand-logo': true,
	    right: alignLinks === 'left',
	    center: centerLogo
	  });
	  var navCSS = (0, _classnames.default)({
	    'nav-extended': extendWith
	  }, className);
	  var navMobileCSS = (0, _classnames.default)('hide-on-med-and-down', [alignLinks]);
	
	  var links = _react.Children.map(children, function (link, index) {
	    return /*#__PURE__*/_react.default.createElement("li", {
	      key: index
	    }, link);
	  });
	
	  var sidenavLinks = sidenav ? sidenav : _react.Children.map(children, function (link, index) {
	    var clonedLink = link && link.props && link.props.id ? (0, _react.cloneElement)(link, _objectSpread({}, link.props, {
	      id: "sidenav-".concat(link.props.id)
	    })) : link;
	    return /*#__PURE__*/_react.default.createElement("li", {
	      key: index
	    }, clonedLink);
	  });
	
	  var navbar = /*#__PURE__*/_react.default.createElement("nav", _extends({
	    className: navCSS
	  }, props), /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)({
	      container: centerChildren
	    }, 'nav-wrapper')
	  }, search ? /*#__PURE__*/_react.default.createElement(_SearchForm.default, null) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, brand && (0, _react.cloneElement)(brand, {
	    className: (0, _classnames.default)(brand.props.className, brandClasses)
	  }), /*#__PURE__*/_react.default.createElement("a", {
	    href: "#!",
	    "data-target": id,
	    className: "sidenav-trigger"
	  }, menuIcon), /*#__PURE__*/_react.default.createElement("ul", {
	    className: navMobileCSS
	  }, links))), extendWith && /*#__PURE__*/_react.default.createElement("div", {
	    className: "nav-content"
	  }, extendWith));
	
	  if (fixed) {
	    navbar = /*#__PURE__*/_react.default.createElement("div", {
	      className: "navbar-fixed"
	    }, navbar);
	  }
	
	  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, navbar, /*#__PURE__*/_react.default.createElement("ul", {
	    id: id,
	    className: (0, _classnames.default)('sidenav', [alignLinks]),
	    ref: _sidenav
	  }, sidenavLinks));
	};
	
	Navbar.propTypes = {
	  /**
	   * override id
	   * @default 'mobile-nav'
	   */
	  id: _propTypes.default.string,
	  brand: _propTypes.default.node,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  extendWith: _propTypes.default.node,
	  search: _propTypes.default.bool,
	
	  /**
	   * Allows for custom sidenav node, used for mobile view
	   */
	  sidenav: _propTypes.default.node,
	
	  /**
	   * left makes the navbar links left aligned, right makes them right aligned
	   */
	  alignLinks: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * The logo will center itself on medium and down screens.
	   * Specifying centerLogo as a prop the logo will always be centered
	   */
	  centerLogo: _propTypes.default.bool,
	
	  /**
	   * The Navbar children will be constrained in a container rather than spread out to the far edges
	   */
	  centerChildren: _propTypes.default.bool,
	
	  /**
	   * Makes the navbar fixed
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * Options hash for the sidenav.
	   * More info: https://materializecss.com/sidenav.html#options
	   */
	  options: _propTypes.default.shape({
	    // Side of screen on which Sidenav appears.
	    edge: _propTypes.default.oneOf(['left', 'right']),
	    // Allow swipe gestures to open / close Sidenav.
	    draggable: _propTypes.default.bool,
	    // Length in ms of enter transition.
	    inDuration: _propTypes.default.number,
	    // Length in ms of exit transition.
	    outDuration: _propTypes.default.number,
	    // Function called when sidenav starts entering.
	    onOpenStart: _propTypes.default.func,
	    // Function called when sidenav finishes entering.
	    onOpenEnd: _propTypes.default.func,
	    // Function called when sidenav starts exiting.
	    onCloseStart: _propTypes.default.func,
	    // Function called when sidenav finishes exiting.
	    onCloseEnd: _propTypes.default.func,
	    // Prevent page from scrolling while sidenav is open.
	    preventScrolling: _propTypes.default.bool
	  }),
	  menuIcon: _propTypes.default.node.isRequired
	};
	Navbar.defaultProps = {
	  id: 'mobile-nav',
	  options: {
	    edge: 'left',
	    draggable: true,
	    inDuration: 250,
	    outDuration: 200,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    preventScrolling: true
	  },
	  menuIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "menu")
	};
	var _default = Navbar;
	exports.default = _default;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Icon = _interopRequireDefault(__webpack_require__(8));
	
	var _PaginationButton = _interopRequireDefault(__webpack_require__(42));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Pagination = function Pagination(_ref) {
	  var items = _ref.items,
	      className = _ref.className,
	      children = _ref.children,
	      _ref$maxButtons = _ref.maxButtons,
	      maxButtons = _ref$maxButtons === void 0 ? items : _ref$maxButtons,
	      leftBtn = _ref.leftBtn,
	      rightBtn = _ref.rightBtn,
	      onSelect = _ref.onSelect,
	      activePageProp = _ref.activePage;
	
	  var _useState = (0, _react.useState)(activePageProp > 0 && activePageProp <= items ? activePageProp : 1),
	      _useState2 = _slicedToArray(_useState, 2),
	      activePage = _useState2[0],
	      setActivePage = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    setActivePage(activePageProp);
	  }, [activePageProp]);
	  var onClick = (0, _react.useCallback)(function (pageIdx) {
	    if (pageIdx > 0 && pageIdx <= items) {
	      if (onSelect) onSelect(pageIdx);
	      setActivePage(pageIdx);
	    }
	  }, [onSelect, items]);
	  var renderButtons = (0, _react.useMemo)(function () {
	    if (children) return children;
	    var buttonsCount = Math.min(maxButtons, items);
	    var maxPos = items - buttonsCount;
	    var halfButtons = parseInt(buttonsCount / 2, 10);
	    var hiddenPagesBefore = activePage - halfButtons;
	
	    if (hiddenPagesBefore > maxPos) {
	      hiddenPagesBefore = maxPos + 1;
	    }
	
	    var from = Math.max(hiddenPagesBefore, 1);
	    var to = Math.min(items, from + maxButtons - 1);
	    var buttons = [/*#__PURE__*/_react.default.createElement(_PaginationButton.default, {
	      disabled: activePage === 1,
	      key: 'pagination-0',
	      onSelect: function onSelect() {
	        return onClick(activePage - 1);
	      }
	    }, leftBtn)];
	
	    var _loop = function _loop(i) {
	      buttons.push( /*#__PURE__*/_react.default.createElement(_PaginationButton.default, {
	        active: i === activePage,
	        key: "pagination-".concat(i),
	        onSelect: function onSelect() {
	          return onClick(i);
	        }
	      }, i));
	    };
	
	    for (var i = from; i <= to; i++) {
	      _loop(i);
	    }
	
	    buttons.push( /*#__PURE__*/_react.default.createElement(_PaginationButton.default, {
	      key: "pagination-".concat(items + 1),
	      disabled: activePage === items,
	      onSelect: function onSelect() {
	        return onClick(activePage + 1);
	      }
	    }, rightBtn));
	    return buttons;
	  }, [children, maxButtons, items, activePage, onClick, leftBtn, rightBtn]);
	  return /*#__PURE__*/_react.default.createElement("ul", {
	    className: (0, _classnames.default)('pagination', className)
	  }, renderButtons);
	};
	
	Pagination.propTypes = {
	  /**
	   * Number of items in the component
	   */
	  items: _propTypes.default.number.isRequired,
	
	  /**
	   * The initial activePage
	   */
	  activePage: _propTypes.default.number,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  maxButtons: _propTypes.default.number,
	  onSelect: _propTypes.default.func,
	  leftBtn: _propTypes.default.node,
	  rightBtn: _propTypes.default.node
	};
	Pagination.defaultProps = {
	  activePage: 1,
	  items: 10,
	  leftBtn: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "chevron_left"),
	  rightBtn: /*#__PURE__*/_react.default.createElement(_Icon.default, null, "chevron_right")
	};
	var _default = Pagination;
	exports.default = _default;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Parallax = function Parallax(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      image = _ref.image,
	      options = _ref.options,
	      props = _objectWithoutProperties(_ref, ["children", "className", "image", "options"]);
	
	  var _parallax = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var instance = M.Parallax.init(_parallax.current, options);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [_parallax, options, children, image]);
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    className: (0, _classnames.default)('parallax-container', className)
	  }, props), children, /*#__PURE__*/_react.default.createElement("div", {
	    className: "parallax",
	    ref: _parallax
	  }, image));
	};
	
	Parallax.propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	
	  /**
	   * The image which will be used for the background of the parallax
	   */
	  image: _propTypes.default.node.isRequired,
	  options: _propTypes.default.shape({
	    /**
	     * The minimum width of the screen, in pixels, where the parallax functionality starts working.
	     */
	    responsiveThreshold: _propTypes.default.number
	  })
	};
	Parallax.defaultProps = {
	  options: {
	    responsiveThreshold: 0
	  }
	};
	var _default = Parallax;
	exports.default = _default;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Spinner = _interopRequireDefault(__webpack_require__(44));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = ['blue', 'red', 'yellow', 'green'];
	
	var Preloader = function Preloader(_ref) {
	  var active = _ref.active,
	      size = _ref.size,
	      color = _ref.color,
	      flashing = _ref.flashing,
	      className = _ref.className;
	  var classes = (0, _classnames.default)('preloader-wrapper', {
	    active: active
	  }, size);
	  var spinners;
	
	  if (flashing) {
	    spinners = colors.map(function (color) {
	      return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
	        color: color,
	        only: false,
	        key: color
	      });
	    });
	  } else {
	    spinners = /*#__PURE__*/_react.default.createElement(_Spinner.default, {
	      color: color
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)(className, classes)
	  }, spinners);
	};
	
	Preloader.propTypes = {
	  className: _propTypes.default.string,
	
	  /**
	   * The scale of the circle
	   * @default 'medium'
	   */
	  size: _propTypes.default.oneOf(['big', 'small', 'medium']),
	
	  /**
	   * Whether to spin
	   * @default true
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * The color of the circle, if not flashing
	   * @default 'blue'
	   */
	  color: _propTypes.default.oneOf(['blue', 'red', 'yellow', 'green']),
	
	  /**
	   * Wheter to circle four different colors
	   * @default false
	   */
	  flashing: _propTypes.default.bool
	};
	Preloader.defaultProps = {
	  active: true,
	  flashing: false,
	  color: 'blue'
	};
	var _default = Preloader;
	exports.default = _default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function ProgressBar(_ref) {
	  var progress = _ref.progress,
	      className = _ref.className;
	  var style;
	  var classes = {
	    indeterminate: progress === undefined,
	    determinate: !!progress
	  };
	
	  if (progress) {
	    style = {
	      width: progress + '%'
	    };
	  }
	
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)('progress lighten-5', className)
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)(classes, className),
	    style: style
	  }));
	};
	
	ProgressBar.propTypes = {
	  className: _propTypes.default.string,
	
	  /**
	   * A number between 0..100 that indicates the current progress,
	   * when provided, a determinate bar with the progress is displayed,
	   * otherwise a indeterminate bar is shown
	   */
	  progress: _propTypes.default.number
	};
	var _default = ProgressBar;
	exports.default = _default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var RadioGroup = function RadioGroup(_ref) {
	  var onChange = _ref.onChange,
	      withGap = _ref.withGap,
	      disabled = _ref.disabled,
	      name = _ref.name,
	      radioClassNames = _ref.radioClassNames,
	      value = _ref.value,
	      options = _ref.options;
	  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, options.map(function (radioItem, idx) {
	    return /*#__PURE__*/_react.default.createElement("label", {
	      className: radioClassNames,
	      htmlFor: "radio".concat(idx),
	      key: "radio".concat(idx)
	    }, /*#__PURE__*/_react.default.createElement("input", {
	      id: "radio".concat(idx),
	      value: radioItem.value,
	      type: "radio",
	      checked: radioItem.value === value,
	      name: name,
	      onChange: onChange,
	      disabled: disabled,
	      className: (0, _classnames.default)({
	        'with-gap': withGap
	      })
	    }), /*#__PURE__*/_react.default.createElement("span", null, radioItem.label));
	  }));
	};
	
	RadioGroup.propTypes = {
	  options: _propTypes.default.arrayOf(_propTypes.default.shape({
	    label: _propTypes.default.string.isRequired,
	    value: _propTypes.default.string.isRequired
	  })).isRequired,
	
	  /**
	   * predefined checked value
	   */
	  value: _propTypes.default.string,
	
	  /**
	   * radio group name
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * with-gap styled checkbox
	   */
	  withGap: _propTypes.default.bool,
	
	  /**
	   * onChange callback
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * disabled input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * classnames passed to label wrapper
	   */
	  radioClassNames: _propTypes.default.string
	};
	var _default = RadioGroup;
	exports.default = _default;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Range = function Range(_ref) {
	  var min = _ref.min,
	      max = _ref.max,
	      step = _ref.step;
	  var rangeRef = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    var instance = M.Range.init(rangeRef.current);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [min, max]);
	  return /*#__PURE__*/_react.default.createElement("p", {
	    className: "range-field"
	  }, /*#__PURE__*/_react.default.createElement("input", {
	    type: "range",
	    ref: rangeRef,
	    min: min,
	    max: max,
	    step: step
	  }));
	};
	
	Range.propTypes = {
	  min: _propTypes.default.string.isRequired,
	  max: _propTypes.default.string.isRequired,
	  step: _propTypes.default.string
	};
	var _default = Range;
	exports.default = _default;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Section = function Section(_ref) {
	  var _ref$node = _ref.node,
	      node = _ref$node === void 0 ? 'div' : _ref$node,
	      className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ["node", "className"]);
	
	  var Component = node;
	  return /*#__PURE__*/_react.default.createElement(Component, _extends({
	    className: (0, _classnames.default)('section', className)
	  }, rest));
	};
	
	Section.propTypes = {
	  children: _propTypes.default.node,
	  node: _propTypes.default.node,
	  id: _propTypes.default.string,
	  className: _propTypes.default.string
	};
	var _default = Section;
	exports.default = _default;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	var _Dropdown = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Select = function Select(_ref) {
	  var id = _ref.id,
	      s = _ref.s,
	      m = _ref.m,
	      l = _ref.l,
	      xl = _ref.xl,
	      noLayout = _ref.noLayout,
	      browserDefault = _ref.browserDefault,
	      icon = _ref.icon,
	      label = _ref.label,
	      className = _ref.className,
	      success = _ref.success,
	      error = _ref.error,
	      validate = _ref.validate,
	      children = _ref.children,
	      multiple = _ref.multiple,
	      options = _ref.options,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      props = _objectWithoutProperties(_ref, ["id", "s", "m", "l", "xl", "noLayout", "browserDefault", "icon", "label", "className", "success", "error", "validate", "children", "multiple", "options", "value", "onChange"]);
	
	  var _useState = (0, _react.useState)(value),
	      _useState2 = _slicedToArray(_useState, 2),
	      selectedValue = _useState2[0],
	      setSelectedValue = _useState2[1];
	
	  var _selectRef = (0, _react.useRef)(null);
	
	  var _formSelectInstance = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    _formSelectInstance.current = M.FormSelect.init(_selectRef.current, options);
	    return function () {
	      _formSelectInstance.current && _formSelectInstance.current.destroy();
	    };
	  }, [options, children]);
	  (0, _react.useEffect)(function () {
	    setSelectedValue(value);
	  }, [value]);
	  var sizes = {
	    s: s,
	    m: m,
	    l: l,
	    xl: xl
	  };
	  var responsiveClasses = {};
	
	  if (!noLayout) {
	    responsiveClasses = {
	      col: true
	    };
	
	    _constants.default.SIZES.forEach(function (size) {
	      responsiveClasses[size + sizes[size]] = sizes[size];
	    });
	  }
	
	  var renderOption = function renderOption(child) {
	    return (0, _react.cloneElement)(child, {
	      key: child.props.value
	    });
	  };
	
	  var handleChange = function handleChange(e) {
	    var value = e.target.value;
	
	    if (multiple) {
	      value = _formSelectInstance.current.getSelectedValues();
	    }
	
	    onChange && onChange(e);
	    setSelectedValue(value);
	  };
	
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)('input-field', responsiveClasses)
	  }, Boolean(icon) && (0, _react.cloneElement)(icon, {
	    className: 'prefix'
	  }), /*#__PURE__*/_react.default.createElement("select", _extends({}, props, {
	    type: "select",
	    id: id,
	    value: selectedValue,
	    ref: _selectRef,
	    onChange: handleChange,
	    className: (0, _classnames.default)(className, _defineProperty({
	      validate: validate,
	      multiple: multiple
	    }, 'browser-default', browserDefault)),
	    multiple: multiple
	  }), _react.Children.map(children, renderOption)), Boolean(label) && /*#__PURE__*/_react.default.createElement("label", {
	    "data-success": success,
	    "data-error": error,
	    htmlFor: id
	  }, label));
	};
	
	Select.propTypes = {
	  /**
	   * Use browser default styles
	   */
	  browserDefault: _propTypes.default.bool,
	
	  /**
	   * Strip away all layout classes such as col and sX
	   */
	  noLayout: _propTypes.default.bool,
	
	  /**
	   * Responsive size for small size screens (Mobile Devices <= 600px)
	   */
	  s: _propTypes.default.number,
	
	  /**
	   * Responsive size for middle size screens (Tablet Devices > 600px)
	   */
	  m: _propTypes.default.number,
	
	  /**
	   * Responsive size for large size screens (Desktop Devices > 992px)
	   */
	  l: _propTypes.default.number,
	
	  /**
	   * Responsive size for extra large screens (Large Desktop Devices > 1200px)
	   */
	  xl: _propTypes.default.number,
	
	  /**
	   * disabled input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * override id
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * prefix icon
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * label text
	   */
	  label: _propTypes.default.string,
	
	  /**
	   * Input initial value
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	
	  /**
	   * Add validate class to input
	   */
	  validate: _propTypes.default.bool,
	
	  /**
	   * Custom success message
	   */
	  success: _propTypes.default.string,
	
	  /**
	   * Custom error message
	   */
	  error: _propTypes.default.string,
	
	  /**
	   * Additional classes for input
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * override type="text"
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * onChange callback
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Render a multiple dropdown,
	   * use instance.getSelectedValues()
	   * to get array of selected values
	   */
	  multiple: _propTypes.default.bool,
	  children: _propTypes.default.any,
	
	  /**
	   * Options for the select
	   * <a target="_blank" href="https://materializecss.com/select.html#options">https://materializecss.com/select.html</a>
	   */
	  options: _propTypes.default.shape({
	    classes: _propTypes.default.string,
	
	    /**
	     * Options for the dropdown
	     * <a target="_blank" href="http://materializecss.com/dropdown.html#options">http://materializecss.com/dropdown.html</a>
	     */
	    dropdownOptions: _Dropdown.dropdownOptions
	  })
	};
	Select.defaultProps = {
	  id: "Select-".concat((0, _idgen.default)()),
	  multiple: false,
	  options: {
	    classes: '',
	    dropdownOptions: {
	      alignment: 'left',
	      autoTrigger: true,
	      constrainWidth: true,
	      coverTrigger: true,
	      closeOnClick: true,
	      hover: false,
	      inDuration: 150,
	      outDuration: 250,
	      onOpenStart: null,
	      onOpenEnd: null,
	      onCloseStart: null,
	      onCloseEnd: null
	    }
	  }
	};
	var _default = Select;
	exports.default = _default;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var SideNav = function SideNav(_ref) {
	  var options = _ref.options,
	      id = _ref.id,
	      className = _ref.className,
	      children = _ref.children,
	      trigger = _ref.trigger,
	      fixed = _ref.fixed,
	      props = _objectWithoutProperties(_ref, ["options", "id", "className", "children", "trigger", "fixed"]);
	
	  var sidenavRef = (0, _react.useRef)(null);
	  var triggerRef = (0, _react.useRef)(null);
	  var classNames = (0, _classnames.default)('sidenav', {
	    'sidenav-fixed': fixed || !trigger
	  }, className);
	  (0, _react.useEffect)(function () {
	    var instance = M.Sidenav.init(sidenavRef.current, options);
	    return function () {
	      return instance.destroy();
	    };
	  }, [options, children]);
	  var renderTrigger = (0, _react.useMemo)(function () {
	    if (!trigger) return;
	    var triggerView = fixed ? 'hide-on-large-only' : 'show-on-large';
	    var classNames = (0, _classnames.default)(trigger.props.className, triggerView, 'sidenav-trigger');
	    return _react.default.cloneElement(trigger, {
	      ref: triggerRef,
	      'data-target': id,
	      className: classNames
	    });
	  }, [id, fixed, trigger]);
	  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, renderTrigger, /*#__PURE__*/_react.default.createElement("ul", _extends({
	    ref: function ref(el) {
	      return sidenavRef.current = el;
	    },
	    id: id,
	    className: classNames
	  }, props), children));
	};
	
	SideNav.propTypes = {
	  /**
	   * Adds sidenav-fixed class to sidenav
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * sidenav id. If none is passed, an id will be generated.
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Component that is rendered to trigger the sidenav
	   */
	  trigger: _propTypes.default.node,
	
	  /**
	   * Options hash for the sidenav.
	   * More info: http://materializecss.com/side-nav.html#options
	   */
	  options: _propTypes.default.shape({
	    edge: _propTypes.default.oneOf(['left', 'right']),
	    draggable: _propTypes.default.bool,
	    inDuration: _propTypes.default.number,
	    outDuration: _propTypes.default.number,
	    onOpenStart: _propTypes.default.func,
	    onOpenEnd: _propTypes.default.func,
	    onCloseStart: _propTypes.default.func,
	    onCloseEnd: _propTypes.default.func,
	    preventScrolling: _propTypes.default.bool
	  }),
	
	  /**
	   * Additional classes added to 'sidenav'
	   */
	  className: _propTypes.default.string,
	  children: _propTypes.default.node
	};
	SideNav.defaultProps = {
	  id: "SideNav-".concat((0, _idgen.default)())
	};
	var _default = SideNav;
	exports.default = _default;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _UserView = _interopRequireWildcard(__webpack_require__(143));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var SideNavItem = function SideNavItem(_ref) {
	  var divider = _ref.divider,
	      subheader = _ref.subheader,
	      userView = _ref.userView,
	      icon = _ref.icon,
	      _ref$href = _ref.href,
	      href = _ref$href === void 0 ? '#!' : _ref$href,
	      waves = _ref.waves,
	      _ref$user = _ref.user,
	      user = _ref$user === void 0 ? {} : _ref$user,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["divider", "subheader", "userView", "icon", "href", "waves", "user", "children"]);
	
	  var itemClasses = {
	    divider: divider
	  };
	  var linkClasses = {
	    subheader: subheader,
	    'waves-effect': waves
	  };
	  return /*#__PURE__*/_react.default.createElement("li", _extends({
	    className: (0, _classnames.default)(itemClasses)
	  }, props), userView && user && /*#__PURE__*/_react.default.createElement(_UserView.default, user), !userView && /*#__PURE__*/_react.default.createElement("a", {
	    className: (0, _classnames.default)(linkClasses),
	    href: href
	  }, icon && _react.default.cloneElement(icon, {
	    className: 'prefix'
	  }), children));
	};
	
	SideNavItem.propTypes = {
	  children: _propTypes.default.node,
	  divider: _propTypes.default.bool,
	  subheader: _propTypes.default.bool,
	  userView: _propTypes.default.bool,
	  waves: _propTypes.default.bool,
	  href: _propTypes.default.string,
	  icon: _propTypes.default.node,
	  user: _propTypes.default.shape(_UserView.UserShape)
	};
	var _default = SideNavItem;
	exports.default = _default;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slide = function Slide(_ref) {
	  var image = _ref.image,
	      children = _ref.children;
	  return /*#__PURE__*/_react.default.createElement("li", null, image, children);
	};
	
	Slide.propTypes = {
	  className: _propTypes.default.string,
	  children: _propTypes.default.node,
	
	  /**
	   * The image that will be used in the Slide
	   */
	  image: _propTypes.default.node.isRequired
	};
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Slider = function Slider(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      options = _ref.options,
	      fullscreen = _ref.fullscreen,
	      props = _objectWithoutProperties(_ref, ["children", "className", "options", "fullscreen"]);
	
	  var sliderInstance = (0, _react.useRef)(null);
	
	  var _slider = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeIndex = _useState2[0],
	      setActiveIndex = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    sliderInstance.current = M.Slider.init(_slider.current, options);
	    return function () {
	      if (sliderInstance.current) {
	        setActiveIndex(sliderInstance.current.activeIndex);
	        sliderInstance.current.destroy();
	      }
	    };
	  }, [_slider, options, fullscreen, children]);
	  (0, _react.useEffect)(function () {
	    if (activeIndex) {
	      if (typeof indicators === 'undefined' || options.indicators) {
	        sliderInstance.current['$indicators'][activeIndex].className = 'indicator-item active';
	      }
	    }
	  }, [activeIndex, options.indicators, fullscreen]);
	  /**
	   * If the slider was not in fullscreen, the height is set as a style attribute
	   * on the Slider element. When `.destroy()` is called, this attribute is not
	   * removed, resulting in a fullscreen displayed incorrectly.
	   */
	
	  (0, _react.useEffect)(function () {
	    if (fullscreen) {
	      _slider.current.removeAttribute('style');
	
	      _slider.current.childNodes[0].removeAttribute('style');
	    }
	  }, [fullscreen]);
	  return /*#__PURE__*/_react.default.createElement("div", _extends({
	    ref: _slider,
	    className: (0, _classnames.default)('slider', className, {
	      fullscreen: fullscreen
	    })
	  }, props), /*#__PURE__*/_react.default.createElement("ul", {
	    className: "slides"
	  }, children));
	};
	
	Slider.propTypes = {
	  className: _propTypes.default.string,
	  children: _propTypes.default.node,
	
	  /**
	   * Whether or not the Slider should be fullscreen
	   * @default false
	   */
	  fullscreen: _propTypes.default.bool,
	  options: _propTypes.default.shape({
	    /**
	     * Set to false to hide slide indicators
	     * @default true
	     */
	    indicators: _propTypes.default.bool,
	
	    /**
	     * The interval between transitions in ms
	     * @default 6000
	     */
	    interval: _propTypes.default.number,
	
	    /**
	     * The duration of the transation animation in ms
	     * @default 500
	     */
	    duration: _propTypes.default.number,
	
	    /**
	     * The height of the Slider window
	     * @default 400
	     */
	    height: _propTypes.default.number
	  })
	};
	Slider.defaultProps = {
	  fullscreen: false,
	  options: {
	    indicators: true,
	    interval: 6000,
	    duration: 500,
	    height: 400
	  }
	};
	var _default = Slider;
	exports.default = _default;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Switch = function Switch(_ref) {
	  var id = _ref.id,
	      offLabel = _ref.offLabel,
	      onLabel = _ref.onLabel,
	      props = _objectWithoutProperties(_ref, ["id", "offLabel", "onLabel"]);
	
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: "switch"
	  }, /*#__PURE__*/_react.default.createElement("label", {
	    htmlFor: id
	  }, offLabel, /*#__PURE__*/_react.default.createElement("input", _extends({
	    id: id,
	    type: "checkbox"
	  }, props)), /*#__PURE__*/_react.default.createElement("span", {
	    className: "lever"
	  }), onLabel));
	};
	
	Switch.propTypes = {
	  /**
	   * override id
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	  className: _propTypes.default.string,
	
	  /**
	   * label for off
	   */
	  offLabel: _propTypes.default.string.isRequired,
	
	  /**
	   * label for on
	   */
	  onLabel: _propTypes.default.string.isRequired,
	
	  /**
	   * onChange callback
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * disabled input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * initialise checkbox checked
	   */
	  checked: _propTypes.default.bool
	};
	Switch.defaultProps = {
	  id: "Switch-".concat((0, _idgen.default)()),
	  onChange: function onChange() {}
	};
	var _default = Switch;
	exports.default = _default;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Table = function Table(_ref) {
	  var centered = _ref.centered,
	      children = _ref.children,
	      className = _ref.className,
	      hoverable = _ref.hoverable,
	      responsive = _ref.responsive,
	      striped = _ref.striped,
	      props = _objectWithoutProperties(_ref, ["centered", "children", "className", "hoverable", "responsive", "striped"]);
	
	  var classes = {
	    centered: centered,
	    highlight: hoverable,
	    'responsive-table': responsive,
	    striped: striped
	  };
	  return /*#__PURE__*/_react.default.createElement("table", _extends({
	    className: (0, _classnames.default)(classes, className)
	  }, props), children);
	};
	
	Table.propTypes = {
	  className: _propTypes.default.string,
	  children: _propTypes.default.node,
	
	  /**
	   * Center align all the text in the table
	   * @default false
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * Highlight the row that's hovered
	   * @default false
	   */
	  hoverable: _propTypes.default.bool,
	
	  /**
	   * Enable response to make the table horizontally scrollable on smaller screens
	   * @default false
	   */
	  responsive: _propTypes.default.bool,
	
	  /**
	   * striped style
	   * @default false
	   */
	  striped: _propTypes.default.bool
	};
	var _default = Table;
	exports.default = _default;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Row = _interopRequireDefault(__webpack_require__(22));
	
	var _Tab = _interopRequireDefault(__webpack_require__(45));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var scope = "tabs-".concat((0, _idgen.default)());
	
	var Tabs = function Tabs(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      defaultValue = _ref.defaultValue,
	      options = _ref.options,
	      onChange = _ref.onChange;
	
	  var _tabsRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var instance = M.Tabs.init(_tabsRef.current, options);
	    return function () {
	      return instance.destroy();
	    };
	  }, [options, children]);
	  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
	    className: (0, _classnames.default)('tabs', className),
	    ref: _tabsRef
	  }, _react.default.Children.map(children, function (child, id) {
	    var _classes;
	
	    var idx = "".concat(scope).concat(id);
	    var _child$props = child.props,
	        active = _child$props.active,
	        disabled = _child$props.disabled,
	        tabWidth = _child$props.tabWidth,
	        title = _child$props.title;
	    var classes = (_classes = {}, _defineProperty(_classes, "s".concat(tabWidth), tabWidth), _defineProperty(_classes, "tab", true), _defineProperty(_classes, "disabled", disabled), _defineProperty(_classes, "col", true), _classes);
	    return /*#__PURE__*/_react.default.createElement("li", {
	      className: (0, _classnames.default)(classes),
	      key: idx
	    }, /*#__PURE__*/_react.default.createElement("a", _extends({
	      href: "#tab_".concat(idx),
	      className: active || defaultValue === idx ? 'active' : ''
	    }, disabled ? {} : {
	      onClick: onChange
	    }), title));
	  })), /*#__PURE__*/_react.default.createElement(_Row.default, null, _react.default.Children.map(children, function (child, id) {
	    var idx = "".concat(scope).concat(id);
	    return (0, _react.cloneElement)(child, {
	      idx: idx
	    });
	  })));
	};
	
	Tabs.propTypes = {
	  children: _propTypes.default.node.isRequired,
	  className: _propTypes.default.string,
	  defaultValue: _propTypes.default.string,
	  onChange: _propTypes.default.func,
	
	  /**
	   * More info
	   * <a href='http://materializecss.com/tabs.html'>http://materializecss.com/tabs.html</a>
	   */
	  options: _propTypes.default.shape({
	    /**
	     * Transition duration in milliseconds.
	     * @default 300
	     */
	    duration: _propTypes.default.number,
	
	    /**
	     * Callback for when a new tab content is showns.
	     * @default null
	     */
	    onShow: _propTypes.default.func,
	
	    /**
	     * Set to true to enable swipeable tabs. This also uses the responsiveThreshold option.
	     * @default false
	     */
	    swipeable: _propTypes.default.bool,
	
	    /**
	     * The maximum width of the screen, in pixels, where the swipeable functionality initializes.
	     * @default Infinity
	     */
	    responsiveThreshold: _propTypes.default.number
	  })
	};
	_Tab.default.defaultProps = {
	  options: {
	    duration: 300,
	    onShow: null,
	    swipeable: false,
	    responsiveThreshold: Infinity
	  }
	};
	var _default = Tabs;
	exports.default = _default;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	var _constants = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Textarea = function Textarea(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      s = _ref.s,
	      m = _ref.m,
	      l = _ref.l,
	      xl = _ref.xl,
	      noLayout = _ref.noLayout,
	      placeholder = _ref.placeholder,
	      icon = _ref.icon,
	      label = _ref.label,
	      success = _ref.success,
	      error = _ref.error,
	      iconClassName = _ref.iconClassName,
	      onChange = _ref.onChange,
	      validate = _ref.validate,
	      defaultValue = _ref.defaultValue,
	      value = _ref.value,
	      id = _ref.id,
	      rest = _objectWithoutProperties(_ref, ["children", "className", "s", "m", "l", "xl", "noLayout", "placeholder", "icon", "label", "success", "error", "iconClassName", "onChange", "validate", "defaultValue", "value", "id"]);
	
	  var textareaRef = (0, _react.useRef)(null);
	  var dataLength = rest['data-length'];
	  (0, _react.useEffect)(function () {
	    if (dataLength) {
	      M.CharacterCounter.init(textareaRef.current);
	    }
	  }, [dataLength, children]);
	  (0, _react.useEffect)(function () {
	    M.textareaAutoResize(textareaRef.current);
	  }, [children]);
	  var sizes = {
	    s: s,
	    m: m,
	    l: l,
	    xl: xl
	  };
	  var responsiveClasses;
	
	  if (!noLayout) {
	    responsiveClasses = {
	      col: true
	    };
	
	    _constants.default.SIZES.forEach(function (size) {
	      responsiveClasses[size + sizes[size]] = sizes[size];
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: (0, _classnames.default)('input-field', responsiveClasses)
	  }, Boolean(icon) && _react.default.cloneElement(icon, {
	    className: 'prefix'
	  }), /*#__PURE__*/_react.default.createElement("textarea", _extends({
	    placeholder: placeholder,
	    id: id,
	    value: value,
	    defaultValue: defaultValue,
	    ref: textareaRef,
	    onChange: onChange
	  }, rest, {
	    className: (0, _classnames.default)('materialize-textarea', {
	      validate: validate
	    }, className)
	  })), Boolean(label) && /*#__PURE__*/_react.default.createElement("label", {
	    className: (0, _classnames.default)({
	      active: value || placeholder,
	      'label-icon': typeof label !== 'string'
	    }),
	    "data-success": success,
	    "data-error": error,
	    htmlFor: id
	  }, label), [error || success] && /*#__PURE__*/_react.default.createElement("span", {
	    className: "helper-text",
	    "data-error": error,
	    "data-success": success
	  }), children);
	};
	
	Textarea.propTypes = {
	  children: _propTypes.default.node,
	
	  /**
	   * Strip away all layout classes such as col and sX
	   */
	  noLayout: _propTypes.default.bool,
	
	  /**
	   * Responsive size for Mobile Devices
	   */
	  s: _propTypes.default.number,
	
	  /**
	   * Responsive size for Tablet Devices
	   */
	  m: _propTypes.default.number,
	
	  /**
	   * Responsive size for Desktop Devices
	   */
	  l: _propTypes.default.number,
	
	  /**
	   *  Responsive size for Large Desktop Devices
	   */
	  xl: _propTypes.default.number,
	
	  /**
	   * disabled input
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Placeholder string
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * override id
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * render icon next to input
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * icon classname
	   */
	  iconClassName: _propTypes.default.string,
	
	  /**
	   * textarea label
	   */
	  label: _propTypes.default.string,
	
	  /**
	   * Input initial value
	   */
	  defaultValue: _propTypes.default.string,
	
	  /**
	   * predefined value
	   */
	  value: _propTypes.default.string,
	
	  /**
	   * Add validate class to input
	   */
	  validate: _propTypes.default.bool,
	
	  /**
	   * Custom success message
	   */
	  success: _propTypes.default.string,
	
	  /**
	   * Custom error message
	   */
	  error: _propTypes.default.string,
	
	  /**
	   * textarea classname
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * onChange callback
	   */
	  onChange: _propTypes.default.func
	};
	Textarea.defaultProps = {
	  id: "Textarea-".concat((0, _idgen.default)())
	};
	var _default = Textarea;
	exports.default = _default;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _TextInput = _interopRequireDefault(__webpack_require__(14));
	
	var _idgen = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var TimePicker = function TimePicker(_ref) {
	  var onChange = _ref.onChange,
	      options = _ref.options,
	      props = _objectWithoutProperties(_ref, ["onChange", "options"]);
	
	  var timeEl = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    var _options = onChange ? _objectSpread({}, options, {
	      onSelect: onChange
	    }) : options;
	
	    var instance = M.Timepicker.init(timeEl.current, _options);
	    return function () {
	      instance && instance.destroy();
	    };
	  }, [options, onChange]);
	  return /*#__PURE__*/_react.default.createElement(_TextInput.default, _extends({
	    ref: timeEl,
	    inputClassName: "timepicker"
	  }, props));
	};
	
	TimePicker.propTypes = {
	  /**
	   * Event called when Time has been selected
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * id passed to Timepicker, also used for init method
	   * @default idgen()
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * options passed to init method
	   * more info: https://materializecss.com/pickers.html#time-picker
	   */
	  options: _propTypes.default.shape({
	    /**
	     * Duration of the transition from/to the hours/minutes view.
	     * @default 350
	     */
	    duration: _propTypes.default.number,
	
	    /**
	     * Specify a selector for a DOM element to render the calendar in, by default it will be placed before the input.
	     * @default null
	     */
	    container: _propTypes.default.string,
	
	    /**
	     * Show the clear button in the Timepicker.
	     * @default false
	     */
	    showClearBtn: _propTypes.default.bool,
	
	    /**
	     * Default time to set on the timepicker 'now' or '13:14'
	     * @default 'now'
	     */
	    defaultTime: _propTypes.default.string,
	
	    /**
	     * Millisecond offset from the defaultTime.
	     * @default 0
	     */
	    fromNow: _propTypes.default.number,
	
	    /**
	     * Internationalization options.
	     * @default See i18n documentation.
	     */
	    i18n: _propTypes.default.shape({
	      cancel: _propTypes.default.string,
	      clear: _propTypes.default.string,
	      done: _propTypes.default.string
	    }),
	
	    /**
	     * Automatically close picker when minute is selected.
	     * @default false
	     */
	    autoClose: _propTypes.default.bool,
	
	    /**
	     * Use 12 hour AM/PM clock instead of 24 hour clock.
	     * @default true
	     */
	    twelveHour: _propTypes.default.bool,
	
	    /**
	     * Vibrate device when dragging clock hand.
	     * @default true
	     */
	    vibrate: _propTypes.default.bool,
	
	    /**
	     * Callback function called before modal is opened.
	     * @default null
	     */
	    onOpenStart: _propTypes.default.func,
	
	    /**
	     * Callback function called after modal is opened.
	     * @default null
	     */
	    onOpenEnd: _propTypes.default.func,
	
	    /**
	     * Callback function called before modal is closed.
	     * @default null
	     */
	    onCloseStart: _propTypes.default.func,
	
	    /**
	     * Callback function called after modal is closed.
	     * @default null
	     */
	    onCloseEnd: _propTypes.default.func,
	
	    /**
	     * Callback function when a time is selected, first parameter is the hour and the second is the minute.
	     * @default null
	     */
	    onSelect: _propTypes.default.func
	  })
	};
	TimePicker.defaultProps = {
	  id: "TimePicker-".concat((0, _idgen.default)()),
	  options: {
	    duration: 350,
	    container: null,
	    showClearBtn: false,
	    defaultTime: 'now',
	    fromNow: 0,
	    i18n: {
	      cancel: 'Cancel',
	      clear: 'Clear',
	      done: 'Ok'
	    },
	    autoClose: false,
	    twelveHour: true,
	    vibrate: true,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    onSelect: null
	  }
	};
	var _default = TimePicker;
	exports.default = _default;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Button = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Toast = function Toast(props) {
	  var children = props.children,
	      className = props.className,
	      _props$options = props.options,
	      options = _props$options === void 0 ? {} : _props$options;
	
	  var showToast = function showToast() {
	    return typeof M !== 'undefined' ? M.toast(options) : null;
	  };
	
	  return /*#__PURE__*/_react.default.createElement(_Button.default, {
	    onClick: showToast,
	    className: (0, _classnames.default)('toast', className)
	  }, children);
	};
	
	Toast.propTypes = {
	  className: _propTypes.default.string,
	
	  /**
	   * Toast trigger content
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Options to pass to Toast method
	   * <a href="https://materializecss.com/toasts.html">More</a>
	   */
	  options: _propTypes.default.shape({
	    /**
	     * The HTML content of the Toast.
	     * @default ''
	     */
	    html: _propTypes.default.string,
	
	    /**
	     * Length in ms the Toast stays before dismissal.
	     * @default 4000
	     */
	    displayLength: _propTypes.default.number,
	
	    /**
	     * Transition in duration in milliseconds.
	     * @default 300
	     */
	    inDuration: _propTypes.default.number,
	
	    /**
	     * Transition out duration in milliseconds.
	     * @default 375
	     */
	    outDuration: _propTypes.default.number,
	
	    /**
	     * Classes to be added to the toast element.
	     * @default ''
	     */
	    classes: _propTypes.default.string,
	
	    /**
	     * Callback function called when toast is dismissed.
	     * @default null
	     */
	    completeCallback: _propTypes.default.func,
	
	    /**
	     * The percentage of the toast's width it takes for a drag to dismiss a Toast.
	     * @default 0.8
	     */
	    activationPercent: _propTypes.default.number
	  })
	};
	var _default = Toast;
	exports.default = _default;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.UserShape = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserShape = {
	  background: _propTypes.default.string,
	  image: _propTypes.default.string,
	  name: _propTypes.default.string,
	  email: _propTypes.default.string
	};
	exports.UserShape = UserShape;
	
	var UserView = function UserView(_ref) {
	  var background = _ref.background,
	      image = _ref.image,
	      name = _ref.name,
	      email = _ref.email;
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: "user-view"
	  }, background && /*#__PURE__*/_react.default.createElement("div", {
	    className: "background"
	  }, /*#__PURE__*/_react.default.createElement("img", {
	    src: background
	  })), image && /*#__PURE__*/_react.default.createElement("a", {
	    href: "#!user"
	  }, /*#__PURE__*/_react.default.createElement("img", {
	    className: "circle",
	    src: image
	  })), name && /*#__PURE__*/_react.default.createElement("a", {
	    href: "#!name"
	  }, /*#__PURE__*/_react.default.createElement("span", {
	    className: "white-text name"
	  }, name)), email && /*#__PURE__*/_react.default.createElement("a", {
	    href: "#!email"
	  }, /*#__PURE__*/_react.default.createElement("span", {
	    className: "white-text email"
	  }, email)));
	};
	
	UserView.propTypes = UserShape;
	var _default = UserView;
	exports.default = _default;

/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.safeJSONStringify = void 0;
	
	var safeJSONStringify = function safeJSONStringify(s) {
	  try {
	    return JSON.stringify(s);
	  } catch (err) {
	    console.error(err);
	    return NaN;
	  }
	};
	
	exports.safeJSONStringify = safeJSONStringify;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	var _interopRequireWildcard = __webpack_require__(27);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Context = __webpack_require__(9);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(23));
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = new _Subscription["default"](store);
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _react.useEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(46));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(51));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(147));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(148));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(149));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(150));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports["default"] = void 0;
	
	var _redux = __webpack_require__(25);
	
	var _wrapMapToProps = __webpack_require__(47);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports["default"] = void 0;
	
	var _wrapMapToProps = __webpack_require__(47);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(16));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(53));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports["default"] = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(17));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(151));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(54));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(9);
	
	var _useStore = __webpack_require__(49);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _useReduxContext2 = __webpack_require__(48);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(23));
	
	var _useIsomorphicLayoutEffect = __webpack_require__(52);
	
	var _Context = __webpack_require__(9);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return new _Subscription["default"](store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      selectedState = selector(storeState);
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newSelectedState = latestSelector.current(store.getState());
	
	        if (equalityFn(newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = newSelectedState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      throw new Error("You must pass a selector to useSelector");
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ },
/* 154 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(19);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(158),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(37);__webpack_require__(2),__webpack_require__(15);var invariant=_interopDefault(__webpack_require__(26));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,s=e.innerRef,f=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(t){t||invariant(!1);var r=t.history,e=normalizeToLocation(resolveToLocation(u,t.location),t.location),o=e?r.createHref(e):"",n=_extends({},f,{href:o,navigate:function(){var e=resolveToLocation(u,t.location);(c?r.replace:r.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||s:n.innerRef=s,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,f){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,d=e.exact,y=e.isActive,m=e.location,v=e.sensitive,b=e.strict,w=e.style,x=e.to,g=e.innerRef,P=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(x,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:d,sensitive:v,strict:b}):null,i=!!(y?y(a,t):a),c=i?joinClassnames(h,p):h,u=i?_extends({},w,{},R):w,s=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},P);return forwardRefShim$1!==forwardRef$1?s.ref=f||g:s.innerRef=g,React.createElement(Link,s)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));__webpack_require__(2);var history=__webpack_require__(37);__webpack_require__(15);var createContext=_interopDefault(__webpack_require__(96)),invariant=_interopDefault(__webpack_require__(26)),pathToRegexp=_interopDefault(__webpack_require__(160));__webpack_require__(20);var hoistStatics=_interopDefault(__webpack_require__(38));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),createNamedContext$1=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext$1("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(157);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(159)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(99).enable();
	  window.Promise = __webpack_require__(98);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(173);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(18);


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v17.0.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var l=__webpack_require__(18),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
	if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
	function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
	function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
	0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
	function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
	exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
	key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
	exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.1";


/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 164 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(164);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 166 */
/***/ function(module, exports) {

	/** @license React v0.20.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
	window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
	E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
	x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
	function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
	function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
	function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
	exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
	exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
	exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(166);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(169);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(172)(module)))

/***/ },
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 170 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(170);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 172 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 173 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.1c60d207.js